import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class TerrainDataContainer {
  get descriptor() {
    return TerrainDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTileMapData = false;
    this._TileMapData = null;
    this._hasRoadData = false;
    this._RoadData = null;
    this._hasMatSetting = false;
    this._MatSetting = null;
    this._hasTileSetSetting = false;
    this._TileSetSetting = null;
    this._hasPropsData = false;
    this._PropsData = null;
    this._hasWaterData = false;
    this._WaterData = null;
    this._hasWaypointsData = false;
    this._WaypointsData = null;
    this._hasUnitsData = false;
    this._UnitsData = null;
    this._hasPreset = false;
    this._Preset = null;
    this._hasRegionsData = false;
    this._RegionsData = null;
    this._hasTerrainChunkData = false;
    this._TerrainChunkData = null;
  }
  isEmpty() {
    if (this._hasTileMapData && !this._TileMapData.isEmpty()) return false;
    if (this._hasRoadData && !this._RoadData.isEmpty()) return false;
    if (this._hasMatSetting && !this._MatSetting.isEmpty()) return false;
    if (this._hasTileSetSetting && !this._TileSetSetting.isEmpty()) return false;
    if (this._hasPropsData && !this._PropsData.isEmpty()) return false;
    if (this._hasWaterData && !this._WaterData.isEmpty()) return false;
    if (this._hasWaypointsData && !this._WaypointsData.isEmpty()) return false;
    if (this._hasUnitsData && !this._UnitsData.isEmpty()) return false;
    if (this._hasPreset && !this._Preset.isEmpty()) return false;
    if (this._hasRegionsData && !this._RegionsData.isEmpty()) return false;
    if (this._hasTerrainChunkData && !this._TerrainChunkData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainDataContainer) {
      return value;
    }
    return TerrainDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainDataContainer();
    if (json.TileMapData != null) {
      result._hasTileMapData = true;
      result._TileMapData = TileMapDataContainer.fromJson(json.TileMapData);
    }
    if (json.RoadData != null) {
      result._hasRoadData = true;
      result._RoadData = RoadDataContainer.fromJson(json.RoadData);
    }
    if (json.MatSetting != null) {
      result._hasMatSetting = true;
      result._MatSetting = MaterialSetting.fromJson(json.MatSetting);
    }
    if (json.TileSetSetting != null) {
      result._hasTileSetSetting = true;
      result._TileSetSetting = TileSetData.fromJson(json.TileSetSetting);
    }
    if (json.PropsData != null) {
      result._hasPropsData = true;
      result._PropsData = PropsDataContainer.fromJson(json.PropsData);
    }
    if (json.WaterData != null) {
      result._hasWaterData = true;
      result._WaterData = WaterDataContainer.fromJson(json.WaterData);
    }
    if (json.WaypointsData != null) {
      result._hasWaypointsData = true;
      result._WaypointsData = WayPointDataContainer.fromJson(json.WaypointsData);
    }
    if (json.UnitsData != null) {
      result._hasUnitsData = true;
      result._UnitsData = UnitsDataContainer.fromJson(json.UnitsData);
    }
    if (json.Preset != null) {
      result._hasPreset = true;
      result._Preset = TerrainPreset.fromJson(json.Preset);
    }
    if (json.RegionsData != null) {
      result._hasRegionsData = true;
      result._RegionsData = RegionsDataContainer.fromJson(json.RegionsData);
    }
    if (json.TerrainChunkData != null) {
      result._hasTerrainChunkData = true;
      result._TerrainChunkData = TerrainChunkDataContainer.fromJson(json.TerrainChunkData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTileMapData && !this._TileMapData.isEmpty()) {
      result.TileMapData = TileMapDataContainer.toJson(this._TileMapData);
    }
    if (this._hasRoadData && !this._RoadData.isEmpty()) {
      result.RoadData = RoadDataContainer.toJson(this._RoadData);
    }
    if (this._hasMatSetting && !this._MatSetting.isEmpty()) {
      result.MatSetting = MaterialSetting.toJson(this._MatSetting);
    }
    if (this._hasTileSetSetting && !this._TileSetSetting.isEmpty()) {
      result.TileSetSetting = TileSetData.toJson(this._TileSetSetting);
    }
    if (this._hasPropsData && !this._PropsData.isEmpty()) {
      result.PropsData = PropsDataContainer.toJson(this._PropsData);
    }
    if (this._hasWaterData && !this._WaterData.isEmpty()) {
      result.WaterData = WaterDataContainer.toJson(this._WaterData);
    }
    if (this._hasWaypointsData && !this._WaypointsData.isEmpty()) {
      result.WaypointsData = WayPointDataContainer.toJson(this._WaypointsData);
    }
    if (this._hasUnitsData && !this._UnitsData.isEmpty()) {
      result.UnitsData = UnitsDataContainer.toJson(this._UnitsData);
    }
    if (this._hasPreset && !this._Preset.isEmpty()) {
      result.Preset = TerrainPreset.toJson(this._Preset);
    }
    if (this._hasRegionsData && !this._RegionsData.isEmpty()) {
      result.RegionsData = RegionsDataContainer.toJson(this._RegionsData);
    }
    if (this._hasTerrainChunkData && !this._TerrainChunkData.isEmpty()) {
      result.TerrainChunkData = TerrainChunkDataContainer.toJson(this._TerrainChunkData);
    }
    return result;
  }
  /**
   * @returns {TileMapDataContainer}
   */
  get TileMapData() {
    return this._hasTileMapData ? this._TileMapData : TileMapDataContainer.default;
  }
  get hasTileMapData() {
    return this._hasTileMapData;
  }
  setTileMapData(path, value) {
    return {type: 'SET', path: path.concat(['TileMapData']), value: value.toJson()};
  }
  deleteTileMapData(path) {
    return {type: 'DELETE', path: path.concat(['TileMapData'])};
  }
  /**
   * @returns {RoadDataContainer}
   */
  get RoadData() {
    return this._hasRoadData ? this._RoadData : RoadDataContainer.default;
  }
  get hasRoadData() {
    return this._hasRoadData;
  }
  setRoadData(path, value) {
    return {type: 'SET', path: path.concat(['RoadData']), value: value.toJson()};
  }
  deleteRoadData(path) {
    return {type: 'DELETE', path: path.concat(['RoadData'])};
  }
  /**
   * @returns {MaterialSetting}
   */
  get MatSetting() {
    return this._hasMatSetting ? this._MatSetting : MaterialSetting.default;
  }
  get hasMatSetting() {
    return this._hasMatSetting;
  }
  setMatSetting(path, value) {
    return {type: 'SET', path: path.concat(['MatSetting']), value: value.toJson()};
  }
  deleteMatSetting(path) {
    return {type: 'DELETE', path: path.concat(['MatSetting'])};
  }
  /**
   * @returns {TileSetData}
   */
  get TileSetSetting() {
    return this._hasTileSetSetting ? this._TileSetSetting : TileSetData.default;
  }
  get hasTileSetSetting() {
    return this._hasTileSetSetting;
  }
  setTileSetSetting(path, value) {
    return {type: 'SET', path: path.concat(['TileSetSetting']), value: value.toJson()};
  }
  deleteTileSetSetting(path) {
    return {type: 'DELETE', path: path.concat(['TileSetSetting'])};
  }
  /**
   * @returns {PropsDataContainer}
   */
  get PropsData() {
    return this._hasPropsData ? this._PropsData : PropsDataContainer.default;
  }
  get hasPropsData() {
    return this._hasPropsData;
  }
  setPropsData(path, value) {
    return {type: 'SET', path: path.concat(['PropsData']), value: value.toJson()};
  }
  deletePropsData(path) {
    return {type: 'DELETE', path: path.concat(['PropsData'])};
  }
  /**
   * @returns {WaterDataContainer}
   */
  get WaterData() {
    return this._hasWaterData ? this._WaterData : WaterDataContainer.default;
  }
  get hasWaterData() {
    return this._hasWaterData;
  }
  setWaterData(path, value) {
    return {type: 'SET', path: path.concat(['WaterData']), value: value.toJson()};
  }
  deleteWaterData(path) {
    return {type: 'DELETE', path: path.concat(['WaterData'])};
  }
  /**
   * @returns {WayPointDataContainer}
   */
  get WaypointsData() {
    return this._hasWaypointsData ? this._WaypointsData : WayPointDataContainer.default;
  }
  get hasWaypointsData() {
    return this._hasWaypointsData;
  }
  setWaypointsData(path, value) {
    return {type: 'SET', path: path.concat(['WaypointsData']), value: value.toJson()};
  }
  deleteWaypointsData(path) {
    return {type: 'DELETE', path: path.concat(['WaypointsData'])};
  }
  /**
   * @returns {UnitsDataContainer}
   */
  get UnitsData() {
    return this._hasUnitsData ? this._UnitsData : UnitsDataContainer.default;
  }
  get hasUnitsData() {
    return this._hasUnitsData;
  }
  setUnitsData(path, value) {
    return {type: 'SET', path: path.concat(['UnitsData']), value: value.toJson()};
  }
  deleteUnitsData(path) {
    return {type: 'DELETE', path: path.concat(['UnitsData'])};
  }
  /**
   * @returns {TerrainPreset}
   */
  get Preset() {
    return this._hasPreset ? this._Preset : TerrainPreset.default;
  }
  get hasPreset() {
    return this._hasPreset;
  }
  setPreset(path, value) {
    return {type: 'SET', path: path.concat(['Preset']), value: value.toJson()};
  }
  deletePreset(path) {
    return {type: 'DELETE', path: path.concat(['Preset'])};
  }
  /**
   * @returns {RegionsDataContainer}
   */
  get RegionsData() {
    return this._hasRegionsData ? this._RegionsData : RegionsDataContainer.default;
  }
  get hasRegionsData() {
    return this._hasRegionsData;
  }
  setRegionsData(path, value) {
    return {type: 'SET', path: path.concat(['RegionsData']), value: value.toJson()};
  }
  deleteRegionsData(path) {
    return {type: 'DELETE', path: path.concat(['RegionsData'])};
  }
  /**
   * @returns {TerrainChunkDataContainer}
   */
  get TerrainChunkData() {
    return this._hasTerrainChunkData ? this._TerrainChunkData : TerrainChunkDataContainer.default;
  }
  get hasTerrainChunkData() {
    return this._hasTerrainChunkData;
  }
  setTerrainChunkData(path, value) {
    return {type: 'SET', path: path.concat(['TerrainChunkData']), value: value.toJson()};
  }
  deleteTerrainChunkData(path) {
    return {type: 'DELETE', path: path.concat(['TerrainChunkData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "TileMapData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasTileMapData = true;
              copy._TileMapData = TileMapDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileMapData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasTileMapData = false;
              copy._TileMapData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTileMapData) {
            const copy = new TerrainDataContainer(this);
            copy._hasTileMapData = true;
            copy._TileMapData = TileMapDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._TileMapData.apply(type, path.slice(1), value);
          if (newValue === this._TileMapData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._TileMapData = copy._TileMapData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "RoadData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasRoadData = true;
              copy._RoadData = RoadDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasRoadData = false;
              copy._RoadData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRoadData) {
            const copy = new TerrainDataContainer(this);
            copy._hasRoadData = true;
            copy._RoadData = RoadDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._RoadData.apply(type, path.slice(1), value);
          if (newValue === this._RoadData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._RoadData = copy._RoadData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "MatSetting": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasMatSetting = true;
              copy._MatSetting = MaterialSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMatSetting) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasMatSetting = false;
              copy._MatSetting = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMatSetting) {
            const copy = new TerrainDataContainer(this);
            copy._hasMatSetting = true;
            copy._MatSetting = MaterialSetting.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._MatSetting.apply(type, path.slice(1), value);
          if (newValue === this._MatSetting) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._MatSetting = copy._MatSetting.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "TileSetSetting": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasTileSetSetting = true;
              copy._TileSetSetting = TileSetData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileSetSetting) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasTileSetSetting = false;
              copy._TileSetSetting = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTileSetSetting) {
            const copy = new TerrainDataContainer(this);
            copy._hasTileSetSetting = true;
            copy._TileSetSetting = TileSetData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._TileSetSetting.apply(type, path.slice(1), value);
          if (newValue === this._TileSetSetting) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._TileSetSetting = copy._TileSetSetting.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "PropsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasPropsData = true;
              copy._PropsData = PropsDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropsData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasPropsData = false;
              copy._PropsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropsData) {
            const copy = new TerrainDataContainer(this);
            copy._hasPropsData = true;
            copy._PropsData = PropsDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._PropsData.apply(type, path.slice(1), value);
          if (newValue === this._PropsData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._PropsData = copy._PropsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "WaterData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasWaterData = true;
              copy._WaterData = WaterDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasWaterData = false;
              copy._WaterData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaterData) {
            const copy = new TerrainDataContainer(this);
            copy._hasWaterData = true;
            copy._WaterData = WaterDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._WaterData.apply(type, path.slice(1), value);
          if (newValue === this._WaterData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._WaterData = copy._WaterData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "WaypointsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasWaypointsData = true;
              copy._WaypointsData = WayPointDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaypointsData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasWaypointsData = false;
              copy._WaypointsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWaypointsData) {
            const copy = new TerrainDataContainer(this);
            copy._hasWaypointsData = true;
            copy._WaypointsData = WayPointDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._WaypointsData.apply(type, path.slice(1), value);
          if (newValue === this._WaypointsData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._WaypointsData = copy._WaypointsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "UnitsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasUnitsData = true;
              copy._UnitsData = UnitsDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitsData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasUnitsData = false;
              copy._UnitsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitsData) {
            const copy = new TerrainDataContainer(this);
            copy._hasUnitsData = true;
            copy._UnitsData = UnitsDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._UnitsData.apply(type, path.slice(1), value);
          if (newValue === this._UnitsData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._UnitsData = copy._UnitsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "Preset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasPreset = true;
              copy._Preset = TerrainPreset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreset) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasPreset = false;
              copy._Preset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPreset) {
            const copy = new TerrainDataContainer(this);
            copy._hasPreset = true;
            copy._Preset = TerrainPreset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._Preset.apply(type, path.slice(1), value);
          if (newValue === this._Preset) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._Preset = copy._Preset.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "RegionsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasRegionsData = true;
              copy._RegionsData = RegionsDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionsData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasRegionsData = false;
              copy._RegionsData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRegionsData) {
            const copy = new TerrainDataContainer(this);
            copy._hasRegionsData = true;
            copy._RegionsData = RegionsDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._RegionsData.apply(type, path.slice(1), value);
          if (newValue === this._RegionsData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._RegionsData = copy._RegionsData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "TerrainChunkData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainDataContainer(this);
              copy._hasTerrainChunkData = true;
              copy._TerrainChunkData = TerrainChunkDataContainer.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTerrainChunkData) {
                return this;
              }
              const copy = new TerrainDataContainer(this);
              copy._hasTerrainChunkData = false;
              copy._TerrainChunkData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTerrainChunkData) {
            const copy = new TerrainDataContainer(this);
            copy._hasTerrainChunkData = true;
            copy._TerrainChunkData = TerrainChunkDataContainer.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._TerrainChunkData.apply(type, path.slice(1), value);
          if (newValue === this._TerrainChunkData) {
            return this;
          }
          const copy = new TerrainDataContainer(this);
          copy._TerrainChunkData = copy._TerrainChunkData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainDataContainer} other
   * @returns {TerrainDataContainer}
   */
  merge(other) {
    const copy = new TerrainDataContainer(this);
    if (other._hasTileMapData) {
      if (copy._hasTileMapData) {
        copy._TileMapData = copy.TileMapData.merge(other.TileMapData);
      } else {
        copy._TileMapData = other._TileMapData;
      }
      copy._hasTileMapData = true;
    }
    if (other._hasRoadData) {
      if (copy._hasRoadData) {
        copy._RoadData = copy.RoadData.merge(other.RoadData);
      } else {
        copy._RoadData = other._RoadData;
      }
      copy._hasRoadData = true;
    }
    if (other._hasMatSetting) {
      if (copy._hasMatSetting) {
        copy._MatSetting = copy.MatSetting.merge(other.MatSetting);
      } else {
        copy._MatSetting = other._MatSetting;
      }
      copy._hasMatSetting = true;
    }
    if (other._hasTileSetSetting) {
      if (copy._hasTileSetSetting) {
        copy._TileSetSetting = copy.TileSetSetting.merge(other.TileSetSetting);
      } else {
        copy._TileSetSetting = other._TileSetSetting;
      }
      copy._hasTileSetSetting = true;
    }
    if (other._hasPropsData) {
      if (copy._hasPropsData) {
        copy._PropsData = copy.PropsData.merge(other.PropsData);
      } else {
        copy._PropsData = other._PropsData;
      }
      copy._hasPropsData = true;
    }
    if (other._hasWaterData) {
      if (copy._hasWaterData) {
        copy._WaterData = copy.WaterData.merge(other.WaterData);
      } else {
        copy._WaterData = other._WaterData;
      }
      copy._hasWaterData = true;
    }
    if (other._hasWaypointsData) {
      if (copy._hasWaypointsData) {
        copy._WaypointsData = copy.WaypointsData.merge(other.WaypointsData);
      } else {
        copy._WaypointsData = other._WaypointsData;
      }
      copy._hasWaypointsData = true;
    }
    if (other._hasUnitsData) {
      if (copy._hasUnitsData) {
        copy._UnitsData = copy.UnitsData.merge(other.UnitsData);
      } else {
        copy._UnitsData = other._UnitsData;
      }
      copy._hasUnitsData = true;
    }
    if (other._hasPreset) {
      if (copy._hasPreset) {
        copy._Preset = copy.Preset.merge(other.Preset);
      } else {
        copy._Preset = other._Preset;
      }
      copy._hasPreset = true;
    }
    if (other._hasRegionsData) {
      if (copy._hasRegionsData) {
        copy._RegionsData = copy.RegionsData.merge(other.RegionsData);
      } else {
        copy._RegionsData = other._RegionsData;
      }
      copy._hasRegionsData = true;
    }
    if (other._hasTerrainChunkData) {
      if (copy._hasTerrainChunkData) {
        copy._TerrainChunkData = copy.TerrainChunkData.merge(other.TerrainChunkData);
      } else {
        copy._TerrainChunkData = other._TerrainChunkData;
      }
      copy._hasTerrainChunkData = true;
    }
    return copy;
  }
}
TerrainDataContainer.default = new TerrainDataContainer();
class TerrainDataContainer_Builder {
  constructor(value) {
    this._value = new TerrainDataContainer(value);
  }
  build() {
    return new TerrainDataContainer(this._value);
  }
  setTileMapData(value) {
    this._value._hasTileMapData = true;
    this._value._TileMapData = value;
    return this;
  }
  deleteTileMapData() {
    this._value._hasTileMapData = false;
    this._value._TileMapData = null;
    return this;
  }
  setRoadData(value) {
    this._value._hasRoadData = true;
    this._value._RoadData = value;
    return this;
  }
  deleteRoadData() {
    this._value._hasRoadData = false;
    this._value._RoadData = null;
    return this;
  }
  setMatSetting(value) {
    this._value._hasMatSetting = true;
    this._value._MatSetting = value;
    return this;
  }
  deleteMatSetting() {
    this._value._hasMatSetting = false;
    this._value._MatSetting = null;
    return this;
  }
  setTileSetSetting(value) {
    this._value._hasTileSetSetting = true;
    this._value._TileSetSetting = value;
    return this;
  }
  deleteTileSetSetting() {
    this._value._hasTileSetSetting = false;
    this._value._TileSetSetting = null;
    return this;
  }
  setPropsData(value) {
    this._value._hasPropsData = true;
    this._value._PropsData = value;
    return this;
  }
  deletePropsData() {
    this._value._hasPropsData = false;
    this._value._PropsData = null;
    return this;
  }
  setWaterData(value) {
    this._value._hasWaterData = true;
    this._value._WaterData = value;
    return this;
  }
  deleteWaterData() {
    this._value._hasWaterData = false;
    this._value._WaterData = null;
    return this;
  }
  setWaypointsData(value) {
    this._value._hasWaypointsData = true;
    this._value._WaypointsData = value;
    return this;
  }
  deleteWaypointsData() {
    this._value._hasWaypointsData = false;
    this._value._WaypointsData = null;
    return this;
  }
  setUnitsData(value) {
    this._value._hasUnitsData = true;
    this._value._UnitsData = value;
    return this;
  }
  deleteUnitsData() {
    this._value._hasUnitsData = false;
    this._value._UnitsData = null;
    return this;
  }
  setPreset(value) {
    this._value._hasPreset = true;
    this._value._Preset = value;
    return this;
  }
  deletePreset() {
    this._value._hasPreset = false;
    this._value._Preset = null;
    return this;
  }
  setRegionsData(value) {
    this._value._hasRegionsData = true;
    this._value._RegionsData = value;
    return this;
  }
  deleteRegionsData() {
    this._value._hasRegionsData = false;
    this._value._RegionsData = null;
    return this;
  }
  setTerrainChunkData(value) {
    this._value._hasTerrainChunkData = true;
    this._value._TerrainChunkData = value;
    return this;
  }
  deleteTerrainChunkData() {
    this._value._hasTerrainChunkData = false;
    this._value._TerrainChunkData = null;
    return this;
  }
}
TerrainDataContainer.Builder = TerrainDataContainer_Builder;
class TerrainDataContainer_WithParent {
  /**
   * @param {TerrainDataContainer} value
   * @param {TerrainDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTileMapData() {
    if (this._cachedHasTileMapData === undefined) {
      if (this._value.hasTileMapData) {
        this._cachedHasTileMapData = true;
      } else {
        this._cachedHasTileMapData = this._parent ? this._parent.hasTileMapData : false;
      }
    }
    return this._cachedHasTileMapData;
  }
  get TileMapData() {
    if (!this._cachedTileMapData) {
      if (this._value.hasTileMapData) {
        this._cachedTileMapData = new TileMapDataContainer.WithParent(this._value.TileMapData, this._parent && this._parent.hasTileMapData ? this._parent.TileMapData : null);
      } else {
        this._cachedTileMapData = this._parent ? new TileMapDataContainer.WithParent(TileMapDataContainer.default, this._parent.TileMapData) : TileMapDataContainer.WithParent.default;
      }
    }
    return this._cachedTileMapData;
  }
  get hasRoadData() {
    if (this._cachedHasRoadData === undefined) {
      if (this._value.hasRoadData) {
        this._cachedHasRoadData = true;
      } else {
        this._cachedHasRoadData = this._parent ? this._parent.hasRoadData : false;
      }
    }
    return this._cachedHasRoadData;
  }
  get RoadData() {
    if (!this._cachedRoadData) {
      if (this._value.hasRoadData) {
        this._cachedRoadData = new RoadDataContainer.WithParent(this._value.RoadData, this._parent && this._parent.hasRoadData ? this._parent.RoadData : null);
      } else {
        this._cachedRoadData = this._parent ? new RoadDataContainer.WithParent(RoadDataContainer.default, this._parent.RoadData) : RoadDataContainer.WithParent.default;
      }
    }
    return this._cachedRoadData;
  }
  get hasMatSetting() {
    if (this._cachedHasMatSetting === undefined) {
      if (this._value.hasMatSetting) {
        this._cachedHasMatSetting = true;
      } else {
        this._cachedHasMatSetting = this._parent ? this._parent.hasMatSetting : false;
      }
    }
    return this._cachedHasMatSetting;
  }
  get MatSetting() {
    if (!this._cachedMatSetting) {
      if (this._value.hasMatSetting) {
        this._cachedMatSetting = new MaterialSetting.WithParent(this._value.MatSetting, this._parent && this._parent.hasMatSetting ? this._parent.MatSetting : null);
      } else {
        this._cachedMatSetting = this._parent ? new MaterialSetting.WithParent(MaterialSetting.default, this._parent.MatSetting) : MaterialSetting.WithParent.default;
      }
    }
    return this._cachedMatSetting;
  }
  get hasTileSetSetting() {
    if (this._cachedHasTileSetSetting === undefined) {
      if (this._value.hasTileSetSetting) {
        this._cachedHasTileSetSetting = true;
      } else {
        this._cachedHasTileSetSetting = this._parent ? this._parent.hasTileSetSetting : false;
      }
    }
    return this._cachedHasTileSetSetting;
  }
  get TileSetSetting() {
    if (!this._cachedTileSetSetting) {
      if (this._value.hasTileSetSetting) {
        this._cachedTileSetSetting = new TileSetData.WithParent(this._value.TileSetSetting, this._parent && this._parent.hasTileSetSetting ? this._parent.TileSetSetting : null);
      } else {
        this._cachedTileSetSetting = this._parent ? new TileSetData.WithParent(TileSetData.default, this._parent.TileSetSetting) : TileSetData.WithParent.default;
      }
    }
    return this._cachedTileSetSetting;
  }
  get hasPropsData() {
    if (this._cachedHasPropsData === undefined) {
      if (this._value.hasPropsData) {
        this._cachedHasPropsData = true;
      } else {
        this._cachedHasPropsData = this._parent ? this._parent.hasPropsData : false;
      }
    }
    return this._cachedHasPropsData;
  }
  get PropsData() {
    if (!this._cachedPropsData) {
      if (this._value.hasPropsData) {
        this._cachedPropsData = new PropsDataContainer.WithParent(this._value.PropsData, this._parent && this._parent.hasPropsData ? this._parent.PropsData : null);
      } else {
        this._cachedPropsData = this._parent ? new PropsDataContainer.WithParent(PropsDataContainer.default, this._parent.PropsData) : PropsDataContainer.WithParent.default;
      }
    }
    return this._cachedPropsData;
  }
  get hasWaterData() {
    if (this._cachedHasWaterData === undefined) {
      if (this._value.hasWaterData) {
        this._cachedHasWaterData = true;
      } else {
        this._cachedHasWaterData = this._parent ? this._parent.hasWaterData : false;
      }
    }
    return this._cachedHasWaterData;
  }
  get WaterData() {
    if (!this._cachedWaterData) {
      if (this._value.hasWaterData) {
        this._cachedWaterData = new WaterDataContainer.WithParent(this._value.WaterData, this._parent && this._parent.hasWaterData ? this._parent.WaterData : null);
      } else {
        this._cachedWaterData = this._parent ? new WaterDataContainer.WithParent(WaterDataContainer.default, this._parent.WaterData) : WaterDataContainer.WithParent.default;
      }
    }
    return this._cachedWaterData;
  }
  get hasWaypointsData() {
    if (this._cachedHasWaypointsData === undefined) {
      if (this._value.hasWaypointsData) {
        this._cachedHasWaypointsData = true;
      } else {
        this._cachedHasWaypointsData = this._parent ? this._parent.hasWaypointsData : false;
      }
    }
    return this._cachedHasWaypointsData;
  }
  get WaypointsData() {
    if (!this._cachedWaypointsData) {
      if (this._value.hasWaypointsData) {
        this._cachedWaypointsData = new WayPointDataContainer.WithParent(this._value.WaypointsData, this._parent && this._parent.hasWaypointsData ? this._parent.WaypointsData : null);
      } else {
        this._cachedWaypointsData = this._parent ? new WayPointDataContainer.WithParent(WayPointDataContainer.default, this._parent.WaypointsData) : WayPointDataContainer.WithParent.default;
      }
    }
    return this._cachedWaypointsData;
  }
  get hasUnitsData() {
    if (this._cachedHasUnitsData === undefined) {
      if (this._value.hasUnitsData) {
        this._cachedHasUnitsData = true;
      } else {
        this._cachedHasUnitsData = this._parent ? this._parent.hasUnitsData : false;
      }
    }
    return this._cachedHasUnitsData;
  }
  get UnitsData() {
    if (!this._cachedUnitsData) {
      if (this._value.hasUnitsData) {
        this._cachedUnitsData = new UnitsDataContainer.WithParent(this._value.UnitsData, this._parent && this._parent.hasUnitsData ? this._parent.UnitsData : null);
      } else {
        this._cachedUnitsData = this._parent ? new UnitsDataContainer.WithParent(UnitsDataContainer.default, this._parent.UnitsData) : UnitsDataContainer.WithParent.default;
      }
    }
    return this._cachedUnitsData;
  }
  get hasPreset() {
    if (this._cachedHasPreset === undefined) {
      if (this._value.hasPreset) {
        this._cachedHasPreset = true;
      } else {
        this._cachedHasPreset = this._parent ? this._parent.hasPreset : false;
      }
    }
    return this._cachedHasPreset;
  }
  get Preset() {
    if (!this._cachedPreset) {
      if (this._value.hasPreset) {
        this._cachedPreset = new TerrainPreset.WithParent(this._value.Preset, this._parent && this._parent.hasPreset ? this._parent.Preset : null);
      } else {
        this._cachedPreset = this._parent ? new TerrainPreset.WithParent(TerrainPreset.default, this._parent.Preset) : TerrainPreset.WithParent.default;
      }
    }
    return this._cachedPreset;
  }
  get hasRegionsData() {
    if (this._cachedHasRegionsData === undefined) {
      if (this._value.hasRegionsData) {
        this._cachedHasRegionsData = true;
      } else {
        this._cachedHasRegionsData = this._parent ? this._parent.hasRegionsData : false;
      }
    }
    return this._cachedHasRegionsData;
  }
  get RegionsData() {
    if (!this._cachedRegionsData) {
      if (this._value.hasRegionsData) {
        this._cachedRegionsData = new RegionsDataContainer.WithParent(this._value.RegionsData, this._parent && this._parent.hasRegionsData ? this._parent.RegionsData : null);
      } else {
        this._cachedRegionsData = this._parent ? new RegionsDataContainer.WithParent(RegionsDataContainer.default, this._parent.RegionsData) : RegionsDataContainer.WithParent.default;
      }
    }
    return this._cachedRegionsData;
  }
  get hasTerrainChunkData() {
    if (this._cachedHasTerrainChunkData === undefined) {
      if (this._value.hasTerrainChunkData) {
        this._cachedHasTerrainChunkData = true;
      } else {
        this._cachedHasTerrainChunkData = this._parent ? this._parent.hasTerrainChunkData : false;
      }
    }
    return this._cachedHasTerrainChunkData;
  }
  get TerrainChunkData() {
    if (!this._cachedTerrainChunkData) {
      if (this._value.hasTerrainChunkData) {
        this._cachedTerrainChunkData = new TerrainChunkDataContainer.WithParent(this._value.TerrainChunkData, this._parent && this._parent.hasTerrainChunkData ? this._parent.TerrainChunkData : null);
      } else {
        this._cachedTerrainChunkData = this._parent ? new TerrainChunkDataContainer.WithParent(TerrainChunkDataContainer.default, this._parent.TerrainChunkData) : TerrainChunkDataContainer.WithParent.default;
      }
    }
    return this._cachedTerrainChunkData;
  }
  update(current, parent) {
    const result = new TerrainDataContainer_WithParent(current, parent);
    if (this._cachedTileMapData && this._value.hasTileMapData && current.hasTileMapData) {
      if (this._value.TileMapData === current.TileMapData && this._parent === parent) {
        result._cachedTileMapData = this._cachedTileMapData;
      } else {
        result._cachedTileMapData = this._cachedTileMapData.update(current.TileMapData, parent && parent.hasTileMapData ? parent.TileMapData : null);
      }
    }
    if (this._cachedRoadData && this._value.hasRoadData && current.hasRoadData) {
      if (this._value.RoadData === current.RoadData && this._parent === parent) {
        result._cachedRoadData = this._cachedRoadData;
      } else {
        result._cachedRoadData = this._cachedRoadData.update(current.RoadData, parent && parent.hasRoadData ? parent.RoadData : null);
      }
    }
    if (this._cachedMatSetting && this._value.hasMatSetting && current.hasMatSetting) {
      if (this._value.MatSetting === current.MatSetting && this._parent === parent) {
        result._cachedMatSetting = this._cachedMatSetting;
      } else {
        result._cachedMatSetting = this._cachedMatSetting.update(current.MatSetting, parent && parent.hasMatSetting ? parent.MatSetting : null);
      }
    }
    if (this._cachedTileSetSetting && this._value.hasTileSetSetting && current.hasTileSetSetting) {
      if (this._value.TileSetSetting === current.TileSetSetting && this._parent === parent) {
        result._cachedTileSetSetting = this._cachedTileSetSetting;
      } else {
        result._cachedTileSetSetting = this._cachedTileSetSetting.update(current.TileSetSetting, parent && parent.hasTileSetSetting ? parent.TileSetSetting : null);
      }
    }
    if (this._cachedPropsData && this._value.hasPropsData && current.hasPropsData) {
      if (this._value.PropsData === current.PropsData && this._parent === parent) {
        result._cachedPropsData = this._cachedPropsData;
      } else {
        result._cachedPropsData = this._cachedPropsData.update(current.PropsData, parent && parent.hasPropsData ? parent.PropsData : null);
      }
    }
    if (this._cachedWaterData && this._value.hasWaterData && current.hasWaterData) {
      if (this._value.WaterData === current.WaterData && this._parent === parent) {
        result._cachedWaterData = this._cachedWaterData;
      } else {
        result._cachedWaterData = this._cachedWaterData.update(current.WaterData, parent && parent.hasWaterData ? parent.WaterData : null);
      }
    }
    if (this._cachedWaypointsData && this._value.hasWaypointsData && current.hasWaypointsData) {
      if (this._value.WaypointsData === current.WaypointsData && this._parent === parent) {
        result._cachedWaypointsData = this._cachedWaypointsData;
      } else {
        result._cachedWaypointsData = this._cachedWaypointsData.update(current.WaypointsData, parent && parent.hasWaypointsData ? parent.WaypointsData : null);
      }
    }
    if (this._cachedUnitsData && this._value.hasUnitsData && current.hasUnitsData) {
      if (this._value.UnitsData === current.UnitsData && this._parent === parent) {
        result._cachedUnitsData = this._cachedUnitsData;
      } else {
        result._cachedUnitsData = this._cachedUnitsData.update(current.UnitsData, parent && parent.hasUnitsData ? parent.UnitsData : null);
      }
    }
    if (this._cachedPreset && this._value.hasPreset && current.hasPreset) {
      if (this._value.Preset === current.Preset && this._parent === parent) {
        result._cachedPreset = this._cachedPreset;
      } else {
        result._cachedPreset = this._cachedPreset.update(current.Preset, parent && parent.hasPreset ? parent.Preset : null);
      }
    }
    if (this._cachedRegionsData && this._value.hasRegionsData && current.hasRegionsData) {
      if (this._value.RegionsData === current.RegionsData && this._parent === parent) {
        result._cachedRegionsData = this._cachedRegionsData;
      } else {
        result._cachedRegionsData = this._cachedRegionsData.update(current.RegionsData, parent && parent.hasRegionsData ? parent.RegionsData : null);
      }
    }
    if (this._cachedTerrainChunkData && this._value.hasTerrainChunkData && current.hasTerrainChunkData) {
      if (this._value.TerrainChunkData === current.TerrainChunkData && this._parent === parent) {
        result._cachedTerrainChunkData = this._cachedTerrainChunkData;
      } else {
        result._cachedTerrainChunkData = this._cachedTerrainChunkData.update(current.TerrainChunkData, parent && parent.hasTerrainChunkData ? parent.TerrainChunkData : null);
      }
    }
    return result;
  }
}
TerrainDataContainer_WithParent.default = new TerrainDataContainer_WithParent(TerrainDataContainer.default, null);
TerrainDataContainer.WithParent = TerrainDataContainer_WithParent;
class TerrainDataContainer_Descriptor {
  get TileMapData() {
    if (!this._TileMapData) {
      this._TileMapData = {
        name: "TileMapData",
        Name: "TileMapData",
        number: 1,
        protoType: 11,
        protoName: "TileMapData",
        type: TileMapDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileMapData;
  }
  get RoadData() {
    if (!this._RoadData) {
      this._RoadData = {
        name: "RoadData",
        Name: "RoadData",
        number: 2,
        protoType: 11,
        protoName: "RoadData",
        type: RoadDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RoadData;
  }
  get MatSetting() {
    if (!this._MatSetting) {
      this._MatSetting = {
        name: "MatSetting",
        Name: "MatSetting",
        number: 3,
        protoType: 11,
        protoName: "MatSetting",
        type: MaterialSetting,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._MatSetting;
  }
  get TileSetSetting() {
    if (!this._TileSetSetting) {
      this._TileSetSetting = {
        name: "TileSetSetting",
        Name: "TileSetSetting",
        number: 4,
        protoType: 11,
        protoName: "TileSetSetting",
        type: TileSetData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileSetSetting;
  }
  get PropsData() {
    if (!this._PropsData) {
      this._PropsData = {
        name: "PropsData",
        Name: "PropsData",
        number: 5,
        protoType: 11,
        protoName: "PropsData",
        type: PropsDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PropsData;
  }
  get WaterData() {
    if (!this._WaterData) {
      this._WaterData = {
        name: "WaterData",
        Name: "WaterData",
        number: 6,
        protoType: 11,
        protoName: "WaterData",
        type: WaterDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._WaterData;
  }
  get WaypointsData() {
    if (!this._WaypointsData) {
      this._WaypointsData = {
        name: "WaypointsData",
        Name: "WaypointsData",
        number: 7,
        protoType: 11,
        protoName: "WaypointsData",
        type: WayPointDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._WaypointsData;
  }
  get UnitsData() {
    if (!this._UnitsData) {
      this._UnitsData = {
        name: "UnitsData",
        Name: "UnitsData",
        number: 8,
        protoType: 11,
        protoName: "UnitsData",
        type: UnitsDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UnitsData;
  }
  get Preset() {
    if (!this._Preset) {
      this._Preset = {
        name: "Preset",
        Name: "Preset",
        number: 9,
        protoType: 11,
        protoName: "Preset",
        type: TerrainPreset,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Preset;
  }
  get RegionsData() {
    if (!this._RegionsData) {
      this._RegionsData = {
        name: "RegionsData",
        Name: "RegionsData",
        number: 10,
        protoType: 11,
        protoName: "RegionsData",
        type: RegionsDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RegionsData;
  }
  get TerrainChunkData() {
    if (!this._TerrainChunkData) {
      this._TerrainChunkData = {
        name: "TerrainChunkData",
        Name: "TerrainChunkData",
        number: 11,
        protoType: 11,
        protoName: "TerrainChunkData",
        type: TerrainChunkDataContainer,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TerrainChunkData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.TileMapData,
        this.RoadData,
        this.MatSetting,
        this.TileSetSetting,
        this.PropsData,
        this.WaterData,
        this.WaypointsData,
        this.UnitsData,
        this.Preset,
        this.RegionsData,
        this.TerrainChunkData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTileMapData",
        Name: "DummyOneofForTileMapData",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadData",
        Name: "DummyOneofForRoadData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMatSetting",
        Name: "DummyOneofForMatSetting",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileSetSetting",
        Name: "DummyOneofForTileSetSetting",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropsData",
        Name: "DummyOneofForPropsData",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterData",
        Name: "DummyOneofForWaterData",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaypointsData",
        Name: "DummyOneofForWaypointsData",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitsData",
        Name: "DummyOneofForUnitsData",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPreset",
        Name: "DummyOneofForPreset",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionsData",
        Name: "DummyOneofForRegionsData",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTerrainChunkData",
        Name: "DummyOneofForTerrainChunkData",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainDataContainer.descriptor = new TerrainDataContainer_Descriptor();
export class TileMapDataContainer {
  get descriptor() {
    return TileMapDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._SpListData = [];
    this._hasMapWidth = false;
    this._MapWidth = null;
    this._hasMapHeight = false;
    this._MapHeight = null;
    this._hasTileSize = false;
    this._TileSize = null;
    this._hasMapYScale = false;
    this._MapYScale = null;
    this._hasSubdivLevel = false;
    this._SubdivLevel = null;
    this._CtrlPtsData = [];
    this._ClampTileId = [];
    this._SpecialTileVariations = [];
    this._hasDisableBorder = false;
    this._DisableBorder = null;
    this._hasNavmeshTileSize = false;
    this._navmeshTileSize = null;
    this._hasUseGridGraph = false;
    this._useGridGraph = null;
    this._hasGridNodeSize = false;
    this._gridNodeSize = null;
  }
  isEmpty() {
    if (this._SpListData.length > 0) return false;
    if (this._hasMapWidth) return false;
    if (this._hasMapHeight) return false;
    if (this._hasTileSize) return false;
    if (this._hasMapYScale) return false;
    if (this._hasSubdivLevel) return false;
    if (this._CtrlPtsData.length > 0) return false;
    if (this._ClampTileId.length > 0) return false;
    if (this._SpecialTileVariations.length > 0) return false;
    if (this._hasDisableBorder) return false;
    if (this._hasNavmeshTileSize) return false;
    if (this._hasUseGridGraph) return false;
    if (this._hasGridNodeSize) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TileMapDataContainer) {
      return value;
    }
    return TileMapDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new TileMapDataContainer();
    result._SpListData = JsonToList(json.SpListData, BezierSplineData);
    if (json.MapWidth != null) {
      result._hasMapWidth = true;
      result._MapWidth = JsonToInt32.fromJson(json.MapWidth);
    }
    if (json.MapHeight != null) {
      result._hasMapHeight = true;
      result._MapHeight = JsonToInt32.fromJson(json.MapHeight);
    }
    if (json.TileSize != null) {
      result._hasTileSize = true;
      result._TileSize = JsonToDouble.fromJson(json.TileSize);
    }
    if (json.MapYScale != null) {
      result._hasMapYScale = true;
      result._MapYScale = JsonToDouble.fromJson(json.MapYScale);
    }
    if (json.SubdivLevel != null) {
      result._hasSubdivLevel = true;
      result._SubdivLevel = JsonToInt32.fromJson(json.SubdivLevel);
    }
    result._CtrlPtsData = JsonToList(json.CtrlPtsData, CtrlPtData);
    result._ClampTileId = JsonToList(json.ClampTileId, JsonToInt32);
    result._SpecialTileVariations = JsonToList(json.SpecialTileVariations, ValueTuple2);
    if (json.DisableBorder != null) {
      result._hasDisableBorder = true;
      result._DisableBorder = JsonToBoolean.fromJson(json.DisableBorder);
    }
    if (json.navmeshTileSize != null) {
      result._hasNavmeshTileSize = true;
      result._navmeshTileSize = JsonToInt32.fromJson(json.navmeshTileSize);
    }
    if (json.useGridGraph != null) {
      result._hasUseGridGraph = true;
      result._useGridGraph = JsonToBoolean.fromJson(json.useGridGraph);
    }
    if (json.gridNodeSize != null) {
      result._hasGridNodeSize = true;
      result._gridNodeSize = JsonToDouble.fromJson(json.gridNodeSize);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._SpListData.length > 0) {
      result.SpListData = ArrayToJson(this._SpListData, BezierSplineData);
    }
    if (this._hasMapWidth) {
      result.MapWidth = JsonToInt32.toJson(this._MapWidth);
    }
    if (this._hasMapHeight) {
      result.MapHeight = JsonToInt32.toJson(this._MapHeight);
    }
    if (this._hasTileSize) {
      result.TileSize = JsonToDouble.toJson(this._TileSize);
    }
    if (this._hasMapYScale) {
      result.MapYScale = JsonToDouble.toJson(this._MapYScale);
    }
    if (this._hasSubdivLevel) {
      result.SubdivLevel = JsonToInt32.toJson(this._SubdivLevel);
    }
    if (this._CtrlPtsData.length > 0) {
      result.CtrlPtsData = ArrayToJson(this._CtrlPtsData, CtrlPtData);
    }
    if (this._ClampTileId.length > 0) {
      result.ClampTileId = ArrayToJson(this._ClampTileId, JsonToInt32);
    }
    if (this._SpecialTileVariations.length > 0) {
      result.SpecialTileVariations = ArrayToJson(this._SpecialTileVariations, ValueTuple2);
    }
    if (this._hasDisableBorder) {
      result.DisableBorder = JsonToBoolean.toJson(this._DisableBorder);
    }
    if (this._hasNavmeshTileSize) {
      result.navmeshTileSize = JsonToInt32.toJson(this._navmeshTileSize);
    }
    if (this._hasUseGridGraph) {
      result.useGridGraph = JsonToBoolean.toJson(this._useGridGraph);
    }
    if (this._hasGridNodeSize) {
      result.gridNodeSize = JsonToDouble.toJson(this._gridNodeSize);
    }
    return result;
  }
  /**
   * @returns {BezierSplineData[]}
   */
  get SpListData() {
    return this._SpListData;
  }
  addSpListData(path, value) {
    return {type: 'ADD', path: path.concat(['SpListData']), value: value.toJson()};
  }
  setSpListData(path, value) {
    return {type: 'SET', path: path.concat(['SpListData']), value: ArrayToJson(value, BezierSplineData)};
  }
  setSpListDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['SpListData', key]), value: value.toJson()};
  }
  deleteSpListData(path) {
    return {type: 'DELETE', path: path.concat(['SpListData'])};
  }
  deleteSpListDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['SpListData', key])};
  }
  /**
   * @returns {number}
   */
  get MapWidth() {
    return this._hasMapWidth ? this._MapWidth : JsonToInt32.default;
  }
  get hasMapWidth() {
    return this._hasMapWidth;
  }
  setMapWidth(path, value) {
    return {type: 'SET', path: path.concat(['MapWidth']), value};
  }
  deleteMapWidth(path) {
    return {type: 'DELETE', path: path.concat(['MapWidth'])};
  }
  /**
   * @returns {number}
   */
  get MapHeight() {
    return this._hasMapHeight ? this._MapHeight : JsonToInt32.default;
  }
  get hasMapHeight() {
    return this._hasMapHeight;
  }
  setMapHeight(path, value) {
    return {type: 'SET', path: path.concat(['MapHeight']), value};
  }
  deleteMapHeight(path) {
    return {type: 'DELETE', path: path.concat(['MapHeight'])};
  }
  /**
   * @returns {number}
   */
  get TileSize() {
    return this._hasTileSize ? this._TileSize : JsonToDouble.default;
  }
  get hasTileSize() {
    return this._hasTileSize;
  }
  setTileSize(path, value) {
    return {type: 'SET', path: path.concat(['TileSize']), value};
  }
  deleteTileSize(path) {
    return {type: 'DELETE', path: path.concat(['TileSize'])};
  }
  /**
   * @returns {number}
   */
  get MapYScale() {
    return this._hasMapYScale ? this._MapYScale : JsonToDouble.default;
  }
  get hasMapYScale() {
    return this._hasMapYScale;
  }
  setMapYScale(path, value) {
    return {type: 'SET', path: path.concat(['MapYScale']), value};
  }
  deleteMapYScale(path) {
    return {type: 'DELETE', path: path.concat(['MapYScale'])};
  }
  /**
   * @returns {number}
   */
  get SubdivLevel() {
    return this._hasSubdivLevel ? this._SubdivLevel : JsonToInt32.default;
  }
  get hasSubdivLevel() {
    return this._hasSubdivLevel;
  }
  setSubdivLevel(path, value) {
    return {type: 'SET', path: path.concat(['SubdivLevel']), value};
  }
  deleteSubdivLevel(path) {
    return {type: 'DELETE', path: path.concat(['SubdivLevel'])};
  }
  /**
   * @returns {CtrlPtData[]}
   */
  get CtrlPtsData() {
    return this._CtrlPtsData;
  }
  addCtrlPtsData(path, value) {
    return {type: 'ADD', path: path.concat(['CtrlPtsData']), value: value.toJson()};
  }
  setCtrlPtsData(path, value) {
    return {type: 'SET', path: path.concat(['CtrlPtsData']), value: ArrayToJson(value, CtrlPtData)};
  }
  setCtrlPtsDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['CtrlPtsData', key]), value: value.toJson()};
  }
  deleteCtrlPtsData(path) {
    return {type: 'DELETE', path: path.concat(['CtrlPtsData'])};
  }
  deleteCtrlPtsDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['CtrlPtsData', key])};
  }
  /**
   * @returns {number[]}
   */
  get ClampTileId() {
    return this._ClampTileId;
  }
  addClampTileId(path, value) {
    return {type: 'ADD', path: path.concat(['ClampTileId']), value};
  }
  setClampTileId(path, value) {
    return {type: 'SET', path: path.concat(['ClampTileId']), value: ArrayToJson(value, JsonToInt32)};
  }
  setClampTileIdByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['ClampTileId', key]), value};
  }
  deleteClampTileId(path) {
    return {type: 'DELETE', path: path.concat(['ClampTileId'])};
  }
  deleteClampTileIdByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['ClampTileId', key])};
  }
  /**
   * @returns {ValueTuple2[]}
   */
  get SpecialTileVariations() {
    return this._SpecialTileVariations;
  }
  addSpecialTileVariations(path, value) {
    return {type: 'ADD', path: path.concat(['SpecialTileVariations']), value: value.toJson()};
  }
  setSpecialTileVariations(path, value) {
    return {type: 'SET', path: path.concat(['SpecialTileVariations']), value: ArrayToJson(value, ValueTuple2)};
  }
  setSpecialTileVariationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['SpecialTileVariations', key]), value: value.toJson()};
  }
  deleteSpecialTileVariations(path) {
    return {type: 'DELETE', path: path.concat(['SpecialTileVariations'])};
  }
  deleteSpecialTileVariationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['SpecialTileVariations', key])};
  }
  /**
   * @returns {boolean}
   */
  get DisableBorder() {
    return this._hasDisableBorder ? this._DisableBorder : JsonToBoolean.default;
  }
  get hasDisableBorder() {
    return this._hasDisableBorder;
  }
  setDisableBorder(path, value) {
    return {type: 'SET', path: path.concat(['DisableBorder']), value};
  }
  deleteDisableBorder(path) {
    return {type: 'DELETE', path: path.concat(['DisableBorder'])};
  }
  /**
   * @returns {number}
   */
  get navmeshTileSize() {
    return this._hasNavmeshTileSize ? this._navmeshTileSize : JsonToInt32.default;
  }
  get hasNavmeshTileSize() {
    return this._hasNavmeshTileSize;
  }
  setNavmeshTileSize(path, value) {
    return {type: 'SET', path: path.concat(['navmeshTileSize']), value};
  }
  deleteNavmeshTileSize(path) {
    return {type: 'DELETE', path: path.concat(['navmeshTileSize'])};
  }
  /**
   * @returns {boolean}
   */
  get useGridGraph() {
    return this._hasUseGridGraph ? this._useGridGraph : JsonToBoolean.default;
  }
  get hasUseGridGraph() {
    return this._hasUseGridGraph;
  }
  setUseGridGraph(path, value) {
    return {type: 'SET', path: path.concat(['useGridGraph']), value};
  }
  deleteUseGridGraph(path) {
    return {type: 'DELETE', path: path.concat(['useGridGraph'])};
  }
  /**
   * @returns {number}
   */
  get gridNodeSize() {
    return this._hasGridNodeSize ? this._gridNodeSize : JsonToDouble.default;
  }
  get hasGridNodeSize() {
    return this._hasGridNodeSize;
  }
  setGridNodeSize(path, value) {
    return {type: 'SET', path: path.concat(['gridNodeSize']), value};
  }
  deleteGridNodeSize(path) {
    return {type: 'DELETE', path: path.concat(['gridNodeSize'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "SpListData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._SpListData = [];        for (let i of value) {
                copy._SpListData.push(BezierSplineData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TileMapDataContainer(this);
              copy._SpListData = copy._SpListData.concat([BezierSplineData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._SpListData.length === 0) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._SpListData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._SpListData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._SpListData = copy._SpListData.slice();
              copy._SpListData[path[1]] = BezierSplineData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TileMapDataContainer(this);
              copy._SpListData = copy._SpListData.slice(0, path[1]).concat(copy._SpListData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._SpListData.length) {
            return this;
          }
          const oldValue = this._SpListData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TileMapDataContainer(this);
          copy._SpListData = copy._SpListData.slice();
          copy._SpListData[key] = newValue;
          return copy;
        }
      }
      case "MapWidth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasMapWidth = true;
              copy._MapWidth = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapWidth) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasMapWidth = false;
              copy._MapWidth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "MapHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasMapHeight = true;
              copy._MapHeight = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapHeight) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasMapHeight = false;
              copy._MapHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "TileSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasTileSize = true;
              copy._TileSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileSize) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasTileSize = false;
              copy._TileSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "MapYScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasMapYScale = true;
              copy._MapYScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapYScale) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasMapYScale = false;
              copy._MapYScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SubdivLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasSubdivLevel = true;
              copy._SubdivLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSubdivLevel) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasSubdivLevel = false;
              copy._SubdivLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "CtrlPtsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._CtrlPtsData = [];        for (let i of value) {
                copy._CtrlPtsData.push(CtrlPtData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TileMapDataContainer(this);
              copy._CtrlPtsData = copy._CtrlPtsData.concat([CtrlPtData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._CtrlPtsData.length === 0) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._CtrlPtsData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._CtrlPtsData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._CtrlPtsData = copy._CtrlPtsData.slice();
              copy._CtrlPtsData[path[1]] = CtrlPtData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TileMapDataContainer(this);
              copy._CtrlPtsData = copy._CtrlPtsData.slice(0, path[1]).concat(copy._CtrlPtsData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._CtrlPtsData.length) {
            return this;
          }
          const oldValue = this._CtrlPtsData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TileMapDataContainer(this);
          copy._CtrlPtsData = copy._CtrlPtsData.slice();
          copy._CtrlPtsData[key] = newValue;
          return copy;
        }
      }
      case "ClampTileId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._ClampTileId = [];        for (let i of value) {
                copy._ClampTileId.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TileMapDataContainer(this);
              copy._ClampTileId = copy._ClampTileId.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._ClampTileId.length === 0) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._ClampTileId = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._ClampTileId.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._ClampTileId = copy._ClampTileId.slice();
              copy._ClampTileId[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TileMapDataContainer(this);
              copy._ClampTileId = copy._ClampTileId.slice(0, path[1]).concat(copy._ClampTileId.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._ClampTileId.length) {
            return this;
          }
          const oldValue = this._ClampTileId[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TileMapDataContainer(this);
          copy._ClampTileId = copy._ClampTileId.slice();
          copy._ClampTileId[key] = newValue;
          return copy;
        }
      }
      case "SpecialTileVariations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._SpecialTileVariations = [];        for (let i of value) {
                copy._SpecialTileVariations.push(ValueTuple2.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TileMapDataContainer(this);
              copy._SpecialTileVariations = copy._SpecialTileVariations.concat([ValueTuple2.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._SpecialTileVariations.length === 0) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._SpecialTileVariations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._SpecialTileVariations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._SpecialTileVariations = copy._SpecialTileVariations.slice();
              copy._SpecialTileVariations[path[1]] = ValueTuple2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TileMapDataContainer(this);
              copy._SpecialTileVariations = copy._SpecialTileVariations.slice(0, path[1]).concat(copy._SpecialTileVariations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._SpecialTileVariations.length) {
            return this;
          }
          const oldValue = this._SpecialTileVariations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TileMapDataContainer(this);
          copy._SpecialTileVariations = copy._SpecialTileVariations.slice();
          copy._SpecialTileVariations[key] = newValue;
          return copy;
        }
      }
      case "DisableBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasDisableBorder = true;
              copy._DisableBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableBorder) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasDisableBorder = false;
              copy._DisableBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "navmeshTileSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasNavmeshTileSize = true;
              copy._navmeshTileSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavmeshTileSize) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasNavmeshTileSize = false;
              copy._navmeshTileSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useGridGraph": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasUseGridGraph = true;
              copy._useGridGraph = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseGridGraph) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasUseGridGraph = false;
              copy._useGridGraph = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gridNodeSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileMapDataContainer(this);
              copy._hasGridNodeSize = true;
              copy._gridNodeSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGridNodeSize) {
                return this;
              }
              const copy = new TileMapDataContainer(this);
              copy._hasGridNodeSize = false;
              copy._gridNodeSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TileMapDataContainer} other
   * @returns {TileMapDataContainer}
   */
  merge(other) {
    const copy = new TileMapDataContainer(this);
    copy._SpListData = this._SpListData.concat(other._SpListData);
    if (other._hasMapWidth) {
      copy._hasMapWidth = true;
      copy._MapWidth = other._MapWidth;
    }
    if (other._hasMapHeight) {
      copy._hasMapHeight = true;
      copy._MapHeight = other._MapHeight;
    }
    if (other._hasTileSize) {
      copy._hasTileSize = true;
      copy._TileSize = other._TileSize;
    }
    if (other._hasMapYScale) {
      copy._hasMapYScale = true;
      copy._MapYScale = other._MapYScale;
    }
    if (other._hasSubdivLevel) {
      copy._hasSubdivLevel = true;
      copy._SubdivLevel = other._SubdivLevel;
    }
    copy._CtrlPtsData = this._CtrlPtsData.concat(other._CtrlPtsData);
    copy._ClampTileId = this._ClampTileId.concat(other._ClampTileId);
    copy._SpecialTileVariations = this._SpecialTileVariations.concat(other._SpecialTileVariations);
    if (other._hasDisableBorder) {
      copy._hasDisableBorder = true;
      copy._DisableBorder = other._DisableBorder;
    }
    if (other._hasNavmeshTileSize) {
      copy._hasNavmeshTileSize = true;
      copy._navmeshTileSize = other._navmeshTileSize;
    }
    if (other._hasUseGridGraph) {
      copy._hasUseGridGraph = true;
      copy._useGridGraph = other._useGridGraph;
    }
    if (other._hasGridNodeSize) {
      copy._hasGridNodeSize = true;
      copy._gridNodeSize = other._gridNodeSize;
    }
    return copy;
  }
}
TileMapDataContainer.default = new TileMapDataContainer();
class TileMapDataContainer_Builder {
  constructor(value) {
    this._value = new TileMapDataContainer(value);
  }
  build() {
    return new TileMapDataContainer(this._value);
  }
  addAllSpListData(values) {
    this._value._SpListData = this._value._SpListData.concat(values);
    return this;
  }
  addSpListData(value) {
    this._value._SpListData = this._value._SpListData.concat([value]);
    return this;
  }
  setSpListData(index, value) {
    this._value._SpListData = this._value._SpListData.concat();
    this._value._SpListData[index] = value;
    return this;
  }
  clearSpListData() {
    this._value._SpListData = [];
    return this;
  }
  setMapWidth(value) {
    this._value._hasMapWidth = true;
    this._value._MapWidth = value;
    return this;
  }
  deleteMapWidth() {
    this._value._hasMapWidth = false;
    this._value._MapWidth = null;
    return this;
  }
  setMapHeight(value) {
    this._value._hasMapHeight = true;
    this._value._MapHeight = value;
    return this;
  }
  deleteMapHeight() {
    this._value._hasMapHeight = false;
    this._value._MapHeight = null;
    return this;
  }
  setTileSize(value) {
    this._value._hasTileSize = true;
    this._value._TileSize = value;
    return this;
  }
  deleteTileSize() {
    this._value._hasTileSize = false;
    this._value._TileSize = null;
    return this;
  }
  setMapYScale(value) {
    this._value._hasMapYScale = true;
    this._value._MapYScale = value;
    return this;
  }
  deleteMapYScale() {
    this._value._hasMapYScale = false;
    this._value._MapYScale = null;
    return this;
  }
  setSubdivLevel(value) {
    this._value._hasSubdivLevel = true;
    this._value._SubdivLevel = value;
    return this;
  }
  deleteSubdivLevel() {
    this._value._hasSubdivLevel = false;
    this._value._SubdivLevel = null;
    return this;
  }
  addAllCtrlPtsData(values) {
    this._value._CtrlPtsData = this._value._CtrlPtsData.concat(values);
    return this;
  }
  addCtrlPtsData(value) {
    this._value._CtrlPtsData = this._value._CtrlPtsData.concat([value]);
    return this;
  }
  setCtrlPtsData(index, value) {
    this._value._CtrlPtsData = this._value._CtrlPtsData.concat();
    this._value._CtrlPtsData[index] = value;
    return this;
  }
  clearCtrlPtsData() {
    this._value._CtrlPtsData = [];
    return this;
  }
  addAllClampTileId(values) {
    this._value._ClampTileId = this._value._ClampTileId.concat(values);
    return this;
  }
  addClampTileId(value) {
    this._value._ClampTileId = this._value._ClampTileId.concat([value]);
    return this;
  }
  setClampTileId(index, value) {
    this._value._ClampTileId = this._value._ClampTileId.concat();
    this._value._ClampTileId[index] = value;
    return this;
  }
  clearClampTileId() {
    this._value._ClampTileId = [];
    return this;
  }
  addAllSpecialTileVariations(values) {
    this._value._SpecialTileVariations = this._value._SpecialTileVariations.concat(values);
    return this;
  }
  addSpecialTileVariations(value) {
    this._value._SpecialTileVariations = this._value._SpecialTileVariations.concat([value]);
    return this;
  }
  setSpecialTileVariations(index, value) {
    this._value._SpecialTileVariations = this._value._SpecialTileVariations.concat();
    this._value._SpecialTileVariations[index] = value;
    return this;
  }
  clearSpecialTileVariations() {
    this._value._SpecialTileVariations = [];
    return this;
  }
  setDisableBorder(value) {
    this._value._hasDisableBorder = true;
    this._value._DisableBorder = value;
    return this;
  }
  deleteDisableBorder() {
    this._value._hasDisableBorder = false;
    this._value._DisableBorder = null;
    return this;
  }
  setNavmeshTileSize(value) {
    this._value._hasNavmeshTileSize = true;
    this._value._navmeshTileSize = value;
    return this;
  }
  deleteNavmeshTileSize() {
    this._value._hasNavmeshTileSize = false;
    this._value._navmeshTileSize = null;
    return this;
  }
  setUseGridGraph(value) {
    this._value._hasUseGridGraph = true;
    this._value._useGridGraph = value;
    return this;
  }
  deleteUseGridGraph() {
    this._value._hasUseGridGraph = false;
    this._value._useGridGraph = null;
    return this;
  }
  setGridNodeSize(value) {
    this._value._hasGridNodeSize = true;
    this._value._gridNodeSize = value;
    return this;
  }
  deleteGridNodeSize() {
    this._value._hasGridNodeSize = false;
    this._value._gridNodeSize = null;
    return this;
  }
}
TileMapDataContainer.Builder = TileMapDataContainer_Builder;
class TileMapDataContainer_WithParent {
  /**
   * @param {TileMapDataContainer} value
   * @param {TileMapDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TileMapDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfSpListData() {
    if (!this._selfSpListData) {
      this._selfSpListData = [];
      for (let i of this._value.SpListData) {
        this._selfSpListData.push(new BezierSplineData.WithParent(i, null));
      }
    }
    return this._selfSpListData;
  }
  get inherentSpListData() {
    if (!this._inherentSpListData) {
      this._inherentSpListData = this._parent ? this._parent.SpListData : [];
    }
    return this._inherentSpListData;
  }
  get SpListData() {
    if (!this._allSpListData) {
      this._allSpListData = this._parent ? this._parent.SpListData.concat(this.selfSpListData) : this.selfSpListData;
    }
    return this._allSpListData;
  }
  get hasMapWidth() {
    if (this._cachedHasMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedHasMapWidth = true;
      } else {
        this._cachedHasMapWidth = this._parent ? this._parent.hasMapWidth : false;
      }
    }
    return this._cachedHasMapWidth;
  }
  get MapWidth() {
    if (this._cachedMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedMapWidth = this._value.MapWidth;
      } else {
        this._cachedMapWidth = this._parent ? this._parent.MapWidth : this._value.MapWidth;
      }
    }
    return this._cachedMapWidth;
  }
  get hasMapHeight() {
    if (this._cachedHasMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedHasMapHeight = true;
      } else {
        this._cachedHasMapHeight = this._parent ? this._parent.hasMapHeight : false;
      }
    }
    return this._cachedHasMapHeight;
  }
  get MapHeight() {
    if (this._cachedMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedMapHeight = this._value.MapHeight;
      } else {
        this._cachedMapHeight = this._parent ? this._parent.MapHeight : this._value.MapHeight;
      }
    }
    return this._cachedMapHeight;
  }
  get hasTileSize() {
    if (this._cachedHasTileSize === undefined) {
      if (this._value.hasTileSize) {
        this._cachedHasTileSize = true;
      } else {
        this._cachedHasTileSize = this._parent ? this._parent.hasTileSize : false;
      }
    }
    return this._cachedHasTileSize;
  }
  get TileSize() {
    if (this._cachedTileSize === undefined) {
      if (this._value.hasTileSize) {
        this._cachedTileSize = this._value.TileSize;
      } else {
        this._cachedTileSize = this._parent ? this._parent.TileSize : this._value.TileSize;
      }
    }
    return this._cachedTileSize;
  }
  get hasMapYScale() {
    if (this._cachedHasMapYScale === undefined) {
      if (this._value.hasMapYScale) {
        this._cachedHasMapYScale = true;
      } else {
        this._cachedHasMapYScale = this._parent ? this._parent.hasMapYScale : false;
      }
    }
    return this._cachedHasMapYScale;
  }
  get MapYScale() {
    if (this._cachedMapYScale === undefined) {
      if (this._value.hasMapYScale) {
        this._cachedMapYScale = this._value.MapYScale;
      } else {
        this._cachedMapYScale = this._parent ? this._parent.MapYScale : this._value.MapYScale;
      }
    }
    return this._cachedMapYScale;
  }
  get hasSubdivLevel() {
    if (this._cachedHasSubdivLevel === undefined) {
      if (this._value.hasSubdivLevel) {
        this._cachedHasSubdivLevel = true;
      } else {
        this._cachedHasSubdivLevel = this._parent ? this._parent.hasSubdivLevel : false;
      }
    }
    return this._cachedHasSubdivLevel;
  }
  get SubdivLevel() {
    if (this._cachedSubdivLevel === undefined) {
      if (this._value.hasSubdivLevel) {
        this._cachedSubdivLevel = this._value.SubdivLevel;
      } else {
        this._cachedSubdivLevel = this._parent ? this._parent.SubdivLevel : this._value.SubdivLevel;
      }
    }
    return this._cachedSubdivLevel;
  }
  get selfCtrlPtsData() {
    if (!this._selfCtrlPtsData) {
      this._selfCtrlPtsData = [];
      for (let i of this._value.CtrlPtsData) {
        this._selfCtrlPtsData.push(new CtrlPtData.WithParent(i, null));
      }
    }
    return this._selfCtrlPtsData;
  }
  get inherentCtrlPtsData() {
    if (!this._inherentCtrlPtsData) {
      this._inherentCtrlPtsData = this._parent ? this._parent.CtrlPtsData : [];
    }
    return this._inherentCtrlPtsData;
  }
  get CtrlPtsData() {
    if (!this._allCtrlPtsData) {
      this._allCtrlPtsData = this._parent ? this._parent.CtrlPtsData.concat(this.selfCtrlPtsData) : this.selfCtrlPtsData;
    }
    return this._allCtrlPtsData;
  }
  get selfClampTileId() {
    return this._value.ClampTileId;
  }
  get inherentClampTileId() {
    if (!this._inherentClampTileId) {
      this._inherentClampTileId = this._parent ? this._parent.ClampTileId : [];
    }
    return this._inherentClampTileId;
  }
  get ClampTileId() {
    if (!this._allClampTileId) {
      this._allClampTileId = this._parent ? this._parent.ClampTileId.concat(this.selfClampTileId) : this.selfClampTileId;
    }
    return this._allClampTileId;
  }
  get selfSpecialTileVariations() {
    if (!this._selfSpecialTileVariations) {
      this._selfSpecialTileVariations = [];
      for (let i of this._value.SpecialTileVariations) {
        this._selfSpecialTileVariations.push(new ValueTuple2.WithParent(i, null));
      }
    }
    return this._selfSpecialTileVariations;
  }
  get inherentSpecialTileVariations() {
    if (!this._inherentSpecialTileVariations) {
      this._inherentSpecialTileVariations = this._parent ? this._parent.SpecialTileVariations : [];
    }
    return this._inherentSpecialTileVariations;
  }
  get SpecialTileVariations() {
    if (!this._allSpecialTileVariations) {
      this._allSpecialTileVariations = this._parent ? this._parent.SpecialTileVariations.concat(this.selfSpecialTileVariations) : this.selfSpecialTileVariations;
    }
    return this._allSpecialTileVariations;
  }
  get hasDisableBorder() {
    if (this._cachedHasDisableBorder === undefined) {
      if (this._value.hasDisableBorder) {
        this._cachedHasDisableBorder = true;
      } else {
        this._cachedHasDisableBorder = this._parent ? this._parent.hasDisableBorder : false;
      }
    }
    return this._cachedHasDisableBorder;
  }
  get DisableBorder() {
    if (this._cachedDisableBorder === undefined) {
      if (this._value.hasDisableBorder) {
        this._cachedDisableBorder = this._value.DisableBorder;
      } else {
        this._cachedDisableBorder = this._parent ? this._parent.DisableBorder : this._value.DisableBorder;
      }
    }
    return this._cachedDisableBorder;
  }
  get hasNavmeshTileSize() {
    if (this._cachedHasNavmeshTileSize === undefined) {
      if (this._value.hasNavmeshTileSize) {
        this._cachedHasNavmeshTileSize = true;
      } else {
        this._cachedHasNavmeshTileSize = this._parent ? this._parent.hasNavmeshTileSize : false;
      }
    }
    return this._cachedHasNavmeshTileSize;
  }
  get navmeshTileSize() {
    if (this._cachedNavmeshTileSize === undefined) {
      if (this._value.hasNavmeshTileSize) {
        this._cachedNavmeshTileSize = this._value.navmeshTileSize;
      } else {
        this._cachedNavmeshTileSize = this._parent ? this._parent.navmeshTileSize : this._value.navmeshTileSize;
      }
    }
    return this._cachedNavmeshTileSize;
  }
  get hasUseGridGraph() {
    if (this._cachedHasUseGridGraph === undefined) {
      if (this._value.hasUseGridGraph) {
        this._cachedHasUseGridGraph = true;
      } else {
        this._cachedHasUseGridGraph = this._parent ? this._parent.hasUseGridGraph : false;
      }
    }
    return this._cachedHasUseGridGraph;
  }
  get useGridGraph() {
    if (this._cachedUseGridGraph === undefined) {
      if (this._value.hasUseGridGraph) {
        this._cachedUseGridGraph = this._value.useGridGraph;
      } else {
        this._cachedUseGridGraph = this._parent ? this._parent.useGridGraph : this._value.useGridGraph;
      }
    }
    return this._cachedUseGridGraph;
  }
  get hasGridNodeSize() {
    if (this._cachedHasGridNodeSize === undefined) {
      if (this._value.hasGridNodeSize) {
        this._cachedHasGridNodeSize = true;
      } else {
        this._cachedHasGridNodeSize = this._parent ? this._parent.hasGridNodeSize : false;
      }
    }
    return this._cachedHasGridNodeSize;
  }
  get gridNodeSize() {
    if (this._cachedGridNodeSize === undefined) {
      if (this._value.hasGridNodeSize) {
        this._cachedGridNodeSize = this._value.gridNodeSize;
      } else {
        this._cachedGridNodeSize = this._parent ? this._parent.gridNodeSize : this._value.gridNodeSize;
      }
    }
    return this._cachedGridNodeSize;
  }
  update(current, parent) {
    const result = new TileMapDataContainer_WithParent(current, parent);
    if (this._selfSpListData) {
      if (this._value.SpListData === current.SpListData) {
        result._selfSpListData = this._selfSpListData;
      } else {
        result._selfSpListData = [];
        for (let i = 0; i < current.SpListData.length; i++) {
          const oldValue = this._value.SpListData[i];
          if (oldValue) {
            const oldCache = this._selfSpListData[i];
            if (oldValue === current.SpListData[i]) {
              result._selfSpListData[i] = oldCache;
            } else {
              result._selfSpListData[i] = oldCache.update(current.SpListData[i], null);
            }
          } else {
            result._selfSpListData[i] = new BezierSplineData.WithParent(current.SpListData[i], null);
          }
        }
      }
    }
    if (this._selfCtrlPtsData) {
      if (this._value.CtrlPtsData === current.CtrlPtsData) {
        result._selfCtrlPtsData = this._selfCtrlPtsData;
      } else {
        result._selfCtrlPtsData = [];
        for (let i = 0; i < current.CtrlPtsData.length; i++) {
          const oldValue = this._value.CtrlPtsData[i];
          if (oldValue) {
            const oldCache = this._selfCtrlPtsData[i];
            if (oldValue === current.CtrlPtsData[i]) {
              result._selfCtrlPtsData[i] = oldCache;
            } else {
              result._selfCtrlPtsData[i] = oldCache.update(current.CtrlPtsData[i], null);
            }
          } else {
            result._selfCtrlPtsData[i] = new CtrlPtData.WithParent(current.CtrlPtsData[i], null);
          }
        }
      }
    }
    if (this._selfSpecialTileVariations) {
      if (this._value.SpecialTileVariations === current.SpecialTileVariations) {
        result._selfSpecialTileVariations = this._selfSpecialTileVariations;
      } else {
        result._selfSpecialTileVariations = [];
        for (let i = 0; i < current.SpecialTileVariations.length; i++) {
          const oldValue = this._value.SpecialTileVariations[i];
          if (oldValue) {
            const oldCache = this._selfSpecialTileVariations[i];
            if (oldValue === current.SpecialTileVariations[i]) {
              result._selfSpecialTileVariations[i] = oldCache;
            } else {
              result._selfSpecialTileVariations[i] = oldCache.update(current.SpecialTileVariations[i], null);
            }
          } else {
            result._selfSpecialTileVariations[i] = new ValueTuple2.WithParent(current.SpecialTileVariations[i], null);
          }
        }
      }
    }
    return result;
  }
}
TileMapDataContainer_WithParent.default = new TileMapDataContainer_WithParent(TileMapDataContainer.default, null);
TileMapDataContainer.WithParent = TileMapDataContainer_WithParent;
class TileMapDataContainer_Descriptor {
  get SpListData() {
    if (!this._SpListData) {
      this._SpListData = {
        name: "SpListData",
        Name: "SpListData",
        number: 1,
        protoType: 11,
        protoName: "SpListData",
        type: BezierSplineData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SpListData;
  }
  get MapWidth() {
    if (!this._MapWidth) {
      this._MapWidth = {
        name: "MapWidth",
        Name: "MapWidth",
        number: 2,
        protoType: 5,
        protoName: "MapWidth",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._MapWidth;
  }
  get MapHeight() {
    if (!this._MapHeight) {
      this._MapHeight = {
        name: "MapHeight",
        Name: "MapHeight",
        number: 3,
        protoType: 5,
        protoName: "MapHeight",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._MapHeight;
  }
  get TileSize() {
    if (!this._TileSize) {
      this._TileSize = {
        name: "TileSize",
        Name: "TileSize",
        number: 4,
        protoType: 1,
        protoName: "TileSize",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileSize;
  }
  get MapYScale() {
    if (!this._MapYScale) {
      this._MapYScale = {
        name: "MapYScale",
        Name: "MapYScale",
        number: 5,
        protoType: 1,
        protoName: "MapYScale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._MapYScale;
  }
  get SubdivLevel() {
    if (!this._SubdivLevel) {
      this._SubdivLevel = {
        name: "SubdivLevel",
        Name: "SubdivLevel",
        number: 6,
        protoType: 5,
        protoName: "SubdivLevel",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SubdivLevel;
  }
  get CtrlPtsData() {
    if (!this._CtrlPtsData) {
      this._CtrlPtsData = {
        name: "CtrlPtsData",
        Name: "CtrlPtsData",
        number: 7,
        protoType: 11,
        protoName: "CtrlPtsData",
        type: CtrlPtData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._CtrlPtsData;
  }
  get ClampTileId() {
    if (!this._ClampTileId) {
      this._ClampTileId = {
        name: "ClampTileId",
        Name: "ClampTileId",
        number: 8,
        protoType: 5,
        protoName: "ClampTileId",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ClampTileId;
  }
  get SpecialTileVariations() {
    if (!this._SpecialTileVariations) {
      this._SpecialTileVariations = {
        name: "SpecialTileVariations",
        Name: "SpecialTileVariations",
        number: 9,
        protoType: 11,
        protoName: "SpecialTileVariations",
        type: ValueTuple2,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SpecialTileVariations;
  }
  get DisableBorder() {
    if (!this._DisableBorder) {
      this._DisableBorder = {
        name: "DisableBorder",
        Name: "DisableBorder",
        number: 10,
        protoType: 8,
        protoName: "DisableBorder",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._DisableBorder;
  }
  get navmeshTileSize() {
    if (!this._navmeshTileSize) {
      this._navmeshTileSize = {
        name: "navmeshTileSize",
        Name: "NavmeshTileSize",
        number: 11,
        protoType: 5,
        protoName: "navmeshTileSize",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navmeshTileSize;
  }
  get useGridGraph() {
    if (!this._useGridGraph) {
      this._useGridGraph = {
        name: "useGridGraph",
        Name: "UseGridGraph",
        number: 12,
        protoType: 8,
        protoName: "useGridGraph",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useGridGraph;
  }
  get gridNodeSize() {
    if (!this._gridNodeSize) {
      this._gridNodeSize = {
        name: "gridNodeSize",
        Name: "GridNodeSize",
        number: 13,
        protoType: 1,
        protoName: "gridNodeSize",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gridNodeSize;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.SpListData,
        this.MapWidth,
        this.MapHeight,
        this.TileSize,
        this.MapYScale,
        this.SubdivLevel,
        this.CtrlPtsData,
        this.ClampTileId,
        this.SpecialTileVariations,
        this.DisableBorder,
        this.navmeshTileSize,
        this.useGridGraph,
        this.gridNodeSize,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapWidth",
        Name: "DummyOneofForMapWidth",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapHeight",
        Name: "DummyOneofForMapHeight",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileSize",
        Name: "DummyOneofForTileSize",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapYScale",
        Name: "DummyOneofForMapYScale",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSubdivLevel",
        Name: "DummyOneofForSubdivLevel",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableBorder",
        Name: "DummyOneofForDisableBorder",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNavmeshTileSize",
        Name: "DummyOneofForNavmeshTileSize",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseGridGraph",
        Name: "DummyOneofForUseGridGraph",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGridNodeSize",
        Name: "DummyOneofForGridNodeSize",
        fields: [
          this.fields[12],
        ],
      });
    }
    return this._oneofs;
  }
}
TileMapDataContainer.descriptor = new TileMapDataContainer_Descriptor();
export class BezierSplineData {
  get descriptor() {
    return BezierSplineData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._EndPoints = [];
  }
  isEmpty() {
    if (this._EndPoints.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BezierSplineData) {
      return value;
    }
    return BezierSplineData.fromJson(value);
  }
  static fromJson(json) {
    const result = new BezierSplineData();
    result._EndPoints = JsonToList(json.EndPoints, BezierPointData);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._EndPoints.length > 0) {
      result.EndPoints = ArrayToJson(this._EndPoints, BezierPointData);
    }
    return result;
  }
  /**
   * @returns {BezierPointData[]}
   */
  get EndPoints() {
    return this._EndPoints;
  }
  addEndPoints(path, value) {
    return {type: 'ADD', path: path.concat(['EndPoints']), value: value.toJson()};
  }
  setEndPoints(path, value) {
    return {type: 'SET', path: path.concat(['EndPoints']), value: ArrayToJson(value, BezierPointData)};
  }
  setEndPointsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['EndPoints', key]), value: value.toJson()};
  }
  deleteEndPoints(path) {
    return {type: 'DELETE', path: path.concat(['EndPoints'])};
  }
  deleteEndPointsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['EndPoints', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "EndPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierSplineData(this);
              copy._EndPoints = [];        for (let i of value) {
                copy._EndPoints.push(BezierPointData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BezierSplineData(this);
              copy._EndPoints = copy._EndPoints.concat([BezierPointData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._EndPoints.length === 0) {
                return this;
              }
              const copy = new BezierSplineData(this);
              copy._EndPoints = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._EndPoints.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BezierSplineData(this);
              copy._EndPoints = copy._EndPoints.slice();
              copy._EndPoints[path[1]] = BezierPointData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BezierSplineData(this);
              copy._EndPoints = copy._EndPoints.slice(0, path[1]).concat(copy._EndPoints.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._EndPoints.length) {
            return this;
          }
          const oldValue = this._EndPoints[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BezierSplineData(this);
          copy._EndPoints = copy._EndPoints.slice();
          copy._EndPoints[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BezierSplineData} other
   * @returns {BezierSplineData}
   */
  merge(other) {
    const copy = new BezierSplineData(this);
    copy._EndPoints = this._EndPoints.concat(other._EndPoints);
    return copy;
  }
}
BezierSplineData.default = new BezierSplineData();
class BezierSplineData_Builder {
  constructor(value) {
    this._value = new BezierSplineData(value);
  }
  build() {
    return new BezierSplineData(this._value);
  }
  addAllEndPoints(values) {
    this._value._EndPoints = this._value._EndPoints.concat(values);
    return this;
  }
  addEndPoints(value) {
    this._value._EndPoints = this._value._EndPoints.concat([value]);
    return this;
  }
  setEndPoints(index, value) {
    this._value._EndPoints = this._value._EndPoints.concat();
    this._value._EndPoints[index] = value;
    return this;
  }
  clearEndPoints() {
    this._value._EndPoints = [];
    return this;
  }
}
BezierSplineData.Builder = BezierSplineData_Builder;
class BezierSplineData_WithParent {
  /**
   * @param {BezierSplineData} value
   * @param {BezierSplineData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BezierSplineData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfEndPoints() {
    if (!this._selfEndPoints) {
      this._selfEndPoints = [];
      for (let i of this._value.EndPoints) {
        this._selfEndPoints.push(new BezierPointData.WithParent(i, null));
      }
    }
    return this._selfEndPoints;
  }
  get inherentEndPoints() {
    if (!this._inherentEndPoints) {
      this._inherentEndPoints = this._parent ? this._parent.EndPoints : [];
    }
    return this._inherentEndPoints;
  }
  get EndPoints() {
    if (!this._allEndPoints) {
      this._allEndPoints = this._parent ? this._parent.EndPoints.concat(this.selfEndPoints) : this.selfEndPoints;
    }
    return this._allEndPoints;
  }
  update(current, parent) {
    const result = new BezierSplineData_WithParent(current, parent);
    if (this._selfEndPoints) {
      if (this._value.EndPoints === current.EndPoints) {
        result._selfEndPoints = this._selfEndPoints;
      } else {
        result._selfEndPoints = [];
        for (let i = 0; i < current.EndPoints.length; i++) {
          const oldValue = this._value.EndPoints[i];
          if (oldValue) {
            const oldCache = this._selfEndPoints[i];
            if (oldValue === current.EndPoints[i]) {
              result._selfEndPoints[i] = oldCache;
            } else {
              result._selfEndPoints[i] = oldCache.update(current.EndPoints[i], null);
            }
          } else {
            result._selfEndPoints[i] = new BezierPointData.WithParent(current.EndPoints[i], null);
          }
        }
      }
    }
    return result;
  }
}
BezierSplineData_WithParent.default = new BezierSplineData_WithParent(BezierSplineData.default, null);
BezierSplineData.WithParent = BezierSplineData_WithParent;
class BezierSplineData_Descriptor {
  get EndPoints() {
    if (!this._EndPoints) {
      this._EndPoints = {
        name: "EndPoints",
        Name: "EndPoints",
        number: 1,
        protoType: 11,
        protoName: "EndPoints",
        type: BezierPointData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._EndPoints;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.EndPoints,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
BezierSplineData.descriptor = new BezierSplineData_Descriptor();
export class BezierPointData {
  get descriptor() {
    return BezierPointData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLocalPosition = false;
    this._LocalPosition = null;
    this._hasLocalRotation = false;
    this._LocalRotation = null;
    this._hasLocalScale = false;
    this._LocalScale = null;
    this._hasHandleMode = false;
    this._HandleMode = null;
    this._hasPrecedingControlPointLocalPosition = false;
    this._PrecedingControlPointLocalPosition = null;
    this._hasFollowingControlPointLocalPosition = false;
    this._FollowingControlPointLocalPosition = null;
  }
  isEmpty() {
    if (this._hasLocalPosition && !this._LocalPosition.isEmpty()) return false;
    if (this._hasLocalRotation && !this._LocalRotation.isEmpty()) return false;
    if (this._hasLocalScale && !this._LocalScale.isEmpty()) return false;
    if (this._hasHandleMode) return false;
    if (this._hasPrecedingControlPointLocalPosition && !this._PrecedingControlPointLocalPosition.isEmpty()) return false;
    if (this._hasFollowingControlPointLocalPosition && !this._FollowingControlPointLocalPosition.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BezierPointData) {
      return value;
    }
    return BezierPointData.fromJson(value);
  }
  static fromJson(json) {
    const result = new BezierPointData();
    if (json.LocalPosition != null) {
      result._hasLocalPosition = true;
      result._LocalPosition = FVector3.fromJson(json.LocalPosition);
    }
    if (json.LocalRotation != null) {
      result._hasLocalRotation = true;
      result._LocalRotation = FVector4.fromJson(json.LocalRotation);
    }
    if (json.LocalScale != null) {
      result._hasLocalScale = true;
      result._LocalScale = FVector3.fromJson(json.LocalScale);
    }
    if (json.HandleMode != null) {
      result._hasHandleMode = true;
      result._HandleMode = JsonToInt32.fromJson(json.HandleMode);
    }
    if (json.PrecedingControlPointLocalPosition != null) {
      result._hasPrecedingControlPointLocalPosition = true;
      result._PrecedingControlPointLocalPosition = FVector3.fromJson(json.PrecedingControlPointLocalPosition);
    }
    if (json.FollowingControlPointLocalPosition != null) {
      result._hasFollowingControlPointLocalPosition = true;
      result._FollowingControlPointLocalPosition = FVector3.fromJson(json.FollowingControlPointLocalPosition);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLocalPosition && !this._LocalPosition.isEmpty()) {
      result.LocalPosition = FVector3.toJson(this._LocalPosition);
    }
    if (this._hasLocalRotation && !this._LocalRotation.isEmpty()) {
      result.LocalRotation = FVector4.toJson(this._LocalRotation);
    }
    if (this._hasLocalScale && !this._LocalScale.isEmpty()) {
      result.LocalScale = FVector3.toJson(this._LocalScale);
    }
    if (this._hasHandleMode) {
      result.HandleMode = JsonToInt32.toJson(this._HandleMode);
    }
    if (this._hasPrecedingControlPointLocalPosition && !this._PrecedingControlPointLocalPosition.isEmpty()) {
      result.PrecedingControlPointLocalPosition = FVector3.toJson(this._PrecedingControlPointLocalPosition);
    }
    if (this._hasFollowingControlPointLocalPosition && !this._FollowingControlPointLocalPosition.isEmpty()) {
      result.FollowingControlPointLocalPosition = FVector3.toJson(this._FollowingControlPointLocalPosition);
    }
    return result;
  }
  /**
   * @returns {FVector3}
   */
  get LocalPosition() {
    return this._hasLocalPosition ? this._LocalPosition : FVector3.default;
  }
  get hasLocalPosition() {
    return this._hasLocalPosition;
  }
  setLocalPosition(path, value) {
    return {type: 'SET', path: path.concat(['LocalPosition']), value: value.toJson()};
  }
  deleteLocalPosition(path) {
    return {type: 'DELETE', path: path.concat(['LocalPosition'])};
  }
  /**
   * @returns {FVector4}
   */
  get LocalRotation() {
    return this._hasLocalRotation ? this._LocalRotation : FVector4.default;
  }
  get hasLocalRotation() {
    return this._hasLocalRotation;
  }
  setLocalRotation(path, value) {
    return {type: 'SET', path: path.concat(['LocalRotation']), value: value.toJson()};
  }
  deleteLocalRotation(path) {
    return {type: 'DELETE', path: path.concat(['LocalRotation'])};
  }
  /**
   * @returns {FVector3}
   */
  get LocalScale() {
    return this._hasLocalScale ? this._LocalScale : FVector3.default;
  }
  get hasLocalScale() {
    return this._hasLocalScale;
  }
  setLocalScale(path, value) {
    return {type: 'SET', path: path.concat(['LocalScale']), value: value.toJson()};
  }
  deleteLocalScale(path) {
    return {type: 'DELETE', path: path.concat(['LocalScale'])};
  }
  /**
   * @returns {number}
   */
  get HandleMode() {
    return this._hasHandleMode ? this._HandleMode : JsonToInt32.default;
  }
  get hasHandleMode() {
    return this._hasHandleMode;
  }
  setHandleMode(path, value) {
    return {type: 'SET', path: path.concat(['HandleMode']), value};
  }
  deleteHandleMode(path) {
    return {type: 'DELETE', path: path.concat(['HandleMode'])};
  }
  /**
   * @returns {FVector3}
   */
  get PrecedingControlPointLocalPosition() {
    return this._hasPrecedingControlPointLocalPosition ? this._PrecedingControlPointLocalPosition : FVector3.default;
  }
  get hasPrecedingControlPointLocalPosition() {
    return this._hasPrecedingControlPointLocalPosition;
  }
  setPrecedingControlPointLocalPosition(path, value) {
    return {type: 'SET', path: path.concat(['PrecedingControlPointLocalPosition']), value: value.toJson()};
  }
  deletePrecedingControlPointLocalPosition(path) {
    return {type: 'DELETE', path: path.concat(['PrecedingControlPointLocalPosition'])};
  }
  /**
   * @returns {FVector3}
   */
  get FollowingControlPointLocalPosition() {
    return this._hasFollowingControlPointLocalPosition ? this._FollowingControlPointLocalPosition : FVector3.default;
  }
  get hasFollowingControlPointLocalPosition() {
    return this._hasFollowingControlPointLocalPosition;
  }
  setFollowingControlPointLocalPosition(path, value) {
    return {type: 'SET', path: path.concat(['FollowingControlPointLocalPosition']), value: value.toJson()};
  }
  deleteFollowingControlPointLocalPosition(path) {
    return {type: 'DELETE', path: path.concat(['FollowingControlPointLocalPosition'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "LocalPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasLocalPosition = true;
              copy._LocalPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocalPosition) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasLocalPosition = false;
              copy._LocalPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLocalPosition) {
            const copy = new BezierPointData(this);
            copy._hasLocalPosition = true;
            copy._LocalPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._LocalPosition.apply(type, path.slice(1), value);
          if (newValue === this._LocalPosition) {
            return this;
          }
          const copy = new BezierPointData(this);
          copy._LocalPosition = copy._LocalPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "LocalRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasLocalRotation = true;
              copy._LocalRotation = FVector4.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocalRotation) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasLocalRotation = false;
              copy._LocalRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLocalRotation) {
            const copy = new BezierPointData(this);
            copy._hasLocalRotation = true;
            copy._LocalRotation = FVector4.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._LocalRotation.apply(type, path.slice(1), value);
          if (newValue === this._LocalRotation) {
            return this;
          }
          const copy = new BezierPointData(this);
          copy._LocalRotation = copy._LocalRotation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "LocalScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasLocalScale = true;
              copy._LocalScale = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLocalScale) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasLocalScale = false;
              copy._LocalScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLocalScale) {
            const copy = new BezierPointData(this);
            copy._hasLocalScale = true;
            copy._LocalScale = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._LocalScale.apply(type, path.slice(1), value);
          if (newValue === this._LocalScale) {
            return this;
          }
          const copy = new BezierPointData(this);
          copy._LocalScale = copy._LocalScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "HandleMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasHandleMode = true;
              copy._HandleMode = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHandleMode) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasHandleMode = false;
              copy._HandleMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "PrecedingControlPointLocalPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasPrecedingControlPointLocalPosition = true;
              copy._PrecedingControlPointLocalPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrecedingControlPointLocalPosition) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasPrecedingControlPointLocalPosition = false;
              copy._PrecedingControlPointLocalPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPrecedingControlPointLocalPosition) {
            const copy = new BezierPointData(this);
            copy._hasPrecedingControlPointLocalPosition = true;
            copy._PrecedingControlPointLocalPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._PrecedingControlPointLocalPosition.apply(type, path.slice(1), value);
          if (newValue === this._PrecedingControlPointLocalPosition) {
            return this;
          }
          const copy = new BezierPointData(this);
          copy._PrecedingControlPointLocalPosition = copy._PrecedingControlPointLocalPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "FollowingControlPointLocalPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BezierPointData(this);
              copy._hasFollowingControlPointLocalPosition = true;
              copy._FollowingControlPointLocalPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFollowingControlPointLocalPosition) {
                return this;
              }
              const copy = new BezierPointData(this);
              copy._hasFollowingControlPointLocalPosition = false;
              copy._FollowingControlPointLocalPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFollowingControlPointLocalPosition) {
            const copy = new BezierPointData(this);
            copy._hasFollowingControlPointLocalPosition = true;
            copy._FollowingControlPointLocalPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._FollowingControlPointLocalPosition.apply(type, path.slice(1), value);
          if (newValue === this._FollowingControlPointLocalPosition) {
            return this;
          }
          const copy = new BezierPointData(this);
          copy._FollowingControlPointLocalPosition = copy._FollowingControlPointLocalPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BezierPointData} other
   * @returns {BezierPointData}
   */
  merge(other) {
    const copy = new BezierPointData(this);
    if (other._hasLocalPosition) {
      if (copy._hasLocalPosition) {
        copy._LocalPosition = copy.LocalPosition.merge(other.LocalPosition);
      } else {
        copy._LocalPosition = other._LocalPosition;
      }
      copy._hasLocalPosition = true;
    }
    if (other._hasLocalRotation) {
      if (copy._hasLocalRotation) {
        copy._LocalRotation = copy.LocalRotation.merge(other.LocalRotation);
      } else {
        copy._LocalRotation = other._LocalRotation;
      }
      copy._hasLocalRotation = true;
    }
    if (other._hasLocalScale) {
      if (copy._hasLocalScale) {
        copy._LocalScale = copy.LocalScale.merge(other.LocalScale);
      } else {
        copy._LocalScale = other._LocalScale;
      }
      copy._hasLocalScale = true;
    }
    if (other._hasHandleMode) {
      copy._hasHandleMode = true;
      copy._HandleMode = other._HandleMode;
    }
    if (other._hasPrecedingControlPointLocalPosition) {
      if (copy._hasPrecedingControlPointLocalPosition) {
        copy._PrecedingControlPointLocalPosition = copy.PrecedingControlPointLocalPosition.merge(other.PrecedingControlPointLocalPosition);
      } else {
        copy._PrecedingControlPointLocalPosition = other._PrecedingControlPointLocalPosition;
      }
      copy._hasPrecedingControlPointLocalPosition = true;
    }
    if (other._hasFollowingControlPointLocalPosition) {
      if (copy._hasFollowingControlPointLocalPosition) {
        copy._FollowingControlPointLocalPosition = copy.FollowingControlPointLocalPosition.merge(other.FollowingControlPointLocalPosition);
      } else {
        copy._FollowingControlPointLocalPosition = other._FollowingControlPointLocalPosition;
      }
      copy._hasFollowingControlPointLocalPosition = true;
    }
    return copy;
  }
}
BezierPointData.default = new BezierPointData();
class BezierPointData_Builder {
  constructor(value) {
    this._value = new BezierPointData(value);
  }
  build() {
    return new BezierPointData(this._value);
  }
  setLocalPosition(value) {
    this._value._hasLocalPosition = true;
    this._value._LocalPosition = value;
    return this;
  }
  deleteLocalPosition() {
    this._value._hasLocalPosition = false;
    this._value._LocalPosition = null;
    return this;
  }
  setLocalRotation(value) {
    this._value._hasLocalRotation = true;
    this._value._LocalRotation = value;
    return this;
  }
  deleteLocalRotation() {
    this._value._hasLocalRotation = false;
    this._value._LocalRotation = null;
    return this;
  }
  setLocalScale(value) {
    this._value._hasLocalScale = true;
    this._value._LocalScale = value;
    return this;
  }
  deleteLocalScale() {
    this._value._hasLocalScale = false;
    this._value._LocalScale = null;
    return this;
  }
  setHandleMode(value) {
    this._value._hasHandleMode = true;
    this._value._HandleMode = value;
    return this;
  }
  deleteHandleMode() {
    this._value._hasHandleMode = false;
    this._value._HandleMode = null;
    return this;
  }
  setPrecedingControlPointLocalPosition(value) {
    this._value._hasPrecedingControlPointLocalPosition = true;
    this._value._PrecedingControlPointLocalPosition = value;
    return this;
  }
  deletePrecedingControlPointLocalPosition() {
    this._value._hasPrecedingControlPointLocalPosition = false;
    this._value._PrecedingControlPointLocalPosition = null;
    return this;
  }
  setFollowingControlPointLocalPosition(value) {
    this._value._hasFollowingControlPointLocalPosition = true;
    this._value._FollowingControlPointLocalPosition = value;
    return this;
  }
  deleteFollowingControlPointLocalPosition() {
    this._value._hasFollowingControlPointLocalPosition = false;
    this._value._FollowingControlPointLocalPosition = null;
    return this;
  }
}
BezierPointData.Builder = BezierPointData_Builder;
class BezierPointData_WithParent {
  /**
   * @param {BezierPointData} value
   * @param {BezierPointData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BezierPointData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLocalPosition() {
    if (this._cachedHasLocalPosition === undefined) {
      if (this._value.hasLocalPosition) {
        this._cachedHasLocalPosition = true;
      } else {
        this._cachedHasLocalPosition = this._parent ? this._parent.hasLocalPosition : false;
      }
    }
    return this._cachedHasLocalPosition;
  }
  get LocalPosition() {
    if (!this._cachedLocalPosition) {
      if (this._value.hasLocalPosition) {
        this._cachedLocalPosition = new FVector3.WithParent(this._value.LocalPosition, this._parent && this._parent.hasLocalPosition ? this._parent.LocalPosition : null);
      } else {
        this._cachedLocalPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.LocalPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedLocalPosition;
  }
  get hasLocalRotation() {
    if (this._cachedHasLocalRotation === undefined) {
      if (this._value.hasLocalRotation) {
        this._cachedHasLocalRotation = true;
      } else {
        this._cachedHasLocalRotation = this._parent ? this._parent.hasLocalRotation : false;
      }
    }
    return this._cachedHasLocalRotation;
  }
  get LocalRotation() {
    if (!this._cachedLocalRotation) {
      if (this._value.hasLocalRotation) {
        this._cachedLocalRotation = new FVector4.WithParent(this._value.LocalRotation, this._parent && this._parent.hasLocalRotation ? this._parent.LocalRotation : null);
      } else {
        this._cachedLocalRotation = this._parent ? new FVector4.WithParent(FVector4.default, this._parent.LocalRotation) : FVector4.WithParent.default;
      }
    }
    return this._cachedLocalRotation;
  }
  get hasLocalScale() {
    if (this._cachedHasLocalScale === undefined) {
      if (this._value.hasLocalScale) {
        this._cachedHasLocalScale = true;
      } else {
        this._cachedHasLocalScale = this._parent ? this._parent.hasLocalScale : false;
      }
    }
    return this._cachedHasLocalScale;
  }
  get LocalScale() {
    if (!this._cachedLocalScale) {
      if (this._value.hasLocalScale) {
        this._cachedLocalScale = new FVector3.WithParent(this._value.LocalScale, this._parent && this._parent.hasLocalScale ? this._parent.LocalScale : null);
      } else {
        this._cachedLocalScale = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.LocalScale) : FVector3.WithParent.default;
      }
    }
    return this._cachedLocalScale;
  }
  get hasHandleMode() {
    if (this._cachedHasHandleMode === undefined) {
      if (this._value.hasHandleMode) {
        this._cachedHasHandleMode = true;
      } else {
        this._cachedHasHandleMode = this._parent ? this._parent.hasHandleMode : false;
      }
    }
    return this._cachedHasHandleMode;
  }
  get HandleMode() {
    if (this._cachedHandleMode === undefined) {
      if (this._value.hasHandleMode) {
        this._cachedHandleMode = this._value.HandleMode;
      } else {
        this._cachedHandleMode = this._parent ? this._parent.HandleMode : this._value.HandleMode;
      }
    }
    return this._cachedHandleMode;
  }
  get hasPrecedingControlPointLocalPosition() {
    if (this._cachedHasPrecedingControlPointLocalPosition === undefined) {
      if (this._value.hasPrecedingControlPointLocalPosition) {
        this._cachedHasPrecedingControlPointLocalPosition = true;
      } else {
        this._cachedHasPrecedingControlPointLocalPosition = this._parent ? this._parent.hasPrecedingControlPointLocalPosition : false;
      }
    }
    return this._cachedHasPrecedingControlPointLocalPosition;
  }
  get PrecedingControlPointLocalPosition() {
    if (!this._cachedPrecedingControlPointLocalPosition) {
      if (this._value.hasPrecedingControlPointLocalPosition) {
        this._cachedPrecedingControlPointLocalPosition = new FVector3.WithParent(this._value.PrecedingControlPointLocalPosition, this._parent && this._parent.hasPrecedingControlPointLocalPosition ? this._parent.PrecedingControlPointLocalPosition : null);
      } else {
        this._cachedPrecedingControlPointLocalPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.PrecedingControlPointLocalPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedPrecedingControlPointLocalPosition;
  }
  get hasFollowingControlPointLocalPosition() {
    if (this._cachedHasFollowingControlPointLocalPosition === undefined) {
      if (this._value.hasFollowingControlPointLocalPosition) {
        this._cachedHasFollowingControlPointLocalPosition = true;
      } else {
        this._cachedHasFollowingControlPointLocalPosition = this._parent ? this._parent.hasFollowingControlPointLocalPosition : false;
      }
    }
    return this._cachedHasFollowingControlPointLocalPosition;
  }
  get FollowingControlPointLocalPosition() {
    if (!this._cachedFollowingControlPointLocalPosition) {
      if (this._value.hasFollowingControlPointLocalPosition) {
        this._cachedFollowingControlPointLocalPosition = new FVector3.WithParent(this._value.FollowingControlPointLocalPosition, this._parent && this._parent.hasFollowingControlPointLocalPosition ? this._parent.FollowingControlPointLocalPosition : null);
      } else {
        this._cachedFollowingControlPointLocalPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.FollowingControlPointLocalPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedFollowingControlPointLocalPosition;
  }
  update(current, parent) {
    const result = new BezierPointData_WithParent(current, parent);
    if (this._cachedLocalPosition && this._value.hasLocalPosition && current.hasLocalPosition) {
      if (this._value.LocalPosition === current.LocalPosition && this._parent === parent) {
        result._cachedLocalPosition = this._cachedLocalPosition;
      } else {
        result._cachedLocalPosition = this._cachedLocalPosition.update(current.LocalPosition, parent && parent.hasLocalPosition ? parent.LocalPosition : null);
      }
    }
    if (this._cachedLocalRotation && this._value.hasLocalRotation && current.hasLocalRotation) {
      if (this._value.LocalRotation === current.LocalRotation && this._parent === parent) {
        result._cachedLocalRotation = this._cachedLocalRotation;
      } else {
        result._cachedLocalRotation = this._cachedLocalRotation.update(current.LocalRotation, parent && parent.hasLocalRotation ? parent.LocalRotation : null);
      }
    }
    if (this._cachedLocalScale && this._value.hasLocalScale && current.hasLocalScale) {
      if (this._value.LocalScale === current.LocalScale && this._parent === parent) {
        result._cachedLocalScale = this._cachedLocalScale;
      } else {
        result._cachedLocalScale = this._cachedLocalScale.update(current.LocalScale, parent && parent.hasLocalScale ? parent.LocalScale : null);
      }
    }
    if (this._cachedPrecedingControlPointLocalPosition && this._value.hasPrecedingControlPointLocalPosition && current.hasPrecedingControlPointLocalPosition) {
      if (this._value.PrecedingControlPointLocalPosition === current.PrecedingControlPointLocalPosition && this._parent === parent) {
        result._cachedPrecedingControlPointLocalPosition = this._cachedPrecedingControlPointLocalPosition;
      } else {
        result._cachedPrecedingControlPointLocalPosition = this._cachedPrecedingControlPointLocalPosition.update(current.PrecedingControlPointLocalPosition, parent && parent.hasPrecedingControlPointLocalPosition ? parent.PrecedingControlPointLocalPosition : null);
      }
    }
    if (this._cachedFollowingControlPointLocalPosition && this._value.hasFollowingControlPointLocalPosition && current.hasFollowingControlPointLocalPosition) {
      if (this._value.FollowingControlPointLocalPosition === current.FollowingControlPointLocalPosition && this._parent === parent) {
        result._cachedFollowingControlPointLocalPosition = this._cachedFollowingControlPointLocalPosition;
      } else {
        result._cachedFollowingControlPointLocalPosition = this._cachedFollowingControlPointLocalPosition.update(current.FollowingControlPointLocalPosition, parent && parent.hasFollowingControlPointLocalPosition ? parent.FollowingControlPointLocalPosition : null);
      }
    }
    return result;
  }
}
BezierPointData_WithParent.default = new BezierPointData_WithParent(BezierPointData.default, null);
BezierPointData.WithParent = BezierPointData_WithParent;
class BezierPointData_Descriptor {
  get LocalPosition() {
    if (!this._LocalPosition) {
      this._LocalPosition = {
        name: "LocalPosition",
        Name: "LocalPosition",
        number: 1,
        protoType: 11,
        protoName: "LocalPosition",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LocalPosition;
  }
  get LocalRotation() {
    if (!this._LocalRotation) {
      this._LocalRotation = {
        name: "LocalRotation",
        Name: "LocalRotation",
        number: 2,
        protoType: 11,
        protoName: "LocalRotation",
        type: FVector4,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LocalRotation;
  }
  get LocalScale() {
    if (!this._LocalScale) {
      this._LocalScale = {
        name: "LocalScale",
        Name: "LocalScale",
        number: 3,
        protoType: 11,
        protoName: "LocalScale",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LocalScale;
  }
  get HandleMode() {
    if (!this._HandleMode) {
      this._HandleMode = {
        name: "HandleMode",
        Name: "HandleMode",
        number: 4,
        protoType: 5,
        protoName: "HandleMode",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._HandleMode;
  }
  get PrecedingControlPointLocalPosition() {
    if (!this._PrecedingControlPointLocalPosition) {
      this._PrecedingControlPointLocalPosition = {
        name: "PrecedingControlPointLocalPosition",
        Name: "PrecedingControlPointLocalPosition",
        number: 5,
        protoType: 11,
        protoName: "PrecedingControlPointLocalPosition",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PrecedingControlPointLocalPosition;
  }
  get FollowingControlPointLocalPosition() {
    if (!this._FollowingControlPointLocalPosition) {
      this._FollowingControlPointLocalPosition = {
        name: "FollowingControlPointLocalPosition",
        Name: "FollowingControlPointLocalPosition",
        number: 6,
        protoType: 11,
        protoName: "FollowingControlPointLocalPosition",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._FollowingControlPointLocalPosition;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.LocalPosition,
        this.LocalRotation,
        this.LocalScale,
        this.HandleMode,
        this.PrecedingControlPointLocalPosition,
        this.FollowingControlPointLocalPosition,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLocalPosition",
        Name: "DummyOneofForLocalPosition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocalRotation",
        Name: "DummyOneofForLocalRotation",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLocalScale",
        Name: "DummyOneofForLocalScale",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHandleMode",
        Name: "DummyOneofForHandleMode",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrecedingControlPointLocalPosition",
        Name: "DummyOneofForPrecedingControlPointLocalPosition",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFollowingControlPointLocalPosition",
        Name: "DummyOneofForFollowingControlPointLocalPosition",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
BezierPointData.descriptor = new BezierPointData_Descriptor();
export class FVector3 {
  get descriptor() {
    return FVector3.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._X = null;
    this._hasY = false;
    this._Y = null;
    this._hasZ = false;
    this._Z = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FVector3) {
      return value;
    }
    return FVector3.fromJson(value);
  }
  static fromJson(json) {
    const result = new FVector3();
    if (json.X != null) {
      result._hasX = true;
      result._X = JsonToDouble.fromJson(json.X);
    }
    if (json.Y != null) {
      result._hasY = true;
      result._Y = JsonToDouble.fromJson(json.Y);
    }
    if (json.Z != null) {
      result._hasZ = true;
      result._Z = JsonToDouble.fromJson(json.Z);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.X = JsonToDouble.toJson(this._X);
    }
    if (this._hasY) {
      result.Y = JsonToDouble.toJson(this._Y);
    }
    if (this._hasZ) {
      result.Z = JsonToDouble.toJson(this._Z);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get X() {
    return this._hasX ? this._X : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['X']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['X'])};
  }
  /**
   * @returns {number}
   */
  get Y() {
    return this._hasY ? this._Y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['Y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['Y'])};
  }
  /**
   * @returns {number}
   */
  get Z() {
    return this._hasZ ? this._Z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['Z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['Z'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "X": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector3(this);
              copy._hasX = true;
              copy._X = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new FVector3(this);
              copy._hasX = false;
              copy._X = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector3(this);
              copy._hasY = true;
              copy._Y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new FVector3(this);
              copy._hasY = false;
              copy._Y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector3(this);
              copy._hasZ = true;
              copy._Z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new FVector3(this);
              copy._hasZ = false;
              copy._Z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FVector3} other
   * @returns {FVector3}
   */
  merge(other) {
    const copy = new FVector3(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._X = other._X;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._Y = other._Y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._Z = other._Z;
    }
    return copy;
  }
}
FVector3.default = new FVector3();
class FVector3_Builder {
  constructor(value) {
    this._value = new FVector3(value);
  }
  build() {
    return new FVector3(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._X = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._X = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._Y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._Y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._Z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._Z = null;
    return this;
  }
}
FVector3.Builder = FVector3_Builder;
class FVector3_WithParent {
  /**
   * @param {FVector3} value
   * @param {FVector3_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FVector3.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get X() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.X;
      } else {
        this._cachedX = this._parent ? this._parent.X : this._value.X;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get Y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.Y;
      } else {
        this._cachedY = this._parent ? this._parent.Y : this._value.Y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get Z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.Z;
      } else {
        this._cachedZ = this._parent ? this._parent.Z : this._value.Z;
      }
    }
    return this._cachedZ;
  }
  update(current, parent) {
    const result = new FVector3_WithParent(current, parent);
    return result;
  }
}
FVector3_WithParent.default = new FVector3_WithParent(FVector3.default, null);
FVector3.WithParent = FVector3_WithParent;
class FVector3_Descriptor {
  get X() {
    if (!this._X) {
      this._X = {
        name: "X",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "X",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._X;
  }
  get Y() {
    if (!this._Y) {
      this._Y = {
        name: "Y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "Y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Y;
  }
  get Z() {
    if (!this._Z) {
      this._Z = {
        name: "Z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "Z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Z;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.X,
        this.Y,
        this.Z,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
FVector3.descriptor = new FVector3_Descriptor();
export class FVector4 {
  get descriptor() {
    return FVector4.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._X = null;
    this._hasY = false;
    this._Y = null;
    this._hasZ = false;
    this._Z = null;
    this._hasW = false;
    this._W = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    if (this._hasZ) return false;
    if (this._hasW) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FVector4) {
      return value;
    }
    return FVector4.fromJson(value);
  }
  static fromJson(json) {
    const result = new FVector4();
    if (json.X != null) {
      result._hasX = true;
      result._X = JsonToDouble.fromJson(json.X);
    }
    if (json.Y != null) {
      result._hasY = true;
      result._Y = JsonToDouble.fromJson(json.Y);
    }
    if (json.Z != null) {
      result._hasZ = true;
      result._Z = JsonToDouble.fromJson(json.Z);
    }
    if (json.W != null) {
      result._hasW = true;
      result._W = JsonToDouble.fromJson(json.W);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.X = JsonToDouble.toJson(this._X);
    }
    if (this._hasY) {
      result.Y = JsonToDouble.toJson(this._Y);
    }
    if (this._hasZ) {
      result.Z = JsonToDouble.toJson(this._Z);
    }
    if (this._hasW) {
      result.W = JsonToDouble.toJson(this._W);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get X() {
    return this._hasX ? this._X : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['X']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['X'])};
  }
  /**
   * @returns {number}
   */
  get Y() {
    return this._hasY ? this._Y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['Y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['Y'])};
  }
  /**
   * @returns {number}
   */
  get Z() {
    return this._hasZ ? this._Z : JsonToDouble.default;
  }
  get hasZ() {
    return this._hasZ;
  }
  setZ(path, value) {
    return {type: 'SET', path: path.concat(['Z']), value};
  }
  deleteZ(path) {
    return {type: 'DELETE', path: path.concat(['Z'])};
  }
  /**
   * @returns {number}
   */
  get W() {
    return this._hasW ? this._W : JsonToDouble.default;
  }
  get hasW() {
    return this._hasW;
  }
  setW(path, value) {
    return {type: 'SET', path: path.concat(['W']), value};
  }
  deleteW(path) {
    return {type: 'DELETE', path: path.concat(['W'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "X": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector4(this);
              copy._hasX = true;
              copy._X = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new FVector4(this);
              copy._hasX = false;
              copy._X = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector4(this);
              copy._hasY = true;
              copy._Y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new FVector4(this);
              copy._hasY = false;
              copy._Y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Z": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector4(this);
              copy._hasZ = true;
              copy._Z = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasZ) {
                return this;
              }
              const copy = new FVector4(this);
              copy._hasZ = false;
              copy._Z = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "W": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector4(this);
              copy._hasW = true;
              copy._W = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasW) {
                return this;
              }
              const copy = new FVector4(this);
              copy._hasW = false;
              copy._W = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FVector4} other
   * @returns {FVector4}
   */
  merge(other) {
    const copy = new FVector4(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._X = other._X;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._Y = other._Y;
    }
    if (other._hasZ) {
      copy._hasZ = true;
      copy._Z = other._Z;
    }
    if (other._hasW) {
      copy._hasW = true;
      copy._W = other._W;
    }
    return copy;
  }
}
FVector4.default = new FVector4();
class FVector4_Builder {
  constructor(value) {
    this._value = new FVector4(value);
  }
  build() {
    return new FVector4(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._X = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._X = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._Y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._Y = null;
    return this;
  }
  setZ(value) {
    this._value._hasZ = true;
    this._value._Z = value;
    return this;
  }
  deleteZ() {
    this._value._hasZ = false;
    this._value._Z = null;
    return this;
  }
  setW(value) {
    this._value._hasW = true;
    this._value._W = value;
    return this;
  }
  deleteW() {
    this._value._hasW = false;
    this._value._W = null;
    return this;
  }
}
FVector4.Builder = FVector4_Builder;
class FVector4_WithParent {
  /**
   * @param {FVector4} value
   * @param {FVector4_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FVector4.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get X() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.X;
      } else {
        this._cachedX = this._parent ? this._parent.X : this._value.X;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get Y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.Y;
      } else {
        this._cachedY = this._parent ? this._parent.Y : this._value.Y;
      }
    }
    return this._cachedY;
  }
  get hasZ() {
    if (this._cachedHasZ === undefined) {
      if (this._value.hasZ) {
        this._cachedHasZ = true;
      } else {
        this._cachedHasZ = this._parent ? this._parent.hasZ : false;
      }
    }
    return this._cachedHasZ;
  }
  get Z() {
    if (this._cachedZ === undefined) {
      if (this._value.hasZ) {
        this._cachedZ = this._value.Z;
      } else {
        this._cachedZ = this._parent ? this._parent.Z : this._value.Z;
      }
    }
    return this._cachedZ;
  }
  get hasW() {
    if (this._cachedHasW === undefined) {
      if (this._value.hasW) {
        this._cachedHasW = true;
      } else {
        this._cachedHasW = this._parent ? this._parent.hasW : false;
      }
    }
    return this._cachedHasW;
  }
  get W() {
    if (this._cachedW === undefined) {
      if (this._value.hasW) {
        this._cachedW = this._value.W;
      } else {
        this._cachedW = this._parent ? this._parent.W : this._value.W;
      }
    }
    return this._cachedW;
  }
  update(current, parent) {
    const result = new FVector4_WithParent(current, parent);
    return result;
  }
}
FVector4_WithParent.default = new FVector4_WithParent(FVector4.default, null);
FVector4.WithParent = FVector4_WithParent;
class FVector4_Descriptor {
  get X() {
    if (!this._X) {
      this._X = {
        name: "X",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "X",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._X;
  }
  get Y() {
    if (!this._Y) {
      this._Y = {
        name: "Y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "Y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Y;
  }
  get Z() {
    if (!this._Z) {
      this._Z = {
        name: "Z",
        Name: "Z",
        number: 3,
        protoType: 1,
        protoName: "Z",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Z;
  }
  get W() {
    if (!this._W) {
      this._W = {
        name: "W",
        Name: "W",
        number: 4,
        protoType: 1,
        protoName: "W",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._W;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.X,
        this.Y,
        this.Z,
        this.W,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForZ",
        Name: "DummyOneofForZ",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForW",
        Name: "DummyOneofForW",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
FVector4.descriptor = new FVector4_Descriptor();
export class CtrlPtData {
  get descriptor() {
    return CtrlPtData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPosition = false;
    this._Position = null;
    this._hasIsBorder = false;
    this._IsBorder = null;
    this._hasIsRamp = false;
    this._IsRamp = null;
    this._hasTileSetId = false;
    this._TileSetId = null;
    this._TextureValue = [];
    this._TextureVariation = [];
    this._hasIsClamped = false;
    this._IsClamped = null;
  }
  isEmpty() {
    if (this._hasPosition && !this._Position.isEmpty()) return false;
    if (this._hasIsBorder) return false;
    if (this._hasIsRamp) return false;
    if (this._hasTileSetId) return false;
    if (this._TextureValue.length > 0) return false;
    if (this._TextureVariation.length > 0) return false;
    if (this._hasIsClamped) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CtrlPtData) {
      return value;
    }
    return CtrlPtData.fromJson(value);
  }
  static fromJson(json) {
    const result = new CtrlPtData();
    if (json.Position != null) {
      result._hasPosition = true;
      result._Position = FVector3.fromJson(json.Position);
    }
    if (json.IsBorder != null) {
      result._hasIsBorder = true;
      result._IsBorder = JsonToBoolean.fromJson(json.IsBorder);
    }
    if (json.IsRamp != null) {
      result._hasIsRamp = true;
      result._IsRamp = JsonToBoolean.fromJson(json.IsRamp);
    }
    if (json.TileSetId != null) {
      result._hasTileSetId = true;
      result._TileSetId = JsonToInt32.fromJson(json.TileSetId);
    }
    result._TextureValue = JsonToList(json.TextureValue, JsonToInt32);
    result._TextureVariation = JsonToList(json.TextureVariation, JsonToInt32);
    if (json.IsClamped != null) {
      result._hasIsClamped = true;
      result._IsClamped = JsonToBoolean.fromJson(json.IsClamped);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPosition && !this._Position.isEmpty()) {
      result.Position = FVector3.toJson(this._Position);
    }
    if (this._hasIsBorder) {
      result.IsBorder = JsonToBoolean.toJson(this._IsBorder);
    }
    if (this._hasIsRamp) {
      result.IsRamp = JsonToBoolean.toJson(this._IsRamp);
    }
    if (this._hasTileSetId) {
      result.TileSetId = JsonToInt32.toJson(this._TileSetId);
    }
    if (this._TextureValue.length > 0) {
      result.TextureValue = ArrayToJson(this._TextureValue, JsonToInt32);
    }
    if (this._TextureVariation.length > 0) {
      result.TextureVariation = ArrayToJson(this._TextureVariation, JsonToInt32);
    }
    if (this._hasIsClamped) {
      result.IsClamped = JsonToBoolean.toJson(this._IsClamped);
    }
    return result;
  }
  /**
   * @returns {FVector3}
   */
  get Position() {
    return this._hasPosition ? this._Position : FVector3.default;
  }
  get hasPosition() {
    return this._hasPosition;
  }
  setPosition(path, value) {
    return {type: 'SET', path: path.concat(['Position']), value: value.toJson()};
  }
  deletePosition(path) {
    return {type: 'DELETE', path: path.concat(['Position'])};
  }
  /**
   * @returns {boolean}
   */
  get IsBorder() {
    return this._hasIsBorder ? this._IsBorder : JsonToBoolean.default;
  }
  get hasIsBorder() {
    return this._hasIsBorder;
  }
  setIsBorder(path, value) {
    return {type: 'SET', path: path.concat(['IsBorder']), value};
  }
  deleteIsBorder(path) {
    return {type: 'DELETE', path: path.concat(['IsBorder'])};
  }
  /**
   * @returns {boolean}
   */
  get IsRamp() {
    return this._hasIsRamp ? this._IsRamp : JsonToBoolean.default;
  }
  get hasIsRamp() {
    return this._hasIsRamp;
  }
  setIsRamp(path, value) {
    return {type: 'SET', path: path.concat(['IsRamp']), value};
  }
  deleteIsRamp(path) {
    return {type: 'DELETE', path: path.concat(['IsRamp'])};
  }
  /**
   * @returns {number}
   */
  get TileSetId() {
    return this._hasTileSetId ? this._TileSetId : JsonToInt32.default;
  }
  get hasTileSetId() {
    return this._hasTileSetId;
  }
  setTileSetId(path, value) {
    return {type: 'SET', path: path.concat(['TileSetId']), value};
  }
  deleteTileSetId(path) {
    return {type: 'DELETE', path: path.concat(['TileSetId'])};
  }
  /**
   * @returns {number[]}
   */
  get TextureValue() {
    return this._TextureValue;
  }
  addTextureValue(path, value) {
    return {type: 'ADD', path: path.concat(['TextureValue']), value};
  }
  setTextureValue(path, value) {
    return {type: 'SET', path: path.concat(['TextureValue']), value: ArrayToJson(value, JsonToInt32)};
  }
  setTextureValueByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['TextureValue', key]), value};
  }
  deleteTextureValue(path) {
    return {type: 'DELETE', path: path.concat(['TextureValue'])};
  }
  deleteTextureValueByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['TextureValue', key])};
  }
  /**
   * @returns {number[]}
   */
  get TextureVariation() {
    return this._TextureVariation;
  }
  addTextureVariation(path, value) {
    return {type: 'ADD', path: path.concat(['TextureVariation']), value};
  }
  setTextureVariation(path, value) {
    return {type: 'SET', path: path.concat(['TextureVariation']), value: ArrayToJson(value, JsonToInt32)};
  }
  setTextureVariationByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['TextureVariation', key]), value};
  }
  deleteTextureVariation(path) {
    return {type: 'DELETE', path: path.concat(['TextureVariation'])};
  }
  deleteTextureVariationByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['TextureVariation', key])};
  }
  /**
   * @returns {boolean}
   */
  get IsClamped() {
    return this._hasIsClamped ? this._IsClamped : JsonToBoolean.default;
  }
  get hasIsClamped() {
    return this._hasIsClamped;
  }
  setIsClamped(path, value) {
    return {type: 'SET', path: path.concat(['IsClamped']), value};
  }
  deleteIsClamped(path) {
    return {type: 'DELETE', path: path.concat(['IsClamped'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "Position": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._hasPosition = true;
              copy._Position = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPosition) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._hasPosition = false;
              copy._Position = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPosition) {
            const copy = new CtrlPtData(this);
            copy._hasPosition = true;
            copy._Position = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._Position.apply(type, path.slice(1), value);
          if (newValue === this._Position) {
            return this;
          }
          const copy = new CtrlPtData(this);
          copy._Position = copy._Position.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "IsBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._hasIsBorder = true;
              copy._IsBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsBorder) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._hasIsBorder = false;
              copy._IsBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "IsRamp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._hasIsRamp = true;
              copy._IsRamp = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsRamp) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._hasIsRamp = false;
              copy._IsRamp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "TileSetId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._hasTileSetId = true;
              copy._TileSetId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileSetId) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._hasTileSetId = false;
              copy._TileSetId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "TextureValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._TextureValue = [];        for (let i of value) {
                copy._TextureValue.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CtrlPtData(this);
              copy._TextureValue = copy._TextureValue.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._TextureValue.length === 0) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._TextureValue = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._TextureValue.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._TextureValue = copy._TextureValue.slice();
              copy._TextureValue[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CtrlPtData(this);
              copy._TextureValue = copy._TextureValue.slice(0, path[1]).concat(copy._TextureValue.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._TextureValue.length) {
            return this;
          }
          const oldValue = this._TextureValue[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CtrlPtData(this);
          copy._TextureValue = copy._TextureValue.slice();
          copy._TextureValue[key] = newValue;
          return copy;
        }
      }
      case "TextureVariation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._TextureVariation = [];        for (let i of value) {
                copy._TextureVariation.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CtrlPtData(this);
              copy._TextureVariation = copy._TextureVariation.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._TextureVariation.length === 0) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._TextureVariation = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._TextureVariation.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._TextureVariation = copy._TextureVariation.slice();
              copy._TextureVariation[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CtrlPtData(this);
              copy._TextureVariation = copy._TextureVariation.slice(0, path[1]).concat(copy._TextureVariation.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._TextureVariation.length) {
            return this;
          }
          const oldValue = this._TextureVariation[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CtrlPtData(this);
          copy._TextureVariation = copy._TextureVariation.slice();
          copy._TextureVariation[key] = newValue;
          return copy;
        }
      }
      case "IsClamped": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CtrlPtData(this);
              copy._hasIsClamped = true;
              copy._IsClamped = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsClamped) {
                return this;
              }
              const copy = new CtrlPtData(this);
              copy._hasIsClamped = false;
              copy._IsClamped = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CtrlPtData} other
   * @returns {CtrlPtData}
   */
  merge(other) {
    const copy = new CtrlPtData(this);
    if (other._hasPosition) {
      if (copy._hasPosition) {
        copy._Position = copy.Position.merge(other.Position);
      } else {
        copy._Position = other._Position;
      }
      copy._hasPosition = true;
    }
    if (other._hasIsBorder) {
      copy._hasIsBorder = true;
      copy._IsBorder = other._IsBorder;
    }
    if (other._hasIsRamp) {
      copy._hasIsRamp = true;
      copy._IsRamp = other._IsRamp;
    }
    if (other._hasTileSetId) {
      copy._hasTileSetId = true;
      copy._TileSetId = other._TileSetId;
    }
    copy._TextureValue = this._TextureValue.concat(other._TextureValue);
    copy._TextureVariation = this._TextureVariation.concat(other._TextureVariation);
    if (other._hasIsClamped) {
      copy._hasIsClamped = true;
      copy._IsClamped = other._IsClamped;
    }
    return copy;
  }
}
CtrlPtData.default = new CtrlPtData();
class CtrlPtData_Builder {
  constructor(value) {
    this._value = new CtrlPtData(value);
  }
  build() {
    return new CtrlPtData(this._value);
  }
  setPosition(value) {
    this._value._hasPosition = true;
    this._value._Position = value;
    return this;
  }
  deletePosition() {
    this._value._hasPosition = false;
    this._value._Position = null;
    return this;
  }
  setIsBorder(value) {
    this._value._hasIsBorder = true;
    this._value._IsBorder = value;
    return this;
  }
  deleteIsBorder() {
    this._value._hasIsBorder = false;
    this._value._IsBorder = null;
    return this;
  }
  setIsRamp(value) {
    this._value._hasIsRamp = true;
    this._value._IsRamp = value;
    return this;
  }
  deleteIsRamp() {
    this._value._hasIsRamp = false;
    this._value._IsRamp = null;
    return this;
  }
  setTileSetId(value) {
    this._value._hasTileSetId = true;
    this._value._TileSetId = value;
    return this;
  }
  deleteTileSetId() {
    this._value._hasTileSetId = false;
    this._value._TileSetId = null;
    return this;
  }
  addAllTextureValue(values) {
    this._value._TextureValue = this._value._TextureValue.concat(values);
    return this;
  }
  addTextureValue(value) {
    this._value._TextureValue = this._value._TextureValue.concat([value]);
    return this;
  }
  setTextureValue(index, value) {
    this._value._TextureValue = this._value._TextureValue.concat();
    this._value._TextureValue[index] = value;
    return this;
  }
  clearTextureValue() {
    this._value._TextureValue = [];
    return this;
  }
  addAllTextureVariation(values) {
    this._value._TextureVariation = this._value._TextureVariation.concat(values);
    return this;
  }
  addTextureVariation(value) {
    this._value._TextureVariation = this._value._TextureVariation.concat([value]);
    return this;
  }
  setTextureVariation(index, value) {
    this._value._TextureVariation = this._value._TextureVariation.concat();
    this._value._TextureVariation[index] = value;
    return this;
  }
  clearTextureVariation() {
    this._value._TextureVariation = [];
    return this;
  }
  setIsClamped(value) {
    this._value._hasIsClamped = true;
    this._value._IsClamped = value;
    return this;
  }
  deleteIsClamped() {
    this._value._hasIsClamped = false;
    this._value._IsClamped = null;
    return this;
  }
}
CtrlPtData.Builder = CtrlPtData_Builder;
class CtrlPtData_WithParent {
  /**
   * @param {CtrlPtData} value
   * @param {CtrlPtData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CtrlPtData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPosition() {
    if (this._cachedHasPosition === undefined) {
      if (this._value.hasPosition) {
        this._cachedHasPosition = true;
      } else {
        this._cachedHasPosition = this._parent ? this._parent.hasPosition : false;
      }
    }
    return this._cachedHasPosition;
  }
  get Position() {
    if (!this._cachedPosition) {
      if (this._value.hasPosition) {
        this._cachedPosition = new FVector3.WithParent(this._value.Position, this._parent && this._parent.hasPosition ? this._parent.Position : null);
      } else {
        this._cachedPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.Position) : FVector3.WithParent.default;
      }
    }
    return this._cachedPosition;
  }
  get hasIsBorder() {
    if (this._cachedHasIsBorder === undefined) {
      if (this._value.hasIsBorder) {
        this._cachedHasIsBorder = true;
      } else {
        this._cachedHasIsBorder = this._parent ? this._parent.hasIsBorder : false;
      }
    }
    return this._cachedHasIsBorder;
  }
  get IsBorder() {
    if (this._cachedIsBorder === undefined) {
      if (this._value.hasIsBorder) {
        this._cachedIsBorder = this._value.IsBorder;
      } else {
        this._cachedIsBorder = this._parent ? this._parent.IsBorder : this._value.IsBorder;
      }
    }
    return this._cachedIsBorder;
  }
  get hasIsRamp() {
    if (this._cachedHasIsRamp === undefined) {
      if (this._value.hasIsRamp) {
        this._cachedHasIsRamp = true;
      } else {
        this._cachedHasIsRamp = this._parent ? this._parent.hasIsRamp : false;
      }
    }
    return this._cachedHasIsRamp;
  }
  get IsRamp() {
    if (this._cachedIsRamp === undefined) {
      if (this._value.hasIsRamp) {
        this._cachedIsRamp = this._value.IsRamp;
      } else {
        this._cachedIsRamp = this._parent ? this._parent.IsRamp : this._value.IsRamp;
      }
    }
    return this._cachedIsRamp;
  }
  get hasTileSetId() {
    if (this._cachedHasTileSetId === undefined) {
      if (this._value.hasTileSetId) {
        this._cachedHasTileSetId = true;
      } else {
        this._cachedHasTileSetId = this._parent ? this._parent.hasTileSetId : false;
      }
    }
    return this._cachedHasTileSetId;
  }
  get TileSetId() {
    if (this._cachedTileSetId === undefined) {
      if (this._value.hasTileSetId) {
        this._cachedTileSetId = this._value.TileSetId;
      } else {
        this._cachedTileSetId = this._parent ? this._parent.TileSetId : this._value.TileSetId;
      }
    }
    return this._cachedTileSetId;
  }
  get selfTextureValue() {
    return this._value.TextureValue;
  }
  get inherentTextureValue() {
    if (!this._inherentTextureValue) {
      this._inherentTextureValue = this._parent ? this._parent.TextureValue : [];
    }
    return this._inherentTextureValue;
  }
  get TextureValue() {
    if (!this._allTextureValue) {
      this._allTextureValue = this._parent ? this._parent.TextureValue.concat(this.selfTextureValue) : this.selfTextureValue;
    }
    return this._allTextureValue;
  }
  get selfTextureVariation() {
    return this._value.TextureVariation;
  }
  get inherentTextureVariation() {
    if (!this._inherentTextureVariation) {
      this._inherentTextureVariation = this._parent ? this._parent.TextureVariation : [];
    }
    return this._inherentTextureVariation;
  }
  get TextureVariation() {
    if (!this._allTextureVariation) {
      this._allTextureVariation = this._parent ? this._parent.TextureVariation.concat(this.selfTextureVariation) : this.selfTextureVariation;
    }
    return this._allTextureVariation;
  }
  get hasIsClamped() {
    if (this._cachedHasIsClamped === undefined) {
      if (this._value.hasIsClamped) {
        this._cachedHasIsClamped = true;
      } else {
        this._cachedHasIsClamped = this._parent ? this._parent.hasIsClamped : false;
      }
    }
    return this._cachedHasIsClamped;
  }
  get IsClamped() {
    if (this._cachedIsClamped === undefined) {
      if (this._value.hasIsClamped) {
        this._cachedIsClamped = this._value.IsClamped;
      } else {
        this._cachedIsClamped = this._parent ? this._parent.IsClamped : this._value.IsClamped;
      }
    }
    return this._cachedIsClamped;
  }
  update(current, parent) {
    const result = new CtrlPtData_WithParent(current, parent);
    if (this._cachedPosition && this._value.hasPosition && current.hasPosition) {
      if (this._value.Position === current.Position && this._parent === parent) {
        result._cachedPosition = this._cachedPosition;
      } else {
        result._cachedPosition = this._cachedPosition.update(current.Position, parent && parent.hasPosition ? parent.Position : null);
      }
    }
    return result;
  }
}
CtrlPtData_WithParent.default = new CtrlPtData_WithParent(CtrlPtData.default, null);
CtrlPtData.WithParent = CtrlPtData_WithParent;
class CtrlPtData_Descriptor {
  get Position() {
    if (!this._Position) {
      this._Position = {
        name: "Position",
        Name: "Position",
        number: 1,
        protoType: 11,
        protoName: "Position",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Position;
  }
  get IsBorder() {
    if (!this._IsBorder) {
      this._IsBorder = {
        name: "IsBorder",
        Name: "IsBorder",
        number: 2,
        protoType: 8,
        protoName: "IsBorder",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._IsBorder;
  }
  get IsRamp() {
    if (!this._IsRamp) {
      this._IsRamp = {
        name: "IsRamp",
        Name: "IsRamp",
        number: 3,
        protoType: 8,
        protoName: "IsRamp",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._IsRamp;
  }
  get TileSetId() {
    if (!this._TileSetId) {
      this._TileSetId = {
        name: "TileSetId",
        Name: "TileSetId",
        number: 4,
        protoType: 5,
        protoName: "TileSetId",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileSetId;
  }
  get TextureValue() {
    if (!this._TextureValue) {
      this._TextureValue = {
        name: "TextureValue",
        Name: "TextureValue",
        number: 5,
        protoType: 5,
        protoName: "TextureValue",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TextureValue;
  }
  get TextureVariation() {
    if (!this._TextureVariation) {
      this._TextureVariation = {
        name: "TextureVariation",
        Name: "TextureVariation",
        number: 6,
        protoType: 5,
        protoName: "TextureVariation",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TextureVariation;
  }
  get IsClamped() {
    if (!this._IsClamped) {
      this._IsClamped = {
        name: "IsClamped",
        Name: "IsClamped",
        number: 7,
        protoType: 8,
        protoName: "IsClamped",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._IsClamped;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.Position,
        this.IsBorder,
        this.IsRamp,
        this.TileSetId,
        this.TextureValue,
        this.TextureVariation,
        this.IsClamped,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPosition",
        Name: "DummyOneofForPosition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsBorder",
        Name: "DummyOneofForIsBorder",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsRamp",
        Name: "DummyOneofForIsRamp",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileSetId",
        Name: "DummyOneofForTileSetId",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsClamped",
        Name: "DummyOneofForIsClamped",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
CtrlPtData.descriptor = new CtrlPtData_Descriptor();
export class ValueTuple2 {
  get descriptor() {
    return ValueTuple2.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItem1 = false;
    this._Item1 = null;
    this._hasItem2 = false;
    this._Item2 = null;
  }
  isEmpty() {
    if (this._hasItem1) return false;
    if (this._hasItem2) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValueTuple2) {
      return value;
    }
    return ValueTuple2.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValueTuple2();
    if (json.Item1 != null) {
      result._hasItem1 = true;
      result._Item1 = JsonToInt32.fromJson(json.Item1);
    }
    if (json.Item2 != null) {
      result._hasItem2 = true;
      result._Item2 = JsonToInt32.fromJson(json.Item2);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItem1) {
      result.Item1 = JsonToInt32.toJson(this._Item1);
    }
    if (this._hasItem2) {
      result.Item2 = JsonToInt32.toJson(this._Item2);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get Item1() {
    return this._hasItem1 ? this._Item1 : JsonToInt32.default;
  }
  get hasItem1() {
    return this._hasItem1;
  }
  setItem1(path, value) {
    return {type: 'SET', path: path.concat(['Item1']), value};
  }
  deleteItem1(path) {
    return {type: 'DELETE', path: path.concat(['Item1'])};
  }
  /**
   * @returns {number}
   */
  get Item2() {
    return this._hasItem2 ? this._Item2 : JsonToInt32.default;
  }
  get hasItem2() {
    return this._hasItem2;
  }
  setItem2(path, value) {
    return {type: 'SET', path: path.concat(['Item2']), value};
  }
  deleteItem2(path) {
    return {type: 'DELETE', path: path.concat(['Item2'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "Item1": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValueTuple2(this);
              copy._hasItem1 = true;
              copy._Item1 = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem1) {
                return this;
              }
              const copy = new ValueTuple2(this);
              copy._hasItem1 = false;
              copy._Item1 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Item2": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValueTuple2(this);
              copy._hasItem2 = true;
              copy._Item2 = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem2) {
                return this;
              }
              const copy = new ValueTuple2(this);
              copy._hasItem2 = false;
              copy._Item2 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValueTuple2} other
   * @returns {ValueTuple2}
   */
  merge(other) {
    const copy = new ValueTuple2(this);
    if (other._hasItem1) {
      copy._hasItem1 = true;
      copy._Item1 = other._Item1;
    }
    if (other._hasItem2) {
      copy._hasItem2 = true;
      copy._Item2 = other._Item2;
    }
    return copy;
  }
}
ValueTuple2.default = new ValueTuple2();
class ValueTuple2_Builder {
  constructor(value) {
    this._value = new ValueTuple2(value);
  }
  build() {
    return new ValueTuple2(this._value);
  }
  setItem1(value) {
    this._value._hasItem1 = true;
    this._value._Item1 = value;
    return this;
  }
  deleteItem1() {
    this._value._hasItem1 = false;
    this._value._Item1 = null;
    return this;
  }
  setItem2(value) {
    this._value._hasItem2 = true;
    this._value._Item2 = value;
    return this;
  }
  deleteItem2() {
    this._value._hasItem2 = false;
    this._value._Item2 = null;
    return this;
  }
}
ValueTuple2.Builder = ValueTuple2_Builder;
class ValueTuple2_WithParent {
  /**
   * @param {ValueTuple2} value
   * @param {ValueTuple2_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValueTuple2.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItem1() {
    if (this._cachedHasItem1 === undefined) {
      if (this._value.hasItem1) {
        this._cachedHasItem1 = true;
      } else {
        this._cachedHasItem1 = this._parent ? this._parent.hasItem1 : false;
      }
    }
    return this._cachedHasItem1;
  }
  get Item1() {
    if (this._cachedItem1 === undefined) {
      if (this._value.hasItem1) {
        this._cachedItem1 = this._value.Item1;
      } else {
        this._cachedItem1 = this._parent ? this._parent.Item1 : this._value.Item1;
      }
    }
    return this._cachedItem1;
  }
  get hasItem2() {
    if (this._cachedHasItem2 === undefined) {
      if (this._value.hasItem2) {
        this._cachedHasItem2 = true;
      } else {
        this._cachedHasItem2 = this._parent ? this._parent.hasItem2 : false;
      }
    }
    return this._cachedHasItem2;
  }
  get Item2() {
    if (this._cachedItem2 === undefined) {
      if (this._value.hasItem2) {
        this._cachedItem2 = this._value.Item2;
      } else {
        this._cachedItem2 = this._parent ? this._parent.Item2 : this._value.Item2;
      }
    }
    return this._cachedItem2;
  }
  update(current, parent) {
    const result = new ValueTuple2_WithParent(current, parent);
    return result;
  }
}
ValueTuple2_WithParent.default = new ValueTuple2_WithParent(ValueTuple2.default, null);
ValueTuple2.WithParent = ValueTuple2_WithParent;
class ValueTuple2_Descriptor {
  get Item1() {
    if (!this._Item1) {
      this._Item1 = {
        name: "Item1",
        Name: "Item1",
        number: 1,
        protoType: 5,
        protoName: "Item1",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Item1;
  }
  get Item2() {
    if (!this._Item2) {
      this._Item2 = {
        name: "Item2",
        Name: "Item2",
        number: 2,
        protoType: 5,
        protoName: "Item2",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Item2;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.Item1,
        this.Item2,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItem1",
        Name: "DummyOneofForItem1",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem2",
        Name: "DummyOneofForItem2",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValueTuple2.descriptor = new ValueTuple2_Descriptor();
export class RoadDataContainer {
  get descriptor() {
    return RoadDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._NodesData = [];
    this._EdgesData = [];
    this._PtList = [];
    this._hasBorderOuter = false;
    this._BorderOuter = null;
    this._hasBorderInner = false;
    this._BorderInner = null;
    this._hasBorderUvScale = false;
    this._BorderUvScale = null;
    this._hasFirstBorderCenterHeight = false;
    this._FirstBorderCenterHeight = null;
    this._hasUseSecondBorder = false;
    this._UseSecondBorder = null;
    this._hasSecondBorderOuter = false;
    this._SecondBorderOuter = null;
    this._hasSecondBorderInner = false;
    this._SecondBorderInner = null;
    this._hasSecondBorderUvScale = false;
    this._SecondBorderUvScale = null;
  }
  isEmpty() {
    if (this._NodesData.length > 0) return false;
    if (this._EdgesData.length > 0) return false;
    if (this._PtList.length > 0) return false;
    if (this._hasBorderOuter) return false;
    if (this._hasBorderInner) return false;
    if (this._hasBorderUvScale) return false;
    if (this._hasFirstBorderCenterHeight) return false;
    if (this._hasUseSecondBorder) return false;
    if (this._hasSecondBorderOuter) return false;
    if (this._hasSecondBorderInner) return false;
    if (this._hasSecondBorderUvScale) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RoadDataContainer) {
      return value;
    }
    return RoadDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new RoadDataContainer();
    result._NodesData = JsonToList(json.NodesData, NodeData);
    result._EdgesData = JsonToList(json.EdgesData, EdgeData);
    result._PtList = JsonToList(json.PtList, FVector3);
    if (json.BorderOuter != null) {
      result._hasBorderOuter = true;
      result._BorderOuter = JsonToDouble.fromJson(json.BorderOuter);
    }
    if (json.BorderInner != null) {
      result._hasBorderInner = true;
      result._BorderInner = JsonToDouble.fromJson(json.BorderInner);
    }
    if (json.BorderUvScale != null) {
      result._hasBorderUvScale = true;
      result._BorderUvScale = JsonToDouble.fromJson(json.BorderUvScale);
    }
    if (json.FirstBorderCenterHeight != null) {
      result._hasFirstBorderCenterHeight = true;
      result._FirstBorderCenterHeight = JsonToDouble.fromJson(json.FirstBorderCenterHeight);
    }
    if (json.UseSecondBorder != null) {
      result._hasUseSecondBorder = true;
      result._UseSecondBorder = JsonToBoolean.fromJson(json.UseSecondBorder);
    }
    if (json.SecondBorderOuter != null) {
      result._hasSecondBorderOuter = true;
      result._SecondBorderOuter = JsonToDouble.fromJson(json.SecondBorderOuter);
    }
    if (json.SecondBorderInner != null) {
      result._hasSecondBorderInner = true;
      result._SecondBorderInner = JsonToDouble.fromJson(json.SecondBorderInner);
    }
    if (json.SecondBorderUvScale != null) {
      result._hasSecondBorderUvScale = true;
      result._SecondBorderUvScale = JsonToDouble.fromJson(json.SecondBorderUvScale);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._NodesData.length > 0) {
      result.NodesData = ArrayToJson(this._NodesData, NodeData);
    }
    if (this._EdgesData.length > 0) {
      result.EdgesData = ArrayToJson(this._EdgesData, EdgeData);
    }
    if (this._PtList.length > 0) {
      result.PtList = ArrayToJson(this._PtList, FVector3);
    }
    if (this._hasBorderOuter) {
      result.BorderOuter = JsonToDouble.toJson(this._BorderOuter);
    }
    if (this._hasBorderInner) {
      result.BorderInner = JsonToDouble.toJson(this._BorderInner);
    }
    if (this._hasBorderUvScale) {
      result.BorderUvScale = JsonToDouble.toJson(this._BorderUvScale);
    }
    if (this._hasFirstBorderCenterHeight) {
      result.FirstBorderCenterHeight = JsonToDouble.toJson(this._FirstBorderCenterHeight);
    }
    if (this._hasUseSecondBorder) {
      result.UseSecondBorder = JsonToBoolean.toJson(this._UseSecondBorder);
    }
    if (this._hasSecondBorderOuter) {
      result.SecondBorderOuter = JsonToDouble.toJson(this._SecondBorderOuter);
    }
    if (this._hasSecondBorderInner) {
      result.SecondBorderInner = JsonToDouble.toJson(this._SecondBorderInner);
    }
    if (this._hasSecondBorderUvScale) {
      result.SecondBorderUvScale = JsonToDouble.toJson(this._SecondBorderUvScale);
    }
    return result;
  }
  /**
   * @returns {NodeData[]}
   */
  get NodesData() {
    return this._NodesData;
  }
  addNodesData(path, value) {
    return {type: 'ADD', path: path.concat(['NodesData']), value: value.toJson()};
  }
  setNodesData(path, value) {
    return {type: 'SET', path: path.concat(['NodesData']), value: ArrayToJson(value, NodeData)};
  }
  setNodesDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['NodesData', key]), value: value.toJson()};
  }
  deleteNodesData(path) {
    return {type: 'DELETE', path: path.concat(['NodesData'])};
  }
  deleteNodesDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['NodesData', key])};
  }
  /**
   * @returns {EdgeData[]}
   */
  get EdgesData() {
    return this._EdgesData;
  }
  addEdgesData(path, value) {
    return {type: 'ADD', path: path.concat(['EdgesData']), value: value.toJson()};
  }
  setEdgesData(path, value) {
    return {type: 'SET', path: path.concat(['EdgesData']), value: ArrayToJson(value, EdgeData)};
  }
  setEdgesDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['EdgesData', key]), value: value.toJson()};
  }
  deleteEdgesData(path) {
    return {type: 'DELETE', path: path.concat(['EdgesData'])};
  }
  deleteEdgesDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['EdgesData', key])};
  }
  /**
   * @returns {FVector3[]}
   */
  get PtList() {
    return this._PtList;
  }
  addPtList(path, value) {
    return {type: 'ADD', path: path.concat(['PtList']), value: value.toJson()};
  }
  setPtList(path, value) {
    return {type: 'SET', path: path.concat(['PtList']), value: ArrayToJson(value, FVector3)};
  }
  setPtListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PtList', key]), value: value.toJson()};
  }
  deletePtList(path) {
    return {type: 'DELETE', path: path.concat(['PtList'])};
  }
  deletePtListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PtList', key])};
  }
  /**
   * @returns {number}
   */
  get BorderOuter() {
    return this._hasBorderOuter ? this._BorderOuter : JsonToDouble.default;
  }
  get hasBorderOuter() {
    return this._hasBorderOuter;
  }
  setBorderOuter(path, value) {
    return {type: 'SET', path: path.concat(['BorderOuter']), value};
  }
  deleteBorderOuter(path) {
    return {type: 'DELETE', path: path.concat(['BorderOuter'])};
  }
  /**
   * @returns {number}
   */
  get BorderInner() {
    return this._hasBorderInner ? this._BorderInner : JsonToDouble.default;
  }
  get hasBorderInner() {
    return this._hasBorderInner;
  }
  setBorderInner(path, value) {
    return {type: 'SET', path: path.concat(['BorderInner']), value};
  }
  deleteBorderInner(path) {
    return {type: 'DELETE', path: path.concat(['BorderInner'])};
  }
  /**
   * @returns {number}
   */
  get BorderUvScale() {
    return this._hasBorderUvScale ? this._BorderUvScale : JsonToDouble.default;
  }
  get hasBorderUvScale() {
    return this._hasBorderUvScale;
  }
  setBorderUvScale(path, value) {
    return {type: 'SET', path: path.concat(['BorderUvScale']), value};
  }
  deleteBorderUvScale(path) {
    return {type: 'DELETE', path: path.concat(['BorderUvScale'])};
  }
  /**
   * @returns {number}
   */
  get FirstBorderCenterHeight() {
    return this._hasFirstBorderCenterHeight ? this._FirstBorderCenterHeight : JsonToDouble.default;
  }
  get hasFirstBorderCenterHeight() {
    return this._hasFirstBorderCenterHeight;
  }
  setFirstBorderCenterHeight(path, value) {
    return {type: 'SET', path: path.concat(['FirstBorderCenterHeight']), value};
  }
  deleteFirstBorderCenterHeight(path) {
    return {type: 'DELETE', path: path.concat(['FirstBorderCenterHeight'])};
  }
  /**
   * @returns {boolean}
   */
  get UseSecondBorder() {
    return this._hasUseSecondBorder ? this._UseSecondBorder : JsonToBoolean.default;
  }
  get hasUseSecondBorder() {
    return this._hasUseSecondBorder;
  }
  setUseSecondBorder(path, value) {
    return {type: 'SET', path: path.concat(['UseSecondBorder']), value};
  }
  deleteUseSecondBorder(path) {
    return {type: 'DELETE', path: path.concat(['UseSecondBorder'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderOuter() {
    return this._hasSecondBorderOuter ? this._SecondBorderOuter : JsonToDouble.default;
  }
  get hasSecondBorderOuter() {
    return this._hasSecondBorderOuter;
  }
  setSecondBorderOuter(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderOuter']), value};
  }
  deleteSecondBorderOuter(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderOuter'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderInner() {
    return this._hasSecondBorderInner ? this._SecondBorderInner : JsonToDouble.default;
  }
  get hasSecondBorderInner() {
    return this._hasSecondBorderInner;
  }
  setSecondBorderInner(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderInner']), value};
  }
  deleteSecondBorderInner(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderInner'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderUvScale() {
    return this._hasSecondBorderUvScale ? this._SecondBorderUvScale : JsonToDouble.default;
  }
  get hasSecondBorderUvScale() {
    return this._hasSecondBorderUvScale;
  }
  setSecondBorderUvScale(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderUvScale']), value};
  }
  deleteSecondBorderUvScale(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderUvScale'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "NodesData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._NodesData = [];        for (let i of value) {
                copy._NodesData.push(NodeData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RoadDataContainer(this);
              copy._NodesData = copy._NodesData.concat([NodeData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._NodesData.length === 0) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._NodesData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._NodesData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._NodesData = copy._NodesData.slice();
              copy._NodesData[path[1]] = NodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RoadDataContainer(this);
              copy._NodesData = copy._NodesData.slice(0, path[1]).concat(copy._NodesData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._NodesData.length) {
            return this;
          }
          const oldValue = this._NodesData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RoadDataContainer(this);
          copy._NodesData = copy._NodesData.slice();
          copy._NodesData[key] = newValue;
          return copy;
        }
      }
      case "EdgesData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._EdgesData = [];        for (let i of value) {
                copy._EdgesData.push(EdgeData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RoadDataContainer(this);
              copy._EdgesData = copy._EdgesData.concat([EdgeData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._EdgesData.length === 0) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._EdgesData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._EdgesData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._EdgesData = copy._EdgesData.slice();
              copy._EdgesData[path[1]] = EdgeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RoadDataContainer(this);
              copy._EdgesData = copy._EdgesData.slice(0, path[1]).concat(copy._EdgesData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._EdgesData.length) {
            return this;
          }
          const oldValue = this._EdgesData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RoadDataContainer(this);
          copy._EdgesData = copy._EdgesData.slice();
          copy._EdgesData[key] = newValue;
          return copy;
        }
      }
      case "PtList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._PtList = [];        for (let i of value) {
                copy._PtList.push(FVector3.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RoadDataContainer(this);
              copy._PtList = copy._PtList.concat([FVector3.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PtList.length === 0) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._PtList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PtList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._PtList = copy._PtList.slice();
              copy._PtList[path[1]] = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RoadDataContainer(this);
              copy._PtList = copy._PtList.slice(0, path[1]).concat(copy._PtList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PtList.length) {
            return this;
          }
          const oldValue = this._PtList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RoadDataContainer(this);
          copy._PtList = copy._PtList.slice();
          copy._PtList[key] = newValue;
          return copy;
        }
      }
      case "BorderOuter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasBorderOuter = true;
              copy._BorderOuter = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderOuter) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasBorderOuter = false;
              copy._BorderOuter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "BorderInner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasBorderInner = true;
              copy._BorderInner = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderInner) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasBorderInner = false;
              copy._BorderInner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "BorderUvScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasBorderUvScale = true;
              copy._BorderUvScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderUvScale) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasBorderUvScale = false;
              copy._BorderUvScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "FirstBorderCenterHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasFirstBorderCenterHeight = true;
              copy._FirstBorderCenterHeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFirstBorderCenterHeight) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasFirstBorderCenterHeight = false;
              copy._FirstBorderCenterHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "UseSecondBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasUseSecondBorder = true;
              copy._UseSecondBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseSecondBorder) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasUseSecondBorder = false;
              copy._UseSecondBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderOuter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderOuter = true;
              copy._SecondBorderOuter = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderOuter) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderOuter = false;
              copy._SecondBorderOuter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderInner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderInner = true;
              copy._SecondBorderInner = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderInner) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderInner = false;
              copy._SecondBorderInner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderUvScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderUvScale = true;
              copy._SecondBorderUvScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderUvScale) {
                return this;
              }
              const copy = new RoadDataContainer(this);
              copy._hasSecondBorderUvScale = false;
              copy._SecondBorderUvScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RoadDataContainer} other
   * @returns {RoadDataContainer}
   */
  merge(other) {
    const copy = new RoadDataContainer(this);
    copy._NodesData = this._NodesData.concat(other._NodesData);
    copy._EdgesData = this._EdgesData.concat(other._EdgesData);
    copy._PtList = this._PtList.concat(other._PtList);
    if (other._hasBorderOuter) {
      copy._hasBorderOuter = true;
      copy._BorderOuter = other._BorderOuter;
    }
    if (other._hasBorderInner) {
      copy._hasBorderInner = true;
      copy._BorderInner = other._BorderInner;
    }
    if (other._hasBorderUvScale) {
      copy._hasBorderUvScale = true;
      copy._BorderUvScale = other._BorderUvScale;
    }
    if (other._hasFirstBorderCenterHeight) {
      copy._hasFirstBorderCenterHeight = true;
      copy._FirstBorderCenterHeight = other._FirstBorderCenterHeight;
    }
    if (other._hasUseSecondBorder) {
      copy._hasUseSecondBorder = true;
      copy._UseSecondBorder = other._UseSecondBorder;
    }
    if (other._hasSecondBorderOuter) {
      copy._hasSecondBorderOuter = true;
      copy._SecondBorderOuter = other._SecondBorderOuter;
    }
    if (other._hasSecondBorderInner) {
      copy._hasSecondBorderInner = true;
      copy._SecondBorderInner = other._SecondBorderInner;
    }
    if (other._hasSecondBorderUvScale) {
      copy._hasSecondBorderUvScale = true;
      copy._SecondBorderUvScale = other._SecondBorderUvScale;
    }
    return copy;
  }
}
RoadDataContainer.default = new RoadDataContainer();
class RoadDataContainer_Builder {
  constructor(value) {
    this._value = new RoadDataContainer(value);
  }
  build() {
    return new RoadDataContainer(this._value);
  }
  addAllNodesData(values) {
    this._value._NodesData = this._value._NodesData.concat(values);
    return this;
  }
  addNodesData(value) {
    this._value._NodesData = this._value._NodesData.concat([value]);
    return this;
  }
  setNodesData(index, value) {
    this._value._NodesData = this._value._NodesData.concat();
    this._value._NodesData[index] = value;
    return this;
  }
  clearNodesData() {
    this._value._NodesData = [];
    return this;
  }
  addAllEdgesData(values) {
    this._value._EdgesData = this._value._EdgesData.concat(values);
    return this;
  }
  addEdgesData(value) {
    this._value._EdgesData = this._value._EdgesData.concat([value]);
    return this;
  }
  setEdgesData(index, value) {
    this._value._EdgesData = this._value._EdgesData.concat();
    this._value._EdgesData[index] = value;
    return this;
  }
  clearEdgesData() {
    this._value._EdgesData = [];
    return this;
  }
  addAllPtList(values) {
    this._value._PtList = this._value._PtList.concat(values);
    return this;
  }
  addPtList(value) {
    this._value._PtList = this._value._PtList.concat([value]);
    return this;
  }
  setPtList(index, value) {
    this._value._PtList = this._value._PtList.concat();
    this._value._PtList[index] = value;
    return this;
  }
  clearPtList() {
    this._value._PtList = [];
    return this;
  }
  setBorderOuter(value) {
    this._value._hasBorderOuter = true;
    this._value._BorderOuter = value;
    return this;
  }
  deleteBorderOuter() {
    this._value._hasBorderOuter = false;
    this._value._BorderOuter = null;
    return this;
  }
  setBorderInner(value) {
    this._value._hasBorderInner = true;
    this._value._BorderInner = value;
    return this;
  }
  deleteBorderInner() {
    this._value._hasBorderInner = false;
    this._value._BorderInner = null;
    return this;
  }
  setBorderUvScale(value) {
    this._value._hasBorderUvScale = true;
    this._value._BorderUvScale = value;
    return this;
  }
  deleteBorderUvScale() {
    this._value._hasBorderUvScale = false;
    this._value._BorderUvScale = null;
    return this;
  }
  setFirstBorderCenterHeight(value) {
    this._value._hasFirstBorderCenterHeight = true;
    this._value._FirstBorderCenterHeight = value;
    return this;
  }
  deleteFirstBorderCenterHeight() {
    this._value._hasFirstBorderCenterHeight = false;
    this._value._FirstBorderCenterHeight = null;
    return this;
  }
  setUseSecondBorder(value) {
    this._value._hasUseSecondBorder = true;
    this._value._UseSecondBorder = value;
    return this;
  }
  deleteUseSecondBorder() {
    this._value._hasUseSecondBorder = false;
    this._value._UseSecondBorder = null;
    return this;
  }
  setSecondBorderOuter(value) {
    this._value._hasSecondBorderOuter = true;
    this._value._SecondBorderOuter = value;
    return this;
  }
  deleteSecondBorderOuter() {
    this._value._hasSecondBorderOuter = false;
    this._value._SecondBorderOuter = null;
    return this;
  }
  setSecondBorderInner(value) {
    this._value._hasSecondBorderInner = true;
    this._value._SecondBorderInner = value;
    return this;
  }
  deleteSecondBorderInner() {
    this._value._hasSecondBorderInner = false;
    this._value._SecondBorderInner = null;
    return this;
  }
  setSecondBorderUvScale(value) {
    this._value._hasSecondBorderUvScale = true;
    this._value._SecondBorderUvScale = value;
    return this;
  }
  deleteSecondBorderUvScale() {
    this._value._hasSecondBorderUvScale = false;
    this._value._SecondBorderUvScale = null;
    return this;
  }
}
RoadDataContainer.Builder = RoadDataContainer_Builder;
class RoadDataContainer_WithParent {
  /**
   * @param {RoadDataContainer} value
   * @param {RoadDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RoadDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfNodesData() {
    if (!this._selfNodesData) {
      this._selfNodesData = [];
      for (let i of this._value.NodesData) {
        this._selfNodesData.push(new NodeData.WithParent(i, null));
      }
    }
    return this._selfNodesData;
  }
  get inherentNodesData() {
    if (!this._inherentNodesData) {
      this._inherentNodesData = this._parent ? this._parent.NodesData : [];
    }
    return this._inherentNodesData;
  }
  get NodesData() {
    if (!this._allNodesData) {
      this._allNodesData = this._parent ? this._parent.NodesData.concat(this.selfNodesData) : this.selfNodesData;
    }
    return this._allNodesData;
  }
  get selfEdgesData() {
    if (!this._selfEdgesData) {
      this._selfEdgesData = [];
      for (let i of this._value.EdgesData) {
        this._selfEdgesData.push(new EdgeData.WithParent(i, null));
      }
    }
    return this._selfEdgesData;
  }
  get inherentEdgesData() {
    if (!this._inherentEdgesData) {
      this._inherentEdgesData = this._parent ? this._parent.EdgesData : [];
    }
    return this._inherentEdgesData;
  }
  get EdgesData() {
    if (!this._allEdgesData) {
      this._allEdgesData = this._parent ? this._parent.EdgesData.concat(this.selfEdgesData) : this.selfEdgesData;
    }
    return this._allEdgesData;
  }
  get selfPtList() {
    if (!this._selfPtList) {
      this._selfPtList = [];
      for (let i of this._value.PtList) {
        this._selfPtList.push(new FVector3.WithParent(i, null));
      }
    }
    return this._selfPtList;
  }
  get inherentPtList() {
    if (!this._inherentPtList) {
      this._inherentPtList = this._parent ? this._parent.PtList : [];
    }
    return this._inherentPtList;
  }
  get PtList() {
    if (!this._allPtList) {
      this._allPtList = this._parent ? this._parent.PtList.concat(this.selfPtList) : this.selfPtList;
    }
    return this._allPtList;
  }
  get hasBorderOuter() {
    if (this._cachedHasBorderOuter === undefined) {
      if (this._value.hasBorderOuter) {
        this._cachedHasBorderOuter = true;
      } else {
        this._cachedHasBorderOuter = this._parent ? this._parent.hasBorderOuter : false;
      }
    }
    return this._cachedHasBorderOuter;
  }
  get BorderOuter() {
    if (this._cachedBorderOuter === undefined) {
      if (this._value.hasBorderOuter) {
        this._cachedBorderOuter = this._value.BorderOuter;
      } else {
        this._cachedBorderOuter = this._parent ? this._parent.BorderOuter : this._value.BorderOuter;
      }
    }
    return this._cachedBorderOuter;
  }
  get hasBorderInner() {
    if (this._cachedHasBorderInner === undefined) {
      if (this._value.hasBorderInner) {
        this._cachedHasBorderInner = true;
      } else {
        this._cachedHasBorderInner = this._parent ? this._parent.hasBorderInner : false;
      }
    }
    return this._cachedHasBorderInner;
  }
  get BorderInner() {
    if (this._cachedBorderInner === undefined) {
      if (this._value.hasBorderInner) {
        this._cachedBorderInner = this._value.BorderInner;
      } else {
        this._cachedBorderInner = this._parent ? this._parent.BorderInner : this._value.BorderInner;
      }
    }
    return this._cachedBorderInner;
  }
  get hasBorderUvScale() {
    if (this._cachedHasBorderUvScale === undefined) {
      if (this._value.hasBorderUvScale) {
        this._cachedHasBorderUvScale = true;
      } else {
        this._cachedHasBorderUvScale = this._parent ? this._parent.hasBorderUvScale : false;
      }
    }
    return this._cachedHasBorderUvScale;
  }
  get BorderUvScale() {
    if (this._cachedBorderUvScale === undefined) {
      if (this._value.hasBorderUvScale) {
        this._cachedBorderUvScale = this._value.BorderUvScale;
      } else {
        this._cachedBorderUvScale = this._parent ? this._parent.BorderUvScale : this._value.BorderUvScale;
      }
    }
    return this._cachedBorderUvScale;
  }
  get hasFirstBorderCenterHeight() {
    if (this._cachedHasFirstBorderCenterHeight === undefined) {
      if (this._value.hasFirstBorderCenterHeight) {
        this._cachedHasFirstBorderCenterHeight = true;
      } else {
        this._cachedHasFirstBorderCenterHeight = this._parent ? this._parent.hasFirstBorderCenterHeight : false;
      }
    }
    return this._cachedHasFirstBorderCenterHeight;
  }
  get FirstBorderCenterHeight() {
    if (this._cachedFirstBorderCenterHeight === undefined) {
      if (this._value.hasFirstBorderCenterHeight) {
        this._cachedFirstBorderCenterHeight = this._value.FirstBorderCenterHeight;
      } else {
        this._cachedFirstBorderCenterHeight = this._parent ? this._parent.FirstBorderCenterHeight : this._value.FirstBorderCenterHeight;
      }
    }
    return this._cachedFirstBorderCenterHeight;
  }
  get hasUseSecondBorder() {
    if (this._cachedHasUseSecondBorder === undefined) {
      if (this._value.hasUseSecondBorder) {
        this._cachedHasUseSecondBorder = true;
      } else {
        this._cachedHasUseSecondBorder = this._parent ? this._parent.hasUseSecondBorder : false;
      }
    }
    return this._cachedHasUseSecondBorder;
  }
  get UseSecondBorder() {
    if (this._cachedUseSecondBorder === undefined) {
      if (this._value.hasUseSecondBorder) {
        this._cachedUseSecondBorder = this._value.UseSecondBorder;
      } else {
        this._cachedUseSecondBorder = this._parent ? this._parent.UseSecondBorder : this._value.UseSecondBorder;
      }
    }
    return this._cachedUseSecondBorder;
  }
  get hasSecondBorderOuter() {
    if (this._cachedHasSecondBorderOuter === undefined) {
      if (this._value.hasSecondBorderOuter) {
        this._cachedHasSecondBorderOuter = true;
      } else {
        this._cachedHasSecondBorderOuter = this._parent ? this._parent.hasSecondBorderOuter : false;
      }
    }
    return this._cachedHasSecondBorderOuter;
  }
  get SecondBorderOuter() {
    if (this._cachedSecondBorderOuter === undefined) {
      if (this._value.hasSecondBorderOuter) {
        this._cachedSecondBorderOuter = this._value.SecondBorderOuter;
      } else {
        this._cachedSecondBorderOuter = this._parent ? this._parent.SecondBorderOuter : this._value.SecondBorderOuter;
      }
    }
    return this._cachedSecondBorderOuter;
  }
  get hasSecondBorderInner() {
    if (this._cachedHasSecondBorderInner === undefined) {
      if (this._value.hasSecondBorderInner) {
        this._cachedHasSecondBorderInner = true;
      } else {
        this._cachedHasSecondBorderInner = this._parent ? this._parent.hasSecondBorderInner : false;
      }
    }
    return this._cachedHasSecondBorderInner;
  }
  get SecondBorderInner() {
    if (this._cachedSecondBorderInner === undefined) {
      if (this._value.hasSecondBorderInner) {
        this._cachedSecondBorderInner = this._value.SecondBorderInner;
      } else {
        this._cachedSecondBorderInner = this._parent ? this._parent.SecondBorderInner : this._value.SecondBorderInner;
      }
    }
    return this._cachedSecondBorderInner;
  }
  get hasSecondBorderUvScale() {
    if (this._cachedHasSecondBorderUvScale === undefined) {
      if (this._value.hasSecondBorderUvScale) {
        this._cachedHasSecondBorderUvScale = true;
      } else {
        this._cachedHasSecondBorderUvScale = this._parent ? this._parent.hasSecondBorderUvScale : false;
      }
    }
    return this._cachedHasSecondBorderUvScale;
  }
  get SecondBorderUvScale() {
    if (this._cachedSecondBorderUvScale === undefined) {
      if (this._value.hasSecondBorderUvScale) {
        this._cachedSecondBorderUvScale = this._value.SecondBorderUvScale;
      } else {
        this._cachedSecondBorderUvScale = this._parent ? this._parent.SecondBorderUvScale : this._value.SecondBorderUvScale;
      }
    }
    return this._cachedSecondBorderUvScale;
  }
  update(current, parent) {
    const result = new RoadDataContainer_WithParent(current, parent);
    if (this._selfNodesData) {
      if (this._value.NodesData === current.NodesData) {
        result._selfNodesData = this._selfNodesData;
      } else {
        result._selfNodesData = [];
        for (let i = 0; i < current.NodesData.length; i++) {
          const oldValue = this._value.NodesData[i];
          if (oldValue) {
            const oldCache = this._selfNodesData[i];
            if (oldValue === current.NodesData[i]) {
              result._selfNodesData[i] = oldCache;
            } else {
              result._selfNodesData[i] = oldCache.update(current.NodesData[i], null);
            }
          } else {
            result._selfNodesData[i] = new NodeData.WithParent(current.NodesData[i], null);
          }
        }
      }
    }
    if (this._selfEdgesData) {
      if (this._value.EdgesData === current.EdgesData) {
        result._selfEdgesData = this._selfEdgesData;
      } else {
        result._selfEdgesData = [];
        for (let i = 0; i < current.EdgesData.length; i++) {
          const oldValue = this._value.EdgesData[i];
          if (oldValue) {
            const oldCache = this._selfEdgesData[i];
            if (oldValue === current.EdgesData[i]) {
              result._selfEdgesData[i] = oldCache;
            } else {
              result._selfEdgesData[i] = oldCache.update(current.EdgesData[i], null);
            }
          } else {
            result._selfEdgesData[i] = new EdgeData.WithParent(current.EdgesData[i], null);
          }
        }
      }
    }
    if (this._selfPtList) {
      if (this._value.PtList === current.PtList) {
        result._selfPtList = this._selfPtList;
      } else {
        result._selfPtList = [];
        for (let i = 0; i < current.PtList.length; i++) {
          const oldValue = this._value.PtList[i];
          if (oldValue) {
            const oldCache = this._selfPtList[i];
            if (oldValue === current.PtList[i]) {
              result._selfPtList[i] = oldCache;
            } else {
              result._selfPtList[i] = oldCache.update(current.PtList[i], null);
            }
          } else {
            result._selfPtList[i] = new FVector3.WithParent(current.PtList[i], null);
          }
        }
      }
    }
    return result;
  }
}
RoadDataContainer_WithParent.default = new RoadDataContainer_WithParent(RoadDataContainer.default, null);
RoadDataContainer.WithParent = RoadDataContainer_WithParent;
class RoadDataContainer_Descriptor {
  get NodesData() {
    if (!this._NodesData) {
      this._NodesData = {
        name: "NodesData",
        Name: "NodesData",
        number: 1,
        protoType: 11,
        protoName: "NodesData",
        type: NodeData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._NodesData;
  }
  get EdgesData() {
    if (!this._EdgesData) {
      this._EdgesData = {
        name: "EdgesData",
        Name: "EdgesData",
        number: 2,
        protoType: 11,
        protoName: "EdgesData",
        type: EdgeData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._EdgesData;
  }
  get PtList() {
    if (!this._PtList) {
      this._PtList = {
        name: "PtList",
        Name: "PtList",
        number: 3,
        protoType: 11,
        protoName: "PtList",
        type: FVector3,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PtList;
  }
  get BorderOuter() {
    if (!this._BorderOuter) {
      this._BorderOuter = {
        name: "BorderOuter",
        Name: "BorderOuter",
        number: 4,
        protoType: 1,
        protoName: "BorderOuter",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderOuter;
  }
  get BorderInner() {
    if (!this._BorderInner) {
      this._BorderInner = {
        name: "BorderInner",
        Name: "BorderInner",
        number: 5,
        protoType: 1,
        protoName: "BorderInner",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderInner;
  }
  get BorderUvScale() {
    if (!this._BorderUvScale) {
      this._BorderUvScale = {
        name: "BorderUvScale",
        Name: "BorderUvScale",
        number: 6,
        protoType: 1,
        protoName: "BorderUvScale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderUvScale;
  }
  get FirstBorderCenterHeight() {
    if (!this._FirstBorderCenterHeight) {
      this._FirstBorderCenterHeight = {
        name: "FirstBorderCenterHeight",
        Name: "FirstBorderCenterHeight",
        number: 7,
        protoType: 1,
        protoName: "FirstBorderCenterHeight",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._FirstBorderCenterHeight;
  }
  get UseSecondBorder() {
    if (!this._UseSecondBorder) {
      this._UseSecondBorder = {
        name: "UseSecondBorder",
        Name: "UseSecondBorder",
        number: 8,
        protoType: 8,
        protoName: "UseSecondBorder",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UseSecondBorder;
  }
  get SecondBorderOuter() {
    if (!this._SecondBorderOuter) {
      this._SecondBorderOuter = {
        name: "SecondBorderOuter",
        Name: "SecondBorderOuter",
        number: 9,
        protoType: 1,
        protoName: "SecondBorderOuter",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderOuter;
  }
  get SecondBorderInner() {
    if (!this._SecondBorderInner) {
      this._SecondBorderInner = {
        name: "SecondBorderInner",
        Name: "SecondBorderInner",
        number: 10,
        protoType: 1,
        protoName: "SecondBorderInner",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderInner;
  }
  get SecondBorderUvScale() {
    if (!this._SecondBorderUvScale) {
      this._SecondBorderUvScale = {
        name: "SecondBorderUvScale",
        Name: "SecondBorderUvScale",
        number: 11,
        protoType: 1,
        protoName: "SecondBorderUvScale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderUvScale;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.NodesData,
        this.EdgesData,
        this.PtList,
        this.BorderOuter,
        this.BorderInner,
        this.BorderUvScale,
        this.FirstBorderCenterHeight,
        this.UseSecondBorder,
        this.SecondBorderOuter,
        this.SecondBorderInner,
        this.SecondBorderUvScale,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBorderOuter",
        Name: "DummyOneofForBorderOuter",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBorderInner",
        Name: "DummyOneofForBorderInner",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBorderUvScale",
        Name: "DummyOneofForBorderUvScale",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFirstBorderCenterHeight",
        Name: "DummyOneofForFirstBorderCenterHeight",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseSecondBorder",
        Name: "DummyOneofForUseSecondBorder",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderOuter",
        Name: "DummyOneofForSecondBorderOuter",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderInner",
        Name: "DummyOneofForSecondBorderInner",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderUvScale",
        Name: "DummyOneofForSecondBorderUvScale",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
RoadDataContainer.descriptor = new RoadDataContainer_Descriptor();
export class NodeData {
  get descriptor() {
    return NodeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRadius = false;
    this._Radius = null;
    this._hasArcRadius = false;
    this._ArcRadius = null;
    this._hasIsCurveCenter = false;
    this._IsCurveCenter = null;
    this._EIndexList = [];
    this._hasTexBlend = false;
    this._TexBlend = null;
  }
  isEmpty() {
    if (this._hasRadius) return false;
    if (this._hasArcRadius) return false;
    if (this._hasIsCurveCenter) return false;
    if (this._EIndexList.length > 0) return false;
    if (this._hasTexBlend) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof NodeData) {
      return value;
    }
    return NodeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new NodeData();
    if (json.Radius != null) {
      result._hasRadius = true;
      result._Radius = JsonToDouble.fromJson(json.Radius);
    }
    if (json.ArcRadius != null) {
      result._hasArcRadius = true;
      result._ArcRadius = JsonToDouble.fromJson(json.ArcRadius);
    }
    if (json.IsCurveCenter != null) {
      result._hasIsCurveCenter = true;
      result._IsCurveCenter = JsonToBoolean.fromJson(json.IsCurveCenter);
    }
    result._EIndexList = JsonToList(json.EIndexList, JsonToInt32);
    if (json.TexBlend != null) {
      result._hasTexBlend = true;
      result._TexBlend = JsonToDouble.fromJson(json.TexBlend);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRadius) {
      result.Radius = JsonToDouble.toJson(this._Radius);
    }
    if (this._hasArcRadius) {
      result.ArcRadius = JsonToDouble.toJson(this._ArcRadius);
    }
    if (this._hasIsCurveCenter) {
      result.IsCurveCenter = JsonToBoolean.toJson(this._IsCurveCenter);
    }
    if (this._EIndexList.length > 0) {
      result.EIndexList = ArrayToJson(this._EIndexList, JsonToInt32);
    }
    if (this._hasTexBlend) {
      result.TexBlend = JsonToDouble.toJson(this._TexBlend);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get Radius() {
    return this._hasRadius ? this._Radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['Radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['Radius'])};
  }
  /**
   * @returns {number}
   */
  get ArcRadius() {
    return this._hasArcRadius ? this._ArcRadius : JsonToDouble.default;
  }
  get hasArcRadius() {
    return this._hasArcRadius;
  }
  setArcRadius(path, value) {
    return {type: 'SET', path: path.concat(['ArcRadius']), value};
  }
  deleteArcRadius(path) {
    return {type: 'DELETE', path: path.concat(['ArcRadius'])};
  }
  /**
   * @returns {boolean}
   */
  get IsCurveCenter() {
    return this._hasIsCurveCenter ? this._IsCurveCenter : JsonToBoolean.default;
  }
  get hasIsCurveCenter() {
    return this._hasIsCurveCenter;
  }
  setIsCurveCenter(path, value) {
    return {type: 'SET', path: path.concat(['IsCurveCenter']), value};
  }
  deleteIsCurveCenter(path) {
    return {type: 'DELETE', path: path.concat(['IsCurveCenter'])};
  }
  /**
   * @returns {number[]}
   */
  get EIndexList() {
    return this._EIndexList;
  }
  addEIndexList(path, value) {
    return {type: 'ADD', path: path.concat(['EIndexList']), value};
  }
  setEIndexList(path, value) {
    return {type: 'SET', path: path.concat(['EIndexList']), value: ArrayToJson(value, JsonToInt32)};
  }
  setEIndexListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['EIndexList', key]), value};
  }
  deleteEIndexList(path) {
    return {type: 'DELETE', path: path.concat(['EIndexList'])};
  }
  deleteEIndexListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['EIndexList', key])};
  }
  /**
   * @returns {number}
   */
  get TexBlend() {
    return this._hasTexBlend ? this._TexBlend : JsonToDouble.default;
  }
  get hasTexBlend() {
    return this._hasTexBlend;
  }
  setTexBlend(path, value) {
    return {type: 'SET', path: path.concat(['TexBlend']), value};
  }
  deleteTexBlend(path) {
    return {type: 'DELETE', path: path.concat(['TexBlend'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "Radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._hasRadius = true;
              copy._Radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new NodeData(this);
              copy._hasRadius = false;
              copy._Radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ArcRadius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._hasArcRadius = true;
              copy._ArcRadius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArcRadius) {
                return this;
              }
              const copy = new NodeData(this);
              copy._hasArcRadius = false;
              copy._ArcRadius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "IsCurveCenter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._hasIsCurveCenter = true;
              copy._IsCurveCenter = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsCurveCenter) {
                return this;
              }
              const copy = new NodeData(this);
              copy._hasIsCurveCenter = false;
              copy._IsCurveCenter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "EIndexList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._EIndexList = [];        for (let i of value) {
                copy._EIndexList.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new NodeData(this);
              copy._EIndexList = copy._EIndexList.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._EIndexList.length === 0) {
                return this;
              }
              const copy = new NodeData(this);
              copy._EIndexList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._EIndexList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._EIndexList = copy._EIndexList.slice();
              copy._EIndexList[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new NodeData(this);
              copy._EIndexList = copy._EIndexList.slice(0, path[1]).concat(copy._EIndexList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._EIndexList.length) {
            return this;
          }
          const oldValue = this._EIndexList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new NodeData(this);
          copy._EIndexList = copy._EIndexList.slice();
          copy._EIndexList[key] = newValue;
          return copy;
        }
      }
      case "TexBlend": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeData(this);
              copy._hasTexBlend = true;
              copy._TexBlend = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTexBlend) {
                return this;
              }
              const copy = new NodeData(this);
              copy._hasTexBlend = false;
              copy._TexBlend = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {NodeData} other
   * @returns {NodeData}
   */
  merge(other) {
    const copy = new NodeData(this);
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._Radius = other._Radius;
    }
    if (other._hasArcRadius) {
      copy._hasArcRadius = true;
      copy._ArcRadius = other._ArcRadius;
    }
    if (other._hasIsCurveCenter) {
      copy._hasIsCurveCenter = true;
      copy._IsCurveCenter = other._IsCurveCenter;
    }
    copy._EIndexList = this._EIndexList.concat(other._EIndexList);
    if (other._hasTexBlend) {
      copy._hasTexBlend = true;
      copy._TexBlend = other._TexBlend;
    }
    return copy;
  }
}
NodeData.default = new NodeData();
class NodeData_Builder {
  constructor(value) {
    this._value = new NodeData(value);
  }
  build() {
    return new NodeData(this._value);
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._Radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._Radius = null;
    return this;
  }
  setArcRadius(value) {
    this._value._hasArcRadius = true;
    this._value._ArcRadius = value;
    return this;
  }
  deleteArcRadius() {
    this._value._hasArcRadius = false;
    this._value._ArcRadius = null;
    return this;
  }
  setIsCurveCenter(value) {
    this._value._hasIsCurveCenter = true;
    this._value._IsCurveCenter = value;
    return this;
  }
  deleteIsCurveCenter() {
    this._value._hasIsCurveCenter = false;
    this._value._IsCurveCenter = null;
    return this;
  }
  addAllEIndexList(values) {
    this._value._EIndexList = this._value._EIndexList.concat(values);
    return this;
  }
  addEIndexList(value) {
    this._value._EIndexList = this._value._EIndexList.concat([value]);
    return this;
  }
  setEIndexList(index, value) {
    this._value._EIndexList = this._value._EIndexList.concat();
    this._value._EIndexList[index] = value;
    return this;
  }
  clearEIndexList() {
    this._value._EIndexList = [];
    return this;
  }
  setTexBlend(value) {
    this._value._hasTexBlend = true;
    this._value._TexBlend = value;
    return this;
  }
  deleteTexBlend() {
    this._value._hasTexBlend = false;
    this._value._TexBlend = null;
    return this;
  }
}
NodeData.Builder = NodeData_Builder;
class NodeData_WithParent {
  /**
   * @param {NodeData} value
   * @param {NodeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return NodeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get Radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.Radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.Radius : this._value.Radius;
      }
    }
    return this._cachedRadius;
  }
  get hasArcRadius() {
    if (this._cachedHasArcRadius === undefined) {
      if (this._value.hasArcRadius) {
        this._cachedHasArcRadius = true;
      } else {
        this._cachedHasArcRadius = this._parent ? this._parent.hasArcRadius : false;
      }
    }
    return this._cachedHasArcRadius;
  }
  get ArcRadius() {
    if (this._cachedArcRadius === undefined) {
      if (this._value.hasArcRadius) {
        this._cachedArcRadius = this._value.ArcRadius;
      } else {
        this._cachedArcRadius = this._parent ? this._parent.ArcRadius : this._value.ArcRadius;
      }
    }
    return this._cachedArcRadius;
  }
  get hasIsCurveCenter() {
    if (this._cachedHasIsCurveCenter === undefined) {
      if (this._value.hasIsCurveCenter) {
        this._cachedHasIsCurveCenter = true;
      } else {
        this._cachedHasIsCurveCenter = this._parent ? this._parent.hasIsCurveCenter : false;
      }
    }
    return this._cachedHasIsCurveCenter;
  }
  get IsCurveCenter() {
    if (this._cachedIsCurveCenter === undefined) {
      if (this._value.hasIsCurveCenter) {
        this._cachedIsCurveCenter = this._value.IsCurveCenter;
      } else {
        this._cachedIsCurveCenter = this._parent ? this._parent.IsCurveCenter : this._value.IsCurveCenter;
      }
    }
    return this._cachedIsCurveCenter;
  }
  get selfEIndexList() {
    return this._value.EIndexList;
  }
  get inherentEIndexList() {
    if (!this._inherentEIndexList) {
      this._inherentEIndexList = this._parent ? this._parent.EIndexList : [];
    }
    return this._inherentEIndexList;
  }
  get EIndexList() {
    if (!this._allEIndexList) {
      this._allEIndexList = this._parent ? this._parent.EIndexList.concat(this.selfEIndexList) : this.selfEIndexList;
    }
    return this._allEIndexList;
  }
  get hasTexBlend() {
    if (this._cachedHasTexBlend === undefined) {
      if (this._value.hasTexBlend) {
        this._cachedHasTexBlend = true;
      } else {
        this._cachedHasTexBlend = this._parent ? this._parent.hasTexBlend : false;
      }
    }
    return this._cachedHasTexBlend;
  }
  get TexBlend() {
    if (this._cachedTexBlend === undefined) {
      if (this._value.hasTexBlend) {
        this._cachedTexBlend = this._value.TexBlend;
      } else {
        this._cachedTexBlend = this._parent ? this._parent.TexBlend : this._value.TexBlend;
      }
    }
    return this._cachedTexBlend;
  }
  update(current, parent) {
    const result = new NodeData_WithParent(current, parent);
    return result;
  }
}
NodeData_WithParent.default = new NodeData_WithParent(NodeData.default, null);
NodeData.WithParent = NodeData_WithParent;
class NodeData_Descriptor {
  get Radius() {
    if (!this._Radius) {
      this._Radius = {
        name: "Radius",
        Name: "Radius",
        number: 1,
        protoType: 1,
        protoName: "Radius",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Radius;
  }
  get ArcRadius() {
    if (!this._ArcRadius) {
      this._ArcRadius = {
        name: "ArcRadius",
        Name: "ArcRadius",
        number: 2,
        protoType: 1,
        protoName: "ArcRadius",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ArcRadius;
  }
  get IsCurveCenter() {
    if (!this._IsCurveCenter) {
      this._IsCurveCenter = {
        name: "IsCurveCenter",
        Name: "IsCurveCenter",
        number: 3,
        protoType: 8,
        protoName: "IsCurveCenter",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._IsCurveCenter;
  }
  get EIndexList() {
    if (!this._EIndexList) {
      this._EIndexList = {
        name: "EIndexList",
        Name: "EIndexList",
        number: 4,
        protoType: 5,
        protoName: "EIndexList",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._EIndexList;
  }
  get TexBlend() {
    if (!this._TexBlend) {
      this._TexBlend = {
        name: "TexBlend",
        Name: "TexBlend",
        number: 5,
        protoType: 1,
        protoName: "TexBlend",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TexBlend;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.Radius,
        this.ArcRadius,
        this.IsCurveCenter,
        this.EIndexList,
        this.TexBlend,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForArcRadius",
        Name: "DummyOneofForArcRadius",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsCurveCenter",
        Name: "DummyOneofForIsCurveCenter",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTexBlend",
        Name: "DummyOneofForTexBlend",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
NodeData.descriptor = new NodeData_Descriptor();
export class EdgeData {
  get descriptor() {
    return EdgeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStartNodeIndex = false;
    this._StartNodeIndex = null;
    this._hasEndNodeIndex = false;
    this._EndNodeIndex = null;
    this._hasNextEdgeIndex = false;
    this._NextEdgeIndex = null;
    this._hasTwinEdgeIndex = false;
    this._TwinEdgeIndex = null;
  }
  isEmpty() {
    if (this._hasStartNodeIndex) return false;
    if (this._hasEndNodeIndex) return false;
    if (this._hasNextEdgeIndex) return false;
    if (this._hasTwinEdgeIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EdgeData) {
      return value;
    }
    return EdgeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new EdgeData();
    if (json.StartNodeIndex != null) {
      result._hasStartNodeIndex = true;
      result._StartNodeIndex = JsonToInt32.fromJson(json.StartNodeIndex);
    }
    if (json.EndNodeIndex != null) {
      result._hasEndNodeIndex = true;
      result._EndNodeIndex = JsonToInt32.fromJson(json.EndNodeIndex);
    }
    if (json.NextEdgeIndex != null) {
      result._hasNextEdgeIndex = true;
      result._NextEdgeIndex = JsonToInt32.fromJson(json.NextEdgeIndex);
    }
    if (json.TwinEdgeIndex != null) {
      result._hasTwinEdgeIndex = true;
      result._TwinEdgeIndex = JsonToInt32.fromJson(json.TwinEdgeIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStartNodeIndex) {
      result.StartNodeIndex = JsonToInt32.toJson(this._StartNodeIndex);
    }
    if (this._hasEndNodeIndex) {
      result.EndNodeIndex = JsonToInt32.toJson(this._EndNodeIndex);
    }
    if (this._hasNextEdgeIndex) {
      result.NextEdgeIndex = JsonToInt32.toJson(this._NextEdgeIndex);
    }
    if (this._hasTwinEdgeIndex) {
      result.TwinEdgeIndex = JsonToInt32.toJson(this._TwinEdgeIndex);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get StartNodeIndex() {
    return this._hasStartNodeIndex ? this._StartNodeIndex : JsonToInt32.default;
  }
  get hasStartNodeIndex() {
    return this._hasStartNodeIndex;
  }
  setStartNodeIndex(path, value) {
    return {type: 'SET', path: path.concat(['StartNodeIndex']), value};
  }
  deleteStartNodeIndex(path) {
    return {type: 'DELETE', path: path.concat(['StartNodeIndex'])};
  }
  /**
   * @returns {number}
   */
  get EndNodeIndex() {
    return this._hasEndNodeIndex ? this._EndNodeIndex : JsonToInt32.default;
  }
  get hasEndNodeIndex() {
    return this._hasEndNodeIndex;
  }
  setEndNodeIndex(path, value) {
    return {type: 'SET', path: path.concat(['EndNodeIndex']), value};
  }
  deleteEndNodeIndex(path) {
    return {type: 'DELETE', path: path.concat(['EndNodeIndex'])};
  }
  /**
   * @returns {number}
   */
  get NextEdgeIndex() {
    return this._hasNextEdgeIndex ? this._NextEdgeIndex : JsonToInt32.default;
  }
  get hasNextEdgeIndex() {
    return this._hasNextEdgeIndex;
  }
  setNextEdgeIndex(path, value) {
    return {type: 'SET', path: path.concat(['NextEdgeIndex']), value};
  }
  deleteNextEdgeIndex(path) {
    return {type: 'DELETE', path: path.concat(['NextEdgeIndex'])};
  }
  /**
   * @returns {number}
   */
  get TwinEdgeIndex() {
    return this._hasTwinEdgeIndex ? this._TwinEdgeIndex : JsonToInt32.default;
  }
  get hasTwinEdgeIndex() {
    return this._hasTwinEdgeIndex;
  }
  setTwinEdgeIndex(path, value) {
    return {type: 'SET', path: path.concat(['TwinEdgeIndex']), value};
  }
  deleteTwinEdgeIndex(path) {
    return {type: 'DELETE', path: path.concat(['TwinEdgeIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "StartNodeIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EdgeData(this);
              copy._hasStartNodeIndex = true;
              copy._StartNodeIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartNodeIndex) {
                return this;
              }
              const copy = new EdgeData(this);
              copy._hasStartNodeIndex = false;
              copy._StartNodeIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "EndNodeIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EdgeData(this);
              copy._hasEndNodeIndex = true;
              copy._EndNodeIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndNodeIndex) {
                return this;
              }
              const copy = new EdgeData(this);
              copy._hasEndNodeIndex = false;
              copy._EndNodeIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "NextEdgeIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EdgeData(this);
              copy._hasNextEdgeIndex = true;
              copy._NextEdgeIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNextEdgeIndex) {
                return this;
              }
              const copy = new EdgeData(this);
              copy._hasNextEdgeIndex = false;
              copy._NextEdgeIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "TwinEdgeIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EdgeData(this);
              copy._hasTwinEdgeIndex = true;
              copy._TwinEdgeIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTwinEdgeIndex) {
                return this;
              }
              const copy = new EdgeData(this);
              copy._hasTwinEdgeIndex = false;
              copy._TwinEdgeIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EdgeData} other
   * @returns {EdgeData}
   */
  merge(other) {
    const copy = new EdgeData(this);
    if (other._hasStartNodeIndex) {
      copy._hasStartNodeIndex = true;
      copy._StartNodeIndex = other._StartNodeIndex;
    }
    if (other._hasEndNodeIndex) {
      copy._hasEndNodeIndex = true;
      copy._EndNodeIndex = other._EndNodeIndex;
    }
    if (other._hasNextEdgeIndex) {
      copy._hasNextEdgeIndex = true;
      copy._NextEdgeIndex = other._NextEdgeIndex;
    }
    if (other._hasTwinEdgeIndex) {
      copy._hasTwinEdgeIndex = true;
      copy._TwinEdgeIndex = other._TwinEdgeIndex;
    }
    return copy;
  }
}
EdgeData.default = new EdgeData();
class EdgeData_Builder {
  constructor(value) {
    this._value = new EdgeData(value);
  }
  build() {
    return new EdgeData(this._value);
  }
  setStartNodeIndex(value) {
    this._value._hasStartNodeIndex = true;
    this._value._StartNodeIndex = value;
    return this;
  }
  deleteStartNodeIndex() {
    this._value._hasStartNodeIndex = false;
    this._value._StartNodeIndex = null;
    return this;
  }
  setEndNodeIndex(value) {
    this._value._hasEndNodeIndex = true;
    this._value._EndNodeIndex = value;
    return this;
  }
  deleteEndNodeIndex() {
    this._value._hasEndNodeIndex = false;
    this._value._EndNodeIndex = null;
    return this;
  }
  setNextEdgeIndex(value) {
    this._value._hasNextEdgeIndex = true;
    this._value._NextEdgeIndex = value;
    return this;
  }
  deleteNextEdgeIndex() {
    this._value._hasNextEdgeIndex = false;
    this._value._NextEdgeIndex = null;
    return this;
  }
  setTwinEdgeIndex(value) {
    this._value._hasTwinEdgeIndex = true;
    this._value._TwinEdgeIndex = value;
    return this;
  }
  deleteTwinEdgeIndex() {
    this._value._hasTwinEdgeIndex = false;
    this._value._TwinEdgeIndex = null;
    return this;
  }
}
EdgeData.Builder = EdgeData_Builder;
class EdgeData_WithParent {
  /**
   * @param {EdgeData} value
   * @param {EdgeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EdgeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStartNodeIndex() {
    if (this._cachedHasStartNodeIndex === undefined) {
      if (this._value.hasStartNodeIndex) {
        this._cachedHasStartNodeIndex = true;
      } else {
        this._cachedHasStartNodeIndex = this._parent ? this._parent.hasStartNodeIndex : false;
      }
    }
    return this._cachedHasStartNodeIndex;
  }
  get StartNodeIndex() {
    if (this._cachedStartNodeIndex === undefined) {
      if (this._value.hasStartNodeIndex) {
        this._cachedStartNodeIndex = this._value.StartNodeIndex;
      } else {
        this._cachedStartNodeIndex = this._parent ? this._parent.StartNodeIndex : this._value.StartNodeIndex;
      }
    }
    return this._cachedStartNodeIndex;
  }
  get hasEndNodeIndex() {
    if (this._cachedHasEndNodeIndex === undefined) {
      if (this._value.hasEndNodeIndex) {
        this._cachedHasEndNodeIndex = true;
      } else {
        this._cachedHasEndNodeIndex = this._parent ? this._parent.hasEndNodeIndex : false;
      }
    }
    return this._cachedHasEndNodeIndex;
  }
  get EndNodeIndex() {
    if (this._cachedEndNodeIndex === undefined) {
      if (this._value.hasEndNodeIndex) {
        this._cachedEndNodeIndex = this._value.EndNodeIndex;
      } else {
        this._cachedEndNodeIndex = this._parent ? this._parent.EndNodeIndex : this._value.EndNodeIndex;
      }
    }
    return this._cachedEndNodeIndex;
  }
  get hasNextEdgeIndex() {
    if (this._cachedHasNextEdgeIndex === undefined) {
      if (this._value.hasNextEdgeIndex) {
        this._cachedHasNextEdgeIndex = true;
      } else {
        this._cachedHasNextEdgeIndex = this._parent ? this._parent.hasNextEdgeIndex : false;
      }
    }
    return this._cachedHasNextEdgeIndex;
  }
  get NextEdgeIndex() {
    if (this._cachedNextEdgeIndex === undefined) {
      if (this._value.hasNextEdgeIndex) {
        this._cachedNextEdgeIndex = this._value.NextEdgeIndex;
      } else {
        this._cachedNextEdgeIndex = this._parent ? this._parent.NextEdgeIndex : this._value.NextEdgeIndex;
      }
    }
    return this._cachedNextEdgeIndex;
  }
  get hasTwinEdgeIndex() {
    if (this._cachedHasTwinEdgeIndex === undefined) {
      if (this._value.hasTwinEdgeIndex) {
        this._cachedHasTwinEdgeIndex = true;
      } else {
        this._cachedHasTwinEdgeIndex = this._parent ? this._parent.hasTwinEdgeIndex : false;
      }
    }
    return this._cachedHasTwinEdgeIndex;
  }
  get TwinEdgeIndex() {
    if (this._cachedTwinEdgeIndex === undefined) {
      if (this._value.hasTwinEdgeIndex) {
        this._cachedTwinEdgeIndex = this._value.TwinEdgeIndex;
      } else {
        this._cachedTwinEdgeIndex = this._parent ? this._parent.TwinEdgeIndex : this._value.TwinEdgeIndex;
      }
    }
    return this._cachedTwinEdgeIndex;
  }
  update(current, parent) {
    const result = new EdgeData_WithParent(current, parent);
    return result;
  }
}
EdgeData_WithParent.default = new EdgeData_WithParent(EdgeData.default, null);
EdgeData.WithParent = EdgeData_WithParent;
class EdgeData_Descriptor {
  get StartNodeIndex() {
    if (!this._StartNodeIndex) {
      this._StartNodeIndex = {
        name: "StartNodeIndex",
        Name: "StartNodeIndex",
        number: 1,
        protoType: 5,
        protoName: "StartNodeIndex",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._StartNodeIndex;
  }
  get EndNodeIndex() {
    if (!this._EndNodeIndex) {
      this._EndNodeIndex = {
        name: "EndNodeIndex",
        Name: "EndNodeIndex",
        number: 2,
        protoType: 5,
        protoName: "EndNodeIndex",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._EndNodeIndex;
  }
  get NextEdgeIndex() {
    if (!this._NextEdgeIndex) {
      this._NextEdgeIndex = {
        name: "NextEdgeIndex",
        Name: "NextEdgeIndex",
        number: 3,
        protoType: 5,
        protoName: "NextEdgeIndex",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._NextEdgeIndex;
  }
  get TwinEdgeIndex() {
    if (!this._TwinEdgeIndex) {
      this._TwinEdgeIndex = {
        name: "TwinEdgeIndex",
        Name: "TwinEdgeIndex",
        number: 4,
        protoType: 5,
        protoName: "TwinEdgeIndex",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TwinEdgeIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.StartNodeIndex,
        this.EndNodeIndex,
        this.NextEdgeIndex,
        this.TwinEdgeIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartNodeIndex",
        Name: "DummyOneofForStartNodeIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndNodeIndex",
        Name: "DummyOneofForEndNodeIndex",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNextEdgeIndex",
        Name: "DummyOneofForNextEdgeIndex",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTwinEdgeIndex",
        Name: "DummyOneofForTwinEdgeIndex",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
EdgeData.descriptor = new EdgeData_Descriptor();
export class MaterialSetting {
  get descriptor() {
    return MaterialSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTileMatPath = false;
    this._TileMatPath = null;
    this._hasWaterMaterialPath = false;
    this._WaterMaterialPath = null;
    this._hasRoadPavMatPath = false;
    this._RoadPavMatPath = null;
    this._hasRoadBorderMatPath = false;
    this._RoadBorderMatPath = null;
    this._hasRoadSecondBorderMatPath = false;
    this._RoadSecondBorderMatPath = null;
    this._LayerTexturePaths = [];
    this._hasPostEffectMatPath = false;
    this._PostEffectMatPath = null;
    this._LayerLockStatus = [];
    this._hasRoadBorderData = false;
    this._RoadBorderData = null;
  }
  isEmpty() {
    if (this._hasTileMatPath) return false;
    if (this._hasWaterMaterialPath) return false;
    if (this._hasRoadPavMatPath) return false;
    if (this._hasRoadBorderMatPath) return false;
    if (this._hasRoadSecondBorderMatPath) return false;
    if (this._LayerTexturePaths.length > 0) return false;
    if (this._hasPostEffectMatPath) return false;
    if (this._LayerLockStatus.length > 0) return false;
    if (this._hasRoadBorderData && !this._RoadBorderData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MaterialSetting) {
      return value;
    }
    return MaterialSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new MaterialSetting();
    if (json.TileMatPath != null) {
      result._hasTileMatPath = true;
      result._TileMatPath = JsonToString.fromJson(json.TileMatPath);
    }
    if (json.WaterMaterialPath != null) {
      result._hasWaterMaterialPath = true;
      result._WaterMaterialPath = JsonToString.fromJson(json.WaterMaterialPath);
    }
    if (json.RoadPavMatPath != null) {
      result._hasRoadPavMatPath = true;
      result._RoadPavMatPath = JsonToString.fromJson(json.RoadPavMatPath);
    }
    if (json.RoadBorderMatPath != null) {
      result._hasRoadBorderMatPath = true;
      result._RoadBorderMatPath = JsonToString.fromJson(json.RoadBorderMatPath);
    }
    if (json.RoadSecondBorderMatPath != null) {
      result._hasRoadSecondBorderMatPath = true;
      result._RoadSecondBorderMatPath = JsonToString.fromJson(json.RoadSecondBorderMatPath);
    }
    result._LayerTexturePaths = JsonToList(json.LayerTexturePaths, JsonToString);
    if (json.PostEffectMatPath != null) {
      result._hasPostEffectMatPath = true;
      result._PostEffectMatPath = JsonToString.fromJson(json.PostEffectMatPath);
    }
    result._LayerLockStatus = JsonToList(json.LayerLockStatus, JsonToBoolean);
    if (json.RoadBorderData != null) {
      result._hasRoadBorderData = true;
      result._RoadBorderData = RoadBorderData.fromJson(json.RoadBorderData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTileMatPath) {
      result.TileMatPath = JsonToString.toJson(this._TileMatPath);
    }
    if (this._hasWaterMaterialPath) {
      result.WaterMaterialPath = JsonToString.toJson(this._WaterMaterialPath);
    }
    if (this._hasRoadPavMatPath) {
      result.RoadPavMatPath = JsonToString.toJson(this._RoadPavMatPath);
    }
    if (this._hasRoadBorderMatPath) {
      result.RoadBorderMatPath = JsonToString.toJson(this._RoadBorderMatPath);
    }
    if (this._hasRoadSecondBorderMatPath) {
      result.RoadSecondBorderMatPath = JsonToString.toJson(this._RoadSecondBorderMatPath);
    }
    if (this._LayerTexturePaths.length > 0) {
      result.LayerTexturePaths = ArrayToJson(this._LayerTexturePaths, JsonToString);
    }
    if (this._hasPostEffectMatPath) {
      result.PostEffectMatPath = JsonToString.toJson(this._PostEffectMatPath);
    }
    if (this._LayerLockStatus.length > 0) {
      result.LayerLockStatus = ArrayToJson(this._LayerLockStatus, JsonToBoolean);
    }
    if (this._hasRoadBorderData && !this._RoadBorderData.isEmpty()) {
      result.RoadBorderData = RoadBorderData.toJson(this._RoadBorderData);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get TileMatPath() {
    return this._hasTileMatPath ? this._TileMatPath : JsonToString.default;
  }
  get hasTileMatPath() {
    return this._hasTileMatPath;
  }
  setTileMatPath(path, value) {
    return {type: 'SET', path: path.concat(['TileMatPath']), value};
  }
  deleteTileMatPath(path) {
    return {type: 'DELETE', path: path.concat(['TileMatPath'])};
  }
  /**
   * @returns {string}
   */
  get WaterMaterialPath() {
    return this._hasWaterMaterialPath ? this._WaterMaterialPath : JsonToString.default;
  }
  get hasWaterMaterialPath() {
    return this._hasWaterMaterialPath;
  }
  setWaterMaterialPath(path, value) {
    return {type: 'SET', path: path.concat(['WaterMaterialPath']), value};
  }
  deleteWaterMaterialPath(path) {
    return {type: 'DELETE', path: path.concat(['WaterMaterialPath'])};
  }
  /**
   * @returns {string}
   */
  get RoadPavMatPath() {
    return this._hasRoadPavMatPath ? this._RoadPavMatPath : JsonToString.default;
  }
  get hasRoadPavMatPath() {
    return this._hasRoadPavMatPath;
  }
  setRoadPavMatPath(path, value) {
    return {type: 'SET', path: path.concat(['RoadPavMatPath']), value};
  }
  deleteRoadPavMatPath(path) {
    return {type: 'DELETE', path: path.concat(['RoadPavMatPath'])};
  }
  /**
   * @returns {string}
   */
  get RoadBorderMatPath() {
    return this._hasRoadBorderMatPath ? this._RoadBorderMatPath : JsonToString.default;
  }
  get hasRoadBorderMatPath() {
    return this._hasRoadBorderMatPath;
  }
  setRoadBorderMatPath(path, value) {
    return {type: 'SET', path: path.concat(['RoadBorderMatPath']), value};
  }
  deleteRoadBorderMatPath(path) {
    return {type: 'DELETE', path: path.concat(['RoadBorderMatPath'])};
  }
  /**
   * @returns {string}
   */
  get RoadSecondBorderMatPath() {
    return this._hasRoadSecondBorderMatPath ? this._RoadSecondBorderMatPath : JsonToString.default;
  }
  get hasRoadSecondBorderMatPath() {
    return this._hasRoadSecondBorderMatPath;
  }
  setRoadSecondBorderMatPath(path, value) {
    return {type: 'SET', path: path.concat(['RoadSecondBorderMatPath']), value};
  }
  deleteRoadSecondBorderMatPath(path) {
    return {type: 'DELETE', path: path.concat(['RoadSecondBorderMatPath'])};
  }
  /**
   * @returns {string[]}
   */
  get LayerTexturePaths() {
    return this._LayerTexturePaths;
  }
  addLayerTexturePaths(path, value) {
    return {type: 'ADD', path: path.concat(['LayerTexturePaths']), value};
  }
  setLayerTexturePaths(path, value) {
    return {type: 'SET', path: path.concat(['LayerTexturePaths']), value: ArrayToJson(value, JsonToString)};
  }
  setLayerTexturePathsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['LayerTexturePaths', key]), value};
  }
  deleteLayerTexturePaths(path) {
    return {type: 'DELETE', path: path.concat(['LayerTexturePaths'])};
  }
  deleteLayerTexturePathsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['LayerTexturePaths', key])};
  }
  /**
   * @returns {string}
   */
  get PostEffectMatPath() {
    return this._hasPostEffectMatPath ? this._PostEffectMatPath : JsonToString.default;
  }
  get hasPostEffectMatPath() {
    return this._hasPostEffectMatPath;
  }
  setPostEffectMatPath(path, value) {
    return {type: 'SET', path: path.concat(['PostEffectMatPath']), value};
  }
  deletePostEffectMatPath(path) {
    return {type: 'DELETE', path: path.concat(['PostEffectMatPath'])};
  }
  /**
   * @returns {boolean[]}
   */
  get LayerLockStatus() {
    return this._LayerLockStatus;
  }
  addLayerLockStatus(path, value) {
    return {type: 'ADD', path: path.concat(['LayerLockStatus']), value};
  }
  setLayerLockStatus(path, value) {
    return {type: 'SET', path: path.concat(['LayerLockStatus']), value: ArrayToJson(value, JsonToBoolean)};
  }
  setLayerLockStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['LayerLockStatus', key]), value};
  }
  deleteLayerLockStatus(path) {
    return {type: 'DELETE', path: path.concat(['LayerLockStatus'])};
  }
  deleteLayerLockStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['LayerLockStatus', key])};
  }
  /**
   * @returns {RoadBorderData}
   */
  get RoadBorderData() {
    return this._hasRoadBorderData ? this._RoadBorderData : RoadBorderData.default;
  }
  get hasRoadBorderData() {
    return this._hasRoadBorderData;
  }
  setRoadBorderData(path, value) {
    return {type: 'SET', path: path.concat(['RoadBorderData']), value: value.toJson()};
  }
  deleteRoadBorderData(path) {
    return {type: 'DELETE', path: path.concat(['RoadBorderData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "TileMatPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasTileMatPath = true;
              copy._TileMatPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileMatPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasTileMatPath = false;
              copy._TileMatPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "WaterMaterialPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasWaterMaterialPath = true;
              copy._WaterMaterialPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterMaterialPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasWaterMaterialPath = false;
              copy._WaterMaterialPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "RoadPavMatPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasRoadPavMatPath = true;
              copy._RoadPavMatPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadPavMatPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasRoadPavMatPath = false;
              copy._RoadPavMatPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "RoadBorderMatPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasRoadBorderMatPath = true;
              copy._RoadBorderMatPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadBorderMatPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasRoadBorderMatPath = false;
              copy._RoadBorderMatPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "RoadSecondBorderMatPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasRoadSecondBorderMatPath = true;
              copy._RoadSecondBorderMatPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadSecondBorderMatPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasRoadSecondBorderMatPath = false;
              copy._RoadSecondBorderMatPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "LayerTexturePaths": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._LayerTexturePaths = [];        for (let i of value) {
                copy._LayerTexturePaths.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MaterialSetting(this);
              copy._LayerTexturePaths = copy._LayerTexturePaths.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._LayerTexturePaths.length === 0) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._LayerTexturePaths = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._LayerTexturePaths.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._LayerTexturePaths = copy._LayerTexturePaths.slice();
              copy._LayerTexturePaths[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MaterialSetting(this);
              copy._LayerTexturePaths = copy._LayerTexturePaths.slice(0, path[1]).concat(copy._LayerTexturePaths.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._LayerTexturePaths.length) {
            return this;
          }
          const oldValue = this._LayerTexturePaths[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MaterialSetting(this);
          copy._LayerTexturePaths = copy._LayerTexturePaths.slice();
          copy._LayerTexturePaths[key] = newValue;
          return copy;
        }
      }
      case "PostEffectMatPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasPostEffectMatPath = true;
              copy._PostEffectMatPath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPostEffectMatPath) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasPostEffectMatPath = false;
              copy._PostEffectMatPath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "LayerLockStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._LayerLockStatus = [];        for (let i of value) {
                copy._LayerLockStatus.push(JsonToBoolean.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MaterialSetting(this);
              copy._LayerLockStatus = copy._LayerLockStatus.concat([JsonToBoolean.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._LayerLockStatus.length === 0) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._LayerLockStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._LayerLockStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._LayerLockStatus = copy._LayerLockStatus.slice();
              copy._LayerLockStatus[path[1]] = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MaterialSetting(this);
              copy._LayerLockStatus = copy._LayerLockStatus.slice(0, path[1]).concat(copy._LayerLockStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._LayerLockStatus.length) {
            return this;
          }
          const oldValue = this._LayerLockStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MaterialSetting(this);
          copy._LayerLockStatus = copy._LayerLockStatus.slice();
          copy._LayerLockStatus[key] = newValue;
          return copy;
        }
      }
      case "RoadBorderData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MaterialSetting(this);
              copy._hasRoadBorderData = true;
              copy._RoadBorderData = RoadBorderData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRoadBorderData) {
                return this;
              }
              const copy = new MaterialSetting(this);
              copy._hasRoadBorderData = false;
              copy._RoadBorderData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRoadBorderData) {
            const copy = new MaterialSetting(this);
            copy._hasRoadBorderData = true;
            copy._RoadBorderData = RoadBorderData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._RoadBorderData.apply(type, path.slice(1), value);
          if (newValue === this._RoadBorderData) {
            return this;
          }
          const copy = new MaterialSetting(this);
          copy._RoadBorderData = copy._RoadBorderData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MaterialSetting} other
   * @returns {MaterialSetting}
   */
  merge(other) {
    const copy = new MaterialSetting(this);
    if (other._hasTileMatPath) {
      copy._hasTileMatPath = true;
      copy._TileMatPath = other._TileMatPath;
    }
    if (other._hasWaterMaterialPath) {
      copy._hasWaterMaterialPath = true;
      copy._WaterMaterialPath = other._WaterMaterialPath;
    }
    if (other._hasRoadPavMatPath) {
      copy._hasRoadPavMatPath = true;
      copy._RoadPavMatPath = other._RoadPavMatPath;
    }
    if (other._hasRoadBorderMatPath) {
      copy._hasRoadBorderMatPath = true;
      copy._RoadBorderMatPath = other._RoadBorderMatPath;
    }
    if (other._hasRoadSecondBorderMatPath) {
      copy._hasRoadSecondBorderMatPath = true;
      copy._RoadSecondBorderMatPath = other._RoadSecondBorderMatPath;
    }
    copy._LayerTexturePaths = this._LayerTexturePaths.concat(other._LayerTexturePaths);
    if (other._hasPostEffectMatPath) {
      copy._hasPostEffectMatPath = true;
      copy._PostEffectMatPath = other._PostEffectMatPath;
    }
    copy._LayerLockStatus = this._LayerLockStatus.concat(other._LayerLockStatus);
    if (other._hasRoadBorderData) {
      if (copy._hasRoadBorderData) {
        copy._RoadBorderData = copy.RoadBorderData.merge(other.RoadBorderData);
      } else {
        copy._RoadBorderData = other._RoadBorderData;
      }
      copy._hasRoadBorderData = true;
    }
    return copy;
  }
}
MaterialSetting.default = new MaterialSetting();
class MaterialSetting_Builder {
  constructor(value) {
    this._value = new MaterialSetting(value);
  }
  build() {
    return new MaterialSetting(this._value);
  }
  setTileMatPath(value) {
    this._value._hasTileMatPath = true;
    this._value._TileMatPath = value;
    return this;
  }
  deleteTileMatPath() {
    this._value._hasTileMatPath = false;
    this._value._TileMatPath = null;
    return this;
  }
  setWaterMaterialPath(value) {
    this._value._hasWaterMaterialPath = true;
    this._value._WaterMaterialPath = value;
    return this;
  }
  deleteWaterMaterialPath() {
    this._value._hasWaterMaterialPath = false;
    this._value._WaterMaterialPath = null;
    return this;
  }
  setRoadPavMatPath(value) {
    this._value._hasRoadPavMatPath = true;
    this._value._RoadPavMatPath = value;
    return this;
  }
  deleteRoadPavMatPath() {
    this._value._hasRoadPavMatPath = false;
    this._value._RoadPavMatPath = null;
    return this;
  }
  setRoadBorderMatPath(value) {
    this._value._hasRoadBorderMatPath = true;
    this._value._RoadBorderMatPath = value;
    return this;
  }
  deleteRoadBorderMatPath() {
    this._value._hasRoadBorderMatPath = false;
    this._value._RoadBorderMatPath = null;
    return this;
  }
  setRoadSecondBorderMatPath(value) {
    this._value._hasRoadSecondBorderMatPath = true;
    this._value._RoadSecondBorderMatPath = value;
    return this;
  }
  deleteRoadSecondBorderMatPath() {
    this._value._hasRoadSecondBorderMatPath = false;
    this._value._RoadSecondBorderMatPath = null;
    return this;
  }
  addAllLayerTexturePaths(values) {
    this._value._LayerTexturePaths = this._value._LayerTexturePaths.concat(values);
    return this;
  }
  addLayerTexturePaths(value) {
    this._value._LayerTexturePaths = this._value._LayerTexturePaths.concat([value]);
    return this;
  }
  setLayerTexturePaths(index, value) {
    this._value._LayerTexturePaths = this._value._LayerTexturePaths.concat();
    this._value._LayerTexturePaths[index] = value;
    return this;
  }
  clearLayerTexturePaths() {
    this._value._LayerTexturePaths = [];
    return this;
  }
  setPostEffectMatPath(value) {
    this._value._hasPostEffectMatPath = true;
    this._value._PostEffectMatPath = value;
    return this;
  }
  deletePostEffectMatPath() {
    this._value._hasPostEffectMatPath = false;
    this._value._PostEffectMatPath = null;
    return this;
  }
  addAllLayerLockStatus(values) {
    this._value._LayerLockStatus = this._value._LayerLockStatus.concat(values);
    return this;
  }
  addLayerLockStatus(value) {
    this._value._LayerLockStatus = this._value._LayerLockStatus.concat([value]);
    return this;
  }
  setLayerLockStatus(index, value) {
    this._value._LayerLockStatus = this._value._LayerLockStatus.concat();
    this._value._LayerLockStatus[index] = value;
    return this;
  }
  clearLayerLockStatus() {
    this._value._LayerLockStatus = [];
    return this;
  }
  setRoadBorderData(value) {
    this._value._hasRoadBorderData = true;
    this._value._RoadBorderData = value;
    return this;
  }
  deleteRoadBorderData() {
    this._value._hasRoadBorderData = false;
    this._value._RoadBorderData = null;
    return this;
  }
}
MaterialSetting.Builder = MaterialSetting_Builder;
class MaterialSetting_WithParent {
  /**
   * @param {MaterialSetting} value
   * @param {MaterialSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MaterialSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTileMatPath() {
    if (this._cachedHasTileMatPath === undefined) {
      if (this._value.hasTileMatPath) {
        this._cachedHasTileMatPath = true;
      } else {
        this._cachedHasTileMatPath = this._parent ? this._parent.hasTileMatPath : false;
      }
    }
    return this._cachedHasTileMatPath;
  }
  get TileMatPath() {
    if (this._cachedTileMatPath === undefined) {
      if (this._value.hasTileMatPath) {
        this._cachedTileMatPath = this._value.TileMatPath;
      } else {
        this._cachedTileMatPath = this._parent ? this._parent.TileMatPath : this._value.TileMatPath;
      }
    }
    return this._cachedTileMatPath;
  }
  get hasWaterMaterialPath() {
    if (this._cachedHasWaterMaterialPath === undefined) {
      if (this._value.hasWaterMaterialPath) {
        this._cachedHasWaterMaterialPath = true;
      } else {
        this._cachedHasWaterMaterialPath = this._parent ? this._parent.hasWaterMaterialPath : false;
      }
    }
    return this._cachedHasWaterMaterialPath;
  }
  get WaterMaterialPath() {
    if (this._cachedWaterMaterialPath === undefined) {
      if (this._value.hasWaterMaterialPath) {
        this._cachedWaterMaterialPath = this._value.WaterMaterialPath;
      } else {
        this._cachedWaterMaterialPath = this._parent ? this._parent.WaterMaterialPath : this._value.WaterMaterialPath;
      }
    }
    return this._cachedWaterMaterialPath;
  }
  get hasRoadPavMatPath() {
    if (this._cachedHasRoadPavMatPath === undefined) {
      if (this._value.hasRoadPavMatPath) {
        this._cachedHasRoadPavMatPath = true;
      } else {
        this._cachedHasRoadPavMatPath = this._parent ? this._parent.hasRoadPavMatPath : false;
      }
    }
    return this._cachedHasRoadPavMatPath;
  }
  get RoadPavMatPath() {
    if (this._cachedRoadPavMatPath === undefined) {
      if (this._value.hasRoadPavMatPath) {
        this._cachedRoadPavMatPath = this._value.RoadPavMatPath;
      } else {
        this._cachedRoadPavMatPath = this._parent ? this._parent.RoadPavMatPath : this._value.RoadPavMatPath;
      }
    }
    return this._cachedRoadPavMatPath;
  }
  get hasRoadBorderMatPath() {
    if (this._cachedHasRoadBorderMatPath === undefined) {
      if (this._value.hasRoadBorderMatPath) {
        this._cachedHasRoadBorderMatPath = true;
      } else {
        this._cachedHasRoadBorderMatPath = this._parent ? this._parent.hasRoadBorderMatPath : false;
      }
    }
    return this._cachedHasRoadBorderMatPath;
  }
  get RoadBorderMatPath() {
    if (this._cachedRoadBorderMatPath === undefined) {
      if (this._value.hasRoadBorderMatPath) {
        this._cachedRoadBorderMatPath = this._value.RoadBorderMatPath;
      } else {
        this._cachedRoadBorderMatPath = this._parent ? this._parent.RoadBorderMatPath : this._value.RoadBorderMatPath;
      }
    }
    return this._cachedRoadBorderMatPath;
  }
  get hasRoadSecondBorderMatPath() {
    if (this._cachedHasRoadSecondBorderMatPath === undefined) {
      if (this._value.hasRoadSecondBorderMatPath) {
        this._cachedHasRoadSecondBorderMatPath = true;
      } else {
        this._cachedHasRoadSecondBorderMatPath = this._parent ? this._parent.hasRoadSecondBorderMatPath : false;
      }
    }
    return this._cachedHasRoadSecondBorderMatPath;
  }
  get RoadSecondBorderMatPath() {
    if (this._cachedRoadSecondBorderMatPath === undefined) {
      if (this._value.hasRoadSecondBorderMatPath) {
        this._cachedRoadSecondBorderMatPath = this._value.RoadSecondBorderMatPath;
      } else {
        this._cachedRoadSecondBorderMatPath = this._parent ? this._parent.RoadSecondBorderMatPath : this._value.RoadSecondBorderMatPath;
      }
    }
    return this._cachedRoadSecondBorderMatPath;
  }
  get selfLayerTexturePaths() {
    return this._value.LayerTexturePaths;
  }
  get inherentLayerTexturePaths() {
    if (!this._inherentLayerTexturePaths) {
      this._inherentLayerTexturePaths = this._parent ? this._parent.LayerTexturePaths : [];
    }
    return this._inherentLayerTexturePaths;
  }
  get LayerTexturePaths() {
    if (!this._allLayerTexturePaths) {
      this._allLayerTexturePaths = this._parent ? this._parent.LayerTexturePaths.concat(this.selfLayerTexturePaths) : this.selfLayerTexturePaths;
    }
    return this._allLayerTexturePaths;
  }
  get hasPostEffectMatPath() {
    if (this._cachedHasPostEffectMatPath === undefined) {
      if (this._value.hasPostEffectMatPath) {
        this._cachedHasPostEffectMatPath = true;
      } else {
        this._cachedHasPostEffectMatPath = this._parent ? this._parent.hasPostEffectMatPath : false;
      }
    }
    return this._cachedHasPostEffectMatPath;
  }
  get PostEffectMatPath() {
    if (this._cachedPostEffectMatPath === undefined) {
      if (this._value.hasPostEffectMatPath) {
        this._cachedPostEffectMatPath = this._value.PostEffectMatPath;
      } else {
        this._cachedPostEffectMatPath = this._parent ? this._parent.PostEffectMatPath : this._value.PostEffectMatPath;
      }
    }
    return this._cachedPostEffectMatPath;
  }
  get selfLayerLockStatus() {
    return this._value.LayerLockStatus;
  }
  get inherentLayerLockStatus() {
    if (!this._inherentLayerLockStatus) {
      this._inherentLayerLockStatus = this._parent ? this._parent.LayerLockStatus : [];
    }
    return this._inherentLayerLockStatus;
  }
  get LayerLockStatus() {
    if (!this._allLayerLockStatus) {
      this._allLayerLockStatus = this._parent ? this._parent.LayerLockStatus.concat(this.selfLayerLockStatus) : this.selfLayerLockStatus;
    }
    return this._allLayerLockStatus;
  }
  get hasRoadBorderData() {
    if (this._cachedHasRoadBorderData === undefined) {
      if (this._value.hasRoadBorderData) {
        this._cachedHasRoadBorderData = true;
      } else {
        this._cachedHasRoadBorderData = this._parent ? this._parent.hasRoadBorderData : false;
      }
    }
    return this._cachedHasRoadBorderData;
  }
  get RoadBorderData() {
    if (!this._cachedRoadBorderData) {
      if (this._value.hasRoadBorderData) {
        this._cachedRoadBorderData = new RoadBorderData.WithParent(this._value.RoadBorderData, this._parent && this._parent.hasRoadBorderData ? this._parent.RoadBorderData : null);
      } else {
        this._cachedRoadBorderData = this._parent ? new RoadBorderData.WithParent(RoadBorderData.default, this._parent.RoadBorderData) : RoadBorderData.WithParent.default;
      }
    }
    return this._cachedRoadBorderData;
  }
  update(current, parent) {
    const result = new MaterialSetting_WithParent(current, parent);
    if (this._cachedRoadBorderData && this._value.hasRoadBorderData && current.hasRoadBorderData) {
      if (this._value.RoadBorderData === current.RoadBorderData && this._parent === parent) {
        result._cachedRoadBorderData = this._cachedRoadBorderData;
      } else {
        result._cachedRoadBorderData = this._cachedRoadBorderData.update(current.RoadBorderData, parent && parent.hasRoadBorderData ? parent.RoadBorderData : null);
      }
    }
    return result;
  }
}
MaterialSetting_WithParent.default = new MaterialSetting_WithParent(MaterialSetting.default, null);
MaterialSetting.WithParent = MaterialSetting_WithParent;
class MaterialSetting_Descriptor {
  get TileMatPath() {
    if (!this._TileMatPath) {
      this._TileMatPath = {
        name: "TileMatPath",
        Name: "TileMatPath",
        number: 1,
        protoType: 9,
        protoName: "TileMatPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileMatPath;
  }
  get WaterMaterialPath() {
    if (!this._WaterMaterialPath) {
      this._WaterMaterialPath = {
        name: "WaterMaterialPath",
        Name: "WaterMaterialPath",
        number: 3,
        protoType: 9,
        protoName: "WaterMaterialPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._WaterMaterialPath;
  }
  get RoadPavMatPath() {
    if (!this._RoadPavMatPath) {
      this._RoadPavMatPath = {
        name: "RoadPavMatPath",
        Name: "RoadPavMatPath",
        number: 4,
        protoType: 9,
        protoName: "RoadPavMatPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RoadPavMatPath;
  }
  get RoadBorderMatPath() {
    if (!this._RoadBorderMatPath) {
      this._RoadBorderMatPath = {
        name: "RoadBorderMatPath",
        Name: "RoadBorderMatPath",
        number: 5,
        protoType: 9,
        protoName: "RoadBorderMatPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RoadBorderMatPath;
  }
  get RoadSecondBorderMatPath() {
    if (!this._RoadSecondBorderMatPath) {
      this._RoadSecondBorderMatPath = {
        name: "RoadSecondBorderMatPath",
        Name: "RoadSecondBorderMatPath",
        number: 6,
        protoType: 9,
        protoName: "RoadSecondBorderMatPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RoadSecondBorderMatPath;
  }
  get LayerTexturePaths() {
    if (!this._LayerTexturePaths) {
      this._LayerTexturePaths = {
        name: "LayerTexturePaths",
        Name: "LayerTexturePaths",
        number: 7,
        protoType: 9,
        protoName: "LayerTexturePaths",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LayerTexturePaths;
  }
  get PostEffectMatPath() {
    if (!this._PostEffectMatPath) {
      this._PostEffectMatPath = {
        name: "PostEffectMatPath",
        Name: "PostEffectMatPath",
        number: 8,
        protoType: 9,
        protoName: "PostEffectMatPath",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PostEffectMatPath;
  }
  get LayerLockStatus() {
    if (!this._LayerLockStatus) {
      this._LayerLockStatus = {
        name: "LayerLockStatus",
        Name: "LayerLockStatus",
        number: 9,
        protoType: 8,
        protoName: "LayerLockStatus",
        type: JsonToBoolean,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LayerLockStatus;
  }
  get RoadBorderData() {
    if (!this._RoadBorderData) {
      this._RoadBorderData = {
        name: "RoadBorderData",
        Name: "RoadBorderData",
        number: 10,
        protoType: 11,
        protoName: "RoadBorderData",
        type: RoadBorderData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RoadBorderData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.TileMatPath,
        this.WaterMaterialPath,
        this.RoadPavMatPath,
        this.RoadBorderMatPath,
        this.RoadSecondBorderMatPath,
        this.LayerTexturePaths,
        this.PostEffectMatPath,
        this.LayerLockStatus,
        this.RoadBorderData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTileMatPath",
        Name: "DummyOneofForTileMatPath",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterMaterialPath",
        Name: "DummyOneofForWaterMaterialPath",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadPavMatPath",
        Name: "DummyOneofForRoadPavMatPath",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadBorderMatPath",
        Name: "DummyOneofForRoadBorderMatPath",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadSecondBorderMatPath",
        Name: "DummyOneofForRoadSecondBorderMatPath",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPostEffectMatPath",
        Name: "DummyOneofForPostEffectMatPath",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRoadBorderData",
        Name: "DummyOneofForRoadBorderData",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
MaterialSetting.descriptor = new MaterialSetting_Descriptor();
export class RoadBorderData {
  get descriptor() {
    return RoadBorderData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBorderOuter = false;
    this._BorderOuter = null;
    this._hasBorderInner = false;
    this._BorderInner = null;
    this._hasBorderUvScale = false;
    this._BorderUvScale = null;
    this._hasFirstBorderCenterHeight = false;
    this._FirstBorderCenterHeight = null;
    this._hasUseSecondBorder = false;
    this._UseSecondBorder = null;
    this._hasSecondBorderOuter = false;
    this._SecondBorderOuter = null;
    this._hasSecondBorderInner = false;
    this._SecondBorderInner = null;
    this._hasSecondBorderUvScale = false;
    this._SecondBorderUvScale = null;
    this._hasDisableProjectToTerrain = false;
    this._DisableProjectToTerrain = null;
  }
  isEmpty() {
    if (this._hasBorderOuter) return false;
    if (this._hasBorderInner) return false;
    if (this._hasBorderUvScale) return false;
    if (this._hasFirstBorderCenterHeight) return false;
    if (this._hasUseSecondBorder) return false;
    if (this._hasSecondBorderOuter) return false;
    if (this._hasSecondBorderInner) return false;
    if (this._hasSecondBorderUvScale) return false;
    if (this._hasDisableProjectToTerrain) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RoadBorderData) {
      return value;
    }
    return RoadBorderData.fromJson(value);
  }
  static fromJson(json) {
    const result = new RoadBorderData();
    if (json.BorderOuter != null) {
      result._hasBorderOuter = true;
      result._BorderOuter = JsonToDouble.fromJson(json.BorderOuter);
    }
    if (json.BorderInner != null) {
      result._hasBorderInner = true;
      result._BorderInner = JsonToDouble.fromJson(json.BorderInner);
    }
    if (json.BorderUvScale != null) {
      result._hasBorderUvScale = true;
      result._BorderUvScale = JsonToDouble.fromJson(json.BorderUvScale);
    }
    if (json.FirstBorderCenterHeight != null) {
      result._hasFirstBorderCenterHeight = true;
      result._FirstBorderCenterHeight = JsonToDouble.fromJson(json.FirstBorderCenterHeight);
    }
    if (json.UseSecondBorder != null) {
      result._hasUseSecondBorder = true;
      result._UseSecondBorder = JsonToBoolean.fromJson(json.UseSecondBorder);
    }
    if (json.SecondBorderOuter != null) {
      result._hasSecondBorderOuter = true;
      result._SecondBorderOuter = JsonToDouble.fromJson(json.SecondBorderOuter);
    }
    if (json.SecondBorderInner != null) {
      result._hasSecondBorderInner = true;
      result._SecondBorderInner = JsonToDouble.fromJson(json.SecondBorderInner);
    }
    if (json.SecondBorderUvScale != null) {
      result._hasSecondBorderUvScale = true;
      result._SecondBorderUvScale = JsonToDouble.fromJson(json.SecondBorderUvScale);
    }
    if (json.DisableProjectToTerrain != null) {
      result._hasDisableProjectToTerrain = true;
      result._DisableProjectToTerrain = JsonToBoolean.fromJson(json.DisableProjectToTerrain);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBorderOuter) {
      result.BorderOuter = JsonToDouble.toJson(this._BorderOuter);
    }
    if (this._hasBorderInner) {
      result.BorderInner = JsonToDouble.toJson(this._BorderInner);
    }
    if (this._hasBorderUvScale) {
      result.BorderUvScale = JsonToDouble.toJson(this._BorderUvScale);
    }
    if (this._hasFirstBorderCenterHeight) {
      result.FirstBorderCenterHeight = JsonToDouble.toJson(this._FirstBorderCenterHeight);
    }
    if (this._hasUseSecondBorder) {
      result.UseSecondBorder = JsonToBoolean.toJson(this._UseSecondBorder);
    }
    if (this._hasSecondBorderOuter) {
      result.SecondBorderOuter = JsonToDouble.toJson(this._SecondBorderOuter);
    }
    if (this._hasSecondBorderInner) {
      result.SecondBorderInner = JsonToDouble.toJson(this._SecondBorderInner);
    }
    if (this._hasSecondBorderUvScale) {
      result.SecondBorderUvScale = JsonToDouble.toJson(this._SecondBorderUvScale);
    }
    if (this._hasDisableProjectToTerrain) {
      result.DisableProjectToTerrain = JsonToBoolean.toJson(this._DisableProjectToTerrain);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get BorderOuter() {
    return this._hasBorderOuter ? this._BorderOuter : JsonToDouble.default;
  }
  get hasBorderOuter() {
    return this._hasBorderOuter;
  }
  setBorderOuter(path, value) {
    return {type: 'SET', path: path.concat(['BorderOuter']), value};
  }
  deleteBorderOuter(path) {
    return {type: 'DELETE', path: path.concat(['BorderOuter'])};
  }
  /**
   * @returns {number}
   */
  get BorderInner() {
    return this._hasBorderInner ? this._BorderInner : JsonToDouble.default;
  }
  get hasBorderInner() {
    return this._hasBorderInner;
  }
  setBorderInner(path, value) {
    return {type: 'SET', path: path.concat(['BorderInner']), value};
  }
  deleteBorderInner(path) {
    return {type: 'DELETE', path: path.concat(['BorderInner'])};
  }
  /**
   * @returns {number}
   */
  get BorderUvScale() {
    return this._hasBorderUvScale ? this._BorderUvScale : JsonToDouble.default;
  }
  get hasBorderUvScale() {
    return this._hasBorderUvScale;
  }
  setBorderUvScale(path, value) {
    return {type: 'SET', path: path.concat(['BorderUvScale']), value};
  }
  deleteBorderUvScale(path) {
    return {type: 'DELETE', path: path.concat(['BorderUvScale'])};
  }
  /**
   * @returns {number}
   */
  get FirstBorderCenterHeight() {
    return this._hasFirstBorderCenterHeight ? this._FirstBorderCenterHeight : JsonToDouble.default;
  }
  get hasFirstBorderCenterHeight() {
    return this._hasFirstBorderCenterHeight;
  }
  setFirstBorderCenterHeight(path, value) {
    return {type: 'SET', path: path.concat(['FirstBorderCenterHeight']), value};
  }
  deleteFirstBorderCenterHeight(path) {
    return {type: 'DELETE', path: path.concat(['FirstBorderCenterHeight'])};
  }
  /**
   * @returns {boolean}
   */
  get UseSecondBorder() {
    return this._hasUseSecondBorder ? this._UseSecondBorder : JsonToBoolean.default;
  }
  get hasUseSecondBorder() {
    return this._hasUseSecondBorder;
  }
  setUseSecondBorder(path, value) {
    return {type: 'SET', path: path.concat(['UseSecondBorder']), value};
  }
  deleteUseSecondBorder(path) {
    return {type: 'DELETE', path: path.concat(['UseSecondBorder'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderOuter() {
    return this._hasSecondBorderOuter ? this._SecondBorderOuter : JsonToDouble.default;
  }
  get hasSecondBorderOuter() {
    return this._hasSecondBorderOuter;
  }
  setSecondBorderOuter(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderOuter']), value};
  }
  deleteSecondBorderOuter(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderOuter'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderInner() {
    return this._hasSecondBorderInner ? this._SecondBorderInner : JsonToDouble.default;
  }
  get hasSecondBorderInner() {
    return this._hasSecondBorderInner;
  }
  setSecondBorderInner(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderInner']), value};
  }
  deleteSecondBorderInner(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderInner'])};
  }
  /**
   * @returns {number}
   */
  get SecondBorderUvScale() {
    return this._hasSecondBorderUvScale ? this._SecondBorderUvScale : JsonToDouble.default;
  }
  get hasSecondBorderUvScale() {
    return this._hasSecondBorderUvScale;
  }
  setSecondBorderUvScale(path, value) {
    return {type: 'SET', path: path.concat(['SecondBorderUvScale']), value};
  }
  deleteSecondBorderUvScale(path) {
    return {type: 'DELETE', path: path.concat(['SecondBorderUvScale'])};
  }
  /**
   * @returns {boolean}
   */
  get DisableProjectToTerrain() {
    return this._hasDisableProjectToTerrain ? this._DisableProjectToTerrain : JsonToBoolean.default;
  }
  get hasDisableProjectToTerrain() {
    return this._hasDisableProjectToTerrain;
  }
  setDisableProjectToTerrain(path, value) {
    return {type: 'SET', path: path.concat(['DisableProjectToTerrain']), value};
  }
  deleteDisableProjectToTerrain(path) {
    return {type: 'DELETE', path: path.concat(['DisableProjectToTerrain'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "BorderOuter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasBorderOuter = true;
              copy._BorderOuter = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderOuter) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasBorderOuter = false;
              copy._BorderOuter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "BorderInner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasBorderInner = true;
              copy._BorderInner = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderInner) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasBorderInner = false;
              copy._BorderInner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "BorderUvScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasBorderUvScale = true;
              copy._BorderUvScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBorderUvScale) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasBorderUvScale = false;
              copy._BorderUvScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "FirstBorderCenterHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasFirstBorderCenterHeight = true;
              copy._FirstBorderCenterHeight = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFirstBorderCenterHeight) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasFirstBorderCenterHeight = false;
              copy._FirstBorderCenterHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "UseSecondBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasUseSecondBorder = true;
              copy._UseSecondBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseSecondBorder) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasUseSecondBorder = false;
              copy._UseSecondBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderOuter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderOuter = true;
              copy._SecondBorderOuter = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderOuter) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderOuter = false;
              copy._SecondBorderOuter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderInner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderInner = true;
              copy._SecondBorderInner = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderInner) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderInner = false;
              copy._SecondBorderInner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "SecondBorderUvScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderUvScale = true;
              copy._SecondBorderUvScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSecondBorderUvScale) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasSecondBorderUvScale = false;
              copy._SecondBorderUvScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "DisableProjectToTerrain": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RoadBorderData(this);
              copy._hasDisableProjectToTerrain = true;
              copy._DisableProjectToTerrain = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableProjectToTerrain) {
                return this;
              }
              const copy = new RoadBorderData(this);
              copy._hasDisableProjectToTerrain = false;
              copy._DisableProjectToTerrain = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RoadBorderData} other
   * @returns {RoadBorderData}
   */
  merge(other) {
    const copy = new RoadBorderData(this);
    if (other._hasBorderOuter) {
      copy._hasBorderOuter = true;
      copy._BorderOuter = other._BorderOuter;
    }
    if (other._hasBorderInner) {
      copy._hasBorderInner = true;
      copy._BorderInner = other._BorderInner;
    }
    if (other._hasBorderUvScale) {
      copy._hasBorderUvScale = true;
      copy._BorderUvScale = other._BorderUvScale;
    }
    if (other._hasFirstBorderCenterHeight) {
      copy._hasFirstBorderCenterHeight = true;
      copy._FirstBorderCenterHeight = other._FirstBorderCenterHeight;
    }
    if (other._hasUseSecondBorder) {
      copy._hasUseSecondBorder = true;
      copy._UseSecondBorder = other._UseSecondBorder;
    }
    if (other._hasSecondBorderOuter) {
      copy._hasSecondBorderOuter = true;
      copy._SecondBorderOuter = other._SecondBorderOuter;
    }
    if (other._hasSecondBorderInner) {
      copy._hasSecondBorderInner = true;
      copy._SecondBorderInner = other._SecondBorderInner;
    }
    if (other._hasSecondBorderUvScale) {
      copy._hasSecondBorderUvScale = true;
      copy._SecondBorderUvScale = other._SecondBorderUvScale;
    }
    if (other._hasDisableProjectToTerrain) {
      copy._hasDisableProjectToTerrain = true;
      copy._DisableProjectToTerrain = other._DisableProjectToTerrain;
    }
    return copy;
  }
}
RoadBorderData.default = new RoadBorderData();
class RoadBorderData_Builder {
  constructor(value) {
    this._value = new RoadBorderData(value);
  }
  build() {
    return new RoadBorderData(this._value);
  }
  setBorderOuter(value) {
    this._value._hasBorderOuter = true;
    this._value._BorderOuter = value;
    return this;
  }
  deleteBorderOuter() {
    this._value._hasBorderOuter = false;
    this._value._BorderOuter = null;
    return this;
  }
  setBorderInner(value) {
    this._value._hasBorderInner = true;
    this._value._BorderInner = value;
    return this;
  }
  deleteBorderInner() {
    this._value._hasBorderInner = false;
    this._value._BorderInner = null;
    return this;
  }
  setBorderUvScale(value) {
    this._value._hasBorderUvScale = true;
    this._value._BorderUvScale = value;
    return this;
  }
  deleteBorderUvScale() {
    this._value._hasBorderUvScale = false;
    this._value._BorderUvScale = null;
    return this;
  }
  setFirstBorderCenterHeight(value) {
    this._value._hasFirstBorderCenterHeight = true;
    this._value._FirstBorderCenterHeight = value;
    return this;
  }
  deleteFirstBorderCenterHeight() {
    this._value._hasFirstBorderCenterHeight = false;
    this._value._FirstBorderCenterHeight = null;
    return this;
  }
  setUseSecondBorder(value) {
    this._value._hasUseSecondBorder = true;
    this._value._UseSecondBorder = value;
    return this;
  }
  deleteUseSecondBorder() {
    this._value._hasUseSecondBorder = false;
    this._value._UseSecondBorder = null;
    return this;
  }
  setSecondBorderOuter(value) {
    this._value._hasSecondBorderOuter = true;
    this._value._SecondBorderOuter = value;
    return this;
  }
  deleteSecondBorderOuter() {
    this._value._hasSecondBorderOuter = false;
    this._value._SecondBorderOuter = null;
    return this;
  }
  setSecondBorderInner(value) {
    this._value._hasSecondBorderInner = true;
    this._value._SecondBorderInner = value;
    return this;
  }
  deleteSecondBorderInner() {
    this._value._hasSecondBorderInner = false;
    this._value._SecondBorderInner = null;
    return this;
  }
  setSecondBorderUvScale(value) {
    this._value._hasSecondBorderUvScale = true;
    this._value._SecondBorderUvScale = value;
    return this;
  }
  deleteSecondBorderUvScale() {
    this._value._hasSecondBorderUvScale = false;
    this._value._SecondBorderUvScale = null;
    return this;
  }
  setDisableProjectToTerrain(value) {
    this._value._hasDisableProjectToTerrain = true;
    this._value._DisableProjectToTerrain = value;
    return this;
  }
  deleteDisableProjectToTerrain() {
    this._value._hasDisableProjectToTerrain = false;
    this._value._DisableProjectToTerrain = null;
    return this;
  }
}
RoadBorderData.Builder = RoadBorderData_Builder;
class RoadBorderData_WithParent {
  /**
   * @param {RoadBorderData} value
   * @param {RoadBorderData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RoadBorderData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBorderOuter() {
    if (this._cachedHasBorderOuter === undefined) {
      if (this._value.hasBorderOuter) {
        this._cachedHasBorderOuter = true;
      } else {
        this._cachedHasBorderOuter = this._parent ? this._parent.hasBorderOuter : false;
      }
    }
    return this._cachedHasBorderOuter;
  }
  get BorderOuter() {
    if (this._cachedBorderOuter === undefined) {
      if (this._value.hasBorderOuter) {
        this._cachedBorderOuter = this._value.BorderOuter;
      } else {
        this._cachedBorderOuter = this._parent ? this._parent.BorderOuter : this._value.BorderOuter;
      }
    }
    return this._cachedBorderOuter;
  }
  get hasBorderInner() {
    if (this._cachedHasBorderInner === undefined) {
      if (this._value.hasBorderInner) {
        this._cachedHasBorderInner = true;
      } else {
        this._cachedHasBorderInner = this._parent ? this._parent.hasBorderInner : false;
      }
    }
    return this._cachedHasBorderInner;
  }
  get BorderInner() {
    if (this._cachedBorderInner === undefined) {
      if (this._value.hasBorderInner) {
        this._cachedBorderInner = this._value.BorderInner;
      } else {
        this._cachedBorderInner = this._parent ? this._parent.BorderInner : this._value.BorderInner;
      }
    }
    return this._cachedBorderInner;
  }
  get hasBorderUvScale() {
    if (this._cachedHasBorderUvScale === undefined) {
      if (this._value.hasBorderUvScale) {
        this._cachedHasBorderUvScale = true;
      } else {
        this._cachedHasBorderUvScale = this._parent ? this._parent.hasBorderUvScale : false;
      }
    }
    return this._cachedHasBorderUvScale;
  }
  get BorderUvScale() {
    if (this._cachedBorderUvScale === undefined) {
      if (this._value.hasBorderUvScale) {
        this._cachedBorderUvScale = this._value.BorderUvScale;
      } else {
        this._cachedBorderUvScale = this._parent ? this._parent.BorderUvScale : this._value.BorderUvScale;
      }
    }
    return this._cachedBorderUvScale;
  }
  get hasFirstBorderCenterHeight() {
    if (this._cachedHasFirstBorderCenterHeight === undefined) {
      if (this._value.hasFirstBorderCenterHeight) {
        this._cachedHasFirstBorderCenterHeight = true;
      } else {
        this._cachedHasFirstBorderCenterHeight = this._parent ? this._parent.hasFirstBorderCenterHeight : false;
      }
    }
    return this._cachedHasFirstBorderCenterHeight;
  }
  get FirstBorderCenterHeight() {
    if (this._cachedFirstBorderCenterHeight === undefined) {
      if (this._value.hasFirstBorderCenterHeight) {
        this._cachedFirstBorderCenterHeight = this._value.FirstBorderCenterHeight;
      } else {
        this._cachedFirstBorderCenterHeight = this._parent ? this._parent.FirstBorderCenterHeight : this._value.FirstBorderCenterHeight;
      }
    }
    return this._cachedFirstBorderCenterHeight;
  }
  get hasUseSecondBorder() {
    if (this._cachedHasUseSecondBorder === undefined) {
      if (this._value.hasUseSecondBorder) {
        this._cachedHasUseSecondBorder = true;
      } else {
        this._cachedHasUseSecondBorder = this._parent ? this._parent.hasUseSecondBorder : false;
      }
    }
    return this._cachedHasUseSecondBorder;
  }
  get UseSecondBorder() {
    if (this._cachedUseSecondBorder === undefined) {
      if (this._value.hasUseSecondBorder) {
        this._cachedUseSecondBorder = this._value.UseSecondBorder;
      } else {
        this._cachedUseSecondBorder = this._parent ? this._parent.UseSecondBorder : this._value.UseSecondBorder;
      }
    }
    return this._cachedUseSecondBorder;
  }
  get hasSecondBorderOuter() {
    if (this._cachedHasSecondBorderOuter === undefined) {
      if (this._value.hasSecondBorderOuter) {
        this._cachedHasSecondBorderOuter = true;
      } else {
        this._cachedHasSecondBorderOuter = this._parent ? this._parent.hasSecondBorderOuter : false;
      }
    }
    return this._cachedHasSecondBorderOuter;
  }
  get SecondBorderOuter() {
    if (this._cachedSecondBorderOuter === undefined) {
      if (this._value.hasSecondBorderOuter) {
        this._cachedSecondBorderOuter = this._value.SecondBorderOuter;
      } else {
        this._cachedSecondBorderOuter = this._parent ? this._parent.SecondBorderOuter : this._value.SecondBorderOuter;
      }
    }
    return this._cachedSecondBorderOuter;
  }
  get hasSecondBorderInner() {
    if (this._cachedHasSecondBorderInner === undefined) {
      if (this._value.hasSecondBorderInner) {
        this._cachedHasSecondBorderInner = true;
      } else {
        this._cachedHasSecondBorderInner = this._parent ? this._parent.hasSecondBorderInner : false;
      }
    }
    return this._cachedHasSecondBorderInner;
  }
  get SecondBorderInner() {
    if (this._cachedSecondBorderInner === undefined) {
      if (this._value.hasSecondBorderInner) {
        this._cachedSecondBorderInner = this._value.SecondBorderInner;
      } else {
        this._cachedSecondBorderInner = this._parent ? this._parent.SecondBorderInner : this._value.SecondBorderInner;
      }
    }
    return this._cachedSecondBorderInner;
  }
  get hasSecondBorderUvScale() {
    if (this._cachedHasSecondBorderUvScale === undefined) {
      if (this._value.hasSecondBorderUvScale) {
        this._cachedHasSecondBorderUvScale = true;
      } else {
        this._cachedHasSecondBorderUvScale = this._parent ? this._parent.hasSecondBorderUvScale : false;
      }
    }
    return this._cachedHasSecondBorderUvScale;
  }
  get SecondBorderUvScale() {
    if (this._cachedSecondBorderUvScale === undefined) {
      if (this._value.hasSecondBorderUvScale) {
        this._cachedSecondBorderUvScale = this._value.SecondBorderUvScale;
      } else {
        this._cachedSecondBorderUvScale = this._parent ? this._parent.SecondBorderUvScale : this._value.SecondBorderUvScale;
      }
    }
    return this._cachedSecondBorderUvScale;
  }
  get hasDisableProjectToTerrain() {
    if (this._cachedHasDisableProjectToTerrain === undefined) {
      if (this._value.hasDisableProjectToTerrain) {
        this._cachedHasDisableProjectToTerrain = true;
      } else {
        this._cachedHasDisableProjectToTerrain = this._parent ? this._parent.hasDisableProjectToTerrain : false;
      }
    }
    return this._cachedHasDisableProjectToTerrain;
  }
  get DisableProjectToTerrain() {
    if (this._cachedDisableProjectToTerrain === undefined) {
      if (this._value.hasDisableProjectToTerrain) {
        this._cachedDisableProjectToTerrain = this._value.DisableProjectToTerrain;
      } else {
        this._cachedDisableProjectToTerrain = this._parent ? this._parent.DisableProjectToTerrain : this._value.DisableProjectToTerrain;
      }
    }
    return this._cachedDisableProjectToTerrain;
  }
  update(current, parent) {
    const result = new RoadBorderData_WithParent(current, parent);
    return result;
  }
}
RoadBorderData_WithParent.default = new RoadBorderData_WithParent(RoadBorderData.default, null);
RoadBorderData.WithParent = RoadBorderData_WithParent;
class RoadBorderData_Descriptor {
  get BorderOuter() {
    if (!this._BorderOuter) {
      this._BorderOuter = {
        name: "BorderOuter",
        Name: "BorderOuter",
        number: 1,
        protoType: 1,
        protoName: "BorderOuter",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderOuter;
  }
  get BorderInner() {
    if (!this._BorderInner) {
      this._BorderInner = {
        name: "BorderInner",
        Name: "BorderInner",
        number: 2,
        protoType: 1,
        protoName: "BorderInner",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderInner;
  }
  get BorderUvScale() {
    if (!this._BorderUvScale) {
      this._BorderUvScale = {
        name: "BorderUvScale",
        Name: "BorderUvScale",
        number: 3,
        protoType: 1,
        protoName: "BorderUvScale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BorderUvScale;
  }
  get FirstBorderCenterHeight() {
    if (!this._FirstBorderCenterHeight) {
      this._FirstBorderCenterHeight = {
        name: "FirstBorderCenterHeight",
        Name: "FirstBorderCenterHeight",
        number: 4,
        protoType: 1,
        protoName: "FirstBorderCenterHeight",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._FirstBorderCenterHeight;
  }
  get UseSecondBorder() {
    if (!this._UseSecondBorder) {
      this._UseSecondBorder = {
        name: "UseSecondBorder",
        Name: "UseSecondBorder",
        number: 5,
        protoType: 8,
        protoName: "UseSecondBorder",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UseSecondBorder;
  }
  get SecondBorderOuter() {
    if (!this._SecondBorderOuter) {
      this._SecondBorderOuter = {
        name: "SecondBorderOuter",
        Name: "SecondBorderOuter",
        number: 6,
        protoType: 1,
        protoName: "SecondBorderOuter",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderOuter;
  }
  get SecondBorderInner() {
    if (!this._SecondBorderInner) {
      this._SecondBorderInner = {
        name: "SecondBorderInner",
        Name: "SecondBorderInner",
        number: 7,
        protoType: 1,
        protoName: "SecondBorderInner",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderInner;
  }
  get SecondBorderUvScale() {
    if (!this._SecondBorderUvScale) {
      this._SecondBorderUvScale = {
        name: "SecondBorderUvScale",
        Name: "SecondBorderUvScale",
        number: 8,
        protoType: 1,
        protoName: "SecondBorderUvScale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._SecondBorderUvScale;
  }
  get DisableProjectToTerrain() {
    if (!this._DisableProjectToTerrain) {
      this._DisableProjectToTerrain = {
        name: "DisableProjectToTerrain",
        Name: "DisableProjectToTerrain",
        number: 9,
        protoType: 8,
        protoName: "DisableProjectToTerrain",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._DisableProjectToTerrain;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.BorderOuter,
        this.BorderInner,
        this.BorderUvScale,
        this.FirstBorderCenterHeight,
        this.UseSecondBorder,
        this.SecondBorderOuter,
        this.SecondBorderInner,
        this.SecondBorderUvScale,
        this.DisableProjectToTerrain,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBorderOuter",
        Name: "DummyOneofForBorderOuter",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBorderInner",
        Name: "DummyOneofForBorderInner",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBorderUvScale",
        Name: "DummyOneofForBorderUvScale",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFirstBorderCenterHeight",
        Name: "DummyOneofForFirstBorderCenterHeight",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseSecondBorder",
        Name: "DummyOneofForUseSecondBorder",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderOuter",
        Name: "DummyOneofForSecondBorderOuter",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderInner",
        Name: "DummyOneofForSecondBorderInner",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSecondBorderUvScale",
        Name: "DummyOneofForSecondBorderUvScale",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableProjectToTerrain",
        Name: "DummyOneofForDisableProjectToTerrain",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
RoadBorderData.descriptor = new RoadBorderData_Descriptor();
export class TileSetData {
  get descriptor() {
    return TileSetData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._TileSetPaths = [];
  }
  isEmpty() {
    if (this._TileSetPaths.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TileSetData) {
      return value;
    }
    return TileSetData.fromJson(value);
  }
  static fromJson(json) {
    const result = new TileSetData();
    result._TileSetPaths = JsonToList(json.TileSetPaths, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._TileSetPaths.length > 0) {
      result.TileSetPaths = ArrayToJson(this._TileSetPaths, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get TileSetPaths() {
    return this._TileSetPaths;
  }
  addTileSetPaths(path, value) {
    return {type: 'ADD', path: path.concat(['TileSetPaths']), value};
  }
  setTileSetPaths(path, value) {
    return {type: 'SET', path: path.concat(['TileSetPaths']), value: ArrayToJson(value, JsonToString)};
  }
  setTileSetPathsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['TileSetPaths', key]), value};
  }
  deleteTileSetPaths(path) {
    return {type: 'DELETE', path: path.concat(['TileSetPaths'])};
  }
  deleteTileSetPathsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['TileSetPaths', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "TileSetPaths": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TileSetData(this);
              copy._TileSetPaths = [];        for (let i of value) {
                copy._TileSetPaths.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TileSetData(this);
              copy._TileSetPaths = copy._TileSetPaths.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._TileSetPaths.length === 0) {
                return this;
              }
              const copy = new TileSetData(this);
              copy._TileSetPaths = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._TileSetPaths.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TileSetData(this);
              copy._TileSetPaths = copy._TileSetPaths.slice();
              copy._TileSetPaths[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TileSetData(this);
              copy._TileSetPaths = copy._TileSetPaths.slice(0, path[1]).concat(copy._TileSetPaths.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._TileSetPaths.length) {
            return this;
          }
          const oldValue = this._TileSetPaths[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TileSetData(this);
          copy._TileSetPaths = copy._TileSetPaths.slice();
          copy._TileSetPaths[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TileSetData} other
   * @returns {TileSetData}
   */
  merge(other) {
    const copy = new TileSetData(this);
    copy._TileSetPaths = this._TileSetPaths.concat(other._TileSetPaths);
    return copy;
  }
}
TileSetData.default = new TileSetData();
class TileSetData_Builder {
  constructor(value) {
    this._value = new TileSetData(value);
  }
  build() {
    return new TileSetData(this._value);
  }
  addAllTileSetPaths(values) {
    this._value._TileSetPaths = this._value._TileSetPaths.concat(values);
    return this;
  }
  addTileSetPaths(value) {
    this._value._TileSetPaths = this._value._TileSetPaths.concat([value]);
    return this;
  }
  setTileSetPaths(index, value) {
    this._value._TileSetPaths = this._value._TileSetPaths.concat();
    this._value._TileSetPaths[index] = value;
    return this;
  }
  clearTileSetPaths() {
    this._value._TileSetPaths = [];
    return this;
  }
}
TileSetData.Builder = TileSetData_Builder;
class TileSetData_WithParent {
  /**
   * @param {TileSetData} value
   * @param {TileSetData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TileSetData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfTileSetPaths() {
    return this._value.TileSetPaths;
  }
  get inherentTileSetPaths() {
    if (!this._inherentTileSetPaths) {
      this._inherentTileSetPaths = this._parent ? this._parent.TileSetPaths : [];
    }
    return this._inherentTileSetPaths;
  }
  get TileSetPaths() {
    if (!this._allTileSetPaths) {
      this._allTileSetPaths = this._parent ? this._parent.TileSetPaths.concat(this.selfTileSetPaths) : this.selfTileSetPaths;
    }
    return this._allTileSetPaths;
  }
  update(current, parent) {
    const result = new TileSetData_WithParent(current, parent);
    return result;
  }
}
TileSetData_WithParent.default = new TileSetData_WithParent(TileSetData.default, null);
TileSetData.WithParent = TileSetData_WithParent;
class TileSetData_Descriptor {
  get TileSetPaths() {
    if (!this._TileSetPaths) {
      this._TileSetPaths = {
        name: "TileSetPaths",
        Name: "TileSetPaths",
        number: 1,
        protoType: 9,
        protoName: "TileSetPaths",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TileSetPaths;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.TileSetPaths,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TileSetData.descriptor = new TileSetData_Descriptor();
export class TerrainPreset {
  get descriptor() {
    return TerrainPreset.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPresetName = false;
    this._PresetName = null;
  }
  isEmpty() {
    if (this._hasPresetName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainPreset) {
      return value;
    }
    return TerrainPreset.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainPreset();
    if (json.PresetName != null) {
      result._hasPresetName = true;
      result._PresetName = JsonToString.fromJson(json.PresetName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPresetName) {
      result.PresetName = JsonToString.toJson(this._PresetName);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get PresetName() {
    return this._hasPresetName ? this._PresetName : JsonToString.default;
  }
  get hasPresetName() {
    return this._hasPresetName;
  }
  setPresetName(path, value) {
    return {type: 'SET', path: path.concat(['PresetName']), value};
  }
  deletePresetName(path) {
    return {type: 'DELETE', path: path.concat(['PresetName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "PresetName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainPreset(this);
              copy._hasPresetName = true;
              copy._PresetName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPresetName) {
                return this;
              }
              const copy = new TerrainPreset(this);
              copy._hasPresetName = false;
              copy._PresetName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainPreset} other
   * @returns {TerrainPreset}
   */
  merge(other) {
    const copy = new TerrainPreset(this);
    if (other._hasPresetName) {
      copy._hasPresetName = true;
      copy._PresetName = other._PresetName;
    }
    return copy;
  }
}
TerrainPreset.default = new TerrainPreset();
class TerrainPreset_Builder {
  constructor(value) {
    this._value = new TerrainPreset(value);
  }
  build() {
    return new TerrainPreset(this._value);
  }
  setPresetName(value) {
    this._value._hasPresetName = true;
    this._value._PresetName = value;
    return this;
  }
  deletePresetName() {
    this._value._hasPresetName = false;
    this._value._PresetName = null;
    return this;
  }
}
TerrainPreset.Builder = TerrainPreset_Builder;
class TerrainPreset_WithParent {
  /**
   * @param {TerrainPreset} value
   * @param {TerrainPreset_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainPreset.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPresetName() {
    if (this._cachedHasPresetName === undefined) {
      if (this._value.hasPresetName) {
        this._cachedHasPresetName = true;
      } else {
        this._cachedHasPresetName = this._parent ? this._parent.hasPresetName : false;
      }
    }
    return this._cachedHasPresetName;
  }
  get PresetName() {
    if (this._cachedPresetName === undefined) {
      if (this._value.hasPresetName) {
        this._cachedPresetName = this._value.PresetName;
      } else {
        this._cachedPresetName = this._parent ? this._parent.PresetName : this._value.PresetName;
      }
    }
    return this._cachedPresetName;
  }
  update(current, parent) {
    const result = new TerrainPreset_WithParent(current, parent);
    return result;
  }
}
TerrainPreset_WithParent.default = new TerrainPreset_WithParent(TerrainPreset.default, null);
TerrainPreset.WithParent = TerrainPreset_WithParent;
class TerrainPreset_Descriptor {
  get PresetName() {
    if (!this._PresetName) {
      this._PresetName = {
        name: "PresetName",
        Name: "PresetName",
        number: 1,
        protoType: 9,
        protoName: "PresetName",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PresetName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.PresetName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPresetName",
        Name: "DummyOneofForPresetName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainPreset.descriptor = new TerrainPreset_Descriptor();
export class PropLayerInfo {
  get descriptor() {
    return PropLayerInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasDisplay = false;
    this._display = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasDisplay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PropLayerInfo) {
      return value;
    }
    return PropLayerInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new PropLayerInfo();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.display != null) {
      result._hasDisplay = true;
      result._display = JsonToBoolean.fromJson(json.display);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasDisplay) {
      result.display = JsonToBoolean.toJson(this._display);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {boolean}
   */
  get display() {
    return this._hasDisplay ? this._display : JsonToBoolean.default;
  }
  get hasDisplay() {
    return this._hasDisplay;
  }
  setDisplay(path, value) {
    return {type: 'SET', path: path.concat(['display']), value};
  }
  deleteDisplay(path) {
    return {type: 'DELETE', path: path.concat(['display'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropLayerInfo(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new PropLayerInfo(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "display": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropLayerInfo(this);
              copy._hasDisplay = true;
              copy._display = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplay) {
                return this;
              }
              const copy = new PropLayerInfo(this);
              copy._hasDisplay = false;
              copy._display = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PropLayerInfo} other
   * @returns {PropLayerInfo}
   */
  merge(other) {
    const copy = new PropLayerInfo(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasDisplay) {
      copy._hasDisplay = true;
      copy._display = other._display;
    }
    return copy;
  }
}
PropLayerInfo.default = new PropLayerInfo();
class PropLayerInfo_Builder {
  constructor(value) {
    this._value = new PropLayerInfo(value);
  }
  build() {
    return new PropLayerInfo(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setDisplay(value) {
    this._value._hasDisplay = true;
    this._value._display = value;
    return this;
  }
  deleteDisplay() {
    this._value._hasDisplay = false;
    this._value._display = null;
    return this;
  }
}
PropLayerInfo.Builder = PropLayerInfo_Builder;
class PropLayerInfo_WithParent {
  /**
   * @param {PropLayerInfo} value
   * @param {PropLayerInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PropLayerInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasDisplay() {
    if (this._cachedHasDisplay === undefined) {
      if (this._value.hasDisplay) {
        this._cachedHasDisplay = true;
      } else {
        this._cachedHasDisplay = this._parent ? this._parent.hasDisplay : false;
      }
    }
    return this._cachedHasDisplay;
  }
  get display() {
    if (this._cachedDisplay === undefined) {
      if (this._value.hasDisplay) {
        this._cachedDisplay = this._value.display;
      } else {
        this._cachedDisplay = this._parent ? this._parent.display : this._value.display;
      }
    }
    return this._cachedDisplay;
  }
  update(current, parent) {
    const result = new PropLayerInfo_WithParent(current, parent);
    return result;
  }
}
PropLayerInfo_WithParent.default = new PropLayerInfo_WithParent(PropLayerInfo.default, null);
PropLayerInfo.WithParent = PropLayerInfo_WithParent;
class PropLayerInfo_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get display() {
    if (!this._display) {
      this._display = {
        name: "display",
        Name: "Display",
        number: 2,
        protoType: 8,
        protoName: "display",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._display;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.display,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplay",
        Name: "DummyOneofForDisplay",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PropLayerInfo.descriptor = new PropLayerInfo_Descriptor();
class PropsDataContainer_LayerSettingsEntry {
  get descriptor() {
    return PropsDataContainer_LayerSettingsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PropsDataContainer_LayerSettingsEntry) {
      return value;
    }
    return PropsDataContainer_LayerSettingsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new PropsDataContainer_LayerSettingsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = PropLayerInfo.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = PropLayerInfo.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {PropLayerInfo}
   */
  get value() {
    return this._hasValue ? this._value : PropLayerInfo.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer_LayerSettingsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PropsDataContainer_LayerSettingsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer_LayerSettingsEntry(this);
              copy._hasValue = true;
              copy._value = PropLayerInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new PropsDataContainer_LayerSettingsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new PropsDataContainer_LayerSettingsEntry(this);
            copy._hasValue = true;
            copy._value = PropLayerInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new PropsDataContainer_LayerSettingsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PropsDataContainer_LayerSettingsEntry} other
   * @returns {PropsDataContainer_LayerSettingsEntry}
   */
  merge(other) {
    const copy = new PropsDataContainer_LayerSettingsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
PropsDataContainer_LayerSettingsEntry.default = new PropsDataContainer_LayerSettingsEntry();
class PropsDataContainer_LayerSettingsEntry_Builder {
  constructor(value) {
    this._value = new PropsDataContainer_LayerSettingsEntry(value);
  }
  build() {
    return new PropsDataContainer_LayerSettingsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
PropsDataContainer_LayerSettingsEntry.Builder = PropsDataContainer_LayerSettingsEntry_Builder;
class PropsDataContainer_LayerSettingsEntry_WithParent {
  /**
   * @param {PropsDataContainer_LayerSettingsEntry} value
   * @param {PropsDataContainer_LayerSettingsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PropsDataContainer_LayerSettingsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new PropLayerInfo.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new PropLayerInfo.WithParent(PropLayerInfo.default, this._parent.value) : PropLayerInfo.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new PropsDataContainer_LayerSettingsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
PropsDataContainer_LayerSettingsEntry_WithParent.default = new PropsDataContainer_LayerSettingsEntry_WithParent(PropsDataContainer_LayerSettingsEntry.default, null);
PropsDataContainer_LayerSettingsEntry.WithParent = PropsDataContainer_LayerSettingsEntry_WithParent;
class PropsDataContainer_LayerSettingsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: PropLayerInfo,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PropsDataContainer_LayerSettingsEntry.descriptor = new PropsDataContainer_LayerSettingsEntry_Descriptor();
export class PropsDataContainer {
  get descriptor() {
    return PropsDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._PrefabsPath = [];
    this._PrefabIds = [];
    this._MatrixData = [];
    this._BoxesSizeData = [];
    this._ContoursLocation = [];
    this._NavmeshIgnore = [];
    this._LayerSettings = {};
    this._PropLayers = [];
    this._PropTags = [];
  }
  isEmpty() {
    if (this._PrefabsPath.length > 0) return false;
    if (this._PrefabIds.length > 0) return false;
    if (this._MatrixData.length > 0) return false;
    if (this._BoxesSizeData.length > 0) return false;
    if (this._ContoursLocation.length > 0) return false;
    if (this._NavmeshIgnore.length > 0) return false;
    if (Object.keys(this._LayerSettings).length > 0) return false;
    if (this._PropLayers.length > 0) return false;
    if (this._PropTags.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PropsDataContainer) {
      return value;
    }
    return PropsDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new PropsDataContainer();
    result._PrefabsPath = JsonToList(json.PrefabsPath, JsonToString);
    result._PrefabIds = JsonToList(json.PrefabIds, JsonToInt32);
    result._MatrixData = JsonToList(json.MatrixData, FMatrix);
    result._BoxesSizeData = JsonToList(json.BoxesSizeData, FVector2);
    result._ContoursLocation = JsonToList(json.ContoursLocation, JsonToDouble);
    result._NavmeshIgnore = JsonToList(json.NavmeshIgnore, JsonToBoolean);
    result._LayerSettings = JsonToMap(json.LayerSettings, JsonToString, PropLayerInfo);
    result._PropLayers = JsonToList(json.PropLayers, JsonToInt32);
    result._PropTags = JsonToList(json.PropTags, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._PrefabsPath.length > 0) {
      result.PrefabsPath = ArrayToJson(this._PrefabsPath, JsonToString);
    }
    if (this._PrefabIds.length > 0) {
      result.PrefabIds = ArrayToJson(this._PrefabIds, JsonToInt32);
    }
    if (this._MatrixData.length > 0) {
      result.MatrixData = ArrayToJson(this._MatrixData, FMatrix);
    }
    if (this._BoxesSizeData.length > 0) {
      result.BoxesSizeData = ArrayToJson(this._BoxesSizeData, FVector2);
    }
    if (this._ContoursLocation.length > 0) {
      result.ContoursLocation = ArrayToJson(this._ContoursLocation, JsonToDouble);
    }
    if (this._NavmeshIgnore.length > 0) {
      result.NavmeshIgnore = ArrayToJson(this._NavmeshIgnore, JsonToBoolean);
    }
    if (Object.keys(this._LayerSettings).length > 0) {
      result.LayerSettings = MapToJson(this._LayerSettings, JsonToString, PropLayerInfo);
    }
    if (this._PropLayers.length > 0) {
      result.PropLayers = ArrayToJson(this._PropLayers, JsonToInt32);
    }
    if (this._PropTags.length > 0) {
      result.PropTags = ArrayToJson(this._PropTags, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get PrefabsPath() {
    return this._PrefabsPath;
  }
  addPrefabsPath(path, value) {
    return {type: 'ADD', path: path.concat(['PrefabsPath']), value};
  }
  setPrefabsPath(path, value) {
    return {type: 'SET', path: path.concat(['PrefabsPath']), value: ArrayToJson(value, JsonToString)};
  }
  setPrefabsPathByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PrefabsPath', key]), value};
  }
  deletePrefabsPath(path) {
    return {type: 'DELETE', path: path.concat(['PrefabsPath'])};
  }
  deletePrefabsPathByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PrefabsPath', key])};
  }
  /**
   * @returns {number[]}
   */
  get PrefabIds() {
    return this._PrefabIds;
  }
  addPrefabIds(path, value) {
    return {type: 'ADD', path: path.concat(['PrefabIds']), value};
  }
  setPrefabIds(path, value) {
    return {type: 'SET', path: path.concat(['PrefabIds']), value: ArrayToJson(value, JsonToInt32)};
  }
  setPrefabIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PrefabIds', key]), value};
  }
  deletePrefabIds(path) {
    return {type: 'DELETE', path: path.concat(['PrefabIds'])};
  }
  deletePrefabIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PrefabIds', key])};
  }
  /**
   * @returns {FMatrix[]}
   */
  get MatrixData() {
    return this._MatrixData;
  }
  addMatrixData(path, value) {
    return {type: 'ADD', path: path.concat(['MatrixData']), value: value.toJson()};
  }
  setMatrixData(path, value) {
    return {type: 'SET', path: path.concat(['MatrixData']), value: ArrayToJson(value, FMatrix)};
  }
  setMatrixDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['MatrixData', key]), value: value.toJson()};
  }
  deleteMatrixData(path) {
    return {type: 'DELETE', path: path.concat(['MatrixData'])};
  }
  deleteMatrixDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['MatrixData', key])};
  }
  /**
   * @returns {FVector2[]}
   */
  get BoxesSizeData() {
    return this._BoxesSizeData;
  }
  addBoxesSizeData(path, value) {
    return {type: 'ADD', path: path.concat(['BoxesSizeData']), value: value.toJson()};
  }
  setBoxesSizeData(path, value) {
    return {type: 'SET', path: path.concat(['BoxesSizeData']), value: ArrayToJson(value, FVector2)};
  }
  setBoxesSizeDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['BoxesSizeData', key]), value: value.toJson()};
  }
  deleteBoxesSizeData(path) {
    return {type: 'DELETE', path: path.concat(['BoxesSizeData'])};
  }
  deleteBoxesSizeDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['BoxesSizeData', key])};
  }
  /**
   * @returns {number[]}
   */
  get ContoursLocation() {
    return this._ContoursLocation;
  }
  addContoursLocation(path, value) {
    return {type: 'ADD', path: path.concat(['ContoursLocation']), value};
  }
  setContoursLocation(path, value) {
    return {type: 'SET', path: path.concat(['ContoursLocation']), value: ArrayToJson(value, JsonToDouble)};
  }
  setContoursLocationByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['ContoursLocation', key]), value};
  }
  deleteContoursLocation(path) {
    return {type: 'DELETE', path: path.concat(['ContoursLocation'])};
  }
  deleteContoursLocationByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['ContoursLocation', key])};
  }
  /**
   * @returns {boolean[]}
   */
  get NavmeshIgnore() {
    return this._NavmeshIgnore;
  }
  addNavmeshIgnore(path, value) {
    return {type: 'ADD', path: path.concat(['NavmeshIgnore']), value};
  }
  setNavmeshIgnore(path, value) {
    return {type: 'SET', path: path.concat(['NavmeshIgnore']), value: ArrayToJson(value, JsonToBoolean)};
  }
  setNavmeshIgnoreByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['NavmeshIgnore', key]), value};
  }
  deleteNavmeshIgnore(path) {
    return {type: 'DELETE', path: path.concat(['NavmeshIgnore'])};
  }
  deleteNavmeshIgnoreByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['NavmeshIgnore', key])};
  }
  /**
   * @returns {Object<string, PropLayerInfo>}
   */
  get LayerSettings() {
    return this._LayerSettings;
  }
  setLayerSettings(path, value) {
    return {type: 'SET', path: path.concat(['LayerSettings']), value: MapToJson(value, JsonToString, PropLayerInfo)};
  }
  setLayerSettingsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['LayerSettings', key]), value: value.toJson()};
  }
  deleteLayerSettings(path) {
    return {type: 'DELETE', path: path.concat(['LayerSettings'])};
  }
  deleteLayerSettingsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['LayerSettings', key])};
  }
  /**
   * @returns {number[]}
   */
  get PropLayers() {
    return this._PropLayers;
  }
  addPropLayers(path, value) {
    return {type: 'ADD', path: path.concat(['PropLayers']), value};
  }
  setPropLayers(path, value) {
    return {type: 'SET', path: path.concat(['PropLayers']), value: ArrayToJson(value, JsonToInt32)};
  }
  setPropLayersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PropLayers', key]), value};
  }
  deletePropLayers(path) {
    return {type: 'DELETE', path: path.concat(['PropLayers'])};
  }
  deletePropLayersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PropLayers', key])};
  }
  /**
   * @returns {string[]}
   */
  get PropTags() {
    return this._PropTags;
  }
  addPropTags(path, value) {
    return {type: 'ADD', path: path.concat(['PropTags']), value};
  }
  setPropTags(path, value) {
    return {type: 'SET', path: path.concat(['PropTags']), value: ArrayToJson(value, JsonToString)};
  }
  setPropTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PropTags', key]), value};
  }
  deletePropTags(path) {
    return {type: 'DELETE', path: path.concat(['PropTags'])};
  }
  deletePropTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PropTags', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "PrefabsPath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PrefabsPath = [];        for (let i of value) {
                copy._PrefabsPath.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._PrefabsPath = copy._PrefabsPath.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PrefabsPath.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._PrefabsPath = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PrefabsPath.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PrefabsPath = copy._PrefabsPath.slice();
              copy._PrefabsPath[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._PrefabsPath = copy._PrefabsPath.slice(0, path[1]).concat(copy._PrefabsPath.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PrefabsPath.length) {
            return this;
          }
          const oldValue = this._PrefabsPath[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._PrefabsPath = copy._PrefabsPath.slice();
          copy._PrefabsPath[key] = newValue;
          return copy;
        }
      }
      case "PrefabIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PrefabIds = [];        for (let i of value) {
                copy._PrefabIds.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._PrefabIds = copy._PrefabIds.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PrefabIds.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._PrefabIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PrefabIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PrefabIds = copy._PrefabIds.slice();
              copy._PrefabIds[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._PrefabIds = copy._PrefabIds.slice(0, path[1]).concat(copy._PrefabIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PrefabIds.length) {
            return this;
          }
          const oldValue = this._PrefabIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._PrefabIds = copy._PrefabIds.slice();
          copy._PrefabIds[key] = newValue;
          return copy;
        }
      }
      case "MatrixData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._MatrixData = [];        for (let i of value) {
                copy._MatrixData.push(FMatrix.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._MatrixData = copy._MatrixData.concat([FMatrix.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._MatrixData.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._MatrixData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._MatrixData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._MatrixData = copy._MatrixData.slice();
              copy._MatrixData[path[1]] = FMatrix.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._MatrixData = copy._MatrixData.slice(0, path[1]).concat(copy._MatrixData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._MatrixData.length) {
            return this;
          }
          const oldValue = this._MatrixData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._MatrixData = copy._MatrixData.slice();
          copy._MatrixData[key] = newValue;
          return copy;
        }
      }
      case "BoxesSizeData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._BoxesSizeData = [];        for (let i of value) {
                copy._BoxesSizeData.push(FVector2.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._BoxesSizeData = copy._BoxesSizeData.concat([FVector2.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._BoxesSizeData.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._BoxesSizeData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._BoxesSizeData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._BoxesSizeData = copy._BoxesSizeData.slice();
              copy._BoxesSizeData[path[1]] = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._BoxesSizeData = copy._BoxesSizeData.slice(0, path[1]).concat(copy._BoxesSizeData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._BoxesSizeData.length) {
            return this;
          }
          const oldValue = this._BoxesSizeData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._BoxesSizeData = copy._BoxesSizeData.slice();
          copy._BoxesSizeData[key] = newValue;
          return copy;
        }
      }
      case "ContoursLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._ContoursLocation = [];        for (let i of value) {
                copy._ContoursLocation.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._ContoursLocation = copy._ContoursLocation.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._ContoursLocation.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._ContoursLocation = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._ContoursLocation.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._ContoursLocation = copy._ContoursLocation.slice();
              copy._ContoursLocation[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._ContoursLocation = copy._ContoursLocation.slice(0, path[1]).concat(copy._ContoursLocation.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._ContoursLocation.length) {
            return this;
          }
          const oldValue = this._ContoursLocation[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._ContoursLocation = copy._ContoursLocation.slice();
          copy._ContoursLocation[key] = newValue;
          return copy;
        }
      }
      case "NavmeshIgnore": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._NavmeshIgnore = [];        for (let i of value) {
                copy._NavmeshIgnore.push(JsonToBoolean.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._NavmeshIgnore = copy._NavmeshIgnore.concat([JsonToBoolean.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._NavmeshIgnore.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._NavmeshIgnore = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._NavmeshIgnore.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._NavmeshIgnore = copy._NavmeshIgnore.slice();
              copy._NavmeshIgnore[path[1]] = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._NavmeshIgnore = copy._NavmeshIgnore.slice(0, path[1]).concat(copy._NavmeshIgnore.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._NavmeshIgnore.length) {
            return this;
          }
          const oldValue = this._NavmeshIgnore[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._NavmeshIgnore = copy._NavmeshIgnore.slice();
          copy._NavmeshIgnore[key] = newValue;
          return copy;
        }
      }
      case "LayerSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._LayerSettings).length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._LayerSettings = {};
              return copy;
            }
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._LayerSettings = {};
              for (let key in value) {
                copy._LayerSettings[key] = PropLayerInfo.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._LayerSettings = {...copy._LayerSettings};
              copy._LayerSettings[path[1]] = PropLayerInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._LayerSettings[path[1]]) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._LayerSettings = {...copy._LayerSettings};
              delete copy._LayerSettings[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._LayerSettings[key] === undefined) {
            const copy = new PropsDataContainer(this);
            copy._LayerSettings = {...copy._LayerSettings};
            copy._LayerSettings[key] = PropLayerInfo.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._LayerSettings[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._LayerSettings = {...copy._LayerSettings};
          copy._LayerSettings[key] = newValue;
          return copy;
        }
      }
      case "PropLayers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PropLayers = [];        for (let i of value) {
                copy._PropLayers.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._PropLayers = copy._PropLayers.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PropLayers.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._PropLayers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PropLayers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PropLayers = copy._PropLayers.slice();
              copy._PropLayers[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._PropLayers = copy._PropLayers.slice(0, path[1]).concat(copy._PropLayers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PropLayers.length) {
            return this;
          }
          const oldValue = this._PropLayers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._PropLayers = copy._PropLayers.slice();
          copy._PropLayers[key] = newValue;
          return copy;
        }
      }
      case "PropTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PropTags = [];        for (let i of value) {
                copy._PropTags.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PropsDataContainer(this);
              copy._PropTags = copy._PropTags.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PropTags.length === 0) {
                return this;
              }
              const copy = new PropsDataContainer(this);
              copy._PropTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PropTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PropsDataContainer(this);
              copy._PropTags = copy._PropTags.slice();
              copy._PropTags[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PropsDataContainer(this);
              copy._PropTags = copy._PropTags.slice(0, path[1]).concat(copy._PropTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PropTags.length) {
            return this;
          }
          const oldValue = this._PropTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PropsDataContainer(this);
          copy._PropTags = copy._PropTags.slice();
          copy._PropTags[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PropsDataContainer} other
   * @returns {PropsDataContainer}
   */
  merge(other) {
    const copy = new PropsDataContainer(this);
    copy._PrefabsPath = this._PrefabsPath.concat(other._PrefabsPath);
    copy._PrefabIds = this._PrefabIds.concat(other._PrefabIds);
    copy._MatrixData = this._MatrixData.concat(other._MatrixData);
    copy._BoxesSizeData = this._BoxesSizeData.concat(other._BoxesSizeData);
    copy._ContoursLocation = this._ContoursLocation.concat(other._ContoursLocation);
    copy._NavmeshIgnore = this._NavmeshIgnore.concat(other._NavmeshIgnore);
    copy._LayerSettings = {...this._LayerSettings, ...other._LayerSettings};
    copy._PropLayers = this._PropLayers.concat(other._PropLayers);
    copy._PropTags = this._PropTags.concat(other._PropTags);
    return copy;
  }
}
PropsDataContainer.default = new PropsDataContainer();
PropsDataContainer.LayerSettingsEntry = PropsDataContainer_LayerSettingsEntry;
class PropsDataContainer_Builder {
  constructor(value) {
    this._value = new PropsDataContainer(value);
  }
  build() {
    return new PropsDataContainer(this._value);
  }
  addAllPrefabsPath(values) {
    this._value._PrefabsPath = this._value._PrefabsPath.concat(values);
    return this;
  }
  addPrefabsPath(value) {
    this._value._PrefabsPath = this._value._PrefabsPath.concat([value]);
    return this;
  }
  setPrefabsPath(index, value) {
    this._value._PrefabsPath = this._value._PrefabsPath.concat();
    this._value._PrefabsPath[index] = value;
    return this;
  }
  clearPrefabsPath() {
    this._value._PrefabsPath = [];
    return this;
  }
  addAllPrefabIds(values) {
    this._value._PrefabIds = this._value._PrefabIds.concat(values);
    return this;
  }
  addPrefabIds(value) {
    this._value._PrefabIds = this._value._PrefabIds.concat([value]);
    return this;
  }
  setPrefabIds(index, value) {
    this._value._PrefabIds = this._value._PrefabIds.concat();
    this._value._PrefabIds[index] = value;
    return this;
  }
  clearPrefabIds() {
    this._value._PrefabIds = [];
    return this;
  }
  addAllMatrixData(values) {
    this._value._MatrixData = this._value._MatrixData.concat(values);
    return this;
  }
  addMatrixData(value) {
    this._value._MatrixData = this._value._MatrixData.concat([value]);
    return this;
  }
  setMatrixData(index, value) {
    this._value._MatrixData = this._value._MatrixData.concat();
    this._value._MatrixData[index] = value;
    return this;
  }
  clearMatrixData() {
    this._value._MatrixData = [];
    return this;
  }
  addAllBoxesSizeData(values) {
    this._value._BoxesSizeData = this._value._BoxesSizeData.concat(values);
    return this;
  }
  addBoxesSizeData(value) {
    this._value._BoxesSizeData = this._value._BoxesSizeData.concat([value]);
    return this;
  }
  setBoxesSizeData(index, value) {
    this._value._BoxesSizeData = this._value._BoxesSizeData.concat();
    this._value._BoxesSizeData[index] = value;
    return this;
  }
  clearBoxesSizeData() {
    this._value._BoxesSizeData = [];
    return this;
  }
  addAllContoursLocation(values) {
    this._value._ContoursLocation = this._value._ContoursLocation.concat(values);
    return this;
  }
  addContoursLocation(value) {
    this._value._ContoursLocation = this._value._ContoursLocation.concat([value]);
    return this;
  }
  setContoursLocation(index, value) {
    this._value._ContoursLocation = this._value._ContoursLocation.concat();
    this._value._ContoursLocation[index] = value;
    return this;
  }
  clearContoursLocation() {
    this._value._ContoursLocation = [];
    return this;
  }
  addAllNavmeshIgnore(values) {
    this._value._NavmeshIgnore = this._value._NavmeshIgnore.concat(values);
    return this;
  }
  addNavmeshIgnore(value) {
    this._value._NavmeshIgnore = this._value._NavmeshIgnore.concat([value]);
    return this;
  }
  setNavmeshIgnore(index, value) {
    this._value._NavmeshIgnore = this._value._NavmeshIgnore.concat();
    this._value._NavmeshIgnore[index] = value;
    return this;
  }
  clearNavmeshIgnore() {
    this._value._NavmeshIgnore = [];
    return this;
  }
  setLayerSettings(key, value) {
    this._value._LayerSettings = {...this._value._LayerSettings, [key]: value};
    return this;
  }
  addAllLayerSettings(values) {
    this._value._LayerSettings = {...this._value._LayerSettings, ...values};
    return this;
  }
  deleteLayerSettings(key) {
    this._value._LayerSettings = {...this._value._LayerSettings};
    delete this._value._LayerSettings[key];
    return this;
  }
  clearLayerSettings() {
    this._value._LayerSettings = {};
    return this;
  }
  addAllPropLayers(values) {
    this._value._PropLayers = this._value._PropLayers.concat(values);
    return this;
  }
  addPropLayers(value) {
    this._value._PropLayers = this._value._PropLayers.concat([value]);
    return this;
  }
  setPropLayers(index, value) {
    this._value._PropLayers = this._value._PropLayers.concat();
    this._value._PropLayers[index] = value;
    return this;
  }
  clearPropLayers() {
    this._value._PropLayers = [];
    return this;
  }
  addAllPropTags(values) {
    this._value._PropTags = this._value._PropTags.concat(values);
    return this;
  }
  addPropTags(value) {
    this._value._PropTags = this._value._PropTags.concat([value]);
    return this;
  }
  setPropTags(index, value) {
    this._value._PropTags = this._value._PropTags.concat();
    this._value._PropTags[index] = value;
    return this;
  }
  clearPropTags() {
    this._value._PropTags = [];
    return this;
  }
}
PropsDataContainer.Builder = PropsDataContainer_Builder;
class PropsDataContainer_WithParent {
  /**
   * @param {PropsDataContainer} value
   * @param {PropsDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PropsDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPrefabsPath() {
    return this._value.PrefabsPath;
  }
  get inherentPrefabsPath() {
    if (!this._inherentPrefabsPath) {
      this._inherentPrefabsPath = this._parent ? this._parent.PrefabsPath : [];
    }
    return this._inherentPrefabsPath;
  }
  get PrefabsPath() {
    if (!this._allPrefabsPath) {
      this._allPrefabsPath = this._parent ? this._parent.PrefabsPath.concat(this.selfPrefabsPath) : this.selfPrefabsPath;
    }
    return this._allPrefabsPath;
  }
  get selfPrefabIds() {
    return this._value.PrefabIds;
  }
  get inherentPrefabIds() {
    if (!this._inherentPrefabIds) {
      this._inherentPrefabIds = this._parent ? this._parent.PrefabIds : [];
    }
    return this._inherentPrefabIds;
  }
  get PrefabIds() {
    if (!this._allPrefabIds) {
      this._allPrefabIds = this._parent ? this._parent.PrefabIds.concat(this.selfPrefabIds) : this.selfPrefabIds;
    }
    return this._allPrefabIds;
  }
  get selfMatrixData() {
    if (!this._selfMatrixData) {
      this._selfMatrixData = [];
      for (let i of this._value.MatrixData) {
        this._selfMatrixData.push(new FMatrix.WithParent(i, null));
      }
    }
    return this._selfMatrixData;
  }
  get inherentMatrixData() {
    if (!this._inherentMatrixData) {
      this._inherentMatrixData = this._parent ? this._parent.MatrixData : [];
    }
    return this._inherentMatrixData;
  }
  get MatrixData() {
    if (!this._allMatrixData) {
      this._allMatrixData = this._parent ? this._parent.MatrixData.concat(this.selfMatrixData) : this.selfMatrixData;
    }
    return this._allMatrixData;
  }
  get selfBoxesSizeData() {
    if (!this._selfBoxesSizeData) {
      this._selfBoxesSizeData = [];
      for (let i of this._value.BoxesSizeData) {
        this._selfBoxesSizeData.push(new FVector2.WithParent(i, null));
      }
    }
    return this._selfBoxesSizeData;
  }
  get inherentBoxesSizeData() {
    if (!this._inherentBoxesSizeData) {
      this._inherentBoxesSizeData = this._parent ? this._parent.BoxesSizeData : [];
    }
    return this._inherentBoxesSizeData;
  }
  get BoxesSizeData() {
    if (!this._allBoxesSizeData) {
      this._allBoxesSizeData = this._parent ? this._parent.BoxesSizeData.concat(this.selfBoxesSizeData) : this.selfBoxesSizeData;
    }
    return this._allBoxesSizeData;
  }
  get selfContoursLocation() {
    return this._value.ContoursLocation;
  }
  get inherentContoursLocation() {
    if (!this._inherentContoursLocation) {
      this._inherentContoursLocation = this._parent ? this._parent.ContoursLocation : [];
    }
    return this._inherentContoursLocation;
  }
  get ContoursLocation() {
    if (!this._allContoursLocation) {
      this._allContoursLocation = this._parent ? this._parent.ContoursLocation.concat(this.selfContoursLocation) : this.selfContoursLocation;
    }
    return this._allContoursLocation;
  }
  get selfNavmeshIgnore() {
    return this._value.NavmeshIgnore;
  }
  get inherentNavmeshIgnore() {
    if (!this._inherentNavmeshIgnore) {
      this._inherentNavmeshIgnore = this._parent ? this._parent.NavmeshIgnore : [];
    }
    return this._inherentNavmeshIgnore;
  }
  get NavmeshIgnore() {
    if (!this._allNavmeshIgnore) {
      this._allNavmeshIgnore = this._parent ? this._parent.NavmeshIgnore.concat(this.selfNavmeshIgnore) : this.selfNavmeshIgnore;
    }
    return this._allNavmeshIgnore;
  }
  get selfLayerSettings() {
    if (!this._selfLayerSettings) {
      this._selfLayerSettings = {};
      for (let i in this._value.LayerSettings) {
        this._selfLayerSettings[i] = new PropLayerInfo.WithParent(this._value.LayerSettings[i], null);
      }
    }
    return this._selfLayerSettings;
  }
  get inherentLayerSettings() {
    if (!this._inherentLayerSettings) {
      this._inherentLayerSettings = this._parent ? this._parent.LayerSettings : {};
    }
    return this._inherentLayerSettings;
  }
  get LayerSettings() {
    if (!this._allLayerSettings) {
      this._allLayerSettings = this._parent ? {...this._parent.LayerSettings, ...this.selfLayerSettings} : this.selfLayerSettings;
    }
    return this._allLayerSettings;
  }
  get selfPropLayers() {
    return this._value.PropLayers;
  }
  get inherentPropLayers() {
    if (!this._inherentPropLayers) {
      this._inherentPropLayers = this._parent ? this._parent.PropLayers : [];
    }
    return this._inherentPropLayers;
  }
  get PropLayers() {
    if (!this._allPropLayers) {
      this._allPropLayers = this._parent ? this._parent.PropLayers.concat(this.selfPropLayers) : this.selfPropLayers;
    }
    return this._allPropLayers;
  }
  get selfPropTags() {
    return this._value.PropTags;
  }
  get inherentPropTags() {
    if (!this._inherentPropTags) {
      this._inherentPropTags = this._parent ? this._parent.PropTags : [];
    }
    return this._inherentPropTags;
  }
  get PropTags() {
    if (!this._allPropTags) {
      this._allPropTags = this._parent ? this._parent.PropTags.concat(this.selfPropTags) : this.selfPropTags;
    }
    return this._allPropTags;
  }
  update(current, parent) {
    const result = new PropsDataContainer_WithParent(current, parent);
    if (this._selfMatrixData) {
      if (this._value.MatrixData === current.MatrixData) {
        result._selfMatrixData = this._selfMatrixData;
      } else {
        result._selfMatrixData = [];
        for (let i = 0; i < current.MatrixData.length; i++) {
          const oldValue = this._value.MatrixData[i];
          if (oldValue) {
            const oldCache = this._selfMatrixData[i];
            if (oldValue === current.MatrixData[i]) {
              result._selfMatrixData[i] = oldCache;
            } else {
              result._selfMatrixData[i] = oldCache.update(current.MatrixData[i], null);
            }
          } else {
            result._selfMatrixData[i] = new FMatrix.WithParent(current.MatrixData[i], null);
          }
        }
      }
    }
    if (this._selfBoxesSizeData) {
      if (this._value.BoxesSizeData === current.BoxesSizeData) {
        result._selfBoxesSizeData = this._selfBoxesSizeData;
      } else {
        result._selfBoxesSizeData = [];
        for (let i = 0; i < current.BoxesSizeData.length; i++) {
          const oldValue = this._value.BoxesSizeData[i];
          if (oldValue) {
            const oldCache = this._selfBoxesSizeData[i];
            if (oldValue === current.BoxesSizeData[i]) {
              result._selfBoxesSizeData[i] = oldCache;
            } else {
              result._selfBoxesSizeData[i] = oldCache.update(current.BoxesSizeData[i], null);
            }
          } else {
            result._selfBoxesSizeData[i] = new FVector2.WithParent(current.BoxesSizeData[i], null);
          }
        }
      }
    }
    if (this._selfLayerSettings) {
      if (this._value.LayerSettings === current.LayerSettings) {
        result._selfLayerSettings = this._selfLayerSettings;
      } else {
        result._selfLayerSettings = {};
        for (let i in current.LayerSettings) {
          const oldValue = this._value.LayerSettings[i];
          if (oldValue) {
            const oldCache = this._selfLayerSettings[i];
            if (oldValue === current.LayerSettings[i]) {
              result._selfLayerSettings[i] = oldCache;
            } else {
              result._selfLayerSettings[i] = oldCache.update(current.LayerSettings[i], null);
            }
          } else {
            result._selfLayerSettings[i] = new PropLayerInfo.WithParent(current.LayerSettings[i], null);
          }
        }
      }
    }
    return result;
  }
}
PropsDataContainer_WithParent.default = new PropsDataContainer_WithParent(PropsDataContainer.default, null);
PropsDataContainer.WithParent = PropsDataContainer_WithParent;
class PropsDataContainer_Descriptor {
  get PrefabsPath() {
    if (!this._PrefabsPath) {
      this._PrefabsPath = {
        name: "PrefabsPath",
        Name: "PrefabsPath",
        number: 1,
        protoType: 9,
        protoName: "PrefabsPath",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PrefabsPath;
  }
  get PrefabIds() {
    if (!this._PrefabIds) {
      this._PrefabIds = {
        name: "PrefabIds",
        Name: "PrefabIds",
        number: 2,
        protoType: 5,
        protoName: "PrefabIds",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PrefabIds;
  }
  get MatrixData() {
    if (!this._MatrixData) {
      this._MatrixData = {
        name: "MatrixData",
        Name: "MatrixData",
        number: 3,
        protoType: 11,
        protoName: "MatrixData",
        type: FMatrix,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._MatrixData;
  }
  get BoxesSizeData() {
    if (!this._BoxesSizeData) {
      this._BoxesSizeData = {
        name: "BoxesSizeData",
        Name: "BoxesSizeData",
        number: 4,
        protoType: 11,
        protoName: "BoxesSizeData",
        type: FVector2,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._BoxesSizeData;
  }
  get ContoursLocation() {
    if (!this._ContoursLocation) {
      this._ContoursLocation = {
        name: "ContoursLocation",
        Name: "ContoursLocation",
        number: 5,
        protoType: 1,
        protoName: "ContoursLocation",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ContoursLocation;
  }
  get NavmeshIgnore() {
    if (!this._NavmeshIgnore) {
      this._NavmeshIgnore = {
        name: "NavmeshIgnore",
        Name: "NavmeshIgnore",
        number: 6,
        protoType: 8,
        protoName: "NavmeshIgnore",
        type: JsonToBoolean,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._NavmeshIgnore;
  }
  get LayerSettings() {
    if (!this._LayerSettings) {
      this._LayerSettings = {
        name: "LayerSettings",
        Name: "LayerSettings",
        number: 7,
        protoType: 11,
        protoName: "LayerSettings",
        isMap: true,
        keyType: JsonToString,
        valueType: PropLayerInfo,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._LayerSettings;
  }
  get PropLayers() {
    if (!this._PropLayers) {
      this._PropLayers = {
        name: "PropLayers",
        Name: "PropLayers",
        number: 8,
        protoType: 5,
        protoName: "PropLayers",
        type: JsonToInt32,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PropLayers;
  }
  get PropTags() {
    if (!this._PropTags) {
      this._PropTags = {
        name: "PropTags",
        Name: "PropTags",
        number: 10,
        protoType: 9,
        protoName: "PropTags",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PropTags;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.PrefabsPath,
        this.PrefabIds,
        this.MatrixData,
        this.BoxesSizeData,
        this.ContoursLocation,
        this.NavmeshIgnore,
        this.LayerSettings,
        this.PropLayers,
        this.PropTags,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PropsDataContainer.descriptor = new PropsDataContainer_Descriptor();
export class FMatrix {
  get descriptor() {
    return FMatrix.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasM00 = false;
    this._M00 = null;
    this._hasM01 = false;
    this._M01 = null;
    this._hasM02 = false;
    this._M02 = null;
    this._hasM03 = false;
    this._M03 = null;
    this._hasM10 = false;
    this._M10 = null;
    this._hasM11 = false;
    this._M11 = null;
    this._hasM12 = false;
    this._M12 = null;
    this._hasM13 = false;
    this._M13 = null;
    this._hasM20 = false;
    this._M20 = null;
    this._hasM21 = false;
    this._M21 = null;
    this._hasM22 = false;
    this._M22 = null;
    this._hasM23 = false;
    this._M23 = null;
    this._hasM30 = false;
    this._M30 = null;
    this._hasM31 = false;
    this._M31 = null;
    this._hasM32 = false;
    this._M32 = null;
    this._hasM33 = false;
    this._M33 = null;
  }
  isEmpty() {
    if (this._hasM00) return false;
    if (this._hasM01) return false;
    if (this._hasM02) return false;
    if (this._hasM03) return false;
    if (this._hasM10) return false;
    if (this._hasM11) return false;
    if (this._hasM12) return false;
    if (this._hasM13) return false;
    if (this._hasM20) return false;
    if (this._hasM21) return false;
    if (this._hasM22) return false;
    if (this._hasM23) return false;
    if (this._hasM30) return false;
    if (this._hasM31) return false;
    if (this._hasM32) return false;
    if (this._hasM33) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FMatrix) {
      return value;
    }
    return FMatrix.fromJson(value);
  }
  static fromJson(json) {
    const result = new FMatrix();
    if (json.M00 != null) {
      result._hasM00 = true;
      result._M00 = JsonToDouble.fromJson(json.M00);
    }
    if (json.M01 != null) {
      result._hasM01 = true;
      result._M01 = JsonToDouble.fromJson(json.M01);
    }
    if (json.M02 != null) {
      result._hasM02 = true;
      result._M02 = JsonToDouble.fromJson(json.M02);
    }
    if (json.M03 != null) {
      result._hasM03 = true;
      result._M03 = JsonToDouble.fromJson(json.M03);
    }
    if (json.M10 != null) {
      result._hasM10 = true;
      result._M10 = JsonToDouble.fromJson(json.M10);
    }
    if (json.M11 != null) {
      result._hasM11 = true;
      result._M11 = JsonToDouble.fromJson(json.M11);
    }
    if (json.M12 != null) {
      result._hasM12 = true;
      result._M12 = JsonToDouble.fromJson(json.M12);
    }
    if (json.M13 != null) {
      result._hasM13 = true;
      result._M13 = JsonToDouble.fromJson(json.M13);
    }
    if (json.M20 != null) {
      result._hasM20 = true;
      result._M20 = JsonToDouble.fromJson(json.M20);
    }
    if (json.M21 != null) {
      result._hasM21 = true;
      result._M21 = JsonToDouble.fromJson(json.M21);
    }
    if (json.M22 != null) {
      result._hasM22 = true;
      result._M22 = JsonToDouble.fromJson(json.M22);
    }
    if (json.M23 != null) {
      result._hasM23 = true;
      result._M23 = JsonToDouble.fromJson(json.M23);
    }
    if (json.M30 != null) {
      result._hasM30 = true;
      result._M30 = JsonToDouble.fromJson(json.M30);
    }
    if (json.M31 != null) {
      result._hasM31 = true;
      result._M31 = JsonToDouble.fromJson(json.M31);
    }
    if (json.M32 != null) {
      result._hasM32 = true;
      result._M32 = JsonToDouble.fromJson(json.M32);
    }
    if (json.M33 != null) {
      result._hasM33 = true;
      result._M33 = JsonToDouble.fromJson(json.M33);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasM00) {
      result.M00 = JsonToDouble.toJson(this._M00);
    }
    if (this._hasM01) {
      result.M01 = JsonToDouble.toJson(this._M01);
    }
    if (this._hasM02) {
      result.M02 = JsonToDouble.toJson(this._M02);
    }
    if (this._hasM03) {
      result.M03 = JsonToDouble.toJson(this._M03);
    }
    if (this._hasM10) {
      result.M10 = JsonToDouble.toJson(this._M10);
    }
    if (this._hasM11) {
      result.M11 = JsonToDouble.toJson(this._M11);
    }
    if (this._hasM12) {
      result.M12 = JsonToDouble.toJson(this._M12);
    }
    if (this._hasM13) {
      result.M13 = JsonToDouble.toJson(this._M13);
    }
    if (this._hasM20) {
      result.M20 = JsonToDouble.toJson(this._M20);
    }
    if (this._hasM21) {
      result.M21 = JsonToDouble.toJson(this._M21);
    }
    if (this._hasM22) {
      result.M22 = JsonToDouble.toJson(this._M22);
    }
    if (this._hasM23) {
      result.M23 = JsonToDouble.toJson(this._M23);
    }
    if (this._hasM30) {
      result.M30 = JsonToDouble.toJson(this._M30);
    }
    if (this._hasM31) {
      result.M31 = JsonToDouble.toJson(this._M31);
    }
    if (this._hasM32) {
      result.M32 = JsonToDouble.toJson(this._M32);
    }
    if (this._hasM33) {
      result.M33 = JsonToDouble.toJson(this._M33);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get M00() {
    return this._hasM00 ? this._M00 : JsonToDouble.default;
  }
  get hasM00() {
    return this._hasM00;
  }
  setM00(path, value) {
    return {type: 'SET', path: path.concat(['M00']), value};
  }
  deleteM00(path) {
    return {type: 'DELETE', path: path.concat(['M00'])};
  }
  /**
   * @returns {number}
   */
  get M01() {
    return this._hasM01 ? this._M01 : JsonToDouble.default;
  }
  get hasM01() {
    return this._hasM01;
  }
  setM01(path, value) {
    return {type: 'SET', path: path.concat(['M01']), value};
  }
  deleteM01(path) {
    return {type: 'DELETE', path: path.concat(['M01'])};
  }
  /**
   * @returns {number}
   */
  get M02() {
    return this._hasM02 ? this._M02 : JsonToDouble.default;
  }
  get hasM02() {
    return this._hasM02;
  }
  setM02(path, value) {
    return {type: 'SET', path: path.concat(['M02']), value};
  }
  deleteM02(path) {
    return {type: 'DELETE', path: path.concat(['M02'])};
  }
  /**
   * @returns {number}
   */
  get M03() {
    return this._hasM03 ? this._M03 : JsonToDouble.default;
  }
  get hasM03() {
    return this._hasM03;
  }
  setM03(path, value) {
    return {type: 'SET', path: path.concat(['M03']), value};
  }
  deleteM03(path) {
    return {type: 'DELETE', path: path.concat(['M03'])};
  }
  /**
   * @returns {number}
   */
  get M10() {
    return this._hasM10 ? this._M10 : JsonToDouble.default;
  }
  get hasM10() {
    return this._hasM10;
  }
  setM10(path, value) {
    return {type: 'SET', path: path.concat(['M10']), value};
  }
  deleteM10(path) {
    return {type: 'DELETE', path: path.concat(['M10'])};
  }
  /**
   * @returns {number}
   */
  get M11() {
    return this._hasM11 ? this._M11 : JsonToDouble.default;
  }
  get hasM11() {
    return this._hasM11;
  }
  setM11(path, value) {
    return {type: 'SET', path: path.concat(['M11']), value};
  }
  deleteM11(path) {
    return {type: 'DELETE', path: path.concat(['M11'])};
  }
  /**
   * @returns {number}
   */
  get M12() {
    return this._hasM12 ? this._M12 : JsonToDouble.default;
  }
  get hasM12() {
    return this._hasM12;
  }
  setM12(path, value) {
    return {type: 'SET', path: path.concat(['M12']), value};
  }
  deleteM12(path) {
    return {type: 'DELETE', path: path.concat(['M12'])};
  }
  /**
   * @returns {number}
   */
  get M13() {
    return this._hasM13 ? this._M13 : JsonToDouble.default;
  }
  get hasM13() {
    return this._hasM13;
  }
  setM13(path, value) {
    return {type: 'SET', path: path.concat(['M13']), value};
  }
  deleteM13(path) {
    return {type: 'DELETE', path: path.concat(['M13'])};
  }
  /**
   * @returns {number}
   */
  get M20() {
    return this._hasM20 ? this._M20 : JsonToDouble.default;
  }
  get hasM20() {
    return this._hasM20;
  }
  setM20(path, value) {
    return {type: 'SET', path: path.concat(['M20']), value};
  }
  deleteM20(path) {
    return {type: 'DELETE', path: path.concat(['M20'])};
  }
  /**
   * @returns {number}
   */
  get M21() {
    return this._hasM21 ? this._M21 : JsonToDouble.default;
  }
  get hasM21() {
    return this._hasM21;
  }
  setM21(path, value) {
    return {type: 'SET', path: path.concat(['M21']), value};
  }
  deleteM21(path) {
    return {type: 'DELETE', path: path.concat(['M21'])};
  }
  /**
   * @returns {number}
   */
  get M22() {
    return this._hasM22 ? this._M22 : JsonToDouble.default;
  }
  get hasM22() {
    return this._hasM22;
  }
  setM22(path, value) {
    return {type: 'SET', path: path.concat(['M22']), value};
  }
  deleteM22(path) {
    return {type: 'DELETE', path: path.concat(['M22'])};
  }
  /**
   * @returns {number}
   */
  get M23() {
    return this._hasM23 ? this._M23 : JsonToDouble.default;
  }
  get hasM23() {
    return this._hasM23;
  }
  setM23(path, value) {
    return {type: 'SET', path: path.concat(['M23']), value};
  }
  deleteM23(path) {
    return {type: 'DELETE', path: path.concat(['M23'])};
  }
  /**
   * @returns {number}
   */
  get M30() {
    return this._hasM30 ? this._M30 : JsonToDouble.default;
  }
  get hasM30() {
    return this._hasM30;
  }
  setM30(path, value) {
    return {type: 'SET', path: path.concat(['M30']), value};
  }
  deleteM30(path) {
    return {type: 'DELETE', path: path.concat(['M30'])};
  }
  /**
   * @returns {number}
   */
  get M31() {
    return this._hasM31 ? this._M31 : JsonToDouble.default;
  }
  get hasM31() {
    return this._hasM31;
  }
  setM31(path, value) {
    return {type: 'SET', path: path.concat(['M31']), value};
  }
  deleteM31(path) {
    return {type: 'DELETE', path: path.concat(['M31'])};
  }
  /**
   * @returns {number}
   */
  get M32() {
    return this._hasM32 ? this._M32 : JsonToDouble.default;
  }
  get hasM32() {
    return this._hasM32;
  }
  setM32(path, value) {
    return {type: 'SET', path: path.concat(['M32']), value};
  }
  deleteM32(path) {
    return {type: 'DELETE', path: path.concat(['M32'])};
  }
  /**
   * @returns {number}
   */
  get M33() {
    return this._hasM33 ? this._M33 : JsonToDouble.default;
  }
  get hasM33() {
    return this._hasM33;
  }
  setM33(path, value) {
    return {type: 'SET', path: path.concat(['M33']), value};
  }
  deleteM33(path) {
    return {type: 'DELETE', path: path.concat(['M33'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "M00": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM00 = true;
              copy._M00 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM00) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM00 = false;
              copy._M00 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M01": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM01 = true;
              copy._M01 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM01) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM01 = false;
              copy._M01 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M02": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM02 = true;
              copy._M02 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM02) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM02 = false;
              copy._M02 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M03": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM03 = true;
              copy._M03 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM03) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM03 = false;
              copy._M03 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M10": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM10 = true;
              copy._M10 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM10) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM10 = false;
              copy._M10 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M11": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM11 = true;
              copy._M11 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM11) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM11 = false;
              copy._M11 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M12": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM12 = true;
              copy._M12 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM12) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM12 = false;
              copy._M12 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M13": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM13 = true;
              copy._M13 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM13) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM13 = false;
              copy._M13 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M20": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM20 = true;
              copy._M20 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM20) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM20 = false;
              copy._M20 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M21": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM21 = true;
              copy._M21 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM21) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM21 = false;
              copy._M21 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M22": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM22 = true;
              copy._M22 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM22) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM22 = false;
              copy._M22 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M23": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM23 = true;
              copy._M23 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM23) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM23 = false;
              copy._M23 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M30": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM30 = true;
              copy._M30 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM30) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM30 = false;
              copy._M30 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M31": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM31 = true;
              copy._M31 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM31) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM31 = false;
              copy._M31 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M32": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM32 = true;
              copy._M32 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM32) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM32 = false;
              copy._M32 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "M33": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FMatrix(this);
              copy._hasM33 = true;
              copy._M33 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasM33) {
                return this;
              }
              const copy = new FMatrix(this);
              copy._hasM33 = false;
              copy._M33 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FMatrix} other
   * @returns {FMatrix}
   */
  merge(other) {
    const copy = new FMatrix(this);
    if (other._hasM00) {
      copy._hasM00 = true;
      copy._M00 = other._M00;
    }
    if (other._hasM01) {
      copy._hasM01 = true;
      copy._M01 = other._M01;
    }
    if (other._hasM02) {
      copy._hasM02 = true;
      copy._M02 = other._M02;
    }
    if (other._hasM03) {
      copy._hasM03 = true;
      copy._M03 = other._M03;
    }
    if (other._hasM10) {
      copy._hasM10 = true;
      copy._M10 = other._M10;
    }
    if (other._hasM11) {
      copy._hasM11 = true;
      copy._M11 = other._M11;
    }
    if (other._hasM12) {
      copy._hasM12 = true;
      copy._M12 = other._M12;
    }
    if (other._hasM13) {
      copy._hasM13 = true;
      copy._M13 = other._M13;
    }
    if (other._hasM20) {
      copy._hasM20 = true;
      copy._M20 = other._M20;
    }
    if (other._hasM21) {
      copy._hasM21 = true;
      copy._M21 = other._M21;
    }
    if (other._hasM22) {
      copy._hasM22 = true;
      copy._M22 = other._M22;
    }
    if (other._hasM23) {
      copy._hasM23 = true;
      copy._M23 = other._M23;
    }
    if (other._hasM30) {
      copy._hasM30 = true;
      copy._M30 = other._M30;
    }
    if (other._hasM31) {
      copy._hasM31 = true;
      copy._M31 = other._M31;
    }
    if (other._hasM32) {
      copy._hasM32 = true;
      copy._M32 = other._M32;
    }
    if (other._hasM33) {
      copy._hasM33 = true;
      copy._M33 = other._M33;
    }
    return copy;
  }
}
FMatrix.default = new FMatrix();
class FMatrix_Builder {
  constructor(value) {
    this._value = new FMatrix(value);
  }
  build() {
    return new FMatrix(this._value);
  }
  setM00(value) {
    this._value._hasM00 = true;
    this._value._M00 = value;
    return this;
  }
  deleteM00() {
    this._value._hasM00 = false;
    this._value._M00 = null;
    return this;
  }
  setM01(value) {
    this._value._hasM01 = true;
    this._value._M01 = value;
    return this;
  }
  deleteM01() {
    this._value._hasM01 = false;
    this._value._M01 = null;
    return this;
  }
  setM02(value) {
    this._value._hasM02 = true;
    this._value._M02 = value;
    return this;
  }
  deleteM02() {
    this._value._hasM02 = false;
    this._value._M02 = null;
    return this;
  }
  setM03(value) {
    this._value._hasM03 = true;
    this._value._M03 = value;
    return this;
  }
  deleteM03() {
    this._value._hasM03 = false;
    this._value._M03 = null;
    return this;
  }
  setM10(value) {
    this._value._hasM10 = true;
    this._value._M10 = value;
    return this;
  }
  deleteM10() {
    this._value._hasM10 = false;
    this._value._M10 = null;
    return this;
  }
  setM11(value) {
    this._value._hasM11 = true;
    this._value._M11 = value;
    return this;
  }
  deleteM11() {
    this._value._hasM11 = false;
    this._value._M11 = null;
    return this;
  }
  setM12(value) {
    this._value._hasM12 = true;
    this._value._M12 = value;
    return this;
  }
  deleteM12() {
    this._value._hasM12 = false;
    this._value._M12 = null;
    return this;
  }
  setM13(value) {
    this._value._hasM13 = true;
    this._value._M13 = value;
    return this;
  }
  deleteM13() {
    this._value._hasM13 = false;
    this._value._M13 = null;
    return this;
  }
  setM20(value) {
    this._value._hasM20 = true;
    this._value._M20 = value;
    return this;
  }
  deleteM20() {
    this._value._hasM20 = false;
    this._value._M20 = null;
    return this;
  }
  setM21(value) {
    this._value._hasM21 = true;
    this._value._M21 = value;
    return this;
  }
  deleteM21() {
    this._value._hasM21 = false;
    this._value._M21 = null;
    return this;
  }
  setM22(value) {
    this._value._hasM22 = true;
    this._value._M22 = value;
    return this;
  }
  deleteM22() {
    this._value._hasM22 = false;
    this._value._M22 = null;
    return this;
  }
  setM23(value) {
    this._value._hasM23 = true;
    this._value._M23 = value;
    return this;
  }
  deleteM23() {
    this._value._hasM23 = false;
    this._value._M23 = null;
    return this;
  }
  setM30(value) {
    this._value._hasM30 = true;
    this._value._M30 = value;
    return this;
  }
  deleteM30() {
    this._value._hasM30 = false;
    this._value._M30 = null;
    return this;
  }
  setM31(value) {
    this._value._hasM31 = true;
    this._value._M31 = value;
    return this;
  }
  deleteM31() {
    this._value._hasM31 = false;
    this._value._M31 = null;
    return this;
  }
  setM32(value) {
    this._value._hasM32 = true;
    this._value._M32 = value;
    return this;
  }
  deleteM32() {
    this._value._hasM32 = false;
    this._value._M32 = null;
    return this;
  }
  setM33(value) {
    this._value._hasM33 = true;
    this._value._M33 = value;
    return this;
  }
  deleteM33() {
    this._value._hasM33 = false;
    this._value._M33 = null;
    return this;
  }
}
FMatrix.Builder = FMatrix_Builder;
class FMatrix_WithParent {
  /**
   * @param {FMatrix} value
   * @param {FMatrix_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FMatrix.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasM00() {
    if (this._cachedHasM00 === undefined) {
      if (this._value.hasM00) {
        this._cachedHasM00 = true;
      } else {
        this._cachedHasM00 = this._parent ? this._parent.hasM00 : false;
      }
    }
    return this._cachedHasM00;
  }
  get M00() {
    if (this._cachedM00 === undefined) {
      if (this._value.hasM00) {
        this._cachedM00 = this._value.M00;
      } else {
        this._cachedM00 = this._parent ? this._parent.M00 : this._value.M00;
      }
    }
    return this._cachedM00;
  }
  get hasM01() {
    if (this._cachedHasM01 === undefined) {
      if (this._value.hasM01) {
        this._cachedHasM01 = true;
      } else {
        this._cachedHasM01 = this._parent ? this._parent.hasM01 : false;
      }
    }
    return this._cachedHasM01;
  }
  get M01() {
    if (this._cachedM01 === undefined) {
      if (this._value.hasM01) {
        this._cachedM01 = this._value.M01;
      } else {
        this._cachedM01 = this._parent ? this._parent.M01 : this._value.M01;
      }
    }
    return this._cachedM01;
  }
  get hasM02() {
    if (this._cachedHasM02 === undefined) {
      if (this._value.hasM02) {
        this._cachedHasM02 = true;
      } else {
        this._cachedHasM02 = this._parent ? this._parent.hasM02 : false;
      }
    }
    return this._cachedHasM02;
  }
  get M02() {
    if (this._cachedM02 === undefined) {
      if (this._value.hasM02) {
        this._cachedM02 = this._value.M02;
      } else {
        this._cachedM02 = this._parent ? this._parent.M02 : this._value.M02;
      }
    }
    return this._cachedM02;
  }
  get hasM03() {
    if (this._cachedHasM03 === undefined) {
      if (this._value.hasM03) {
        this._cachedHasM03 = true;
      } else {
        this._cachedHasM03 = this._parent ? this._parent.hasM03 : false;
      }
    }
    return this._cachedHasM03;
  }
  get M03() {
    if (this._cachedM03 === undefined) {
      if (this._value.hasM03) {
        this._cachedM03 = this._value.M03;
      } else {
        this._cachedM03 = this._parent ? this._parent.M03 : this._value.M03;
      }
    }
    return this._cachedM03;
  }
  get hasM10() {
    if (this._cachedHasM10 === undefined) {
      if (this._value.hasM10) {
        this._cachedHasM10 = true;
      } else {
        this._cachedHasM10 = this._parent ? this._parent.hasM10 : false;
      }
    }
    return this._cachedHasM10;
  }
  get M10() {
    if (this._cachedM10 === undefined) {
      if (this._value.hasM10) {
        this._cachedM10 = this._value.M10;
      } else {
        this._cachedM10 = this._parent ? this._parent.M10 : this._value.M10;
      }
    }
    return this._cachedM10;
  }
  get hasM11() {
    if (this._cachedHasM11 === undefined) {
      if (this._value.hasM11) {
        this._cachedHasM11 = true;
      } else {
        this._cachedHasM11 = this._parent ? this._parent.hasM11 : false;
      }
    }
    return this._cachedHasM11;
  }
  get M11() {
    if (this._cachedM11 === undefined) {
      if (this._value.hasM11) {
        this._cachedM11 = this._value.M11;
      } else {
        this._cachedM11 = this._parent ? this._parent.M11 : this._value.M11;
      }
    }
    return this._cachedM11;
  }
  get hasM12() {
    if (this._cachedHasM12 === undefined) {
      if (this._value.hasM12) {
        this._cachedHasM12 = true;
      } else {
        this._cachedHasM12 = this._parent ? this._parent.hasM12 : false;
      }
    }
    return this._cachedHasM12;
  }
  get M12() {
    if (this._cachedM12 === undefined) {
      if (this._value.hasM12) {
        this._cachedM12 = this._value.M12;
      } else {
        this._cachedM12 = this._parent ? this._parent.M12 : this._value.M12;
      }
    }
    return this._cachedM12;
  }
  get hasM13() {
    if (this._cachedHasM13 === undefined) {
      if (this._value.hasM13) {
        this._cachedHasM13 = true;
      } else {
        this._cachedHasM13 = this._parent ? this._parent.hasM13 : false;
      }
    }
    return this._cachedHasM13;
  }
  get M13() {
    if (this._cachedM13 === undefined) {
      if (this._value.hasM13) {
        this._cachedM13 = this._value.M13;
      } else {
        this._cachedM13 = this._parent ? this._parent.M13 : this._value.M13;
      }
    }
    return this._cachedM13;
  }
  get hasM20() {
    if (this._cachedHasM20 === undefined) {
      if (this._value.hasM20) {
        this._cachedHasM20 = true;
      } else {
        this._cachedHasM20 = this._parent ? this._parent.hasM20 : false;
      }
    }
    return this._cachedHasM20;
  }
  get M20() {
    if (this._cachedM20 === undefined) {
      if (this._value.hasM20) {
        this._cachedM20 = this._value.M20;
      } else {
        this._cachedM20 = this._parent ? this._parent.M20 : this._value.M20;
      }
    }
    return this._cachedM20;
  }
  get hasM21() {
    if (this._cachedHasM21 === undefined) {
      if (this._value.hasM21) {
        this._cachedHasM21 = true;
      } else {
        this._cachedHasM21 = this._parent ? this._parent.hasM21 : false;
      }
    }
    return this._cachedHasM21;
  }
  get M21() {
    if (this._cachedM21 === undefined) {
      if (this._value.hasM21) {
        this._cachedM21 = this._value.M21;
      } else {
        this._cachedM21 = this._parent ? this._parent.M21 : this._value.M21;
      }
    }
    return this._cachedM21;
  }
  get hasM22() {
    if (this._cachedHasM22 === undefined) {
      if (this._value.hasM22) {
        this._cachedHasM22 = true;
      } else {
        this._cachedHasM22 = this._parent ? this._parent.hasM22 : false;
      }
    }
    return this._cachedHasM22;
  }
  get M22() {
    if (this._cachedM22 === undefined) {
      if (this._value.hasM22) {
        this._cachedM22 = this._value.M22;
      } else {
        this._cachedM22 = this._parent ? this._parent.M22 : this._value.M22;
      }
    }
    return this._cachedM22;
  }
  get hasM23() {
    if (this._cachedHasM23 === undefined) {
      if (this._value.hasM23) {
        this._cachedHasM23 = true;
      } else {
        this._cachedHasM23 = this._parent ? this._parent.hasM23 : false;
      }
    }
    return this._cachedHasM23;
  }
  get M23() {
    if (this._cachedM23 === undefined) {
      if (this._value.hasM23) {
        this._cachedM23 = this._value.M23;
      } else {
        this._cachedM23 = this._parent ? this._parent.M23 : this._value.M23;
      }
    }
    return this._cachedM23;
  }
  get hasM30() {
    if (this._cachedHasM30 === undefined) {
      if (this._value.hasM30) {
        this._cachedHasM30 = true;
      } else {
        this._cachedHasM30 = this._parent ? this._parent.hasM30 : false;
      }
    }
    return this._cachedHasM30;
  }
  get M30() {
    if (this._cachedM30 === undefined) {
      if (this._value.hasM30) {
        this._cachedM30 = this._value.M30;
      } else {
        this._cachedM30 = this._parent ? this._parent.M30 : this._value.M30;
      }
    }
    return this._cachedM30;
  }
  get hasM31() {
    if (this._cachedHasM31 === undefined) {
      if (this._value.hasM31) {
        this._cachedHasM31 = true;
      } else {
        this._cachedHasM31 = this._parent ? this._parent.hasM31 : false;
      }
    }
    return this._cachedHasM31;
  }
  get M31() {
    if (this._cachedM31 === undefined) {
      if (this._value.hasM31) {
        this._cachedM31 = this._value.M31;
      } else {
        this._cachedM31 = this._parent ? this._parent.M31 : this._value.M31;
      }
    }
    return this._cachedM31;
  }
  get hasM32() {
    if (this._cachedHasM32 === undefined) {
      if (this._value.hasM32) {
        this._cachedHasM32 = true;
      } else {
        this._cachedHasM32 = this._parent ? this._parent.hasM32 : false;
      }
    }
    return this._cachedHasM32;
  }
  get M32() {
    if (this._cachedM32 === undefined) {
      if (this._value.hasM32) {
        this._cachedM32 = this._value.M32;
      } else {
        this._cachedM32 = this._parent ? this._parent.M32 : this._value.M32;
      }
    }
    return this._cachedM32;
  }
  get hasM33() {
    if (this._cachedHasM33 === undefined) {
      if (this._value.hasM33) {
        this._cachedHasM33 = true;
      } else {
        this._cachedHasM33 = this._parent ? this._parent.hasM33 : false;
      }
    }
    return this._cachedHasM33;
  }
  get M33() {
    if (this._cachedM33 === undefined) {
      if (this._value.hasM33) {
        this._cachedM33 = this._value.M33;
      } else {
        this._cachedM33 = this._parent ? this._parent.M33 : this._value.M33;
      }
    }
    return this._cachedM33;
  }
  update(current, parent) {
    const result = new FMatrix_WithParent(current, parent);
    return result;
  }
}
FMatrix_WithParent.default = new FMatrix_WithParent(FMatrix.default, null);
FMatrix.WithParent = FMatrix_WithParent;
class FMatrix_Descriptor {
  get M00() {
    if (!this._M00) {
      this._M00 = {
        name: "M00",
        Name: "M00",
        number: 1,
        protoType: 1,
        protoName: "M00",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M00;
  }
  get M01() {
    if (!this._M01) {
      this._M01 = {
        name: "M01",
        Name: "M01",
        number: 2,
        protoType: 1,
        protoName: "M01",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M01;
  }
  get M02() {
    if (!this._M02) {
      this._M02 = {
        name: "M02",
        Name: "M02",
        number: 3,
        protoType: 1,
        protoName: "M02",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M02;
  }
  get M03() {
    if (!this._M03) {
      this._M03 = {
        name: "M03",
        Name: "M03",
        number: 4,
        protoType: 1,
        protoName: "M03",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M03;
  }
  get M10() {
    if (!this._M10) {
      this._M10 = {
        name: "M10",
        Name: "M10",
        number: 5,
        protoType: 1,
        protoName: "M10",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M10;
  }
  get M11() {
    if (!this._M11) {
      this._M11 = {
        name: "M11",
        Name: "M11",
        number: 6,
        protoType: 1,
        protoName: "M11",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M11;
  }
  get M12() {
    if (!this._M12) {
      this._M12 = {
        name: "M12",
        Name: "M12",
        number: 7,
        protoType: 1,
        protoName: "M12",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M12;
  }
  get M13() {
    if (!this._M13) {
      this._M13 = {
        name: "M13",
        Name: "M13",
        number: 8,
        protoType: 1,
        protoName: "M13",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M13;
  }
  get M20() {
    if (!this._M20) {
      this._M20 = {
        name: "M20",
        Name: "M20",
        number: 9,
        protoType: 1,
        protoName: "M20",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M20;
  }
  get M21() {
    if (!this._M21) {
      this._M21 = {
        name: "M21",
        Name: "M21",
        number: 10,
        protoType: 1,
        protoName: "M21",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M21;
  }
  get M22() {
    if (!this._M22) {
      this._M22 = {
        name: "M22",
        Name: "M22",
        number: 11,
        protoType: 1,
        protoName: "M22",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M22;
  }
  get M23() {
    if (!this._M23) {
      this._M23 = {
        name: "M23",
        Name: "M23",
        number: 12,
        protoType: 1,
        protoName: "M23",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M23;
  }
  get M30() {
    if (!this._M30) {
      this._M30 = {
        name: "M30",
        Name: "M30",
        number: 13,
        protoType: 1,
        protoName: "M30",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M30;
  }
  get M31() {
    if (!this._M31) {
      this._M31 = {
        name: "M31",
        Name: "M31",
        number: 14,
        protoType: 1,
        protoName: "M31",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M31;
  }
  get M32() {
    if (!this._M32) {
      this._M32 = {
        name: "M32",
        Name: "M32",
        number: 15,
        protoType: 1,
        protoName: "M32",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M32;
  }
  get M33() {
    if (!this._M33) {
      this._M33 = {
        name: "M33",
        Name: "M33",
        number: 16,
        protoType: 1,
        protoName: "M33",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._M33;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.M00,
        this.M01,
        this.M02,
        this.M03,
        this.M10,
        this.M11,
        this.M12,
        this.M13,
        this.M20,
        this.M21,
        this.M22,
        this.M23,
        this.M30,
        this.M31,
        this.M32,
        this.M33,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForM00",
        Name: "DummyOneofForM00",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM01",
        Name: "DummyOneofForM01",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM02",
        Name: "DummyOneofForM02",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM03",
        Name: "DummyOneofForM03",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM10",
        Name: "DummyOneofForM10",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM11",
        Name: "DummyOneofForM11",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM12",
        Name: "DummyOneofForM12",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM13",
        Name: "DummyOneofForM13",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM20",
        Name: "DummyOneofForM20",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM21",
        Name: "DummyOneofForM21",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM22",
        Name: "DummyOneofForM22",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM23",
        Name: "DummyOneofForM23",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM30",
        Name: "DummyOneofForM30",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM31",
        Name: "DummyOneofForM31",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM32",
        Name: "DummyOneofForM32",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForM33",
        Name: "DummyOneofForM33",
        fields: [
          this.fields[15],
        ],
      });
    }
    return this._oneofs;
  }
}
FMatrix.descriptor = new FMatrix_Descriptor();
export class FVector2 {
  get descriptor() {
    return FVector2.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasX = false;
    this._X = null;
    this._hasY = false;
    this._Y = null;
  }
  isEmpty() {
    if (this._hasX) return false;
    if (this._hasY) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FVector2) {
      return value;
    }
    return FVector2.fromJson(value);
  }
  static fromJson(json) {
    const result = new FVector2();
    if (json.X != null) {
      result._hasX = true;
      result._X = JsonToDouble.fromJson(json.X);
    }
    if (json.Y != null) {
      result._hasY = true;
      result._Y = JsonToDouble.fromJson(json.Y);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasX) {
      result.X = JsonToDouble.toJson(this._X);
    }
    if (this._hasY) {
      result.Y = JsonToDouble.toJson(this._Y);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get X() {
    return this._hasX ? this._X : JsonToDouble.default;
  }
  get hasX() {
    return this._hasX;
  }
  setX(path, value) {
    return {type: 'SET', path: path.concat(['X']), value};
  }
  deleteX(path) {
    return {type: 'DELETE', path: path.concat(['X'])};
  }
  /**
   * @returns {number}
   */
  get Y() {
    return this._hasY ? this._Y : JsonToDouble.default;
  }
  get hasY() {
    return this._hasY;
  }
  setY(path, value) {
    return {type: 'SET', path: path.concat(['Y']), value};
  }
  deleteY(path) {
    return {type: 'DELETE', path: path.concat(['Y'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "X": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector2(this);
              copy._hasX = true;
              copy._X = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasX) {
                return this;
              }
              const copy = new FVector2(this);
              copy._hasX = false;
              copy._X = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Y": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector2(this);
              copy._hasY = true;
              copy._Y = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasY) {
                return this;
              }
              const copy = new FVector2(this);
              copy._hasY = false;
              copy._Y = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FVector2} other
   * @returns {FVector2}
   */
  merge(other) {
    const copy = new FVector2(this);
    if (other._hasX) {
      copy._hasX = true;
      copy._X = other._X;
    }
    if (other._hasY) {
      copy._hasY = true;
      copy._Y = other._Y;
    }
    return copy;
  }
}
FVector2.default = new FVector2();
class FVector2_Builder {
  constructor(value) {
    this._value = new FVector2(value);
  }
  build() {
    return new FVector2(this._value);
  }
  setX(value) {
    this._value._hasX = true;
    this._value._X = value;
    return this;
  }
  deleteX() {
    this._value._hasX = false;
    this._value._X = null;
    return this;
  }
  setY(value) {
    this._value._hasY = true;
    this._value._Y = value;
    return this;
  }
  deleteY() {
    this._value._hasY = false;
    this._value._Y = null;
    return this;
  }
}
FVector2.Builder = FVector2_Builder;
class FVector2_WithParent {
  /**
   * @param {FVector2} value
   * @param {FVector2_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FVector2.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasX() {
    if (this._cachedHasX === undefined) {
      if (this._value.hasX) {
        this._cachedHasX = true;
      } else {
        this._cachedHasX = this._parent ? this._parent.hasX : false;
      }
    }
    return this._cachedHasX;
  }
  get X() {
    if (this._cachedX === undefined) {
      if (this._value.hasX) {
        this._cachedX = this._value.X;
      } else {
        this._cachedX = this._parent ? this._parent.X : this._value.X;
      }
    }
    return this._cachedX;
  }
  get hasY() {
    if (this._cachedHasY === undefined) {
      if (this._value.hasY) {
        this._cachedHasY = true;
      } else {
        this._cachedHasY = this._parent ? this._parent.hasY : false;
      }
    }
    return this._cachedHasY;
  }
  get Y() {
    if (this._cachedY === undefined) {
      if (this._value.hasY) {
        this._cachedY = this._value.Y;
      } else {
        this._cachedY = this._parent ? this._parent.Y : this._value.Y;
      }
    }
    return this._cachedY;
  }
  update(current, parent) {
    const result = new FVector2_WithParent(current, parent);
    return result;
  }
}
FVector2_WithParent.default = new FVector2_WithParent(FVector2.default, null);
FVector2.WithParent = FVector2_WithParent;
class FVector2_Descriptor {
  get X() {
    if (!this._X) {
      this._X = {
        name: "X",
        Name: "X",
        number: 1,
        protoType: 1,
        protoName: "X",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._X;
  }
  get Y() {
    if (!this._Y) {
      this._Y = {
        name: "Y",
        Name: "Y",
        number: 2,
        protoType: 1,
        protoName: "Y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Y;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.X,
        this.Y,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForX",
        Name: "DummyOneofForX",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForY",
        Name: "DummyOneofForY",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
FVector2.descriptor = new FVector2_Descriptor();
export class WaterDataContainer {
  get descriptor() {
    return WaterDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._WaterLevels = [];
    this._PickLocation = [];
  }
  isEmpty() {
    if (this._WaterLevels.length > 0) return false;
    if (this._PickLocation.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof WaterDataContainer) {
      return value;
    }
    return WaterDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new WaterDataContainer();
    result._WaterLevels = JsonToList(json.WaterLevels, JsonToDouble);
    result._PickLocation = JsonToList(json.PickLocation, FVector2);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._WaterLevels.length > 0) {
      result.WaterLevels = ArrayToJson(this._WaterLevels, JsonToDouble);
    }
    if (this._PickLocation.length > 0) {
      result.PickLocation = ArrayToJson(this._PickLocation, FVector2);
    }
    return result;
  }
  /**
   * @returns {number[]}
   */
  get WaterLevels() {
    return this._WaterLevels;
  }
  addWaterLevels(path, value) {
    return {type: 'ADD', path: path.concat(['WaterLevels']), value};
  }
  setWaterLevels(path, value) {
    return {type: 'SET', path: path.concat(['WaterLevels']), value: ArrayToJson(value, JsonToDouble)};
  }
  setWaterLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['WaterLevels', key]), value};
  }
  deleteWaterLevels(path) {
    return {type: 'DELETE', path: path.concat(['WaterLevels'])};
  }
  deleteWaterLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['WaterLevels', key])};
  }
  /**
   * @returns {FVector2[]}
   */
  get PickLocation() {
    return this._PickLocation;
  }
  addPickLocation(path, value) {
    return {type: 'ADD', path: path.concat(['PickLocation']), value: value.toJson()};
  }
  setPickLocation(path, value) {
    return {type: 'SET', path: path.concat(['PickLocation']), value: ArrayToJson(value, FVector2)};
  }
  setPickLocationByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PickLocation', key]), value: value.toJson()};
  }
  deletePickLocation(path) {
    return {type: 'DELETE', path: path.concat(['PickLocation'])};
  }
  deletePickLocationByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PickLocation', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "WaterLevels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WaterDataContainer(this);
              copy._WaterLevels = [];        for (let i of value) {
                copy._WaterLevels.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WaterDataContainer(this);
              copy._WaterLevels = copy._WaterLevels.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._WaterLevels.length === 0) {
                return this;
              }
              const copy = new WaterDataContainer(this);
              copy._WaterLevels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._WaterLevels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WaterDataContainer(this);
              copy._WaterLevels = copy._WaterLevels.slice();
              copy._WaterLevels[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WaterDataContainer(this);
              copy._WaterLevels = copy._WaterLevels.slice(0, path[1]).concat(copy._WaterLevels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._WaterLevels.length) {
            return this;
          }
          const oldValue = this._WaterLevels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WaterDataContainer(this);
          copy._WaterLevels = copy._WaterLevels.slice();
          copy._WaterLevels[key] = newValue;
          return copy;
        }
      }
      case "PickLocation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WaterDataContainer(this);
              copy._PickLocation = [];        for (let i of value) {
                copy._PickLocation.push(FVector2.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WaterDataContainer(this);
              copy._PickLocation = copy._PickLocation.concat([FVector2.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PickLocation.length === 0) {
                return this;
              }
              const copy = new WaterDataContainer(this);
              copy._PickLocation = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PickLocation.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WaterDataContainer(this);
              copy._PickLocation = copy._PickLocation.slice();
              copy._PickLocation[path[1]] = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WaterDataContainer(this);
              copy._PickLocation = copy._PickLocation.slice(0, path[1]).concat(copy._PickLocation.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PickLocation.length) {
            return this;
          }
          const oldValue = this._PickLocation[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WaterDataContainer(this);
          copy._PickLocation = copy._PickLocation.slice();
          copy._PickLocation[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {WaterDataContainer} other
   * @returns {WaterDataContainer}
   */
  merge(other) {
    const copy = new WaterDataContainer(this);
    copy._WaterLevels = this._WaterLevels.concat(other._WaterLevels);
    copy._PickLocation = this._PickLocation.concat(other._PickLocation);
    return copy;
  }
}
WaterDataContainer.default = new WaterDataContainer();
class WaterDataContainer_Builder {
  constructor(value) {
    this._value = new WaterDataContainer(value);
  }
  build() {
    return new WaterDataContainer(this._value);
  }
  addAllWaterLevels(values) {
    this._value._WaterLevels = this._value._WaterLevels.concat(values);
    return this;
  }
  addWaterLevels(value) {
    this._value._WaterLevels = this._value._WaterLevels.concat([value]);
    return this;
  }
  setWaterLevels(index, value) {
    this._value._WaterLevels = this._value._WaterLevels.concat();
    this._value._WaterLevels[index] = value;
    return this;
  }
  clearWaterLevels() {
    this._value._WaterLevels = [];
    return this;
  }
  addAllPickLocation(values) {
    this._value._PickLocation = this._value._PickLocation.concat(values);
    return this;
  }
  addPickLocation(value) {
    this._value._PickLocation = this._value._PickLocation.concat([value]);
    return this;
  }
  setPickLocation(index, value) {
    this._value._PickLocation = this._value._PickLocation.concat();
    this._value._PickLocation[index] = value;
    return this;
  }
  clearPickLocation() {
    this._value._PickLocation = [];
    return this;
  }
}
WaterDataContainer.Builder = WaterDataContainer_Builder;
class WaterDataContainer_WithParent {
  /**
   * @param {WaterDataContainer} value
   * @param {WaterDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return WaterDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfWaterLevels() {
    return this._value.WaterLevels;
  }
  get inherentWaterLevels() {
    if (!this._inherentWaterLevels) {
      this._inherentWaterLevels = this._parent ? this._parent.WaterLevels : [];
    }
    return this._inherentWaterLevels;
  }
  get WaterLevels() {
    if (!this._allWaterLevels) {
      this._allWaterLevels = this._parent ? this._parent.WaterLevels.concat(this.selfWaterLevels) : this.selfWaterLevels;
    }
    return this._allWaterLevels;
  }
  get selfPickLocation() {
    if (!this._selfPickLocation) {
      this._selfPickLocation = [];
      for (let i of this._value.PickLocation) {
        this._selfPickLocation.push(new FVector2.WithParent(i, null));
      }
    }
    return this._selfPickLocation;
  }
  get inherentPickLocation() {
    if (!this._inherentPickLocation) {
      this._inherentPickLocation = this._parent ? this._parent.PickLocation : [];
    }
    return this._inherentPickLocation;
  }
  get PickLocation() {
    if (!this._allPickLocation) {
      this._allPickLocation = this._parent ? this._parent.PickLocation.concat(this.selfPickLocation) : this.selfPickLocation;
    }
    return this._allPickLocation;
  }
  update(current, parent) {
    const result = new WaterDataContainer_WithParent(current, parent);
    if (this._selfPickLocation) {
      if (this._value.PickLocation === current.PickLocation) {
        result._selfPickLocation = this._selfPickLocation;
      } else {
        result._selfPickLocation = [];
        for (let i = 0; i < current.PickLocation.length; i++) {
          const oldValue = this._value.PickLocation[i];
          if (oldValue) {
            const oldCache = this._selfPickLocation[i];
            if (oldValue === current.PickLocation[i]) {
              result._selfPickLocation[i] = oldCache;
            } else {
              result._selfPickLocation[i] = oldCache.update(current.PickLocation[i], null);
            }
          } else {
            result._selfPickLocation[i] = new FVector2.WithParent(current.PickLocation[i], null);
          }
        }
      }
    }
    return result;
  }
}
WaterDataContainer_WithParent.default = new WaterDataContainer_WithParent(WaterDataContainer.default, null);
WaterDataContainer.WithParent = WaterDataContainer_WithParent;
class WaterDataContainer_Descriptor {
  get WaterLevels() {
    if (!this._WaterLevels) {
      this._WaterLevels = {
        name: "WaterLevels",
        Name: "WaterLevels",
        number: 1,
        protoType: 1,
        protoName: "WaterLevels",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._WaterLevels;
  }
  get PickLocation() {
    if (!this._PickLocation) {
      this._PickLocation = {
        name: "PickLocation",
        Name: "PickLocation",
        number: 2,
        protoType: 11,
        protoName: "PickLocation",
        type: FVector2,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PickLocation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.WaterLevels,
        this.PickLocation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
WaterDataContainer.descriptor = new WaterDataContainer_Descriptor();
export class WayPointDataContainer {
  get descriptor() {
    return WayPointDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._PathNameData = [];
    this._RawPathesData = [];
    this._RawPathesLocData = [];
    this._AdditionalNodesData = [];
    this._AdditionalNodesLocData = [];
    this._DisableRallyStatus = [];
  }
  isEmpty() {
    if (this._PathNameData.length > 0) return false;
    if (this._RawPathesData.length > 0) return false;
    if (this._RawPathesLocData.length > 0) return false;
    if (this._AdditionalNodesData.length > 0) return false;
    if (this._AdditionalNodesLocData.length > 0) return false;
    if (this._DisableRallyStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof WayPointDataContainer) {
      return value;
    }
    return WayPointDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new WayPointDataContainer();
    result._PathNameData = JsonToList(json.PathNameData, JsonToString);
    result._RawPathesData = JsonToList(json.RawPathesData, NodeDataList);
    result._RawPathesLocData = JsonToList(json.RawPathesLocData, FVector3List);
    result._AdditionalNodesData = JsonToList(json.AdditionalNodesData, NodeData);
    result._AdditionalNodesLocData = JsonToList(json.AdditionalNodesLocData, FVector3);
    result._DisableRallyStatus = JsonToList(json.DisableRallyStatus, JsonToBoolean);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._PathNameData.length > 0) {
      result.PathNameData = ArrayToJson(this._PathNameData, JsonToString);
    }
    if (this._RawPathesData.length > 0) {
      result.RawPathesData = ArrayToJson(this._RawPathesData, NodeDataList);
    }
    if (this._RawPathesLocData.length > 0) {
      result.RawPathesLocData = ArrayToJson(this._RawPathesLocData, FVector3List);
    }
    if (this._AdditionalNodesData.length > 0) {
      result.AdditionalNodesData = ArrayToJson(this._AdditionalNodesData, NodeData);
    }
    if (this._AdditionalNodesLocData.length > 0) {
      result.AdditionalNodesLocData = ArrayToJson(this._AdditionalNodesLocData, FVector3);
    }
    if (this._DisableRallyStatus.length > 0) {
      result.DisableRallyStatus = ArrayToJson(this._DisableRallyStatus, JsonToBoolean);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get PathNameData() {
    return this._PathNameData;
  }
  addPathNameData(path, value) {
    return {type: 'ADD', path: path.concat(['PathNameData']), value};
  }
  setPathNameData(path, value) {
    return {type: 'SET', path: path.concat(['PathNameData']), value: ArrayToJson(value, JsonToString)};
  }
  setPathNameDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['PathNameData', key]), value};
  }
  deletePathNameData(path) {
    return {type: 'DELETE', path: path.concat(['PathNameData'])};
  }
  deletePathNameDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['PathNameData', key])};
  }
  /**
   * @returns {NodeDataList[]}
   */
  get RawPathesData() {
    return this._RawPathesData;
  }
  addRawPathesData(path, value) {
    return {type: 'ADD', path: path.concat(['RawPathesData']), value: value.toJson()};
  }
  setRawPathesData(path, value) {
    return {type: 'SET', path: path.concat(['RawPathesData']), value: ArrayToJson(value, NodeDataList)};
  }
  setRawPathesDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['RawPathesData', key]), value: value.toJson()};
  }
  deleteRawPathesData(path) {
    return {type: 'DELETE', path: path.concat(['RawPathesData'])};
  }
  deleteRawPathesDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['RawPathesData', key])};
  }
  /**
   * @returns {FVector3List[]}
   */
  get RawPathesLocData() {
    return this._RawPathesLocData;
  }
  addRawPathesLocData(path, value) {
    return {type: 'ADD', path: path.concat(['RawPathesLocData']), value: value.toJson()};
  }
  setRawPathesLocData(path, value) {
    return {type: 'SET', path: path.concat(['RawPathesLocData']), value: ArrayToJson(value, FVector3List)};
  }
  setRawPathesLocDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['RawPathesLocData', key]), value: value.toJson()};
  }
  deleteRawPathesLocData(path) {
    return {type: 'DELETE', path: path.concat(['RawPathesLocData'])};
  }
  deleteRawPathesLocDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['RawPathesLocData', key])};
  }
  /**
   * @returns {NodeData[]}
   */
  get AdditionalNodesData() {
    return this._AdditionalNodesData;
  }
  addAdditionalNodesData(path, value) {
    return {type: 'ADD', path: path.concat(['AdditionalNodesData']), value: value.toJson()};
  }
  setAdditionalNodesData(path, value) {
    return {type: 'SET', path: path.concat(['AdditionalNodesData']), value: ArrayToJson(value, NodeData)};
  }
  setAdditionalNodesDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['AdditionalNodesData', key]), value: value.toJson()};
  }
  deleteAdditionalNodesData(path) {
    return {type: 'DELETE', path: path.concat(['AdditionalNodesData'])};
  }
  deleteAdditionalNodesDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['AdditionalNodesData', key])};
  }
  /**
   * @returns {FVector3[]}
   */
  get AdditionalNodesLocData() {
    return this._AdditionalNodesLocData;
  }
  addAdditionalNodesLocData(path, value) {
    return {type: 'ADD', path: path.concat(['AdditionalNodesLocData']), value: value.toJson()};
  }
  setAdditionalNodesLocData(path, value) {
    return {type: 'SET', path: path.concat(['AdditionalNodesLocData']), value: ArrayToJson(value, FVector3)};
  }
  setAdditionalNodesLocDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['AdditionalNodesLocData', key]), value: value.toJson()};
  }
  deleteAdditionalNodesLocData(path) {
    return {type: 'DELETE', path: path.concat(['AdditionalNodesLocData'])};
  }
  deleteAdditionalNodesLocDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['AdditionalNodesLocData', key])};
  }
  /**
   * @returns {boolean[]}
   */
  get DisableRallyStatus() {
    return this._DisableRallyStatus;
  }
  addDisableRallyStatus(path, value) {
    return {type: 'ADD', path: path.concat(['DisableRallyStatus']), value};
  }
  setDisableRallyStatus(path, value) {
    return {type: 'SET', path: path.concat(['DisableRallyStatus']), value: ArrayToJson(value, JsonToBoolean)};
  }
  setDisableRallyStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['DisableRallyStatus', key]), value};
  }
  deleteDisableRallyStatus(path) {
    return {type: 'DELETE', path: path.concat(['DisableRallyStatus'])};
  }
  deleteDisableRallyStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['DisableRallyStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "PathNameData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._PathNameData = [];        for (let i of value) {
                copy._PathNameData.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._PathNameData = copy._PathNameData.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._PathNameData.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._PathNameData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._PathNameData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._PathNameData = copy._PathNameData.slice();
              copy._PathNameData[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._PathNameData = copy._PathNameData.slice(0, path[1]).concat(copy._PathNameData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._PathNameData.length) {
            return this;
          }
          const oldValue = this._PathNameData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._PathNameData = copy._PathNameData.slice();
          copy._PathNameData[key] = newValue;
          return copy;
        }
      }
      case "RawPathesData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesData = [];        for (let i of value) {
                copy._RawPathesData.push(NodeDataList.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesData = copy._RawPathesData.concat([NodeDataList.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._RawPathesData.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._RawPathesData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._RawPathesData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesData = copy._RawPathesData.slice();
              copy._RawPathesData[path[1]] = NodeDataList.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesData = copy._RawPathesData.slice(0, path[1]).concat(copy._RawPathesData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._RawPathesData.length) {
            return this;
          }
          const oldValue = this._RawPathesData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._RawPathesData = copy._RawPathesData.slice();
          copy._RawPathesData[key] = newValue;
          return copy;
        }
      }
      case "RawPathesLocData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesLocData = [];        for (let i of value) {
                copy._RawPathesLocData.push(FVector3List.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesLocData = copy._RawPathesLocData.concat([FVector3List.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._RawPathesLocData.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._RawPathesLocData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._RawPathesLocData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesLocData = copy._RawPathesLocData.slice();
              copy._RawPathesLocData[path[1]] = FVector3List.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._RawPathesLocData = copy._RawPathesLocData.slice(0, path[1]).concat(copy._RawPathesLocData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._RawPathesLocData.length) {
            return this;
          }
          const oldValue = this._RawPathesLocData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._RawPathesLocData = copy._RawPathesLocData.slice();
          copy._RawPathesLocData[key] = newValue;
          return copy;
        }
      }
      case "AdditionalNodesData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesData = [];        for (let i of value) {
                copy._AdditionalNodesData.push(NodeData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesData = copy._AdditionalNodesData.concat([NodeData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._AdditionalNodesData.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._AdditionalNodesData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesData = copy._AdditionalNodesData.slice();
              copy._AdditionalNodesData[path[1]] = NodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesData = copy._AdditionalNodesData.slice(0, path[1]).concat(copy._AdditionalNodesData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._AdditionalNodesData.length) {
            return this;
          }
          const oldValue = this._AdditionalNodesData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._AdditionalNodesData = copy._AdditionalNodesData.slice();
          copy._AdditionalNodesData[key] = newValue;
          return copy;
        }
      }
      case "AdditionalNodesLocData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesLocData = [];        for (let i of value) {
                copy._AdditionalNodesLocData.push(FVector3.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesLocData = copy._AdditionalNodesLocData.concat([FVector3.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._AdditionalNodesLocData.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesLocData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._AdditionalNodesLocData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesLocData = copy._AdditionalNodesLocData.slice();
              copy._AdditionalNodesLocData[path[1]] = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._AdditionalNodesLocData = copy._AdditionalNodesLocData.slice(0, path[1]).concat(copy._AdditionalNodesLocData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._AdditionalNodesLocData.length) {
            return this;
          }
          const oldValue = this._AdditionalNodesLocData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._AdditionalNodesLocData = copy._AdditionalNodesLocData.slice();
          copy._AdditionalNodesLocData[key] = newValue;
          return copy;
        }
      }
      case "DisableRallyStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._DisableRallyStatus = [];        for (let i of value) {
                copy._DisableRallyStatus.push(JsonToBoolean.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new WayPointDataContainer(this);
              copy._DisableRallyStatus = copy._DisableRallyStatus.concat([JsonToBoolean.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._DisableRallyStatus.length === 0) {
                return this;
              }
              const copy = new WayPointDataContainer(this);
              copy._DisableRallyStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._DisableRallyStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new WayPointDataContainer(this);
              copy._DisableRallyStatus = copy._DisableRallyStatus.slice();
              copy._DisableRallyStatus[path[1]] = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new WayPointDataContainer(this);
              copy._DisableRallyStatus = copy._DisableRallyStatus.slice(0, path[1]).concat(copy._DisableRallyStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._DisableRallyStatus.length) {
            return this;
          }
          const oldValue = this._DisableRallyStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new WayPointDataContainer(this);
          copy._DisableRallyStatus = copy._DisableRallyStatus.slice();
          copy._DisableRallyStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {WayPointDataContainer} other
   * @returns {WayPointDataContainer}
   */
  merge(other) {
    const copy = new WayPointDataContainer(this);
    copy._PathNameData = this._PathNameData.concat(other._PathNameData);
    copy._RawPathesData = this._RawPathesData.concat(other._RawPathesData);
    copy._RawPathesLocData = this._RawPathesLocData.concat(other._RawPathesLocData);
    copy._AdditionalNodesData = this._AdditionalNodesData.concat(other._AdditionalNodesData);
    copy._AdditionalNodesLocData = this._AdditionalNodesLocData.concat(other._AdditionalNodesLocData);
    copy._DisableRallyStatus = this._DisableRallyStatus.concat(other._DisableRallyStatus);
    return copy;
  }
}
WayPointDataContainer.default = new WayPointDataContainer();
class WayPointDataContainer_Builder {
  constructor(value) {
    this._value = new WayPointDataContainer(value);
  }
  build() {
    return new WayPointDataContainer(this._value);
  }
  addAllPathNameData(values) {
    this._value._PathNameData = this._value._PathNameData.concat(values);
    return this;
  }
  addPathNameData(value) {
    this._value._PathNameData = this._value._PathNameData.concat([value]);
    return this;
  }
  setPathNameData(index, value) {
    this._value._PathNameData = this._value._PathNameData.concat();
    this._value._PathNameData[index] = value;
    return this;
  }
  clearPathNameData() {
    this._value._PathNameData = [];
    return this;
  }
  addAllRawPathesData(values) {
    this._value._RawPathesData = this._value._RawPathesData.concat(values);
    return this;
  }
  addRawPathesData(value) {
    this._value._RawPathesData = this._value._RawPathesData.concat([value]);
    return this;
  }
  setRawPathesData(index, value) {
    this._value._RawPathesData = this._value._RawPathesData.concat();
    this._value._RawPathesData[index] = value;
    return this;
  }
  clearRawPathesData() {
    this._value._RawPathesData = [];
    return this;
  }
  addAllRawPathesLocData(values) {
    this._value._RawPathesLocData = this._value._RawPathesLocData.concat(values);
    return this;
  }
  addRawPathesLocData(value) {
    this._value._RawPathesLocData = this._value._RawPathesLocData.concat([value]);
    return this;
  }
  setRawPathesLocData(index, value) {
    this._value._RawPathesLocData = this._value._RawPathesLocData.concat();
    this._value._RawPathesLocData[index] = value;
    return this;
  }
  clearRawPathesLocData() {
    this._value._RawPathesLocData = [];
    return this;
  }
  addAllAdditionalNodesData(values) {
    this._value._AdditionalNodesData = this._value._AdditionalNodesData.concat(values);
    return this;
  }
  addAdditionalNodesData(value) {
    this._value._AdditionalNodesData = this._value._AdditionalNodesData.concat([value]);
    return this;
  }
  setAdditionalNodesData(index, value) {
    this._value._AdditionalNodesData = this._value._AdditionalNodesData.concat();
    this._value._AdditionalNodesData[index] = value;
    return this;
  }
  clearAdditionalNodesData() {
    this._value._AdditionalNodesData = [];
    return this;
  }
  addAllAdditionalNodesLocData(values) {
    this._value._AdditionalNodesLocData = this._value._AdditionalNodesLocData.concat(values);
    return this;
  }
  addAdditionalNodesLocData(value) {
    this._value._AdditionalNodesLocData = this._value._AdditionalNodesLocData.concat([value]);
    return this;
  }
  setAdditionalNodesLocData(index, value) {
    this._value._AdditionalNodesLocData = this._value._AdditionalNodesLocData.concat();
    this._value._AdditionalNodesLocData[index] = value;
    return this;
  }
  clearAdditionalNodesLocData() {
    this._value._AdditionalNodesLocData = [];
    return this;
  }
  addAllDisableRallyStatus(values) {
    this._value._DisableRallyStatus = this._value._DisableRallyStatus.concat(values);
    return this;
  }
  addDisableRallyStatus(value) {
    this._value._DisableRallyStatus = this._value._DisableRallyStatus.concat([value]);
    return this;
  }
  setDisableRallyStatus(index, value) {
    this._value._DisableRallyStatus = this._value._DisableRallyStatus.concat();
    this._value._DisableRallyStatus[index] = value;
    return this;
  }
  clearDisableRallyStatus() {
    this._value._DisableRallyStatus = [];
    return this;
  }
}
WayPointDataContainer.Builder = WayPointDataContainer_Builder;
class WayPointDataContainer_WithParent {
  /**
   * @param {WayPointDataContainer} value
   * @param {WayPointDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return WayPointDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPathNameData() {
    return this._value.PathNameData;
  }
  get inherentPathNameData() {
    if (!this._inherentPathNameData) {
      this._inherentPathNameData = this._parent ? this._parent.PathNameData : [];
    }
    return this._inherentPathNameData;
  }
  get PathNameData() {
    if (!this._allPathNameData) {
      this._allPathNameData = this._parent ? this._parent.PathNameData.concat(this.selfPathNameData) : this.selfPathNameData;
    }
    return this._allPathNameData;
  }
  get selfRawPathesData() {
    if (!this._selfRawPathesData) {
      this._selfRawPathesData = [];
      for (let i of this._value.RawPathesData) {
        this._selfRawPathesData.push(new NodeDataList.WithParent(i, null));
      }
    }
    return this._selfRawPathesData;
  }
  get inherentRawPathesData() {
    if (!this._inherentRawPathesData) {
      this._inherentRawPathesData = this._parent ? this._parent.RawPathesData : [];
    }
    return this._inherentRawPathesData;
  }
  get RawPathesData() {
    if (!this._allRawPathesData) {
      this._allRawPathesData = this._parent ? this._parent.RawPathesData.concat(this.selfRawPathesData) : this.selfRawPathesData;
    }
    return this._allRawPathesData;
  }
  get selfRawPathesLocData() {
    if (!this._selfRawPathesLocData) {
      this._selfRawPathesLocData = [];
      for (let i of this._value.RawPathesLocData) {
        this._selfRawPathesLocData.push(new FVector3List.WithParent(i, null));
      }
    }
    return this._selfRawPathesLocData;
  }
  get inherentRawPathesLocData() {
    if (!this._inherentRawPathesLocData) {
      this._inherentRawPathesLocData = this._parent ? this._parent.RawPathesLocData : [];
    }
    return this._inherentRawPathesLocData;
  }
  get RawPathesLocData() {
    if (!this._allRawPathesLocData) {
      this._allRawPathesLocData = this._parent ? this._parent.RawPathesLocData.concat(this.selfRawPathesLocData) : this.selfRawPathesLocData;
    }
    return this._allRawPathesLocData;
  }
  get selfAdditionalNodesData() {
    if (!this._selfAdditionalNodesData) {
      this._selfAdditionalNodesData = [];
      for (let i of this._value.AdditionalNodesData) {
        this._selfAdditionalNodesData.push(new NodeData.WithParent(i, null));
      }
    }
    return this._selfAdditionalNodesData;
  }
  get inherentAdditionalNodesData() {
    if (!this._inherentAdditionalNodesData) {
      this._inherentAdditionalNodesData = this._parent ? this._parent.AdditionalNodesData : [];
    }
    return this._inherentAdditionalNodesData;
  }
  get AdditionalNodesData() {
    if (!this._allAdditionalNodesData) {
      this._allAdditionalNodesData = this._parent ? this._parent.AdditionalNodesData.concat(this.selfAdditionalNodesData) : this.selfAdditionalNodesData;
    }
    return this._allAdditionalNodesData;
  }
  get selfAdditionalNodesLocData() {
    if (!this._selfAdditionalNodesLocData) {
      this._selfAdditionalNodesLocData = [];
      for (let i of this._value.AdditionalNodesLocData) {
        this._selfAdditionalNodesLocData.push(new FVector3.WithParent(i, null));
      }
    }
    return this._selfAdditionalNodesLocData;
  }
  get inherentAdditionalNodesLocData() {
    if (!this._inherentAdditionalNodesLocData) {
      this._inherentAdditionalNodesLocData = this._parent ? this._parent.AdditionalNodesLocData : [];
    }
    return this._inherentAdditionalNodesLocData;
  }
  get AdditionalNodesLocData() {
    if (!this._allAdditionalNodesLocData) {
      this._allAdditionalNodesLocData = this._parent ? this._parent.AdditionalNodesLocData.concat(this.selfAdditionalNodesLocData) : this.selfAdditionalNodesLocData;
    }
    return this._allAdditionalNodesLocData;
  }
  get selfDisableRallyStatus() {
    return this._value.DisableRallyStatus;
  }
  get inherentDisableRallyStatus() {
    if (!this._inherentDisableRallyStatus) {
      this._inherentDisableRallyStatus = this._parent ? this._parent.DisableRallyStatus : [];
    }
    return this._inherentDisableRallyStatus;
  }
  get DisableRallyStatus() {
    if (!this._allDisableRallyStatus) {
      this._allDisableRallyStatus = this._parent ? this._parent.DisableRallyStatus.concat(this.selfDisableRallyStatus) : this.selfDisableRallyStatus;
    }
    return this._allDisableRallyStatus;
  }
  update(current, parent) {
    const result = new WayPointDataContainer_WithParent(current, parent);
    if (this._selfRawPathesData) {
      if (this._value.RawPathesData === current.RawPathesData) {
        result._selfRawPathesData = this._selfRawPathesData;
      } else {
        result._selfRawPathesData = [];
        for (let i = 0; i < current.RawPathesData.length; i++) {
          const oldValue = this._value.RawPathesData[i];
          if (oldValue) {
            const oldCache = this._selfRawPathesData[i];
            if (oldValue === current.RawPathesData[i]) {
              result._selfRawPathesData[i] = oldCache;
            } else {
              result._selfRawPathesData[i] = oldCache.update(current.RawPathesData[i], null);
            }
          } else {
            result._selfRawPathesData[i] = new NodeDataList.WithParent(current.RawPathesData[i], null);
          }
        }
      }
    }
    if (this._selfRawPathesLocData) {
      if (this._value.RawPathesLocData === current.RawPathesLocData) {
        result._selfRawPathesLocData = this._selfRawPathesLocData;
      } else {
        result._selfRawPathesLocData = [];
        for (let i = 0; i < current.RawPathesLocData.length; i++) {
          const oldValue = this._value.RawPathesLocData[i];
          if (oldValue) {
            const oldCache = this._selfRawPathesLocData[i];
            if (oldValue === current.RawPathesLocData[i]) {
              result._selfRawPathesLocData[i] = oldCache;
            } else {
              result._selfRawPathesLocData[i] = oldCache.update(current.RawPathesLocData[i], null);
            }
          } else {
            result._selfRawPathesLocData[i] = new FVector3List.WithParent(current.RawPathesLocData[i], null);
          }
        }
      }
    }
    if (this._selfAdditionalNodesData) {
      if (this._value.AdditionalNodesData === current.AdditionalNodesData) {
        result._selfAdditionalNodesData = this._selfAdditionalNodesData;
      } else {
        result._selfAdditionalNodesData = [];
        for (let i = 0; i < current.AdditionalNodesData.length; i++) {
          const oldValue = this._value.AdditionalNodesData[i];
          if (oldValue) {
            const oldCache = this._selfAdditionalNodesData[i];
            if (oldValue === current.AdditionalNodesData[i]) {
              result._selfAdditionalNodesData[i] = oldCache;
            } else {
              result._selfAdditionalNodesData[i] = oldCache.update(current.AdditionalNodesData[i], null);
            }
          } else {
            result._selfAdditionalNodesData[i] = new NodeData.WithParent(current.AdditionalNodesData[i], null);
          }
        }
      }
    }
    if (this._selfAdditionalNodesLocData) {
      if (this._value.AdditionalNodesLocData === current.AdditionalNodesLocData) {
        result._selfAdditionalNodesLocData = this._selfAdditionalNodesLocData;
      } else {
        result._selfAdditionalNodesLocData = [];
        for (let i = 0; i < current.AdditionalNodesLocData.length; i++) {
          const oldValue = this._value.AdditionalNodesLocData[i];
          if (oldValue) {
            const oldCache = this._selfAdditionalNodesLocData[i];
            if (oldValue === current.AdditionalNodesLocData[i]) {
              result._selfAdditionalNodesLocData[i] = oldCache;
            } else {
              result._selfAdditionalNodesLocData[i] = oldCache.update(current.AdditionalNodesLocData[i], null);
            }
          } else {
            result._selfAdditionalNodesLocData[i] = new FVector3.WithParent(current.AdditionalNodesLocData[i], null);
          }
        }
      }
    }
    return result;
  }
}
WayPointDataContainer_WithParent.default = new WayPointDataContainer_WithParent(WayPointDataContainer.default, null);
WayPointDataContainer.WithParent = WayPointDataContainer_WithParent;
class WayPointDataContainer_Descriptor {
  get PathNameData() {
    if (!this._PathNameData) {
      this._PathNameData = {
        name: "PathNameData",
        Name: "PathNameData",
        number: 1,
        protoType: 9,
        protoName: "PathNameData",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._PathNameData;
  }
  get RawPathesData() {
    if (!this._RawPathesData) {
      this._RawPathesData = {
        name: "RawPathesData",
        Name: "RawPathesData",
        number: 2,
        protoType: 11,
        protoName: "RawPathesData",
        type: NodeDataList,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RawPathesData;
  }
  get RawPathesLocData() {
    if (!this._RawPathesLocData) {
      this._RawPathesLocData = {
        name: "RawPathesLocData",
        Name: "RawPathesLocData",
        number: 3,
        protoType: 11,
        protoName: "RawPathesLocData",
        type: FVector3List,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RawPathesLocData;
  }
  get AdditionalNodesData() {
    if (!this._AdditionalNodesData) {
      this._AdditionalNodesData = {
        name: "AdditionalNodesData",
        Name: "AdditionalNodesData",
        number: 4,
        protoType: 11,
        protoName: "AdditionalNodesData",
        type: NodeData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._AdditionalNodesData;
  }
  get AdditionalNodesLocData() {
    if (!this._AdditionalNodesLocData) {
      this._AdditionalNodesLocData = {
        name: "AdditionalNodesLocData",
        Name: "AdditionalNodesLocData",
        number: 5,
        protoType: 11,
        protoName: "AdditionalNodesLocData",
        type: FVector3,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._AdditionalNodesLocData;
  }
  get DisableRallyStatus() {
    if (!this._DisableRallyStatus) {
      this._DisableRallyStatus = {
        name: "DisableRallyStatus",
        Name: "DisableRallyStatus",
        number: 6,
        protoType: 8,
        protoName: "DisableRallyStatus",
        type: JsonToBoolean,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._DisableRallyStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.PathNameData,
        this.RawPathesData,
        this.RawPathesLocData,
        this.AdditionalNodesData,
        this.AdditionalNodesLocData,
        this.DisableRallyStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
WayPointDataContainer.descriptor = new WayPointDataContainer_Descriptor();
export class NodeDataList {
  get descriptor() {
    return NodeDataList.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._values = [];
  }
  isEmpty() {
    if (this._values.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof NodeDataList) {
      return value;
    }
    return NodeDataList.fromJson(value);
  }
  static fromJson(json) {
    const result = new NodeDataList();
    if (Array.isArray(json)) {
      result._values = JsonToList(json, NodeData);
      return result;
    }
    result._values = JsonToList(json.values, NodeData);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    return ArrayToJson(this._values, NodeData);
  }
  /**
   * @returns {NodeData[]}
   */
  get values() {
    return this._values;
  }
  addValues(path, value) {
    return {type: 'ADD', path: path.concat(['values']), value: value.toJson()};
  }
  setValues(path, value) {
    return {type: 'SET', path: path.concat(['values']), value: ArrayToJson(value, NodeData)};
  }
  setValuesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['values', key]), value: value.toJson()};
  }
  deleteValues(path) {
    return {type: 'DELETE', path: path.concat(['values'])};
  }
  deleteValuesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['values', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "values": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new NodeDataList(this);
              copy._values = [];        for (let i of value) {
                copy._values.push(NodeData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new NodeDataList(this);
              copy._values = copy._values.concat([NodeData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._values.length === 0) {
                return this;
              }
              const copy = new NodeDataList(this);
              copy._values = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new NodeDataList(this);
              copy._values = copy._values.slice();
              copy._values[path[1]] = NodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new NodeDataList(this);
              copy._values = copy._values.slice(0, path[1]).concat(copy._values.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          const oldValue = this._values[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new NodeDataList(this);
          copy._values = copy._values.slice();
          copy._values[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {NodeDataList} other
   * @returns {NodeDataList}
   */
  merge(other) {
    const copy = new NodeDataList(this);
    copy._values = this._values.concat(other._values);
    return copy;
  }
}
NodeDataList.default = new NodeDataList();
class NodeDataList_Builder {
  constructor(value) {
    this._value = new NodeDataList(value);
  }
  build() {
    return new NodeDataList(this._value);
  }
  addAllValues(values) {
    this._value._values = this._value._values.concat(values);
    return this;
  }
  addValues(value) {
    this._value._values = this._value._values.concat([value]);
    return this;
  }
  setValues(index, value) {
    this._value._values = this._value._values.concat();
    this._value._values[index] = value;
    return this;
  }
  clearValues() {
    this._value._values = [];
    return this;
  }
}
NodeDataList.Builder = NodeDataList_Builder;
class NodeDataList_WithParent {
  /**
   * @param {NodeDataList} value
   * @param {NodeDataList_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return NodeDataList.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfValues() {
    if (!this._selfValues) {
      this._selfValues = [];
      for (let i of this._value.values) {
        this._selfValues.push(new NodeData.WithParent(i, null));
      }
    }
    return this._selfValues;
  }
  get inherentValues() {
    if (!this._inherentValues) {
      this._inherentValues = this._parent ? this._parent.values : [];
    }
    return this._inherentValues;
  }
  get values() {
    if (!this._allValues) {
      this._allValues = this._parent ? this._parent.values.concat(this.selfValues) : this.selfValues;
    }
    return this._allValues;
  }
  update(current, parent) {
    const result = new NodeDataList_WithParent(current, parent);
    if (this._selfValues) {
      if (this._value.values === current.values) {
        result._selfValues = this._selfValues;
      } else {
        result._selfValues = [];
        for (let i = 0; i < current.values.length; i++) {
          const oldValue = this._value.values[i];
          if (oldValue) {
            const oldCache = this._selfValues[i];
            if (oldValue === current.values[i]) {
              result._selfValues[i] = oldCache;
            } else {
              result._selfValues[i] = oldCache.update(current.values[i], null);
            }
          } else {
            result._selfValues[i] = new NodeData.WithParent(current.values[i], null);
          }
        }
      }
    }
    return result;
  }
}
NodeDataList_WithParent.default = new NodeDataList_WithParent(NodeDataList.default, null);
NodeDataList.WithParent = NodeDataList_WithParent;
class NodeDataList_Descriptor {
  get values() {
    if (!this._values) {
      this._values = {
        name: "values",
        Name: "Values",
        number: 1,
        protoType: 11,
        protoName: "values",
        type: NodeData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._values;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.values,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
NodeDataList.descriptor = new NodeDataList_Descriptor();
export class FVector3List {
  get descriptor() {
    return FVector3List.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._values = [];
  }
  isEmpty() {
    if (this._values.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FVector3List) {
      return value;
    }
    return FVector3List.fromJson(value);
  }
  static fromJson(json) {
    const result = new FVector3List();
    if (Array.isArray(json)) {
      result._values = JsonToList(json, FVector3);
      return result;
    }
    result._values = JsonToList(json.values, FVector3);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    return ArrayToJson(this._values, FVector3);
  }
  /**
   * @returns {FVector3[]}
   */
  get values() {
    return this._values;
  }
  addValues(path, value) {
    return {type: 'ADD', path: path.concat(['values']), value: value.toJson()};
  }
  setValues(path, value) {
    return {type: 'SET', path: path.concat(['values']), value: ArrayToJson(value, FVector3)};
  }
  setValuesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['values', key]), value: value.toJson()};
  }
  deleteValues(path) {
    return {type: 'DELETE', path: path.concat(['values'])};
  }
  deleteValuesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['values', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "values": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FVector3List(this);
              copy._values = [];        for (let i of value) {
                copy._values.push(FVector3.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new FVector3List(this);
              copy._values = copy._values.concat([FVector3.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._values.length === 0) {
                return this;
              }
              const copy = new FVector3List(this);
              copy._values = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new FVector3List(this);
              copy._values = copy._values.slice();
              copy._values[path[1]] = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new FVector3List(this);
              copy._values = copy._values.slice(0, path[1]).concat(copy._values.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          const oldValue = this._values[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new FVector3List(this);
          copy._values = copy._values.slice();
          copy._values[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FVector3List} other
   * @returns {FVector3List}
   */
  merge(other) {
    const copy = new FVector3List(this);
    copy._values = this._values.concat(other._values);
    return copy;
  }
}
FVector3List.default = new FVector3List();
class FVector3List_Builder {
  constructor(value) {
    this._value = new FVector3List(value);
  }
  build() {
    return new FVector3List(this._value);
  }
  addAllValues(values) {
    this._value._values = this._value._values.concat(values);
    return this;
  }
  addValues(value) {
    this._value._values = this._value._values.concat([value]);
    return this;
  }
  setValues(index, value) {
    this._value._values = this._value._values.concat();
    this._value._values[index] = value;
    return this;
  }
  clearValues() {
    this._value._values = [];
    return this;
  }
}
FVector3List.Builder = FVector3List_Builder;
class FVector3List_WithParent {
  /**
   * @param {FVector3List} value
   * @param {FVector3List_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FVector3List.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfValues() {
    if (!this._selfValues) {
      this._selfValues = [];
      for (let i of this._value.values) {
        this._selfValues.push(new FVector3.WithParent(i, null));
      }
    }
    return this._selfValues;
  }
  get inherentValues() {
    if (!this._inherentValues) {
      this._inherentValues = this._parent ? this._parent.values : [];
    }
    return this._inherentValues;
  }
  get values() {
    if (!this._allValues) {
      this._allValues = this._parent ? this._parent.values.concat(this.selfValues) : this.selfValues;
    }
    return this._allValues;
  }
  update(current, parent) {
    const result = new FVector3List_WithParent(current, parent);
    if (this._selfValues) {
      if (this._value.values === current.values) {
        result._selfValues = this._selfValues;
      } else {
        result._selfValues = [];
        for (let i = 0; i < current.values.length; i++) {
          const oldValue = this._value.values[i];
          if (oldValue) {
            const oldCache = this._selfValues[i];
            if (oldValue === current.values[i]) {
              result._selfValues[i] = oldCache;
            } else {
              result._selfValues[i] = oldCache.update(current.values[i], null);
            }
          } else {
            result._selfValues[i] = new FVector3.WithParent(current.values[i], null);
          }
        }
      }
    }
    return result;
  }
}
FVector3List_WithParent.default = new FVector3List_WithParent(FVector3List.default, null);
FVector3List.WithParent = FVector3List_WithParent;
class FVector3List_Descriptor {
  get values() {
    if (!this._values) {
      this._values = {
        name: "values",
        Name: "Values",
        number: 1,
        protoType: 11,
        protoName: "values",
        type: FVector3,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._values;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.values,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
FVector3List.descriptor = new FVector3List_Descriptor();
export class UnitsDataContainer {
  get descriptor() {
    return UnitsDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._UnitsData = [];
  }
  isEmpty() {
    if (this._UnitsData.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitsDataContainer) {
      return value;
    }
    return UnitsDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitsDataContainer();
    result._UnitsData = JsonToList(json.UnitsData, SerializableUnit);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._UnitsData.length > 0) {
      result.UnitsData = ArrayToJson(this._UnitsData, SerializableUnit);
    }
    return result;
  }
  /**
   * @returns {SerializableUnit[]}
   */
  get UnitsData() {
    return this._UnitsData;
  }
  addUnitsData(path, value) {
    return {type: 'ADD', path: path.concat(['UnitsData']), value: value.toJson()};
  }
  setUnitsData(path, value) {
    return {type: 'SET', path: path.concat(['UnitsData']), value: ArrayToJson(value, SerializableUnit)};
  }
  setUnitsDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['UnitsData', key]), value: value.toJson()};
  }
  deleteUnitsData(path) {
    return {type: 'DELETE', path: path.concat(['UnitsData'])};
  }
  deleteUnitsDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['UnitsData', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "UnitsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitsDataContainer(this);
              copy._UnitsData = [];        for (let i of value) {
                copy._UnitsData.push(SerializableUnit.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UnitsDataContainer(this);
              copy._UnitsData = copy._UnitsData.concat([SerializableUnit.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._UnitsData.length === 0) {
                return this;
              }
              const copy = new UnitsDataContainer(this);
              copy._UnitsData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._UnitsData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UnitsDataContainer(this);
              copy._UnitsData = copy._UnitsData.slice();
              copy._UnitsData[path[1]] = SerializableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UnitsDataContainer(this);
              copy._UnitsData = copy._UnitsData.slice(0, path[1]).concat(copy._UnitsData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._UnitsData.length) {
            return this;
          }
          const oldValue = this._UnitsData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UnitsDataContainer(this);
          copy._UnitsData = copy._UnitsData.slice();
          copy._UnitsData[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitsDataContainer} other
   * @returns {UnitsDataContainer}
   */
  merge(other) {
    const copy = new UnitsDataContainer(this);
    copy._UnitsData = this._UnitsData.concat(other._UnitsData);
    return copy;
  }
}
UnitsDataContainer.default = new UnitsDataContainer();
class UnitsDataContainer_Builder {
  constructor(value) {
    this._value = new UnitsDataContainer(value);
  }
  build() {
    return new UnitsDataContainer(this._value);
  }
  addAllUnitsData(values) {
    this._value._UnitsData = this._value._UnitsData.concat(values);
    return this;
  }
  addUnitsData(value) {
    this._value._UnitsData = this._value._UnitsData.concat([value]);
    return this;
  }
  setUnitsData(index, value) {
    this._value._UnitsData = this._value._UnitsData.concat();
    this._value._UnitsData[index] = value;
    return this;
  }
  clearUnitsData() {
    this._value._UnitsData = [];
    return this;
  }
}
UnitsDataContainer.Builder = UnitsDataContainer_Builder;
class UnitsDataContainer_WithParent {
  /**
   * @param {UnitsDataContainer} value
   * @param {UnitsDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitsDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUnitsData() {
    if (!this._selfUnitsData) {
      this._selfUnitsData = [];
      for (let i of this._value.UnitsData) {
        this._selfUnitsData.push(new SerializableUnit.WithParent(i, null));
      }
    }
    return this._selfUnitsData;
  }
  get inherentUnitsData() {
    if (!this._inherentUnitsData) {
      this._inherentUnitsData = this._parent ? this._parent.UnitsData : [];
    }
    return this._inherentUnitsData;
  }
  get UnitsData() {
    if (!this._allUnitsData) {
      this._allUnitsData = this._parent ? this._parent.UnitsData.concat(this.selfUnitsData) : this.selfUnitsData;
    }
    return this._allUnitsData;
  }
  update(current, parent) {
    const result = new UnitsDataContainer_WithParent(current, parent);
    if (this._selfUnitsData) {
      if (this._value.UnitsData === current.UnitsData) {
        result._selfUnitsData = this._selfUnitsData;
      } else {
        result._selfUnitsData = [];
        for (let i = 0; i < current.UnitsData.length; i++) {
          const oldValue = this._value.UnitsData[i];
          if (oldValue) {
            const oldCache = this._selfUnitsData[i];
            if (oldValue === current.UnitsData[i]) {
              result._selfUnitsData[i] = oldCache;
            } else {
              result._selfUnitsData[i] = oldCache.update(current.UnitsData[i], null);
            }
          } else {
            result._selfUnitsData[i] = new SerializableUnit.WithParent(current.UnitsData[i], null);
          }
        }
      }
    }
    return result;
  }
}
UnitsDataContainer_WithParent.default = new UnitsDataContainer_WithParent(UnitsDataContainer.default, null);
UnitsDataContainer.WithParent = UnitsDataContainer_WithParent;
class UnitsDataContainer_Descriptor {
  get UnitsData() {
    if (!this._UnitsData) {
      this._UnitsData = {
        name: "UnitsData",
        Name: "UnitsData",
        number: 1,
        protoType: 11,
        protoName: "UnitsData",
        type: SerializableUnit,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UnitsData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.UnitsData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UnitsDataContainer.descriptor = new UnitsDataContainer_Descriptor();
export class RegionsDataContainer {
  get descriptor() {
    return RegionsDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._RegionsData = [];
  }
  isEmpty() {
    if (this._RegionsData.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RegionsDataContainer) {
      return value;
    }
    return RegionsDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new RegionsDataContainer();
    result._RegionsData = JsonToList(json.RegionsData, UndoableRegion);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._RegionsData.length > 0) {
      result.RegionsData = ArrayToJson(this._RegionsData, UndoableRegion);
    }
    return result;
  }
  /**
   * @returns {UndoableRegion[]}
   */
  get RegionsData() {
    return this._RegionsData;
  }
  addRegionsData(path, value) {
    return {type: 'ADD', path: path.concat(['RegionsData']), value: value.toJson()};
  }
  setRegionsData(path, value) {
    return {type: 'SET', path: path.concat(['RegionsData']), value: ArrayToJson(value, UndoableRegion)};
  }
  setRegionsDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['RegionsData', key]), value: value.toJson()};
  }
  deleteRegionsData(path) {
    return {type: 'DELETE', path: path.concat(['RegionsData'])};
  }
  deleteRegionsDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['RegionsData', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "RegionsData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RegionsDataContainer(this);
              copy._RegionsData = [];        for (let i of value) {
                copy._RegionsData.push(UndoableRegion.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RegionsDataContainer(this);
              copy._RegionsData = copy._RegionsData.concat([UndoableRegion.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._RegionsData.length === 0) {
                return this;
              }
              const copy = new RegionsDataContainer(this);
              copy._RegionsData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._RegionsData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RegionsDataContainer(this);
              copy._RegionsData = copy._RegionsData.slice();
              copy._RegionsData[path[1]] = UndoableRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RegionsDataContainer(this);
              copy._RegionsData = copy._RegionsData.slice(0, path[1]).concat(copy._RegionsData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._RegionsData.length) {
            return this;
          }
          const oldValue = this._RegionsData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RegionsDataContainer(this);
          copy._RegionsData = copy._RegionsData.slice();
          copy._RegionsData[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RegionsDataContainer} other
   * @returns {RegionsDataContainer}
   */
  merge(other) {
    const copy = new RegionsDataContainer(this);
    copy._RegionsData = this._RegionsData.concat(other._RegionsData);
    return copy;
  }
}
RegionsDataContainer.default = new RegionsDataContainer();
class RegionsDataContainer_Builder {
  constructor(value) {
    this._value = new RegionsDataContainer(value);
  }
  build() {
    return new RegionsDataContainer(this._value);
  }
  addAllRegionsData(values) {
    this._value._RegionsData = this._value._RegionsData.concat(values);
    return this;
  }
  addRegionsData(value) {
    this._value._RegionsData = this._value._RegionsData.concat([value]);
    return this;
  }
  setRegionsData(index, value) {
    this._value._RegionsData = this._value._RegionsData.concat();
    this._value._RegionsData[index] = value;
    return this;
  }
  clearRegionsData() {
    this._value._RegionsData = [];
    return this;
  }
}
RegionsDataContainer.Builder = RegionsDataContainer_Builder;
class RegionsDataContainer_WithParent {
  /**
   * @param {RegionsDataContainer} value
   * @param {RegionsDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RegionsDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRegionsData() {
    if (!this._selfRegionsData) {
      this._selfRegionsData = [];
      for (let i of this._value.RegionsData) {
        this._selfRegionsData.push(new UndoableRegion.WithParent(i, null));
      }
    }
    return this._selfRegionsData;
  }
  get inherentRegionsData() {
    if (!this._inherentRegionsData) {
      this._inherentRegionsData = this._parent ? this._parent.RegionsData : [];
    }
    return this._inherentRegionsData;
  }
  get RegionsData() {
    if (!this._allRegionsData) {
      this._allRegionsData = this._parent ? this._parent.RegionsData.concat(this.selfRegionsData) : this.selfRegionsData;
    }
    return this._allRegionsData;
  }
  update(current, parent) {
    const result = new RegionsDataContainer_WithParent(current, parent);
    if (this._selfRegionsData) {
      if (this._value.RegionsData === current.RegionsData) {
        result._selfRegionsData = this._selfRegionsData;
      } else {
        result._selfRegionsData = [];
        for (let i = 0; i < current.RegionsData.length; i++) {
          const oldValue = this._value.RegionsData[i];
          if (oldValue) {
            const oldCache = this._selfRegionsData[i];
            if (oldValue === current.RegionsData[i]) {
              result._selfRegionsData[i] = oldCache;
            } else {
              result._selfRegionsData[i] = oldCache.update(current.RegionsData[i], null);
            }
          } else {
            result._selfRegionsData[i] = new UndoableRegion.WithParent(current.RegionsData[i], null);
          }
        }
      }
    }
    return result;
  }
}
RegionsDataContainer_WithParent.default = new RegionsDataContainer_WithParent(RegionsDataContainer.default, null);
RegionsDataContainer.WithParent = RegionsDataContainer_WithParent;
class RegionsDataContainer_Descriptor {
  get RegionsData() {
    if (!this._RegionsData) {
      this._RegionsData = {
        name: "RegionsData",
        Name: "RegionsData",
        number: 1,
        protoType: 11,
        protoName: "RegionsData",
        type: UndoableRegion,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RegionsData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.RegionsData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RegionsDataContainer.descriptor = new RegionsDataContainer_Descriptor();
export class GameEntityListContainer {
  get descriptor() {
    return GameEntityListContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._GameEntityList = [];
    this._RegionList = [];
  }
  isEmpty() {
    if (this._GameEntityList.length > 0) return false;
    if (this._RegionList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GameEntityListContainer) {
      return value;
    }
    return GameEntityListContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new GameEntityListContainer();
    result._GameEntityList = JsonToList(json.GameEntityList, SerializableUnit);
    result._RegionList = JsonToList(json.RegionList, UndoableRegion);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._GameEntityList.length > 0) {
      result.GameEntityList = ArrayToJson(this._GameEntityList, SerializableUnit);
    }
    if (this._RegionList.length > 0) {
      result.RegionList = ArrayToJson(this._RegionList, UndoableRegion);
    }
    return result;
  }
  /**
   * @returns {SerializableUnit[]}
   */
  get GameEntityList() {
    return this._GameEntityList;
  }
  addGameEntityList(path, value) {
    return {type: 'ADD', path: path.concat(['GameEntityList']), value: value.toJson()};
  }
  setGameEntityList(path, value) {
    return {type: 'SET', path: path.concat(['GameEntityList']), value: ArrayToJson(value, SerializableUnit)};
  }
  setGameEntityListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['GameEntityList', key]), value: value.toJson()};
  }
  deleteGameEntityList(path) {
    return {type: 'DELETE', path: path.concat(['GameEntityList'])};
  }
  deleteGameEntityListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['GameEntityList', key])};
  }
  /**
   * @returns {UndoableRegion[]}
   */
  get RegionList() {
    return this._RegionList;
  }
  addRegionList(path, value) {
    return {type: 'ADD', path: path.concat(['RegionList']), value: value.toJson()};
  }
  setRegionList(path, value) {
    return {type: 'SET', path: path.concat(['RegionList']), value: ArrayToJson(value, UndoableRegion)};
  }
  setRegionListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['RegionList', key]), value: value.toJson()};
  }
  deleteRegionList(path) {
    return {type: 'DELETE', path: path.concat(['RegionList'])};
  }
  deleteRegionListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['RegionList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "GameEntityList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GameEntityListContainer(this);
              copy._GameEntityList = [];        for (let i of value) {
                copy._GameEntityList.push(SerializableUnit.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GameEntityListContainer(this);
              copy._GameEntityList = copy._GameEntityList.concat([SerializableUnit.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._GameEntityList.length === 0) {
                return this;
              }
              const copy = new GameEntityListContainer(this);
              copy._GameEntityList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._GameEntityList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GameEntityListContainer(this);
              copy._GameEntityList = copy._GameEntityList.slice();
              copy._GameEntityList[path[1]] = SerializableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GameEntityListContainer(this);
              copy._GameEntityList = copy._GameEntityList.slice(0, path[1]).concat(copy._GameEntityList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._GameEntityList.length) {
            return this;
          }
          const oldValue = this._GameEntityList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GameEntityListContainer(this);
          copy._GameEntityList = copy._GameEntityList.slice();
          copy._GameEntityList[key] = newValue;
          return copy;
        }
      }
      case "RegionList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GameEntityListContainer(this);
              copy._RegionList = [];        for (let i of value) {
                copy._RegionList.push(UndoableRegion.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GameEntityListContainer(this);
              copy._RegionList = copy._RegionList.concat([UndoableRegion.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._RegionList.length === 0) {
                return this;
              }
              const copy = new GameEntityListContainer(this);
              copy._RegionList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._RegionList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GameEntityListContainer(this);
              copy._RegionList = copy._RegionList.slice();
              copy._RegionList[path[1]] = UndoableRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GameEntityListContainer(this);
              copy._RegionList = copy._RegionList.slice(0, path[1]).concat(copy._RegionList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._RegionList.length) {
            return this;
          }
          const oldValue = this._RegionList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GameEntityListContainer(this);
          copy._RegionList = copy._RegionList.slice();
          copy._RegionList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GameEntityListContainer} other
   * @returns {GameEntityListContainer}
   */
  merge(other) {
    const copy = new GameEntityListContainer(this);
    copy._GameEntityList = this._GameEntityList.concat(other._GameEntityList);
    copy._RegionList = this._RegionList.concat(other._RegionList);
    return copy;
  }
}
GameEntityListContainer.default = new GameEntityListContainer();
class GameEntityListContainer_Builder {
  constructor(value) {
    this._value = new GameEntityListContainer(value);
  }
  build() {
    return new GameEntityListContainer(this._value);
  }
  addAllGameEntityList(values) {
    this._value._GameEntityList = this._value._GameEntityList.concat(values);
    return this;
  }
  addGameEntityList(value) {
    this._value._GameEntityList = this._value._GameEntityList.concat([value]);
    return this;
  }
  setGameEntityList(index, value) {
    this._value._GameEntityList = this._value._GameEntityList.concat();
    this._value._GameEntityList[index] = value;
    return this;
  }
  clearGameEntityList() {
    this._value._GameEntityList = [];
    return this;
  }
  addAllRegionList(values) {
    this._value._RegionList = this._value._RegionList.concat(values);
    return this;
  }
  addRegionList(value) {
    this._value._RegionList = this._value._RegionList.concat([value]);
    return this;
  }
  setRegionList(index, value) {
    this._value._RegionList = this._value._RegionList.concat();
    this._value._RegionList[index] = value;
    return this;
  }
  clearRegionList() {
    this._value._RegionList = [];
    return this;
  }
}
GameEntityListContainer.Builder = GameEntityListContainer_Builder;
class GameEntityListContainer_WithParent {
  /**
   * @param {GameEntityListContainer} value
   * @param {GameEntityListContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GameEntityListContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGameEntityList() {
    if (!this._selfGameEntityList) {
      this._selfGameEntityList = [];
      for (let i of this._value.GameEntityList) {
        this._selfGameEntityList.push(new SerializableUnit.WithParent(i, null));
      }
    }
    return this._selfGameEntityList;
  }
  get inherentGameEntityList() {
    if (!this._inherentGameEntityList) {
      this._inherentGameEntityList = this._parent ? this._parent.GameEntityList : [];
    }
    return this._inherentGameEntityList;
  }
  get GameEntityList() {
    if (!this._allGameEntityList) {
      this._allGameEntityList = this._parent ? this._parent.GameEntityList.concat(this.selfGameEntityList) : this.selfGameEntityList;
    }
    return this._allGameEntityList;
  }
  get selfRegionList() {
    if (!this._selfRegionList) {
      this._selfRegionList = [];
      for (let i of this._value.RegionList) {
        this._selfRegionList.push(new UndoableRegion.WithParent(i, null));
      }
    }
    return this._selfRegionList;
  }
  get inherentRegionList() {
    if (!this._inherentRegionList) {
      this._inherentRegionList = this._parent ? this._parent.RegionList : [];
    }
    return this._inherentRegionList;
  }
  get RegionList() {
    if (!this._allRegionList) {
      this._allRegionList = this._parent ? this._parent.RegionList.concat(this.selfRegionList) : this.selfRegionList;
    }
    return this._allRegionList;
  }
  update(current, parent) {
    const result = new GameEntityListContainer_WithParent(current, parent);
    if (this._selfGameEntityList) {
      if (this._value.GameEntityList === current.GameEntityList) {
        result._selfGameEntityList = this._selfGameEntityList;
      } else {
        result._selfGameEntityList = [];
        for (let i = 0; i < current.GameEntityList.length; i++) {
          const oldValue = this._value.GameEntityList[i];
          if (oldValue) {
            const oldCache = this._selfGameEntityList[i];
            if (oldValue === current.GameEntityList[i]) {
              result._selfGameEntityList[i] = oldCache;
            } else {
              result._selfGameEntityList[i] = oldCache.update(current.GameEntityList[i], null);
            }
          } else {
            result._selfGameEntityList[i] = new SerializableUnit.WithParent(current.GameEntityList[i], null);
          }
        }
      }
    }
    if (this._selfRegionList) {
      if (this._value.RegionList === current.RegionList) {
        result._selfRegionList = this._selfRegionList;
      } else {
        result._selfRegionList = [];
        for (let i = 0; i < current.RegionList.length; i++) {
          const oldValue = this._value.RegionList[i];
          if (oldValue) {
            const oldCache = this._selfRegionList[i];
            if (oldValue === current.RegionList[i]) {
              result._selfRegionList[i] = oldCache;
            } else {
              result._selfRegionList[i] = oldCache.update(current.RegionList[i], null);
            }
          } else {
            result._selfRegionList[i] = new UndoableRegion.WithParent(current.RegionList[i], null);
          }
        }
      }
    }
    return result;
  }
}
GameEntityListContainer_WithParent.default = new GameEntityListContainer_WithParent(GameEntityListContainer.default, null);
GameEntityListContainer.WithParent = GameEntityListContainer_WithParent;
class GameEntityListContainer_Descriptor {
  get GameEntityList() {
    if (!this._GameEntityList) {
      this._GameEntityList = {
        name: "GameEntityList",
        Name: "GameEntityList",
        number: 1,
        protoType: 11,
        protoName: "GameEntityList",
        type: SerializableUnit,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._GameEntityList;
  }
  get RegionList() {
    if (!this._RegionList) {
      this._RegionList = {
        name: "RegionList",
        Name: "RegionList",
        number: 2,
        protoType: 11,
        protoName: "RegionList",
        type: UndoableRegion,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._RegionList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.GameEntityList,
        this.RegionList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
GameEntityListContainer.descriptor = new GameEntityListContainer_Descriptor();
export class SerializableUnit {
  get descriptor() {
    return SerializableUnit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitName = false;
    this._UnitName = null;
    this._Position = [];
    this._Rotation = [];
    this._hasTeam = false;
    this._Team = null;
    this._hasPlayer = false;
    this._Player = null;
  }
  isEmpty() {
    if (this._hasUnitName) return false;
    if (this._Position.length > 0) return false;
    if (this._Rotation.length > 0) return false;
    if (this._hasTeam) return false;
    if (this._hasPlayer) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SerializableUnit) {
      return value;
    }
    return SerializableUnit.fromJson(value);
  }
  static fromJson(json) {
    const result = new SerializableUnit();
    if (json.UnitName != null) {
      result._hasUnitName = true;
      result._UnitName = JsonToString.fromJson(json.UnitName);
    }
    result._Position = JsonToList(json.Position, JsonToDouble);
    result._Rotation = JsonToList(json.Rotation, JsonToDouble);
    if (json.Team != null) {
      result._hasTeam = true;
      result._Team = Team.fromJson(json.Team);
    }
    if (json.Player != null) {
      result._hasPlayer = true;
      result._Player = JsonToInt32.fromJson(json.Player);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitName) {
      result.UnitName = JsonToString.toJson(this._UnitName);
    }
    if (this._Position.length > 0) {
      result.Position = ArrayToJson(this._Position, JsonToDouble);
    }
    if (this._Rotation.length > 0) {
      result.Rotation = ArrayToJson(this._Rotation, JsonToDouble);
    }
    if (this._hasTeam) {
      result.Team = Team.toJson(this._Team);
    }
    if (this._hasPlayer) {
      result.Player = JsonToInt32.toJson(this._Player);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get UnitName() {
    return this._hasUnitName ? this._UnitName : JsonToString.default;
  }
  get hasUnitName() {
    return this._hasUnitName;
  }
  setUnitName(path, value) {
    return {type: 'SET', path: path.concat(['UnitName']), value};
  }
  deleteUnitName(path) {
    return {type: 'DELETE', path: path.concat(['UnitName'])};
  }
  /**
   * @returns {number[]}
   */
  get Position() {
    return this._Position;
  }
  addPosition(path, value) {
    return {type: 'ADD', path: path.concat(['Position']), value};
  }
  setPosition(path, value) {
    return {type: 'SET', path: path.concat(['Position']), value: ArrayToJson(value, JsonToDouble)};
  }
  setPositionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['Position', key]), value};
  }
  deletePosition(path) {
    return {type: 'DELETE', path: path.concat(['Position'])};
  }
  deletePositionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['Position', key])};
  }
  /**
   * @returns {number[]}
   */
  get Rotation() {
    return this._Rotation;
  }
  addRotation(path, value) {
    return {type: 'ADD', path: path.concat(['Rotation']), value};
  }
  setRotation(path, value) {
    return {type: 'SET', path: path.concat(['Rotation']), value: ArrayToJson(value, JsonToDouble)};
  }
  setRotationByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['Rotation', key]), value};
  }
  deleteRotation(path) {
    return {type: 'DELETE', path: path.concat(['Rotation'])};
  }
  deleteRotationByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['Rotation', key])};
  }
  /**
   * @returns {number}
   */
  get Team() {
    return this._hasTeam ? this._Team : Team.default;
  }
  get hasTeam() {
    return this._hasTeam;
  }
  setTeam(path, value) {
    return {type: 'SET', path: path.concat(['Team']), value};
  }
  deleteTeam(path) {
    return {type: 'DELETE', path: path.concat(['Team'])};
  }
  /**
   * @returns {number}
   */
  get Player() {
    return this._hasPlayer ? this._Player : JsonToInt32.default;
  }
  get hasPlayer() {
    return this._hasPlayer;
  }
  setPlayer(path, value) {
    return {type: 'SET', path: path.concat(['Player']), value};
  }
  deletePlayer(path) {
    return {type: 'DELETE', path: path.concat(['Player'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "UnitName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._hasUnitName = true;
              copy._UnitName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitName) {
                return this;
              }
              const copy = new SerializableUnit(this);
              copy._hasUnitName = false;
              copy._UnitName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Position": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._Position = [];        for (let i of value) {
                copy._Position.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SerializableUnit(this);
              copy._Position = copy._Position.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._Position.length === 0) {
                return this;
              }
              const copy = new SerializableUnit(this);
              copy._Position = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._Position.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._Position = copy._Position.slice();
              copy._Position[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SerializableUnit(this);
              copy._Position = copy._Position.slice(0, path[1]).concat(copy._Position.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._Position.length) {
            return this;
          }
          const oldValue = this._Position[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SerializableUnit(this);
          copy._Position = copy._Position.slice();
          copy._Position[key] = newValue;
          return copy;
        }
      }
      case "Rotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._Rotation = [];        for (let i of value) {
                copy._Rotation.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SerializableUnit(this);
              copy._Rotation = copy._Rotation.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._Rotation.length === 0) {
                return this;
              }
              const copy = new SerializableUnit(this);
              copy._Rotation = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._Rotation.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._Rotation = copy._Rotation.slice();
              copy._Rotation[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SerializableUnit(this);
              copy._Rotation = copy._Rotation.slice(0, path[1]).concat(copy._Rotation.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._Rotation.length) {
            return this;
          }
          const oldValue = this._Rotation[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SerializableUnit(this);
          copy._Rotation = copy._Rotation.slice();
          copy._Rotation[key] = newValue;
          return copy;
        }
      }
      case "Team": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._hasTeam = true;
              copy._Team = Team.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTeam) {
                return this;
              }
              const copy = new SerializableUnit(this);
              copy._hasTeam = false;
              copy._Team = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Player": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SerializableUnit(this);
              copy._hasPlayer = true;
              copy._Player = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayer) {
                return this;
              }
              const copy = new SerializableUnit(this);
              copy._hasPlayer = false;
              copy._Player = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SerializableUnit} other
   * @returns {SerializableUnit}
   */
  merge(other) {
    const copy = new SerializableUnit(this);
    if (other._hasUnitName) {
      copy._hasUnitName = true;
      copy._UnitName = other._UnitName;
    }
    copy._Position = this._Position.concat(other._Position);
    copy._Rotation = this._Rotation.concat(other._Rotation);
    if (other._hasTeam) {
      copy._hasTeam = true;
      copy._Team = other._Team;
    }
    if (other._hasPlayer) {
      copy._hasPlayer = true;
      copy._Player = other._Player;
    }
    return copy;
  }
}
SerializableUnit.default = new SerializableUnit();
class SerializableUnit_Builder {
  constructor(value) {
    this._value = new SerializableUnit(value);
  }
  build() {
    return new SerializableUnit(this._value);
  }
  setUnitName(value) {
    this._value._hasUnitName = true;
    this._value._UnitName = value;
    return this;
  }
  deleteUnitName() {
    this._value._hasUnitName = false;
    this._value._UnitName = null;
    return this;
  }
  addAllPosition(values) {
    this._value._Position = this._value._Position.concat(values);
    return this;
  }
  addPosition(value) {
    this._value._Position = this._value._Position.concat([value]);
    return this;
  }
  setPosition(index, value) {
    this._value._Position = this._value._Position.concat();
    this._value._Position[index] = value;
    return this;
  }
  clearPosition() {
    this._value._Position = [];
    return this;
  }
  addAllRotation(values) {
    this._value._Rotation = this._value._Rotation.concat(values);
    return this;
  }
  addRotation(value) {
    this._value._Rotation = this._value._Rotation.concat([value]);
    return this;
  }
  setRotation(index, value) {
    this._value._Rotation = this._value._Rotation.concat();
    this._value._Rotation[index] = value;
    return this;
  }
  clearRotation() {
    this._value._Rotation = [];
    return this;
  }
  setTeam(value) {
    this._value._hasTeam = true;
    this._value._Team = value;
    return this;
  }
  deleteTeam() {
    this._value._hasTeam = false;
    this._value._Team = null;
    return this;
  }
  setPlayer(value) {
    this._value._hasPlayer = true;
    this._value._Player = value;
    return this;
  }
  deletePlayer() {
    this._value._hasPlayer = false;
    this._value._Player = null;
    return this;
  }
}
SerializableUnit.Builder = SerializableUnit_Builder;
class SerializableUnit_WithParent {
  /**
   * @param {SerializableUnit} value
   * @param {SerializableUnit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SerializableUnit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitName() {
    if (this._cachedHasUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedHasUnitName = true;
      } else {
        this._cachedHasUnitName = this._parent ? this._parent.hasUnitName : false;
      }
    }
    return this._cachedHasUnitName;
  }
  get UnitName() {
    if (this._cachedUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedUnitName = this._value.UnitName;
      } else {
        this._cachedUnitName = this._parent ? this._parent.UnitName : this._value.UnitName;
      }
    }
    return this._cachedUnitName;
  }
  get selfPosition() {
    return this._value.Position;
  }
  get inherentPosition() {
    if (!this._inherentPosition) {
      this._inherentPosition = this._parent ? this._parent.Position : [];
    }
    return this._inherentPosition;
  }
  get Position() {
    if (!this._allPosition) {
      this._allPosition = this._parent ? this._parent.Position.concat(this.selfPosition) : this.selfPosition;
    }
    return this._allPosition;
  }
  get selfRotation() {
    return this._value.Rotation;
  }
  get inherentRotation() {
    if (!this._inherentRotation) {
      this._inherentRotation = this._parent ? this._parent.Rotation : [];
    }
    return this._inherentRotation;
  }
  get Rotation() {
    if (!this._allRotation) {
      this._allRotation = this._parent ? this._parent.Rotation.concat(this.selfRotation) : this.selfRotation;
    }
    return this._allRotation;
  }
  get hasTeam() {
    if (this._cachedHasTeam === undefined) {
      if (this._value.hasTeam) {
        this._cachedHasTeam = true;
      } else {
        this._cachedHasTeam = this._parent ? this._parent.hasTeam : false;
      }
    }
    return this._cachedHasTeam;
  }
  get Team() {
    if (this._cachedTeam === undefined) {
      if (this._value.hasTeam) {
        this._cachedTeam = this._value.Team;
      } else {
        this._cachedTeam = this._parent ? this._parent.Team : this._value.Team;
      }
    }
    return this._cachedTeam;
  }
  get hasPlayer() {
    if (this._cachedHasPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedHasPlayer = true;
      } else {
        this._cachedHasPlayer = this._parent ? this._parent.hasPlayer : false;
      }
    }
    return this._cachedHasPlayer;
  }
  get Player() {
    if (this._cachedPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedPlayer = this._value.Player;
      } else {
        this._cachedPlayer = this._parent ? this._parent.Player : this._value.Player;
      }
    }
    return this._cachedPlayer;
  }
  update(current, parent) {
    const result = new SerializableUnit_WithParent(current, parent);
    return result;
  }
}
SerializableUnit_WithParent.default = new SerializableUnit_WithParent(SerializableUnit.default, null);
SerializableUnit.WithParent = SerializableUnit_WithParent;
class SerializableUnit_Descriptor {
  get UnitName() {
    if (!this._UnitName) {
      this._UnitName = {
        name: "UnitName",
        Name: "UnitName",
        number: 1,
        protoType: 9,
        protoName: "UnitName",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UnitName;
  }
  get Position() {
    if (!this._Position) {
      this._Position = {
        name: "Position",
        Name: "Position",
        number: 2,
        protoType: 1,
        protoName: "Position",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Position;
  }
  get Rotation() {
    if (!this._Rotation) {
      this._Rotation = {
        name: "Rotation",
        Name: "Rotation",
        number: 3,
        protoType: 1,
        protoName: "Rotation",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Rotation;
  }
  get Team() {
    if (!this._Team) {
      this._Team = {
        name: "Team",
        Name: "Team",
        number: 4,
        protoType: 14,
        protoName: "Team",
        type: Team,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Team;
  }
  get Player() {
    if (!this._Player) {
      this._Player = {
        name: "Player",
        Name: "Player",
        number: 5,
        protoType: 5,
        protoName: "Player",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Player;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.UnitName,
        this.Position,
        this.Rotation,
        this.Team,
        this.Player,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitName",
        Name: "DummyOneofForUnitName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTeam",
        Name: "DummyOneofForTeam",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayer",
        Name: "DummyOneofForPlayer",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
SerializableUnit.descriptor = new SerializableUnit_Descriptor();
export class TerrainChunkDataContainer {
  get descriptor() {
    return TerrainChunkDataContainer.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUseTerrainChunk = false;
    this._UseTerrainChunk = null;
    this._TerrainChunkDefinitions = [];
  }
  isEmpty() {
    if (this._hasUseTerrainChunk) return false;
    if (this._TerrainChunkDefinitions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainChunkDataContainer) {
      return value;
    }
    return TerrainChunkDataContainer.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainChunkDataContainer();
    if (json.UseTerrainChunk != null) {
      result._hasUseTerrainChunk = true;
      result._UseTerrainChunk = JsonToBoolean.fromJson(json.UseTerrainChunk);
    }
    result._TerrainChunkDefinitions = JsonToList(json.TerrainChunkDefinitions, TerrainChunkDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUseTerrainChunk) {
      result.UseTerrainChunk = JsonToBoolean.toJson(this._UseTerrainChunk);
    }
    if (this._TerrainChunkDefinitions.length > 0) {
      result.TerrainChunkDefinitions = ArrayToJson(this._TerrainChunkDefinitions, TerrainChunkDefinition);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get UseTerrainChunk() {
    return this._hasUseTerrainChunk ? this._UseTerrainChunk : JsonToBoolean.default;
  }
  get hasUseTerrainChunk() {
    return this._hasUseTerrainChunk;
  }
  setUseTerrainChunk(path, value) {
    return {type: 'SET', path: path.concat(['UseTerrainChunk']), value};
  }
  deleteUseTerrainChunk(path) {
    return {type: 'DELETE', path: path.concat(['UseTerrainChunk'])};
  }
  /**
   * @returns {TerrainChunkDefinition[]}
   */
  get TerrainChunkDefinitions() {
    return this._TerrainChunkDefinitions;
  }
  addTerrainChunkDefinitions(path, value) {
    return {type: 'ADD', path: path.concat(['TerrainChunkDefinitions']), value: value.toJson()};
  }
  setTerrainChunkDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['TerrainChunkDefinitions']), value: ArrayToJson(value, TerrainChunkDefinition)};
  }
  setTerrainChunkDefinitionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['TerrainChunkDefinitions', key]), value: value.toJson()};
  }
  deleteTerrainChunkDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['TerrainChunkDefinitions'])};
  }
  deleteTerrainChunkDefinitionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['TerrainChunkDefinitions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "UseTerrainChunk": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDataContainer(this);
              copy._hasUseTerrainChunk = true;
              copy._UseTerrainChunk = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseTerrainChunk) {
                return this;
              }
              const copy = new TerrainChunkDataContainer(this);
              copy._hasUseTerrainChunk = false;
              copy._UseTerrainChunk = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "TerrainChunkDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDataContainer(this);
              copy._TerrainChunkDefinitions = [];        for (let i of value) {
                copy._TerrainChunkDefinitions.push(TerrainChunkDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TerrainChunkDataContainer(this);
              copy._TerrainChunkDefinitions = copy._TerrainChunkDefinitions.concat([TerrainChunkDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._TerrainChunkDefinitions.length === 0) {
                return this;
              }
              const copy = new TerrainChunkDataContainer(this);
              copy._TerrainChunkDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._TerrainChunkDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDataContainer(this);
              copy._TerrainChunkDefinitions = copy._TerrainChunkDefinitions.slice();
              copy._TerrainChunkDefinitions[path[1]] = TerrainChunkDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TerrainChunkDataContainer(this);
              copy._TerrainChunkDefinitions = copy._TerrainChunkDefinitions.slice(0, path[1]).concat(copy._TerrainChunkDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._TerrainChunkDefinitions.length) {
            return this;
          }
          const oldValue = this._TerrainChunkDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TerrainChunkDataContainer(this);
          copy._TerrainChunkDefinitions = copy._TerrainChunkDefinitions.slice();
          copy._TerrainChunkDefinitions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainChunkDataContainer} other
   * @returns {TerrainChunkDataContainer}
   */
  merge(other) {
    const copy = new TerrainChunkDataContainer(this);
    if (other._hasUseTerrainChunk) {
      copy._hasUseTerrainChunk = true;
      copy._UseTerrainChunk = other._UseTerrainChunk;
    }
    copy._TerrainChunkDefinitions = this._TerrainChunkDefinitions.concat(other._TerrainChunkDefinitions);
    return copy;
  }
}
TerrainChunkDataContainer.default = new TerrainChunkDataContainer();
class TerrainChunkDataContainer_Builder {
  constructor(value) {
    this._value = new TerrainChunkDataContainer(value);
  }
  build() {
    return new TerrainChunkDataContainer(this._value);
  }
  setUseTerrainChunk(value) {
    this._value._hasUseTerrainChunk = true;
    this._value._UseTerrainChunk = value;
    return this;
  }
  deleteUseTerrainChunk() {
    this._value._hasUseTerrainChunk = false;
    this._value._UseTerrainChunk = null;
    return this;
  }
  addAllTerrainChunkDefinitions(values) {
    this._value._TerrainChunkDefinitions = this._value._TerrainChunkDefinitions.concat(values);
    return this;
  }
  addTerrainChunkDefinitions(value) {
    this._value._TerrainChunkDefinitions = this._value._TerrainChunkDefinitions.concat([value]);
    return this;
  }
  setTerrainChunkDefinitions(index, value) {
    this._value._TerrainChunkDefinitions = this._value._TerrainChunkDefinitions.concat();
    this._value._TerrainChunkDefinitions[index] = value;
    return this;
  }
  clearTerrainChunkDefinitions() {
    this._value._TerrainChunkDefinitions = [];
    return this;
  }
}
TerrainChunkDataContainer.Builder = TerrainChunkDataContainer_Builder;
class TerrainChunkDataContainer_WithParent {
  /**
   * @param {TerrainChunkDataContainer} value
   * @param {TerrainChunkDataContainer_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainChunkDataContainer.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUseTerrainChunk() {
    if (this._cachedHasUseTerrainChunk === undefined) {
      if (this._value.hasUseTerrainChunk) {
        this._cachedHasUseTerrainChunk = true;
      } else {
        this._cachedHasUseTerrainChunk = this._parent ? this._parent.hasUseTerrainChunk : false;
      }
    }
    return this._cachedHasUseTerrainChunk;
  }
  get UseTerrainChunk() {
    if (this._cachedUseTerrainChunk === undefined) {
      if (this._value.hasUseTerrainChunk) {
        this._cachedUseTerrainChunk = this._value.UseTerrainChunk;
      } else {
        this._cachedUseTerrainChunk = this._parent ? this._parent.UseTerrainChunk : this._value.UseTerrainChunk;
      }
    }
    return this._cachedUseTerrainChunk;
  }
  get selfTerrainChunkDefinitions() {
    if (!this._selfTerrainChunkDefinitions) {
      this._selfTerrainChunkDefinitions = [];
      for (let i of this._value.TerrainChunkDefinitions) {
        this._selfTerrainChunkDefinitions.push(new TerrainChunkDefinition.WithParent(i, null));
      }
    }
    return this._selfTerrainChunkDefinitions;
  }
  get inherentTerrainChunkDefinitions() {
    if (!this._inherentTerrainChunkDefinitions) {
      this._inherentTerrainChunkDefinitions = this._parent ? this._parent.TerrainChunkDefinitions : [];
    }
    return this._inherentTerrainChunkDefinitions;
  }
  get TerrainChunkDefinitions() {
    if (!this._allTerrainChunkDefinitions) {
      this._allTerrainChunkDefinitions = this._parent ? this._parent.TerrainChunkDefinitions.concat(this.selfTerrainChunkDefinitions) : this.selfTerrainChunkDefinitions;
    }
    return this._allTerrainChunkDefinitions;
  }
  update(current, parent) {
    const result = new TerrainChunkDataContainer_WithParent(current, parent);
    if (this._selfTerrainChunkDefinitions) {
      if (this._value.TerrainChunkDefinitions === current.TerrainChunkDefinitions) {
        result._selfTerrainChunkDefinitions = this._selfTerrainChunkDefinitions;
      } else {
        result._selfTerrainChunkDefinitions = [];
        for (let i = 0; i < current.TerrainChunkDefinitions.length; i++) {
          const oldValue = this._value.TerrainChunkDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfTerrainChunkDefinitions[i];
            if (oldValue === current.TerrainChunkDefinitions[i]) {
              result._selfTerrainChunkDefinitions[i] = oldCache;
            } else {
              result._selfTerrainChunkDefinitions[i] = oldCache.update(current.TerrainChunkDefinitions[i], null);
            }
          } else {
            result._selfTerrainChunkDefinitions[i] = new TerrainChunkDefinition.WithParent(current.TerrainChunkDefinitions[i], null);
          }
        }
      }
    }
    return result;
  }
}
TerrainChunkDataContainer_WithParent.default = new TerrainChunkDataContainer_WithParent(TerrainChunkDataContainer.default, null);
TerrainChunkDataContainer.WithParent = TerrainChunkDataContainer_WithParent;
class TerrainChunkDataContainer_Descriptor {
  get UseTerrainChunk() {
    if (!this._UseTerrainChunk) {
      this._UseTerrainChunk = {
        name: "UseTerrainChunk",
        Name: "UseTerrainChunk",
        number: 1,
        protoType: 8,
        protoName: "UseTerrainChunk",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._UseTerrainChunk;
  }
  get TerrainChunkDefinitions() {
    if (!this._TerrainChunkDefinitions) {
      this._TerrainChunkDefinitions = {
        name: "TerrainChunkDefinitions",
        Name: "TerrainChunkDefinitions",
        number: 2,
        protoType: 11,
        protoName: "TerrainChunkDefinitions",
        type: TerrainChunkDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._TerrainChunkDefinitions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.UseTerrainChunk,
        this.TerrainChunkDefinitions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUseTerrainChunk",
        Name: "DummyOneofForUseTerrainChunk",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainChunkDataContainer.descriptor = new TerrainChunkDataContainer_Descriptor();
export class TerrainChunkDefinition {
  get descriptor() {
    return TerrainChunkDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasId = false;
    this._Id = null;
    this._hasCenter = false;
    this._Center = null;
    this._hasStartPoint = false;
    this._StartPoint = null;
    this._hasSize = false;
    this._Size = null;
  }
  isEmpty() {
    if (this._hasId) return false;
    if (this._hasCenter && !this._Center.isEmpty()) return false;
    if (this._hasStartPoint && !this._StartPoint.isEmpty()) return false;
    if (this._hasSize && !this._Size.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TerrainChunkDefinition) {
      return value;
    }
    return TerrainChunkDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new TerrainChunkDefinition();
    if (json.Id != null) {
      result._hasId = true;
      result._Id = JsonToString.fromJson(json.Id);
    }
    if (json.Center != null) {
      result._hasCenter = true;
      result._Center = FVector2.fromJson(json.Center);
    }
    if (json.StartPoint != null) {
      result._hasStartPoint = true;
      result._StartPoint = FVector2.fromJson(json.StartPoint);
    }
    if (json.Size != null) {
      result._hasSize = true;
      result._Size = FVector2.fromJson(json.Size);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasId) {
      result.Id = JsonToString.toJson(this._Id);
    }
    if (this._hasCenter && !this._Center.isEmpty()) {
      result.Center = FVector2.toJson(this._Center);
    }
    if (this._hasStartPoint && !this._StartPoint.isEmpty()) {
      result.StartPoint = FVector2.toJson(this._StartPoint);
    }
    if (this._hasSize && !this._Size.isEmpty()) {
      result.Size = FVector2.toJson(this._Size);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get Id() {
    return this._hasId ? this._Id : JsonToString.default;
  }
  get hasId() {
    return this._hasId;
  }
  setId(path, value) {
    return {type: 'SET', path: path.concat(['Id']), value};
  }
  deleteId(path) {
    return {type: 'DELETE', path: path.concat(['Id'])};
  }
  /**
   * @returns {FVector2}
   */
  get Center() {
    return this._hasCenter ? this._Center : FVector2.default;
  }
  get hasCenter() {
    return this._hasCenter;
  }
  setCenter(path, value) {
    return {type: 'SET', path: path.concat(['Center']), value: value.toJson()};
  }
  deleteCenter(path) {
    return {type: 'DELETE', path: path.concat(['Center'])};
  }
  /**
   * @returns {FVector2}
   */
  get StartPoint() {
    return this._hasStartPoint ? this._StartPoint : FVector2.default;
  }
  get hasStartPoint() {
    return this._hasStartPoint;
  }
  setStartPoint(path, value) {
    return {type: 'SET', path: path.concat(['StartPoint']), value: value.toJson()};
  }
  deleteStartPoint(path) {
    return {type: 'DELETE', path: path.concat(['StartPoint'])};
  }
  /**
   * @returns {FVector2}
   */
  get Size() {
    return this._hasSize ? this._Size : FVector2.default;
  }
  get hasSize() {
    return this._hasSize;
  }
  setSize(path, value) {
    return {type: 'SET', path: path.concat(['Size']), value: value.toJson()};
  }
  deleteSize(path) {
    return {type: 'DELETE', path: path.concat(['Size'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "Id": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDefinition(this);
              copy._hasId = true;
              copy._Id = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasId) {
                return this;
              }
              const copy = new TerrainChunkDefinition(this);
              copy._hasId = false;
              copy._Id = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Center": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDefinition(this);
              copy._hasCenter = true;
              copy._Center = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCenter) {
                return this;
              }
              const copy = new TerrainChunkDefinition(this);
              copy._hasCenter = false;
              copy._Center = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCenter) {
            const copy = new TerrainChunkDefinition(this);
            copy._hasCenter = true;
            copy._Center = FVector2.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._Center.apply(type, path.slice(1), value);
          if (newValue === this._Center) {
            return this;
          }
          const copy = new TerrainChunkDefinition(this);
          copy._Center = copy._Center.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "StartPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDefinition(this);
              copy._hasStartPoint = true;
              copy._StartPoint = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartPoint) {
                return this;
              }
              const copy = new TerrainChunkDefinition(this);
              copy._hasStartPoint = false;
              copy._StartPoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStartPoint) {
            const copy = new TerrainChunkDefinition(this);
            copy._hasStartPoint = true;
            copy._StartPoint = FVector2.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._StartPoint.apply(type, path.slice(1), value);
          if (newValue === this._StartPoint) {
            return this;
          }
          const copy = new TerrainChunkDefinition(this);
          copy._StartPoint = copy._StartPoint.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "Size": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TerrainChunkDefinition(this);
              copy._hasSize = true;
              copy._Size = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSize) {
                return this;
              }
              const copy = new TerrainChunkDefinition(this);
              copy._hasSize = false;
              copy._Size = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSize) {
            const copy = new TerrainChunkDefinition(this);
            copy._hasSize = true;
            copy._Size = FVector2.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._Size.apply(type, path.slice(1), value);
          if (newValue === this._Size) {
            return this;
          }
          const copy = new TerrainChunkDefinition(this);
          copy._Size = copy._Size.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TerrainChunkDefinition} other
   * @returns {TerrainChunkDefinition}
   */
  merge(other) {
    const copy = new TerrainChunkDefinition(this);
    if (other._hasId) {
      copy._hasId = true;
      copy._Id = other._Id;
    }
    if (other._hasCenter) {
      if (copy._hasCenter) {
        copy._Center = copy.Center.merge(other.Center);
      } else {
        copy._Center = other._Center;
      }
      copy._hasCenter = true;
    }
    if (other._hasStartPoint) {
      if (copy._hasStartPoint) {
        copy._StartPoint = copy.StartPoint.merge(other.StartPoint);
      } else {
        copy._StartPoint = other._StartPoint;
      }
      copy._hasStartPoint = true;
    }
    if (other._hasSize) {
      if (copy._hasSize) {
        copy._Size = copy.Size.merge(other.Size);
      } else {
        copy._Size = other._Size;
      }
      copy._hasSize = true;
    }
    return copy;
  }
}
TerrainChunkDefinition.default = new TerrainChunkDefinition();
class TerrainChunkDefinition_Builder {
  constructor(value) {
    this._value = new TerrainChunkDefinition(value);
  }
  build() {
    return new TerrainChunkDefinition(this._value);
  }
  setId(value) {
    this._value._hasId = true;
    this._value._Id = value;
    return this;
  }
  deleteId() {
    this._value._hasId = false;
    this._value._Id = null;
    return this;
  }
  setCenter(value) {
    this._value._hasCenter = true;
    this._value._Center = value;
    return this;
  }
  deleteCenter() {
    this._value._hasCenter = false;
    this._value._Center = null;
    return this;
  }
  setStartPoint(value) {
    this._value._hasStartPoint = true;
    this._value._StartPoint = value;
    return this;
  }
  deleteStartPoint() {
    this._value._hasStartPoint = false;
    this._value._StartPoint = null;
    return this;
  }
  setSize(value) {
    this._value._hasSize = true;
    this._value._Size = value;
    return this;
  }
  deleteSize() {
    this._value._hasSize = false;
    this._value._Size = null;
    return this;
  }
}
TerrainChunkDefinition.Builder = TerrainChunkDefinition_Builder;
class TerrainChunkDefinition_WithParent {
  /**
   * @param {TerrainChunkDefinition} value
   * @param {TerrainChunkDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TerrainChunkDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasId() {
    if (this._cachedHasId === undefined) {
      if (this._value.hasId) {
        this._cachedHasId = true;
      } else {
        this._cachedHasId = this._parent ? this._parent.hasId : false;
      }
    }
    return this._cachedHasId;
  }
  get Id() {
    if (this._cachedId === undefined) {
      if (this._value.hasId) {
        this._cachedId = this._value.Id;
      } else {
        this._cachedId = this._parent ? this._parent.Id : this._value.Id;
      }
    }
    return this._cachedId;
  }
  get hasCenter() {
    if (this._cachedHasCenter === undefined) {
      if (this._value.hasCenter) {
        this._cachedHasCenter = true;
      } else {
        this._cachedHasCenter = this._parent ? this._parent.hasCenter : false;
      }
    }
    return this._cachedHasCenter;
  }
  get Center() {
    if (!this._cachedCenter) {
      if (this._value.hasCenter) {
        this._cachedCenter = new FVector2.WithParent(this._value.Center, this._parent && this._parent.hasCenter ? this._parent.Center : null);
      } else {
        this._cachedCenter = this._parent ? new FVector2.WithParent(FVector2.default, this._parent.Center) : FVector2.WithParent.default;
      }
    }
    return this._cachedCenter;
  }
  get hasStartPoint() {
    if (this._cachedHasStartPoint === undefined) {
      if (this._value.hasStartPoint) {
        this._cachedHasStartPoint = true;
      } else {
        this._cachedHasStartPoint = this._parent ? this._parent.hasStartPoint : false;
      }
    }
    return this._cachedHasStartPoint;
  }
  get StartPoint() {
    if (!this._cachedStartPoint) {
      if (this._value.hasStartPoint) {
        this._cachedStartPoint = new FVector2.WithParent(this._value.StartPoint, this._parent && this._parent.hasStartPoint ? this._parent.StartPoint : null);
      } else {
        this._cachedStartPoint = this._parent ? new FVector2.WithParent(FVector2.default, this._parent.StartPoint) : FVector2.WithParent.default;
      }
    }
    return this._cachedStartPoint;
  }
  get hasSize() {
    if (this._cachedHasSize === undefined) {
      if (this._value.hasSize) {
        this._cachedHasSize = true;
      } else {
        this._cachedHasSize = this._parent ? this._parent.hasSize : false;
      }
    }
    return this._cachedHasSize;
  }
  get Size() {
    if (!this._cachedSize) {
      if (this._value.hasSize) {
        this._cachedSize = new FVector2.WithParent(this._value.Size, this._parent && this._parent.hasSize ? this._parent.Size : null);
      } else {
        this._cachedSize = this._parent ? new FVector2.WithParent(FVector2.default, this._parent.Size) : FVector2.WithParent.default;
      }
    }
    return this._cachedSize;
  }
  update(current, parent) {
    const result = new TerrainChunkDefinition_WithParent(current, parent);
    if (this._cachedCenter && this._value.hasCenter && current.hasCenter) {
      if (this._value.Center === current.Center && this._parent === parent) {
        result._cachedCenter = this._cachedCenter;
      } else {
        result._cachedCenter = this._cachedCenter.update(current.Center, parent && parent.hasCenter ? parent.Center : null);
      }
    }
    if (this._cachedStartPoint && this._value.hasStartPoint && current.hasStartPoint) {
      if (this._value.StartPoint === current.StartPoint && this._parent === parent) {
        result._cachedStartPoint = this._cachedStartPoint;
      } else {
        result._cachedStartPoint = this._cachedStartPoint.update(current.StartPoint, parent && parent.hasStartPoint ? parent.StartPoint : null);
      }
    }
    if (this._cachedSize && this._value.hasSize && current.hasSize) {
      if (this._value.Size === current.Size && this._parent === parent) {
        result._cachedSize = this._cachedSize;
      } else {
        result._cachedSize = this._cachedSize.update(current.Size, parent && parent.hasSize ? parent.Size : null);
      }
    }
    return result;
  }
}
TerrainChunkDefinition_WithParent.default = new TerrainChunkDefinition_WithParent(TerrainChunkDefinition.default, null);
TerrainChunkDefinition.WithParent = TerrainChunkDefinition_WithParent;
class TerrainChunkDefinition_Descriptor {
  get Id() {
    if (!this._Id) {
      this._Id = {
        name: "Id",
        Name: "Id",
        number: 1,
        protoType: 9,
        protoName: "Id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Id;
  }
  get Center() {
    if (!this._Center) {
      this._Center = {
        name: "Center",
        Name: "Center",
        number: 2,
        protoType: 11,
        protoName: "Center",
        type: FVector2,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Center;
  }
  get StartPoint() {
    if (!this._StartPoint) {
      this._StartPoint = {
        name: "StartPoint",
        Name: "StartPoint",
        number: 3,
        protoType: 11,
        protoName: "StartPoint",
        type: FVector2,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._StartPoint;
  }
  get Size() {
    if (!this._Size) {
      this._Size = {
        name: "Size",
        Name: "Size",
        number: 4,
        protoType: 11,
        protoName: "Size",
        type: FVector2,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Size;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.Id,
        this.Center,
        this.StartPoint,
        this.Size,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForId",
        Name: "DummyOneofForId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCenter",
        Name: "DummyOneofForCenter",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartPoint",
        Name: "DummyOneofForStartPoint",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSize",
        Name: "DummyOneofForSize",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TerrainChunkDefinition.descriptor = new TerrainChunkDefinition_Descriptor();
export class UndoableNodeData {
  get descriptor() {
    return UndoableNodeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSize = false;
    this._size = null;
    this._hasCurvature = false;
    this._curvature = null;
    this._hasIsCurveCenter = false;
    this._isCurveCenter = null;
    this._position = [];
    this._hasTexBlend = false;
    this._texBlend = null;
  }
  isEmpty() {
    if (this._hasSize) return false;
    if (this._hasCurvature) return false;
    if (this._hasIsCurveCenter) return false;
    if (this._position.length > 0) return false;
    if (this._hasTexBlend) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableNodeData) {
      return value;
    }
    return UndoableNodeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableNodeData();
    if (json.size != null) {
      result._hasSize = true;
      result._size = JsonToDouble.fromJson(json.size);
    }
    if (json.curvature != null) {
      result._hasCurvature = true;
      result._curvature = JsonToDouble.fromJson(json.curvature);
    }
    if (json.isCurveCenter != null) {
      result._hasIsCurveCenter = true;
      result._isCurveCenter = JsonToBoolean.fromJson(json.isCurveCenter);
    }
    result._position = JsonToList(json.position, JsonToDouble);
    if (json.texBlend != null) {
      result._hasTexBlend = true;
      result._texBlend = JsonToDouble.fromJson(json.texBlend);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSize) {
      result.size = JsonToDouble.toJson(this._size);
    }
    if (this._hasCurvature) {
      result.curvature = JsonToDouble.toJson(this._curvature);
    }
    if (this._hasIsCurveCenter) {
      result.isCurveCenter = JsonToBoolean.toJson(this._isCurveCenter);
    }
    if (this._position.length > 0) {
      result.position = ArrayToJson(this._position, JsonToDouble);
    }
    if (this._hasTexBlend) {
      result.texBlend = JsonToDouble.toJson(this._texBlend);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get size() {
    return this._hasSize ? this._size : JsonToDouble.default;
  }
  get hasSize() {
    return this._hasSize;
  }
  setSize(path, value) {
    return {type: 'SET', path: path.concat(['size']), value};
  }
  deleteSize(path) {
    return {type: 'DELETE', path: path.concat(['size'])};
  }
  /**
   * @returns {number}
   */
  get curvature() {
    return this._hasCurvature ? this._curvature : JsonToDouble.default;
  }
  get hasCurvature() {
    return this._hasCurvature;
  }
  setCurvature(path, value) {
    return {type: 'SET', path: path.concat(['curvature']), value};
  }
  deleteCurvature(path) {
    return {type: 'DELETE', path: path.concat(['curvature'])};
  }
  /**
   * @returns {boolean}
   */
  get isCurveCenter() {
    return this._hasIsCurveCenter ? this._isCurveCenter : JsonToBoolean.default;
  }
  get hasIsCurveCenter() {
    return this._hasIsCurveCenter;
  }
  setIsCurveCenter(path, value) {
    return {type: 'SET', path: path.concat(['isCurveCenter']), value};
  }
  deleteIsCurveCenter(path) {
    return {type: 'DELETE', path: path.concat(['isCurveCenter'])};
  }
  /**
   * @returns {number[]}
   */
  get position() {
    return this._position;
  }
  addPosition(path, value) {
    return {type: 'ADD', path: path.concat(['position']), value};
  }
  setPosition(path, value) {
    return {type: 'SET', path: path.concat(['position']), value: ArrayToJson(value, JsonToDouble)};
  }
  setPositionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['position', key]), value};
  }
  deletePosition(path) {
    return {type: 'DELETE', path: path.concat(['position'])};
  }
  deletePositionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['position', key])};
  }
  /**
   * @returns {number}
   */
  get texBlend() {
    return this._hasTexBlend ? this._texBlend : JsonToDouble.default;
  }
  get hasTexBlend() {
    return this._hasTexBlend;
  }
  setTexBlend(path, value) {
    return {type: 'SET', path: path.concat(['texBlend']), value};
  }
  deleteTexBlend(path) {
    return {type: 'DELETE', path: path.concat(['texBlend'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "size": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._hasSize = true;
              copy._size = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSize) {
                return this;
              }
              const copy = new UndoableNodeData(this);
              copy._hasSize = false;
              copy._size = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "curvature": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._hasCurvature = true;
              copy._curvature = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurvature) {
                return this;
              }
              const copy = new UndoableNodeData(this);
              copy._hasCurvature = false;
              copy._curvature = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isCurveCenter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._hasIsCurveCenter = true;
              copy._isCurveCenter = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsCurveCenter) {
                return this;
              }
              const copy = new UndoableNodeData(this);
              copy._hasIsCurveCenter = false;
              copy._isCurveCenter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "position": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._position = [];        for (let i of value) {
                copy._position.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UndoableNodeData(this);
              copy._position = copy._position.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._position.length === 0) {
                return this;
              }
              const copy = new UndoableNodeData(this);
              copy._position = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._position.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._position = copy._position.slice();
              copy._position[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UndoableNodeData(this);
              copy._position = copy._position.slice(0, path[1]).concat(copy._position.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._position.length) {
            return this;
          }
          const oldValue = this._position[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableNodeData(this);
          copy._position = copy._position.slice();
          copy._position[key] = newValue;
          return copy;
        }
      }
      case "texBlend": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableNodeData(this);
              copy._hasTexBlend = true;
              copy._texBlend = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTexBlend) {
                return this;
              }
              const copy = new UndoableNodeData(this);
              copy._hasTexBlend = false;
              copy._texBlend = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableNodeData} other
   * @returns {UndoableNodeData}
   */
  merge(other) {
    const copy = new UndoableNodeData(this);
    if (other._hasSize) {
      copy._hasSize = true;
      copy._size = other._size;
    }
    if (other._hasCurvature) {
      copy._hasCurvature = true;
      copy._curvature = other._curvature;
    }
    if (other._hasIsCurveCenter) {
      copy._hasIsCurveCenter = true;
      copy._isCurveCenter = other._isCurveCenter;
    }
    copy._position = this._position.concat(other._position);
    if (other._hasTexBlend) {
      copy._hasTexBlend = true;
      copy._texBlend = other._texBlend;
    }
    return copy;
  }
}
UndoableNodeData.default = new UndoableNodeData();
class UndoableNodeData_Builder {
  constructor(value) {
    this._value = new UndoableNodeData(value);
  }
  build() {
    return new UndoableNodeData(this._value);
  }
  setSize(value) {
    this._value._hasSize = true;
    this._value._size = value;
    return this;
  }
  deleteSize() {
    this._value._hasSize = false;
    this._value._size = null;
    return this;
  }
  setCurvature(value) {
    this._value._hasCurvature = true;
    this._value._curvature = value;
    return this;
  }
  deleteCurvature() {
    this._value._hasCurvature = false;
    this._value._curvature = null;
    return this;
  }
  setIsCurveCenter(value) {
    this._value._hasIsCurveCenter = true;
    this._value._isCurveCenter = value;
    return this;
  }
  deleteIsCurveCenter() {
    this._value._hasIsCurveCenter = false;
    this._value._isCurveCenter = null;
    return this;
  }
  addAllPosition(values) {
    this._value._position = this._value._position.concat(values);
    return this;
  }
  addPosition(value) {
    this._value._position = this._value._position.concat([value]);
    return this;
  }
  setPosition(index, value) {
    this._value._position = this._value._position.concat();
    this._value._position[index] = value;
    return this;
  }
  clearPosition() {
    this._value._position = [];
    return this;
  }
  setTexBlend(value) {
    this._value._hasTexBlend = true;
    this._value._texBlend = value;
    return this;
  }
  deleteTexBlend() {
    this._value._hasTexBlend = false;
    this._value._texBlend = null;
    return this;
  }
}
UndoableNodeData.Builder = UndoableNodeData_Builder;
class UndoableNodeData_WithParent {
  /**
   * @param {UndoableNodeData} value
   * @param {UndoableNodeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableNodeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSize() {
    if (this._cachedHasSize === undefined) {
      if (this._value.hasSize) {
        this._cachedHasSize = true;
      } else {
        this._cachedHasSize = this._parent ? this._parent.hasSize : false;
      }
    }
    return this._cachedHasSize;
  }
  get size() {
    if (this._cachedSize === undefined) {
      if (this._value.hasSize) {
        this._cachedSize = this._value.size;
      } else {
        this._cachedSize = this._parent ? this._parent.size : this._value.size;
      }
    }
    return this._cachedSize;
  }
  get hasCurvature() {
    if (this._cachedHasCurvature === undefined) {
      if (this._value.hasCurvature) {
        this._cachedHasCurvature = true;
      } else {
        this._cachedHasCurvature = this._parent ? this._parent.hasCurvature : false;
      }
    }
    return this._cachedHasCurvature;
  }
  get curvature() {
    if (this._cachedCurvature === undefined) {
      if (this._value.hasCurvature) {
        this._cachedCurvature = this._value.curvature;
      } else {
        this._cachedCurvature = this._parent ? this._parent.curvature : this._value.curvature;
      }
    }
    return this._cachedCurvature;
  }
  get hasIsCurveCenter() {
    if (this._cachedHasIsCurveCenter === undefined) {
      if (this._value.hasIsCurveCenter) {
        this._cachedHasIsCurveCenter = true;
      } else {
        this._cachedHasIsCurveCenter = this._parent ? this._parent.hasIsCurveCenter : false;
      }
    }
    return this._cachedHasIsCurveCenter;
  }
  get isCurveCenter() {
    if (this._cachedIsCurveCenter === undefined) {
      if (this._value.hasIsCurveCenter) {
        this._cachedIsCurveCenter = this._value.isCurveCenter;
      } else {
        this._cachedIsCurveCenter = this._parent ? this._parent.isCurveCenter : this._value.isCurveCenter;
      }
    }
    return this._cachedIsCurveCenter;
  }
  get selfPosition() {
    return this._value.position;
  }
  get inherentPosition() {
    if (!this._inherentPosition) {
      this._inherentPosition = this._parent ? this._parent.position : [];
    }
    return this._inherentPosition;
  }
  get position() {
    if (!this._allPosition) {
      this._allPosition = this._parent ? this._parent.position.concat(this.selfPosition) : this.selfPosition;
    }
    return this._allPosition;
  }
  get hasTexBlend() {
    if (this._cachedHasTexBlend === undefined) {
      if (this._value.hasTexBlend) {
        this._cachedHasTexBlend = true;
      } else {
        this._cachedHasTexBlend = this._parent ? this._parent.hasTexBlend : false;
      }
    }
    return this._cachedHasTexBlend;
  }
  get texBlend() {
    if (this._cachedTexBlend === undefined) {
      if (this._value.hasTexBlend) {
        this._cachedTexBlend = this._value.texBlend;
      } else {
        this._cachedTexBlend = this._parent ? this._parent.texBlend : this._value.texBlend;
      }
    }
    return this._cachedTexBlend;
  }
  update(current, parent) {
    const result = new UndoableNodeData_WithParent(current, parent);
    return result;
  }
}
UndoableNodeData_WithParent.default = new UndoableNodeData_WithParent(UndoableNodeData.default, null);
UndoableNodeData.WithParent = UndoableNodeData_WithParent;
class UndoableNodeData_Descriptor {
  get size() {
    if (!this._size) {
      this._size = {
        name: "size",
        Name: "Size",
        number: 1,
        protoType: 1,
        protoName: "size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._size;
  }
  get curvature() {
    if (!this._curvature) {
      this._curvature = {
        name: "curvature",
        Name: "Curvature",
        number: 2,
        protoType: 1,
        protoName: "curvature",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._curvature;
  }
  get isCurveCenter() {
    if (!this._isCurveCenter) {
      this._isCurveCenter = {
        name: "isCurveCenter",
        Name: "IsCurveCenter",
        number: 3,
        protoType: 8,
        protoName: "is_curve_center",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isCurveCenter;
  }
  get position() {
    if (!this._position) {
      this._position = {
        name: "position",
        Name: "Position",
        number: 4,
        protoType: 1,
        protoName: "position",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._position;
  }
  get texBlend() {
    if (!this._texBlend) {
      this._texBlend = {
        name: "texBlend",
        Name: "TexBlend",
        number: 5,
        protoType: 1,
        protoName: "tex_blend",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._texBlend;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.size,
        this.curvature,
        this.isCurveCenter,
        this.position,
        this.texBlend,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSize",
        Name: "DummyOneofForSize",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurvature",
        Name: "DummyOneofForCurvature",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsCurveCenter",
        Name: "DummyOneofForIsCurveCenter",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTexBlend",
        Name: "DummyOneofForTexBlend",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableNodeData.descriptor = new UndoableNodeData_Descriptor();
export class UndoableEdgeData {
  get descriptor() {
    return UndoableEdgeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStartNode = false;
    this._startNode = null;
    this._hasEndNode = false;
    this._endNode = null;
    this._hasTwinEdge = false;
    this._twinEdge = null;
  }
  isEmpty() {
    if (this._hasStartNode) return false;
    if (this._hasEndNode) return false;
    if (this._hasTwinEdge) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableEdgeData) {
      return value;
    }
    return UndoableEdgeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableEdgeData();
    if (json.startNode != null) {
      result._hasStartNode = true;
      result._startNode = JsonToString.fromJson(json.startNode);
    }
    if (json.endNode != null) {
      result._hasEndNode = true;
      result._endNode = JsonToString.fromJson(json.endNode);
    }
    if (json.twinEdge != null) {
      result._hasTwinEdge = true;
      result._twinEdge = JsonToString.fromJson(json.twinEdge);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStartNode) {
      result.startNode = JsonToString.toJson(this._startNode);
    }
    if (this._hasEndNode) {
      result.endNode = JsonToString.toJson(this._endNode);
    }
    if (this._hasTwinEdge) {
      result.twinEdge = JsonToString.toJson(this._twinEdge);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get startNode() {
    return this._hasStartNode ? this._startNode : JsonToString.default;
  }
  get hasStartNode() {
    return this._hasStartNode;
  }
  setStartNode(path, value) {
    return {type: 'SET', path: path.concat(['startNode']), value};
  }
  deleteStartNode(path) {
    return {type: 'DELETE', path: path.concat(['startNode'])};
  }
  /**
   * @returns {string}
   */
  get endNode() {
    return this._hasEndNode ? this._endNode : JsonToString.default;
  }
  get hasEndNode() {
    return this._hasEndNode;
  }
  setEndNode(path, value) {
    return {type: 'SET', path: path.concat(['endNode']), value};
  }
  deleteEndNode(path) {
    return {type: 'DELETE', path: path.concat(['endNode'])};
  }
  /**
   * @returns {string}
   */
  get twinEdge() {
    return this._hasTwinEdge ? this._twinEdge : JsonToString.default;
  }
  get hasTwinEdge() {
    return this._hasTwinEdge;
  }
  setTwinEdge(path, value) {
    return {type: 'SET', path: path.concat(['twinEdge']), value};
  }
  deleteTwinEdge(path) {
    return {type: 'DELETE', path: path.concat(['twinEdge'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "startNode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableEdgeData(this);
              copy._hasStartNode = true;
              copy._startNode = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartNode) {
                return this;
              }
              const copy = new UndoableEdgeData(this);
              copy._hasStartNode = false;
              copy._startNode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "endNode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableEdgeData(this);
              copy._hasEndNode = true;
              copy._endNode = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndNode) {
                return this;
              }
              const copy = new UndoableEdgeData(this);
              copy._hasEndNode = false;
              copy._endNode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "twinEdge": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableEdgeData(this);
              copy._hasTwinEdge = true;
              copy._twinEdge = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTwinEdge) {
                return this;
              }
              const copy = new UndoableEdgeData(this);
              copy._hasTwinEdge = false;
              copy._twinEdge = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableEdgeData} other
   * @returns {UndoableEdgeData}
   */
  merge(other) {
    const copy = new UndoableEdgeData(this);
    if (other._hasStartNode) {
      copy._hasStartNode = true;
      copy._startNode = other._startNode;
    }
    if (other._hasEndNode) {
      copy._hasEndNode = true;
      copy._endNode = other._endNode;
    }
    if (other._hasTwinEdge) {
      copy._hasTwinEdge = true;
      copy._twinEdge = other._twinEdge;
    }
    return copy;
  }
}
UndoableEdgeData.default = new UndoableEdgeData();
class UndoableEdgeData_Builder {
  constructor(value) {
    this._value = new UndoableEdgeData(value);
  }
  build() {
    return new UndoableEdgeData(this._value);
  }
  setStartNode(value) {
    this._value._hasStartNode = true;
    this._value._startNode = value;
    return this;
  }
  deleteStartNode() {
    this._value._hasStartNode = false;
    this._value._startNode = null;
    return this;
  }
  setEndNode(value) {
    this._value._hasEndNode = true;
    this._value._endNode = value;
    return this;
  }
  deleteEndNode() {
    this._value._hasEndNode = false;
    this._value._endNode = null;
    return this;
  }
  setTwinEdge(value) {
    this._value._hasTwinEdge = true;
    this._value._twinEdge = value;
    return this;
  }
  deleteTwinEdge() {
    this._value._hasTwinEdge = false;
    this._value._twinEdge = null;
    return this;
  }
}
UndoableEdgeData.Builder = UndoableEdgeData_Builder;
class UndoableEdgeData_WithParent {
  /**
   * @param {UndoableEdgeData} value
   * @param {UndoableEdgeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableEdgeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStartNode() {
    if (this._cachedHasStartNode === undefined) {
      if (this._value.hasStartNode) {
        this._cachedHasStartNode = true;
      } else {
        this._cachedHasStartNode = this._parent ? this._parent.hasStartNode : false;
      }
    }
    return this._cachedHasStartNode;
  }
  get startNode() {
    if (this._cachedStartNode === undefined) {
      if (this._value.hasStartNode) {
        this._cachedStartNode = this._value.startNode;
      } else {
        this._cachedStartNode = this._parent ? this._parent.startNode : this._value.startNode;
      }
    }
    return this._cachedStartNode;
  }
  get hasEndNode() {
    if (this._cachedHasEndNode === undefined) {
      if (this._value.hasEndNode) {
        this._cachedHasEndNode = true;
      } else {
        this._cachedHasEndNode = this._parent ? this._parent.hasEndNode : false;
      }
    }
    return this._cachedHasEndNode;
  }
  get endNode() {
    if (this._cachedEndNode === undefined) {
      if (this._value.hasEndNode) {
        this._cachedEndNode = this._value.endNode;
      } else {
        this._cachedEndNode = this._parent ? this._parent.endNode : this._value.endNode;
      }
    }
    return this._cachedEndNode;
  }
  get hasTwinEdge() {
    if (this._cachedHasTwinEdge === undefined) {
      if (this._value.hasTwinEdge) {
        this._cachedHasTwinEdge = true;
      } else {
        this._cachedHasTwinEdge = this._parent ? this._parent.hasTwinEdge : false;
      }
    }
    return this._cachedHasTwinEdge;
  }
  get twinEdge() {
    if (this._cachedTwinEdge === undefined) {
      if (this._value.hasTwinEdge) {
        this._cachedTwinEdge = this._value.twinEdge;
      } else {
        this._cachedTwinEdge = this._parent ? this._parent.twinEdge : this._value.twinEdge;
      }
    }
    return this._cachedTwinEdge;
  }
  update(current, parent) {
    const result = new UndoableEdgeData_WithParent(current, parent);
    return result;
  }
}
UndoableEdgeData_WithParent.default = new UndoableEdgeData_WithParent(UndoableEdgeData.default, null);
UndoableEdgeData.WithParent = UndoableEdgeData_WithParent;
class UndoableEdgeData_Descriptor {
  get startNode() {
    if (!this._startNode) {
      this._startNode = {
        name: "startNode",
        Name: "StartNode",
        number: 1,
        protoType: 9,
        protoName: "start_node",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startNode;
  }
  get endNode() {
    if (!this._endNode) {
      this._endNode = {
        name: "endNode",
        Name: "EndNode",
        number: 2,
        protoType: 9,
        protoName: "end_node",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._endNode;
  }
  get twinEdge() {
    if (!this._twinEdge) {
      this._twinEdge = {
        name: "twinEdge",
        Name: "TwinEdge",
        number: 3,
        protoType: 9,
        protoName: "twin_edge",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._twinEdge;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.startNode,
        this.endNode,
        this.twinEdge,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartNode",
        Name: "DummyOneofForStartNode",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndNode",
        Name: "DummyOneofForEndNode",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTwinEdge",
        Name: "DummyOneofForTwinEdge",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableEdgeData.descriptor = new UndoableEdgeData_Descriptor();
class UndoableRoadData_RoadNodesEntry {
  get descriptor() {
    return UndoableRoadData_RoadNodesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRoadData_RoadNodesEntry) {
      return value;
    }
    return UndoableRoadData_RoadNodesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRoadData_RoadNodesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableNodeData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableNodeData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableNodeData}
   */
  get value() {
    return this._hasValue ? this._value : UndoableNodeData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData_RoadNodesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableRoadData_RoadNodesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData_RoadNodesEntry(this);
              copy._hasValue = true;
              copy._value = UndoableNodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableRoadData_RoadNodesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableRoadData_RoadNodesEntry(this);
            copy._hasValue = true;
            copy._value = UndoableNodeData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableRoadData_RoadNodesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRoadData_RoadNodesEntry} other
   * @returns {UndoableRoadData_RoadNodesEntry}
   */
  merge(other) {
    const copy = new UndoableRoadData_RoadNodesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableRoadData_RoadNodesEntry.default = new UndoableRoadData_RoadNodesEntry();
class UndoableRoadData_RoadNodesEntry_Builder {
  constructor(value) {
    this._value = new UndoableRoadData_RoadNodesEntry(value);
  }
  build() {
    return new UndoableRoadData_RoadNodesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableRoadData_RoadNodesEntry.Builder = UndoableRoadData_RoadNodesEntry_Builder;
class UndoableRoadData_RoadNodesEntry_WithParent {
  /**
   * @param {UndoableRoadData_RoadNodesEntry} value
   * @param {UndoableRoadData_RoadNodesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRoadData_RoadNodesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableNodeData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableNodeData.WithParent(UndoableNodeData.default, this._parent.value) : UndoableNodeData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableRoadData_RoadNodesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableRoadData_RoadNodesEntry_WithParent.default = new UndoableRoadData_RoadNodesEntry_WithParent(UndoableRoadData_RoadNodesEntry.default, null);
UndoableRoadData_RoadNodesEntry.WithParent = UndoableRoadData_RoadNodesEntry_WithParent;
class UndoableRoadData_RoadNodesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableNodeData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableRoadData_RoadNodesEntry.descriptor = new UndoableRoadData_RoadNodesEntry_Descriptor();
class UndoableRoadData_EdgesEntry {
  get descriptor() {
    return UndoableRoadData_EdgesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRoadData_EdgesEntry) {
      return value;
    }
    return UndoableRoadData_EdgesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRoadData_EdgesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableEdgeData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableEdgeData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableEdgeData}
   */
  get value() {
    return this._hasValue ? this._value : UndoableEdgeData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData_EdgesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableRoadData_EdgesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData_EdgesEntry(this);
              copy._hasValue = true;
              copy._value = UndoableEdgeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableRoadData_EdgesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableRoadData_EdgesEntry(this);
            copy._hasValue = true;
            copy._value = UndoableEdgeData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableRoadData_EdgesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRoadData_EdgesEntry} other
   * @returns {UndoableRoadData_EdgesEntry}
   */
  merge(other) {
    const copy = new UndoableRoadData_EdgesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableRoadData_EdgesEntry.default = new UndoableRoadData_EdgesEntry();
class UndoableRoadData_EdgesEntry_Builder {
  constructor(value) {
    this._value = new UndoableRoadData_EdgesEntry(value);
  }
  build() {
    return new UndoableRoadData_EdgesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableRoadData_EdgesEntry.Builder = UndoableRoadData_EdgesEntry_Builder;
class UndoableRoadData_EdgesEntry_WithParent {
  /**
   * @param {UndoableRoadData_EdgesEntry} value
   * @param {UndoableRoadData_EdgesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRoadData_EdgesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableEdgeData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableEdgeData.WithParent(UndoableEdgeData.default, this._parent.value) : UndoableEdgeData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableRoadData_EdgesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableRoadData_EdgesEntry_WithParent.default = new UndoableRoadData_EdgesEntry_WithParent(UndoableRoadData_EdgesEntry.default, null);
UndoableRoadData_EdgesEntry.WithParent = UndoableRoadData_EdgesEntry_WithParent;
class UndoableRoadData_EdgesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableEdgeData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableRoadData_EdgesEntry.descriptor = new UndoableRoadData_EdgesEntry_Descriptor();
export class UndoableRoadData {
  get descriptor() {
    return UndoableRoadData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._roadNodes = {};
    this._edges = {};
    this._hasDisableProjectToTerrain = false;
    this._disableProjectToTerrain = null;
  }
  isEmpty() {
    if (Object.keys(this._roadNodes).length > 0) return false;
    if (Object.keys(this._edges).length > 0) return false;
    if (this._hasDisableProjectToTerrain) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRoadData) {
      return value;
    }
    return UndoableRoadData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRoadData();
    result._roadNodes = JsonToMap(json.roadNodes, JsonToString, UndoableNodeData);
    result._edges = JsonToMap(json.edges, JsonToString, UndoableEdgeData);
    if (json.disableProjectToTerrain != null) {
      result._hasDisableProjectToTerrain = true;
      result._disableProjectToTerrain = JsonToBoolean.fromJson(json.disableProjectToTerrain);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._roadNodes).length > 0) {
      result.roadNodes = MapToJson(this._roadNodes, JsonToString, UndoableNodeData);
    }
    if (Object.keys(this._edges).length > 0) {
      result.edges = MapToJson(this._edges, JsonToString, UndoableEdgeData);
    }
    if (this._hasDisableProjectToTerrain) {
      result.disableProjectToTerrain = JsonToBoolean.toJson(this._disableProjectToTerrain);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoableNodeData>}
   */
  get roadNodes() {
    return this._roadNodes;
  }
  setRoadNodes(path, value) {
    return {type: 'SET', path: path.concat(['roadNodes']), value: MapToJson(value, JsonToString, UndoableNodeData)};
  }
  setRoadNodesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['roadNodes', key]), value: value.toJson()};
  }
  deleteRoadNodes(path) {
    return {type: 'DELETE', path: path.concat(['roadNodes'])};
  }
  deleteRoadNodesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['roadNodes', key])};
  }
  /**
   * @returns {Object<string, UndoableEdgeData>}
   */
  get edges() {
    return this._edges;
  }
  setEdges(path, value) {
    return {type: 'SET', path: path.concat(['edges']), value: MapToJson(value, JsonToString, UndoableEdgeData)};
  }
  setEdgesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['edges', key]), value: value.toJson()};
  }
  deleteEdges(path) {
    return {type: 'DELETE', path: path.concat(['edges'])};
  }
  deleteEdgesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['edges', key])};
  }
  /**
   * @returns {boolean}
   */
  get disableProjectToTerrain() {
    return this._hasDisableProjectToTerrain ? this._disableProjectToTerrain : JsonToBoolean.default;
  }
  get hasDisableProjectToTerrain() {
    return this._hasDisableProjectToTerrain;
  }
  setDisableProjectToTerrain(path, value) {
    return {type: 'SET', path: path.concat(['disableProjectToTerrain']), value};
  }
  deleteDisableProjectToTerrain(path) {
    return {type: 'DELETE', path: path.concat(['disableProjectToTerrain'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "roadNodes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._roadNodes).length === 0) {
                return this;
              }
              const copy = new UndoableRoadData(this);
              copy._roadNodes = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableRoadData(this);
              copy._roadNodes = {};
              for (let key in value) {
                copy._roadNodes[key] = UndoableNodeData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData(this);
              copy._roadNodes = {...copy._roadNodes};
              copy._roadNodes[path[1]] = UndoableNodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._roadNodes[path[1]]) {
                return this;
              }
              const copy = new UndoableRoadData(this);
              copy._roadNodes = {...copy._roadNodes};
              delete copy._roadNodes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._roadNodes[key] === undefined) {
            const copy = new UndoableRoadData(this);
            copy._roadNodes = {...copy._roadNodes};
            copy._roadNodes[key] = UndoableNodeData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._roadNodes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableRoadData(this);
          copy._roadNodes = {...copy._roadNodes};
          copy._roadNodes[key] = newValue;
          return copy;
        }
      }
      case "edges": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._edges).length === 0) {
                return this;
              }
              const copy = new UndoableRoadData(this);
              copy._edges = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableRoadData(this);
              copy._edges = {};
              for (let key in value) {
                copy._edges[key] = UndoableEdgeData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData(this);
              copy._edges = {...copy._edges};
              copy._edges[path[1]] = UndoableEdgeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._edges[path[1]]) {
                return this;
              }
              const copy = new UndoableRoadData(this);
              copy._edges = {...copy._edges};
              delete copy._edges[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._edges[key] === undefined) {
            const copy = new UndoableRoadData(this);
            copy._edges = {...copy._edges};
            copy._edges[key] = UndoableEdgeData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._edges[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableRoadData(this);
          copy._edges = {...copy._edges};
          copy._edges[key] = newValue;
          return copy;
        }
      }
      case "disableProjectToTerrain": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRoadData(this);
              copy._hasDisableProjectToTerrain = true;
              copy._disableProjectToTerrain = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableProjectToTerrain) {
                return this;
              }
              const copy = new UndoableRoadData(this);
              copy._hasDisableProjectToTerrain = false;
              copy._disableProjectToTerrain = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRoadData} other
   * @returns {UndoableRoadData}
   */
  merge(other) {
    const copy = new UndoableRoadData(this);
    copy._roadNodes = {...this._roadNodes, ...other._roadNodes};
    copy._edges = {...this._edges, ...other._edges};
    if (other._hasDisableProjectToTerrain) {
      copy._hasDisableProjectToTerrain = true;
      copy._disableProjectToTerrain = other._disableProjectToTerrain;
    }
    return copy;
  }
}
UndoableRoadData.default = new UndoableRoadData();
UndoableRoadData.RoadNodesEntry = UndoableRoadData_RoadNodesEntry;
UndoableRoadData.EdgesEntry = UndoableRoadData_EdgesEntry;
class UndoableRoadData_Builder {
  constructor(value) {
    this._value = new UndoableRoadData(value);
  }
  build() {
    return new UndoableRoadData(this._value);
  }
  setRoadNodes(key, value) {
    this._value._roadNodes = {...this._value._roadNodes, [key]: value};
    return this;
  }
  addAllRoadNodes(values) {
    this._value._roadNodes = {...this._value._roadNodes, ...values};
    return this;
  }
  deleteRoadNodes(key) {
    this._value._roadNodes = {...this._value._roadNodes};
    delete this._value._roadNodes[key];
    return this;
  }
  clearRoadNodes() {
    this._value._roadNodes = {};
    return this;
  }
  setEdges(key, value) {
    this._value._edges = {...this._value._edges, [key]: value};
    return this;
  }
  addAllEdges(values) {
    this._value._edges = {...this._value._edges, ...values};
    return this;
  }
  deleteEdges(key) {
    this._value._edges = {...this._value._edges};
    delete this._value._edges[key];
    return this;
  }
  clearEdges() {
    this._value._edges = {};
    return this;
  }
  setDisableProjectToTerrain(value) {
    this._value._hasDisableProjectToTerrain = true;
    this._value._disableProjectToTerrain = value;
    return this;
  }
  deleteDisableProjectToTerrain() {
    this._value._hasDisableProjectToTerrain = false;
    this._value._disableProjectToTerrain = null;
    return this;
  }
}
UndoableRoadData.Builder = UndoableRoadData_Builder;
class UndoableRoadData_WithParent {
  /**
   * @param {UndoableRoadData} value
   * @param {UndoableRoadData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRoadData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRoadNodes() {
    if (!this._selfRoadNodes) {
      this._selfRoadNodes = {};
      for (let i in this._value.roadNodes) {
        this._selfRoadNodes[i] = new UndoableNodeData.WithParent(this._value.roadNodes[i], null);
      }
    }
    return this._selfRoadNodes;
  }
  get inherentRoadNodes() {
    if (!this._inherentRoadNodes) {
      this._inherentRoadNodes = this._parent ? this._parent.roadNodes : {};
    }
    return this._inherentRoadNodes;
  }
  get roadNodes() {
    if (!this._allRoadNodes) {
      this._allRoadNodes = this._parent ? {...this._parent.roadNodes, ...this.selfRoadNodes} : this.selfRoadNodes;
    }
    return this._allRoadNodes;
  }
  get selfEdges() {
    if (!this._selfEdges) {
      this._selfEdges = {};
      for (let i in this._value.edges) {
        this._selfEdges[i] = new UndoableEdgeData.WithParent(this._value.edges[i], null);
      }
    }
    return this._selfEdges;
  }
  get inherentEdges() {
    if (!this._inherentEdges) {
      this._inherentEdges = this._parent ? this._parent.edges : {};
    }
    return this._inherentEdges;
  }
  get edges() {
    if (!this._allEdges) {
      this._allEdges = this._parent ? {...this._parent.edges, ...this.selfEdges} : this.selfEdges;
    }
    return this._allEdges;
  }
  get hasDisableProjectToTerrain() {
    if (this._cachedHasDisableProjectToTerrain === undefined) {
      if (this._value.hasDisableProjectToTerrain) {
        this._cachedHasDisableProjectToTerrain = true;
      } else {
        this._cachedHasDisableProjectToTerrain = this._parent ? this._parent.hasDisableProjectToTerrain : false;
      }
    }
    return this._cachedHasDisableProjectToTerrain;
  }
  get disableProjectToTerrain() {
    if (this._cachedDisableProjectToTerrain === undefined) {
      if (this._value.hasDisableProjectToTerrain) {
        this._cachedDisableProjectToTerrain = this._value.disableProjectToTerrain;
      } else {
        this._cachedDisableProjectToTerrain = this._parent ? this._parent.disableProjectToTerrain : this._value.disableProjectToTerrain;
      }
    }
    return this._cachedDisableProjectToTerrain;
  }
  update(current, parent) {
    const result = new UndoableRoadData_WithParent(current, parent);
    if (this._selfRoadNodes) {
      if (this._value.roadNodes === current.roadNodes) {
        result._selfRoadNodes = this._selfRoadNodes;
      } else {
        result._selfRoadNodes = {};
        for (let i in current.roadNodes) {
          const oldValue = this._value.roadNodes[i];
          if (oldValue) {
            const oldCache = this._selfRoadNodes[i];
            if (oldValue === current.roadNodes[i]) {
              result._selfRoadNodes[i] = oldCache;
            } else {
              result._selfRoadNodes[i] = oldCache.update(current.roadNodes[i], null);
            }
          } else {
            result._selfRoadNodes[i] = new UndoableNodeData.WithParent(current.roadNodes[i], null);
          }
        }
      }
    }
    if (this._selfEdges) {
      if (this._value.edges === current.edges) {
        result._selfEdges = this._selfEdges;
      } else {
        result._selfEdges = {};
        for (let i in current.edges) {
          const oldValue = this._value.edges[i];
          if (oldValue) {
            const oldCache = this._selfEdges[i];
            if (oldValue === current.edges[i]) {
              result._selfEdges[i] = oldCache;
            } else {
              result._selfEdges[i] = oldCache.update(current.edges[i], null);
            }
          } else {
            result._selfEdges[i] = new UndoableEdgeData.WithParent(current.edges[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableRoadData_WithParent.default = new UndoableRoadData_WithParent(UndoableRoadData.default, null);
UndoableRoadData.WithParent = UndoableRoadData_WithParent;
class UndoableRoadData_Descriptor {
  get roadNodes() {
    if (!this._roadNodes) {
      this._roadNodes = {
        name: "roadNodes",
        Name: "RoadNodes",
        number: 1,
        protoType: 11,
        protoName: "road_nodes",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableNodeData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._roadNodes;
  }
  get edges() {
    if (!this._edges) {
      this._edges = {
        name: "edges",
        Name: "Edges",
        number: 2,
        protoType: 11,
        protoName: "edges",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableEdgeData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._edges;
  }
  get disableProjectToTerrain() {
    if (!this._disableProjectToTerrain) {
      this._disableProjectToTerrain = {
        name: "disableProjectToTerrain",
        Name: "DisableProjectToTerrain",
        number: 3,
        protoType: 8,
        protoName: "disable_project_to_terrain",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableProjectToTerrain;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.roadNodes,
        this.edges,
        this.disableProjectToTerrain,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisableProjectToTerrain",
        Name: "DummyOneofForDisableProjectToTerrain",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableRoadData.descriptor = new UndoableRoadData_Descriptor();
export class UndoableControlPoint {
  get descriptor() {
    return UndoableControlPoint.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHeight = false;
    this._height = null;
    this._hasIsBorder = false;
    this._isBorder = null;
    this._hasIsRamp = false;
    this._isRamp = null;
    this._hasIsClamped = false;
    this._isClamped = null;
    this._hasTileSetId = false;
    this._tileSetId = null;
    this._hasTileVariation = false;
    this._tileVariation = null;
  }
  isEmpty() {
    if (this._hasHeight) return false;
    if (this._hasIsBorder) return false;
    if (this._hasIsRamp) return false;
    if (this._hasIsClamped) return false;
    if (this._hasTileSetId) return false;
    if (this._hasTileVariation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableControlPoint) {
      return value;
    }
    return UndoableControlPoint.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableControlPoint();
    if (json.height != null) {
      result._hasHeight = true;
      result._height = JsonToInt32.fromJson(json.height);
    }
    if (json.isBorder != null) {
      result._hasIsBorder = true;
      result._isBorder = JsonToBoolean.fromJson(json.isBorder);
    }
    if (json.isRamp != null) {
      result._hasIsRamp = true;
      result._isRamp = JsonToBoolean.fromJson(json.isRamp);
    }
    if (json.isClamped != null) {
      result._hasIsClamped = true;
      result._isClamped = JsonToBoolean.fromJson(json.isClamped);
    }
    if (json.tileSetId != null) {
      result._hasTileSetId = true;
      result._tileSetId = JsonToInt32.fromJson(json.tileSetId);
    }
    if (json.tileVariation != null) {
      result._hasTileVariation = true;
      result._tileVariation = JsonToInt32.fromJson(json.tileVariation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHeight) {
      result.height = JsonToInt32.toJson(this._height);
    }
    if (this._hasIsBorder) {
      result.isBorder = JsonToBoolean.toJson(this._isBorder);
    }
    if (this._hasIsRamp) {
      result.isRamp = JsonToBoolean.toJson(this._isRamp);
    }
    if (this._hasIsClamped) {
      result.isClamped = JsonToBoolean.toJson(this._isClamped);
    }
    if (this._hasTileSetId) {
      result.tileSetId = JsonToInt32.toJson(this._tileSetId);
    }
    if (this._hasTileVariation) {
      result.tileVariation = JsonToInt32.toJson(this._tileVariation);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get height() {
    return this._hasHeight ? this._height : JsonToInt32.default;
  }
  get hasHeight() {
    return this._hasHeight;
  }
  setHeight(path, value) {
    return {type: 'SET', path: path.concat(['height']), value};
  }
  deleteHeight(path) {
    return {type: 'DELETE', path: path.concat(['height'])};
  }
  /**
   * @returns {boolean}
   */
  get isBorder() {
    return this._hasIsBorder ? this._isBorder : JsonToBoolean.default;
  }
  get hasIsBorder() {
    return this._hasIsBorder;
  }
  setIsBorder(path, value) {
    return {type: 'SET', path: path.concat(['isBorder']), value};
  }
  deleteIsBorder(path) {
    return {type: 'DELETE', path: path.concat(['isBorder'])};
  }
  /**
   * @returns {boolean}
   */
  get isRamp() {
    return this._hasIsRamp ? this._isRamp : JsonToBoolean.default;
  }
  get hasIsRamp() {
    return this._hasIsRamp;
  }
  setIsRamp(path, value) {
    return {type: 'SET', path: path.concat(['isRamp']), value};
  }
  deleteIsRamp(path) {
    return {type: 'DELETE', path: path.concat(['isRamp'])};
  }
  /**
   * @returns {boolean}
   */
  get isClamped() {
    return this._hasIsClamped ? this._isClamped : JsonToBoolean.default;
  }
  get hasIsClamped() {
    return this._hasIsClamped;
  }
  setIsClamped(path, value) {
    return {type: 'SET', path: path.concat(['isClamped']), value};
  }
  deleteIsClamped(path) {
    return {type: 'DELETE', path: path.concat(['isClamped'])};
  }
  /**
   * @returns {number}
   */
  get tileSetId() {
    return this._hasTileSetId ? this._tileSetId : JsonToInt32.default;
  }
  get hasTileSetId() {
    return this._hasTileSetId;
  }
  setTileSetId(path, value) {
    return {type: 'SET', path: path.concat(['tileSetId']), value};
  }
  deleteTileSetId(path) {
    return {type: 'DELETE', path: path.concat(['tileSetId'])};
  }
  /**
   * @returns {number}
   */
  get tileVariation() {
    return this._hasTileVariation ? this._tileVariation : JsonToInt32.default;
  }
  get hasTileVariation() {
    return this._hasTileVariation;
  }
  setTileVariation(path, value) {
    return {type: 'SET', path: path.concat(['tileVariation']), value};
  }
  deleteTileVariation(path) {
    return {type: 'DELETE', path: path.concat(['tileVariation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "height": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasHeight = true;
              copy._height = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeight) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasHeight = false;
              copy._height = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isBorder": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasIsBorder = true;
              copy._isBorder = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsBorder) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasIsBorder = false;
              copy._isBorder = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isRamp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasIsRamp = true;
              copy._isRamp = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsRamp) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasIsRamp = false;
              copy._isRamp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isClamped": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasIsClamped = true;
              copy._isClamped = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsClamped) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasIsClamped = false;
              copy._isClamped = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tileSetId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasTileSetId = true;
              copy._tileSetId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileSetId) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasTileSetId = false;
              copy._tileSetId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tileVariation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableControlPoint(this);
              copy._hasTileVariation = true;
              copy._tileVariation = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileVariation) {
                return this;
              }
              const copy = new UndoableControlPoint(this);
              copy._hasTileVariation = false;
              copy._tileVariation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableControlPoint} other
   * @returns {UndoableControlPoint}
   */
  merge(other) {
    const copy = new UndoableControlPoint(this);
    if (other._hasHeight) {
      copy._hasHeight = true;
      copy._height = other._height;
    }
    if (other._hasIsBorder) {
      copy._hasIsBorder = true;
      copy._isBorder = other._isBorder;
    }
    if (other._hasIsRamp) {
      copy._hasIsRamp = true;
      copy._isRamp = other._isRamp;
    }
    if (other._hasIsClamped) {
      copy._hasIsClamped = true;
      copy._isClamped = other._isClamped;
    }
    if (other._hasTileSetId) {
      copy._hasTileSetId = true;
      copy._tileSetId = other._tileSetId;
    }
    if (other._hasTileVariation) {
      copy._hasTileVariation = true;
      copy._tileVariation = other._tileVariation;
    }
    return copy;
  }
}
UndoableControlPoint.default = new UndoableControlPoint();
class UndoableControlPoint_Builder {
  constructor(value) {
    this._value = new UndoableControlPoint(value);
  }
  build() {
    return new UndoableControlPoint(this._value);
  }
  setHeight(value) {
    this._value._hasHeight = true;
    this._value._height = value;
    return this;
  }
  deleteHeight() {
    this._value._hasHeight = false;
    this._value._height = null;
    return this;
  }
  setIsBorder(value) {
    this._value._hasIsBorder = true;
    this._value._isBorder = value;
    return this;
  }
  deleteIsBorder() {
    this._value._hasIsBorder = false;
    this._value._isBorder = null;
    return this;
  }
  setIsRamp(value) {
    this._value._hasIsRamp = true;
    this._value._isRamp = value;
    return this;
  }
  deleteIsRamp() {
    this._value._hasIsRamp = false;
    this._value._isRamp = null;
    return this;
  }
  setIsClamped(value) {
    this._value._hasIsClamped = true;
    this._value._isClamped = value;
    return this;
  }
  deleteIsClamped() {
    this._value._hasIsClamped = false;
    this._value._isClamped = null;
    return this;
  }
  setTileSetId(value) {
    this._value._hasTileSetId = true;
    this._value._tileSetId = value;
    return this;
  }
  deleteTileSetId() {
    this._value._hasTileSetId = false;
    this._value._tileSetId = null;
    return this;
  }
  setTileVariation(value) {
    this._value._hasTileVariation = true;
    this._value._tileVariation = value;
    return this;
  }
  deleteTileVariation() {
    this._value._hasTileVariation = false;
    this._value._tileVariation = null;
    return this;
  }
}
UndoableControlPoint.Builder = UndoableControlPoint_Builder;
class UndoableControlPoint_WithParent {
  /**
   * @param {UndoableControlPoint} value
   * @param {UndoableControlPoint_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableControlPoint.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHeight() {
    if (this._cachedHasHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHasHeight = true;
      } else {
        this._cachedHasHeight = this._parent ? this._parent.hasHeight : false;
      }
    }
    return this._cachedHasHeight;
  }
  get height() {
    if (this._cachedHeight === undefined) {
      if (this._value.hasHeight) {
        this._cachedHeight = this._value.height;
      } else {
        this._cachedHeight = this._parent ? this._parent.height : this._value.height;
      }
    }
    return this._cachedHeight;
  }
  get hasIsBorder() {
    if (this._cachedHasIsBorder === undefined) {
      if (this._value.hasIsBorder) {
        this._cachedHasIsBorder = true;
      } else {
        this._cachedHasIsBorder = this._parent ? this._parent.hasIsBorder : false;
      }
    }
    return this._cachedHasIsBorder;
  }
  get isBorder() {
    if (this._cachedIsBorder === undefined) {
      if (this._value.hasIsBorder) {
        this._cachedIsBorder = this._value.isBorder;
      } else {
        this._cachedIsBorder = this._parent ? this._parent.isBorder : this._value.isBorder;
      }
    }
    return this._cachedIsBorder;
  }
  get hasIsRamp() {
    if (this._cachedHasIsRamp === undefined) {
      if (this._value.hasIsRamp) {
        this._cachedHasIsRamp = true;
      } else {
        this._cachedHasIsRamp = this._parent ? this._parent.hasIsRamp : false;
      }
    }
    return this._cachedHasIsRamp;
  }
  get isRamp() {
    if (this._cachedIsRamp === undefined) {
      if (this._value.hasIsRamp) {
        this._cachedIsRamp = this._value.isRamp;
      } else {
        this._cachedIsRamp = this._parent ? this._parent.isRamp : this._value.isRamp;
      }
    }
    return this._cachedIsRamp;
  }
  get hasIsClamped() {
    if (this._cachedHasIsClamped === undefined) {
      if (this._value.hasIsClamped) {
        this._cachedHasIsClamped = true;
      } else {
        this._cachedHasIsClamped = this._parent ? this._parent.hasIsClamped : false;
      }
    }
    return this._cachedHasIsClamped;
  }
  get isClamped() {
    if (this._cachedIsClamped === undefined) {
      if (this._value.hasIsClamped) {
        this._cachedIsClamped = this._value.isClamped;
      } else {
        this._cachedIsClamped = this._parent ? this._parent.isClamped : this._value.isClamped;
      }
    }
    return this._cachedIsClamped;
  }
  get hasTileSetId() {
    if (this._cachedHasTileSetId === undefined) {
      if (this._value.hasTileSetId) {
        this._cachedHasTileSetId = true;
      } else {
        this._cachedHasTileSetId = this._parent ? this._parent.hasTileSetId : false;
      }
    }
    return this._cachedHasTileSetId;
  }
  get tileSetId() {
    if (this._cachedTileSetId === undefined) {
      if (this._value.hasTileSetId) {
        this._cachedTileSetId = this._value.tileSetId;
      } else {
        this._cachedTileSetId = this._parent ? this._parent.tileSetId : this._value.tileSetId;
      }
    }
    return this._cachedTileSetId;
  }
  get hasTileVariation() {
    if (this._cachedHasTileVariation === undefined) {
      if (this._value.hasTileVariation) {
        this._cachedHasTileVariation = true;
      } else {
        this._cachedHasTileVariation = this._parent ? this._parent.hasTileVariation : false;
      }
    }
    return this._cachedHasTileVariation;
  }
  get tileVariation() {
    if (this._cachedTileVariation === undefined) {
      if (this._value.hasTileVariation) {
        this._cachedTileVariation = this._value.tileVariation;
      } else {
        this._cachedTileVariation = this._parent ? this._parent.tileVariation : this._value.tileVariation;
      }
    }
    return this._cachedTileVariation;
  }
  update(current, parent) {
    const result = new UndoableControlPoint_WithParent(current, parent);
    return result;
  }
}
UndoableControlPoint_WithParent.default = new UndoableControlPoint_WithParent(UndoableControlPoint.default, null);
UndoableControlPoint.WithParent = UndoableControlPoint_WithParent;
class UndoableControlPoint_Descriptor {
  get height() {
    if (!this._height) {
      this._height = {
        name: "height",
        Name: "Height",
        number: 1,
        protoType: 5,
        protoName: "height",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._height;
  }
  get isBorder() {
    if (!this._isBorder) {
      this._isBorder = {
        name: "isBorder",
        Name: "IsBorder",
        number: 2,
        protoType: 8,
        protoName: "is_border",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isBorder;
  }
  get isRamp() {
    if (!this._isRamp) {
      this._isRamp = {
        name: "isRamp",
        Name: "IsRamp",
        number: 3,
        protoType: 8,
        protoName: "is_ramp",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isRamp;
  }
  get isClamped() {
    if (!this._isClamped) {
      this._isClamped = {
        name: "isClamped",
        Name: "IsClamped",
        number: 4,
        protoType: 8,
        protoName: "is_clamped",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isClamped;
  }
  get tileSetId() {
    if (!this._tileSetId) {
      this._tileSetId = {
        name: "tileSetId",
        Name: "TileSetId",
        number: 5,
        protoType: 5,
        protoName: "tile_set_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tileSetId;
  }
  get tileVariation() {
    if (!this._tileVariation) {
      this._tileVariation = {
        name: "tileVariation",
        Name: "TileVariation",
        number: 6,
        protoType: 5,
        protoName: "tile_variation",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tileVariation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.height,
        this.isBorder,
        this.isRamp,
        this.isClamped,
        this.tileSetId,
        this.tileVariation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHeight",
        Name: "DummyOneofForHeight",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsBorder",
        Name: "DummyOneofForIsBorder",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsRamp",
        Name: "DummyOneofForIsRamp",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsClamped",
        Name: "DummyOneofForIsClamped",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileSetId",
        Name: "DummyOneofForTileSetId",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileVariation",
        Name: "DummyOneofForTileVariation",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableControlPoint.descriptor = new UndoableControlPoint_Descriptor();
export class UndoableTextureControlPoint {
  get descriptor() {
    return UndoableTextureControlPoint.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTextureValue = false;
    this._textureValue = null;
    this._hasTextureVariation = false;
    this._textureVariation = null;
  }
  isEmpty() {
    if (this._hasTextureValue) return false;
    if (this._hasTextureVariation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableTextureControlPoint) {
      return value;
    }
    return UndoableTextureControlPoint.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableTextureControlPoint();
    if (json.textureValue != null) {
      result._hasTextureValue = true;
      result._textureValue = JsonToInt32.fromJson(json.textureValue);
    }
    if (json.textureVariation != null) {
      result._hasTextureVariation = true;
      result._textureVariation = JsonToInt32.fromJson(json.textureVariation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTextureValue) {
      result.textureValue = JsonToInt32.toJson(this._textureValue);
    }
    if (this._hasTextureVariation) {
      result.textureVariation = JsonToInt32.toJson(this._textureVariation);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get textureValue() {
    return this._hasTextureValue ? this._textureValue : JsonToInt32.default;
  }
  get hasTextureValue() {
    return this._hasTextureValue;
  }
  setTextureValue(path, value) {
    return {type: 'SET', path: path.concat(['textureValue']), value};
  }
  deleteTextureValue(path) {
    return {type: 'DELETE', path: path.concat(['textureValue'])};
  }
  /**
   * @returns {number}
   */
  get textureVariation() {
    return this._hasTextureVariation ? this._textureVariation : JsonToInt32.default;
  }
  get hasTextureVariation() {
    return this._hasTextureVariation;
  }
  setTextureVariation(path, value) {
    return {type: 'SET', path: path.concat(['textureVariation']), value};
  }
  deleteTextureVariation(path) {
    return {type: 'DELETE', path: path.concat(['textureVariation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "textureValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTextureControlPoint(this);
              copy._hasTextureValue = true;
              copy._textureValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTextureValue) {
                return this;
              }
              const copy = new UndoableTextureControlPoint(this);
              copy._hasTextureValue = false;
              copy._textureValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "textureVariation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTextureControlPoint(this);
              copy._hasTextureVariation = true;
              copy._textureVariation = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTextureVariation) {
                return this;
              }
              const copy = new UndoableTextureControlPoint(this);
              copy._hasTextureVariation = false;
              copy._textureVariation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableTextureControlPoint} other
   * @returns {UndoableTextureControlPoint}
   */
  merge(other) {
    const copy = new UndoableTextureControlPoint(this);
    if (other._hasTextureValue) {
      copy._hasTextureValue = true;
      copy._textureValue = other._textureValue;
    }
    if (other._hasTextureVariation) {
      copy._hasTextureVariation = true;
      copy._textureVariation = other._textureVariation;
    }
    return copy;
  }
}
UndoableTextureControlPoint.default = new UndoableTextureControlPoint();
class UndoableTextureControlPoint_Builder {
  constructor(value) {
    this._value = new UndoableTextureControlPoint(value);
  }
  build() {
    return new UndoableTextureControlPoint(this._value);
  }
  setTextureValue(value) {
    this._value._hasTextureValue = true;
    this._value._textureValue = value;
    return this;
  }
  deleteTextureValue() {
    this._value._hasTextureValue = false;
    this._value._textureValue = null;
    return this;
  }
  setTextureVariation(value) {
    this._value._hasTextureVariation = true;
    this._value._textureVariation = value;
    return this;
  }
  deleteTextureVariation() {
    this._value._hasTextureVariation = false;
    this._value._textureVariation = null;
    return this;
  }
}
UndoableTextureControlPoint.Builder = UndoableTextureControlPoint_Builder;
class UndoableTextureControlPoint_WithParent {
  /**
   * @param {UndoableTextureControlPoint} value
   * @param {UndoableTextureControlPoint_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableTextureControlPoint.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTextureValue() {
    if (this._cachedHasTextureValue === undefined) {
      if (this._value.hasTextureValue) {
        this._cachedHasTextureValue = true;
      } else {
        this._cachedHasTextureValue = this._parent ? this._parent.hasTextureValue : false;
      }
    }
    return this._cachedHasTextureValue;
  }
  get textureValue() {
    if (this._cachedTextureValue === undefined) {
      if (this._value.hasTextureValue) {
        this._cachedTextureValue = this._value.textureValue;
      } else {
        this._cachedTextureValue = this._parent ? this._parent.textureValue : this._value.textureValue;
      }
    }
    return this._cachedTextureValue;
  }
  get hasTextureVariation() {
    if (this._cachedHasTextureVariation === undefined) {
      if (this._value.hasTextureVariation) {
        this._cachedHasTextureVariation = true;
      } else {
        this._cachedHasTextureVariation = this._parent ? this._parent.hasTextureVariation : false;
      }
    }
    return this._cachedHasTextureVariation;
  }
  get textureVariation() {
    if (this._cachedTextureVariation === undefined) {
      if (this._value.hasTextureVariation) {
        this._cachedTextureVariation = this._value.textureVariation;
      } else {
        this._cachedTextureVariation = this._parent ? this._parent.textureVariation : this._value.textureVariation;
      }
    }
    return this._cachedTextureVariation;
  }
  update(current, parent) {
    const result = new UndoableTextureControlPoint_WithParent(current, parent);
    return result;
  }
}
UndoableTextureControlPoint_WithParent.default = new UndoableTextureControlPoint_WithParent(UndoableTextureControlPoint.default, null);
UndoableTextureControlPoint.WithParent = UndoableTextureControlPoint_WithParent;
class UndoableTextureControlPoint_Descriptor {
  get textureValue() {
    if (!this._textureValue) {
      this._textureValue = {
        name: "textureValue",
        Name: "TextureValue",
        number: 1,
        protoType: 5,
        protoName: "texture_value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._textureValue;
  }
  get textureVariation() {
    if (!this._textureVariation) {
      this._textureVariation = {
        name: "textureVariation",
        Name: "TextureVariation",
        number: 2,
        protoType: 5,
        protoName: "texture_variation",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._textureVariation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.textureValue,
        this.textureVariation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTextureValue",
        Name: "DummyOneofForTextureValue",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTextureVariation",
        Name: "DummyOneofForTextureVariation",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableTextureControlPoint.descriptor = new UndoableTextureControlPoint_Descriptor();
export class UndoableTileMapData {
  get descriptor() {
    return UndoableTileMapData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapWidth = false;
    this._mapWidth = null;
    this._hasMapHeight = false;
    this._mapHeight = null;
    this._hasTileSize = false;
    this._tileSize = null;
    this._ctrlPts = [];
    this._texCtrlPts = [];
    this._hasNavmeshTileSize = false;
    this._navmeshTileSize = null;
    this._hasUseGridGraph = false;
    this._useGridGraph = null;
    this._hasGridNodeSize = false;
    this._gridNodeSize = null;
  }
  isEmpty() {
    if (this._hasMapWidth) return false;
    if (this._hasMapHeight) return false;
    if (this._hasTileSize) return false;
    if (this._ctrlPts.length > 0) return false;
    if (this._texCtrlPts.length > 0) return false;
    if (this._hasNavmeshTileSize) return false;
    if (this._hasUseGridGraph) return false;
    if (this._hasGridNodeSize) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableTileMapData) {
      return value;
    }
    return UndoableTileMapData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableTileMapData();
    if (json.mapWidth != null) {
      result._hasMapWidth = true;
      result._mapWidth = JsonToInt32.fromJson(json.mapWidth);
    }
    if (json.mapHeight != null) {
      result._hasMapHeight = true;
      result._mapHeight = JsonToInt32.fromJson(json.mapHeight);
    }
    if (json.tileSize != null) {
      result._hasTileSize = true;
      result._tileSize = JsonToDouble.fromJson(json.tileSize);
    }
    result._ctrlPts = JsonToList(json.ctrlPts, UndoableControlPoint);
    result._texCtrlPts = JsonToList(json.texCtrlPts, UndoableTextureControlPoint);
    if (json.navmeshTileSize != null) {
      result._hasNavmeshTileSize = true;
      result._navmeshTileSize = JsonToInt32.fromJson(json.navmeshTileSize);
    }
    if (json.useGridGraph != null) {
      result._hasUseGridGraph = true;
      result._useGridGraph = JsonToBoolean.fromJson(json.useGridGraph);
    }
    if (json.gridNodeSize != null) {
      result._hasGridNodeSize = true;
      result._gridNodeSize = JsonToDouble.fromJson(json.gridNodeSize);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapWidth) {
      result.mapWidth = JsonToInt32.toJson(this._mapWidth);
    }
    if (this._hasMapHeight) {
      result.mapHeight = JsonToInt32.toJson(this._mapHeight);
    }
    if (this._hasTileSize) {
      result.tileSize = JsonToDouble.toJson(this._tileSize);
    }
    if (this._ctrlPts.length > 0) {
      result.ctrlPts = ArrayToJson(this._ctrlPts, UndoableControlPoint);
    }
    if (this._texCtrlPts.length > 0) {
      result.texCtrlPts = ArrayToJson(this._texCtrlPts, UndoableTextureControlPoint);
    }
    if (this._hasNavmeshTileSize) {
      result.navmeshTileSize = JsonToInt32.toJson(this._navmeshTileSize);
    }
    if (this._hasUseGridGraph) {
      result.useGridGraph = JsonToBoolean.toJson(this._useGridGraph);
    }
    if (this._hasGridNodeSize) {
      result.gridNodeSize = JsonToDouble.toJson(this._gridNodeSize);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get mapWidth() {
    return this._hasMapWidth ? this._mapWidth : JsonToInt32.default;
  }
  get hasMapWidth() {
    return this._hasMapWidth;
  }
  setMapWidth(path, value) {
    return {type: 'SET', path: path.concat(['mapWidth']), value};
  }
  deleteMapWidth(path) {
    return {type: 'DELETE', path: path.concat(['mapWidth'])};
  }
  /**
   * @returns {number}
   */
  get mapHeight() {
    return this._hasMapHeight ? this._mapHeight : JsonToInt32.default;
  }
  get hasMapHeight() {
    return this._hasMapHeight;
  }
  setMapHeight(path, value) {
    return {type: 'SET', path: path.concat(['mapHeight']), value};
  }
  deleteMapHeight(path) {
    return {type: 'DELETE', path: path.concat(['mapHeight'])};
  }
  /**
   * @returns {number}
   */
  get tileSize() {
    return this._hasTileSize ? this._tileSize : JsonToDouble.default;
  }
  get hasTileSize() {
    return this._hasTileSize;
  }
  setTileSize(path, value) {
    return {type: 'SET', path: path.concat(['tileSize']), value};
  }
  deleteTileSize(path) {
    return {type: 'DELETE', path: path.concat(['tileSize'])};
  }
  /**
   * @returns {UndoableControlPoint[]}
   */
  get ctrlPts() {
    return this._ctrlPts;
  }
  addCtrlPts(path, value) {
    return {type: 'ADD', path: path.concat(['ctrlPts']), value: value.toJson()};
  }
  setCtrlPts(path, value) {
    return {type: 'SET', path: path.concat(['ctrlPts']), value: ArrayToJson(value, UndoableControlPoint)};
  }
  setCtrlPtsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['ctrlPts', key]), value: value.toJson()};
  }
  deleteCtrlPts(path) {
    return {type: 'DELETE', path: path.concat(['ctrlPts'])};
  }
  deleteCtrlPtsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['ctrlPts', key])};
  }
  /**
   * @returns {UndoableTextureControlPoint[]}
   */
  get texCtrlPts() {
    return this._texCtrlPts;
  }
  addTexCtrlPts(path, value) {
    return {type: 'ADD', path: path.concat(['texCtrlPts']), value: value.toJson()};
  }
  setTexCtrlPts(path, value) {
    return {type: 'SET', path: path.concat(['texCtrlPts']), value: ArrayToJson(value, UndoableTextureControlPoint)};
  }
  setTexCtrlPtsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['texCtrlPts', key]), value: value.toJson()};
  }
  deleteTexCtrlPts(path) {
    return {type: 'DELETE', path: path.concat(['texCtrlPts'])};
  }
  deleteTexCtrlPtsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['texCtrlPts', key])};
  }
  /**
   * @returns {number}
   */
  get navmeshTileSize() {
    return this._hasNavmeshTileSize ? this._navmeshTileSize : JsonToInt32.default;
  }
  get hasNavmeshTileSize() {
    return this._hasNavmeshTileSize;
  }
  setNavmeshTileSize(path, value) {
    return {type: 'SET', path: path.concat(['navmeshTileSize']), value};
  }
  deleteNavmeshTileSize(path) {
    return {type: 'DELETE', path: path.concat(['navmeshTileSize'])};
  }
  /**
   * @returns {boolean}
   */
  get useGridGraph() {
    return this._hasUseGridGraph ? this._useGridGraph : JsonToBoolean.default;
  }
  get hasUseGridGraph() {
    return this._hasUseGridGraph;
  }
  setUseGridGraph(path, value) {
    return {type: 'SET', path: path.concat(['useGridGraph']), value};
  }
  deleteUseGridGraph(path) {
    return {type: 'DELETE', path: path.concat(['useGridGraph'])};
  }
  /**
   * @returns {number}
   */
  get gridNodeSize() {
    return this._hasGridNodeSize ? this._gridNodeSize : JsonToDouble.default;
  }
  get hasGridNodeSize() {
    return this._hasGridNodeSize;
  }
  setGridNodeSize(path, value) {
    return {type: 'SET', path: path.concat(['gridNodeSize']), value};
  }
  deleteGridNodeSize(path) {
    return {type: 'DELETE', path: path.concat(['gridNodeSize'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapWidth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasMapWidth = true;
              copy._mapWidth = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapWidth) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasMapWidth = false;
              copy._mapWidth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mapHeight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasMapHeight = true;
              copy._mapHeight = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapHeight) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasMapHeight = false;
              copy._mapHeight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tileSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasTileSize = true;
              copy._tileSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTileSize) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasTileSize = false;
              copy._tileSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ctrlPts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._ctrlPts = [];        for (let i of value) {
                copy._ctrlPts.push(UndoableControlPoint.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UndoableTileMapData(this);
              copy._ctrlPts = copy._ctrlPts.concat([UndoableControlPoint.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._ctrlPts.length === 0) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._ctrlPts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._ctrlPts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._ctrlPts = copy._ctrlPts.slice();
              copy._ctrlPts[path[1]] = UndoableControlPoint.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UndoableTileMapData(this);
              copy._ctrlPts = copy._ctrlPts.slice(0, path[1]).concat(copy._ctrlPts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._ctrlPts.length) {
            return this;
          }
          const oldValue = this._ctrlPts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableTileMapData(this);
          copy._ctrlPts = copy._ctrlPts.slice();
          copy._ctrlPts[key] = newValue;
          return copy;
        }
      }
      case "texCtrlPts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._texCtrlPts = [];        for (let i of value) {
                copy._texCtrlPts.push(UndoableTextureControlPoint.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UndoableTileMapData(this);
              copy._texCtrlPts = copy._texCtrlPts.concat([UndoableTextureControlPoint.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._texCtrlPts.length === 0) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._texCtrlPts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._texCtrlPts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._texCtrlPts = copy._texCtrlPts.slice();
              copy._texCtrlPts[path[1]] = UndoableTextureControlPoint.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UndoableTileMapData(this);
              copy._texCtrlPts = copy._texCtrlPts.slice(0, path[1]).concat(copy._texCtrlPts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._texCtrlPts.length) {
            return this;
          }
          const oldValue = this._texCtrlPts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableTileMapData(this);
          copy._texCtrlPts = copy._texCtrlPts.slice();
          copy._texCtrlPts[key] = newValue;
          return copy;
        }
      }
      case "navmeshTileSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasNavmeshTileSize = true;
              copy._navmeshTileSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavmeshTileSize) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasNavmeshTileSize = false;
              copy._navmeshTileSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useGridGraph": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasUseGridGraph = true;
              copy._useGridGraph = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseGridGraph) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasUseGridGraph = false;
              copy._useGridGraph = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gridNodeSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTileMapData(this);
              copy._hasGridNodeSize = true;
              copy._gridNodeSize = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGridNodeSize) {
                return this;
              }
              const copy = new UndoableTileMapData(this);
              copy._hasGridNodeSize = false;
              copy._gridNodeSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableTileMapData} other
   * @returns {UndoableTileMapData}
   */
  merge(other) {
    const copy = new UndoableTileMapData(this);
    if (other._hasMapWidth) {
      copy._hasMapWidth = true;
      copy._mapWidth = other._mapWidth;
    }
    if (other._hasMapHeight) {
      copy._hasMapHeight = true;
      copy._mapHeight = other._mapHeight;
    }
    if (other._hasTileSize) {
      copy._hasTileSize = true;
      copy._tileSize = other._tileSize;
    }
    copy._ctrlPts = this._ctrlPts.concat(other._ctrlPts);
    copy._texCtrlPts = this._texCtrlPts.concat(other._texCtrlPts);
    if (other._hasNavmeshTileSize) {
      copy._hasNavmeshTileSize = true;
      copy._navmeshTileSize = other._navmeshTileSize;
    }
    if (other._hasUseGridGraph) {
      copy._hasUseGridGraph = true;
      copy._useGridGraph = other._useGridGraph;
    }
    if (other._hasGridNodeSize) {
      copy._hasGridNodeSize = true;
      copy._gridNodeSize = other._gridNodeSize;
    }
    return copy;
  }
}
UndoableTileMapData.default = new UndoableTileMapData();
class UndoableTileMapData_Builder {
  constructor(value) {
    this._value = new UndoableTileMapData(value);
  }
  build() {
    return new UndoableTileMapData(this._value);
  }
  setMapWidth(value) {
    this._value._hasMapWidth = true;
    this._value._mapWidth = value;
    return this;
  }
  deleteMapWidth() {
    this._value._hasMapWidth = false;
    this._value._mapWidth = null;
    return this;
  }
  setMapHeight(value) {
    this._value._hasMapHeight = true;
    this._value._mapHeight = value;
    return this;
  }
  deleteMapHeight() {
    this._value._hasMapHeight = false;
    this._value._mapHeight = null;
    return this;
  }
  setTileSize(value) {
    this._value._hasTileSize = true;
    this._value._tileSize = value;
    return this;
  }
  deleteTileSize() {
    this._value._hasTileSize = false;
    this._value._tileSize = null;
    return this;
  }
  addAllCtrlPts(values) {
    this._value._ctrlPts = this._value._ctrlPts.concat(values);
    return this;
  }
  addCtrlPts(value) {
    this._value._ctrlPts = this._value._ctrlPts.concat([value]);
    return this;
  }
  setCtrlPts(index, value) {
    this._value._ctrlPts = this._value._ctrlPts.concat();
    this._value._ctrlPts[index] = value;
    return this;
  }
  clearCtrlPts() {
    this._value._ctrlPts = [];
    return this;
  }
  addAllTexCtrlPts(values) {
    this._value._texCtrlPts = this._value._texCtrlPts.concat(values);
    return this;
  }
  addTexCtrlPts(value) {
    this._value._texCtrlPts = this._value._texCtrlPts.concat([value]);
    return this;
  }
  setTexCtrlPts(index, value) {
    this._value._texCtrlPts = this._value._texCtrlPts.concat();
    this._value._texCtrlPts[index] = value;
    return this;
  }
  clearTexCtrlPts() {
    this._value._texCtrlPts = [];
    return this;
  }
  setNavmeshTileSize(value) {
    this._value._hasNavmeshTileSize = true;
    this._value._navmeshTileSize = value;
    return this;
  }
  deleteNavmeshTileSize() {
    this._value._hasNavmeshTileSize = false;
    this._value._navmeshTileSize = null;
    return this;
  }
  setUseGridGraph(value) {
    this._value._hasUseGridGraph = true;
    this._value._useGridGraph = value;
    return this;
  }
  deleteUseGridGraph() {
    this._value._hasUseGridGraph = false;
    this._value._useGridGraph = null;
    return this;
  }
  setGridNodeSize(value) {
    this._value._hasGridNodeSize = true;
    this._value._gridNodeSize = value;
    return this;
  }
  deleteGridNodeSize() {
    this._value._hasGridNodeSize = false;
    this._value._gridNodeSize = null;
    return this;
  }
}
UndoableTileMapData.Builder = UndoableTileMapData_Builder;
class UndoableTileMapData_WithParent {
  /**
   * @param {UndoableTileMapData} value
   * @param {UndoableTileMapData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableTileMapData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapWidth() {
    if (this._cachedHasMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedHasMapWidth = true;
      } else {
        this._cachedHasMapWidth = this._parent ? this._parent.hasMapWidth : false;
      }
    }
    return this._cachedHasMapWidth;
  }
  get mapWidth() {
    if (this._cachedMapWidth === undefined) {
      if (this._value.hasMapWidth) {
        this._cachedMapWidth = this._value.mapWidth;
      } else {
        this._cachedMapWidth = this._parent ? this._parent.mapWidth : this._value.mapWidth;
      }
    }
    return this._cachedMapWidth;
  }
  get hasMapHeight() {
    if (this._cachedHasMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedHasMapHeight = true;
      } else {
        this._cachedHasMapHeight = this._parent ? this._parent.hasMapHeight : false;
      }
    }
    return this._cachedHasMapHeight;
  }
  get mapHeight() {
    if (this._cachedMapHeight === undefined) {
      if (this._value.hasMapHeight) {
        this._cachedMapHeight = this._value.mapHeight;
      } else {
        this._cachedMapHeight = this._parent ? this._parent.mapHeight : this._value.mapHeight;
      }
    }
    return this._cachedMapHeight;
  }
  get hasTileSize() {
    if (this._cachedHasTileSize === undefined) {
      if (this._value.hasTileSize) {
        this._cachedHasTileSize = true;
      } else {
        this._cachedHasTileSize = this._parent ? this._parent.hasTileSize : false;
      }
    }
    return this._cachedHasTileSize;
  }
  get tileSize() {
    if (this._cachedTileSize === undefined) {
      if (this._value.hasTileSize) {
        this._cachedTileSize = this._value.tileSize;
      } else {
        this._cachedTileSize = this._parent ? this._parent.tileSize : this._value.tileSize;
      }
    }
    return this._cachedTileSize;
  }
  get selfCtrlPts() {
    if (!this._selfCtrlPts) {
      this._selfCtrlPts = [];
      for (let i of this._value.ctrlPts) {
        this._selfCtrlPts.push(new UndoableControlPoint.WithParent(i, null));
      }
    }
    return this._selfCtrlPts;
  }
  get inherentCtrlPts() {
    if (!this._inherentCtrlPts) {
      this._inherentCtrlPts = this._parent ? this._parent.ctrlPts : [];
    }
    return this._inherentCtrlPts;
  }
  get ctrlPts() {
    if (!this._allCtrlPts) {
      this._allCtrlPts = this._parent ? this._parent.ctrlPts.concat(this.selfCtrlPts) : this.selfCtrlPts;
    }
    return this._allCtrlPts;
  }
  get selfTexCtrlPts() {
    if (!this._selfTexCtrlPts) {
      this._selfTexCtrlPts = [];
      for (let i of this._value.texCtrlPts) {
        this._selfTexCtrlPts.push(new UndoableTextureControlPoint.WithParent(i, null));
      }
    }
    return this._selfTexCtrlPts;
  }
  get inherentTexCtrlPts() {
    if (!this._inherentTexCtrlPts) {
      this._inherentTexCtrlPts = this._parent ? this._parent.texCtrlPts : [];
    }
    return this._inherentTexCtrlPts;
  }
  get texCtrlPts() {
    if (!this._allTexCtrlPts) {
      this._allTexCtrlPts = this._parent ? this._parent.texCtrlPts.concat(this.selfTexCtrlPts) : this.selfTexCtrlPts;
    }
    return this._allTexCtrlPts;
  }
  get hasNavmeshTileSize() {
    if (this._cachedHasNavmeshTileSize === undefined) {
      if (this._value.hasNavmeshTileSize) {
        this._cachedHasNavmeshTileSize = true;
      } else {
        this._cachedHasNavmeshTileSize = this._parent ? this._parent.hasNavmeshTileSize : false;
      }
    }
    return this._cachedHasNavmeshTileSize;
  }
  get navmeshTileSize() {
    if (this._cachedNavmeshTileSize === undefined) {
      if (this._value.hasNavmeshTileSize) {
        this._cachedNavmeshTileSize = this._value.navmeshTileSize;
      } else {
        this._cachedNavmeshTileSize = this._parent ? this._parent.navmeshTileSize : this._value.navmeshTileSize;
      }
    }
    return this._cachedNavmeshTileSize;
  }
  get hasUseGridGraph() {
    if (this._cachedHasUseGridGraph === undefined) {
      if (this._value.hasUseGridGraph) {
        this._cachedHasUseGridGraph = true;
      } else {
        this._cachedHasUseGridGraph = this._parent ? this._parent.hasUseGridGraph : false;
      }
    }
    return this._cachedHasUseGridGraph;
  }
  get useGridGraph() {
    if (this._cachedUseGridGraph === undefined) {
      if (this._value.hasUseGridGraph) {
        this._cachedUseGridGraph = this._value.useGridGraph;
      } else {
        this._cachedUseGridGraph = this._parent ? this._parent.useGridGraph : this._value.useGridGraph;
      }
    }
    return this._cachedUseGridGraph;
  }
  get hasGridNodeSize() {
    if (this._cachedHasGridNodeSize === undefined) {
      if (this._value.hasGridNodeSize) {
        this._cachedHasGridNodeSize = true;
      } else {
        this._cachedHasGridNodeSize = this._parent ? this._parent.hasGridNodeSize : false;
      }
    }
    return this._cachedHasGridNodeSize;
  }
  get gridNodeSize() {
    if (this._cachedGridNodeSize === undefined) {
      if (this._value.hasGridNodeSize) {
        this._cachedGridNodeSize = this._value.gridNodeSize;
      } else {
        this._cachedGridNodeSize = this._parent ? this._parent.gridNodeSize : this._value.gridNodeSize;
      }
    }
    return this._cachedGridNodeSize;
  }
  update(current, parent) {
    const result = new UndoableTileMapData_WithParent(current, parent);
    if (this._selfCtrlPts) {
      if (this._value.ctrlPts === current.ctrlPts) {
        result._selfCtrlPts = this._selfCtrlPts;
      } else {
        result._selfCtrlPts = [];
        for (let i = 0; i < current.ctrlPts.length; i++) {
          const oldValue = this._value.ctrlPts[i];
          if (oldValue) {
            const oldCache = this._selfCtrlPts[i];
            if (oldValue === current.ctrlPts[i]) {
              result._selfCtrlPts[i] = oldCache;
            } else {
              result._selfCtrlPts[i] = oldCache.update(current.ctrlPts[i], null);
            }
          } else {
            result._selfCtrlPts[i] = new UndoableControlPoint.WithParent(current.ctrlPts[i], null);
          }
        }
      }
    }
    if (this._selfTexCtrlPts) {
      if (this._value.texCtrlPts === current.texCtrlPts) {
        result._selfTexCtrlPts = this._selfTexCtrlPts;
      } else {
        result._selfTexCtrlPts = [];
        for (let i = 0; i < current.texCtrlPts.length; i++) {
          const oldValue = this._value.texCtrlPts[i];
          if (oldValue) {
            const oldCache = this._selfTexCtrlPts[i];
            if (oldValue === current.texCtrlPts[i]) {
              result._selfTexCtrlPts[i] = oldCache;
            } else {
              result._selfTexCtrlPts[i] = oldCache.update(current.texCtrlPts[i], null);
            }
          } else {
            result._selfTexCtrlPts[i] = new UndoableTextureControlPoint.WithParent(current.texCtrlPts[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableTileMapData_WithParent.default = new UndoableTileMapData_WithParent(UndoableTileMapData.default, null);
UndoableTileMapData.WithParent = UndoableTileMapData_WithParent;
class UndoableTileMapData_Descriptor {
  get mapWidth() {
    if (!this._mapWidth) {
      this._mapWidth = {
        name: "mapWidth",
        Name: "MapWidth",
        number: 1,
        protoType: 5,
        protoName: "map_width",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapWidth;
  }
  get mapHeight() {
    if (!this._mapHeight) {
      this._mapHeight = {
        name: "mapHeight",
        Name: "MapHeight",
        number: 2,
        protoType: 5,
        protoName: "map_height",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapHeight;
  }
  get tileSize() {
    if (!this._tileSize) {
      this._tileSize = {
        name: "tileSize",
        Name: "TileSize",
        number: 3,
        protoType: 2,
        protoName: "tile_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tileSize;
  }
  get ctrlPts() {
    if (!this._ctrlPts) {
      this._ctrlPts = {
        name: "ctrlPts",
        Name: "CtrlPts",
        number: 4,
        protoType: 11,
        protoName: "ctrl_pts",
        type: UndoableControlPoint,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ctrlPts;
  }
  get texCtrlPts() {
    if (!this._texCtrlPts) {
      this._texCtrlPts = {
        name: "texCtrlPts",
        Name: "TexCtrlPts",
        number: 5,
        protoType: 11,
        protoName: "tex_ctrl_pts",
        type: UndoableTextureControlPoint,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._texCtrlPts;
  }
  get navmeshTileSize() {
    if (!this._navmeshTileSize) {
      this._navmeshTileSize = {
        name: "navmeshTileSize",
        Name: "NavmeshTileSize",
        number: 11,
        protoType: 5,
        protoName: "navmesh_tile_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navmeshTileSize;
  }
  get useGridGraph() {
    if (!this._useGridGraph) {
      this._useGridGraph = {
        name: "useGridGraph",
        Name: "UseGridGraph",
        number: 12,
        protoType: 8,
        protoName: "use_grid_graph",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useGridGraph;
  }
  get gridNodeSize() {
    if (!this._gridNodeSize) {
      this._gridNodeSize = {
        name: "gridNodeSize",
        Name: "GridNodeSize",
        number: 13,
        protoType: 1,
        protoName: "grid_node_size",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gridNodeSize;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapWidth,
        this.mapHeight,
        this.tileSize,
        this.ctrlPts,
        this.texCtrlPts,
        this.navmeshTileSize,
        this.useGridGraph,
        this.gridNodeSize,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapWidth",
        Name: "DummyOneofForMapWidth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMapHeight",
        Name: "DummyOneofForMapHeight",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTileSize",
        Name: "DummyOneofForTileSize",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNavmeshTileSize",
        Name: "DummyOneofForNavmeshTileSize",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseGridGraph",
        Name: "DummyOneofForUseGridGraph",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGridNodeSize",
        Name: "DummyOneofForGridNodeSize",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableTileMapData.descriptor = new UndoableTileMapData_Descriptor();
class UndoablePropsData_PrefabsEntry {
  get descriptor() {
    return UndoablePropsData_PrefabsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsData_PrefabsEntry) {
      return value;
    }
    return UndoablePropsData_PrefabsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsData_PrefabsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoablePrefabData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoablePrefabData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoablePrefabData}
   */
  get value() {
    return this._hasValue ? this._value : UndoablePrefabData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PrefabsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoablePropsData_PrefabsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PrefabsEntry(this);
              copy._hasValue = true;
              copy._value = UndoablePrefabData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoablePropsData_PrefabsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoablePropsData_PrefabsEntry(this);
            copy._hasValue = true;
            copy._value = UndoablePrefabData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoablePropsData_PrefabsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsData_PrefabsEntry} other
   * @returns {UndoablePropsData_PrefabsEntry}
   */
  merge(other) {
    const copy = new UndoablePropsData_PrefabsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoablePropsData_PrefabsEntry.default = new UndoablePropsData_PrefabsEntry();
class UndoablePropsData_PrefabsEntry_Builder {
  constructor(value) {
    this._value = new UndoablePropsData_PrefabsEntry(value);
  }
  build() {
    return new UndoablePropsData_PrefabsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoablePropsData_PrefabsEntry.Builder = UndoablePropsData_PrefabsEntry_Builder;
class UndoablePropsData_PrefabsEntry_WithParent {
  /**
   * @param {UndoablePropsData_PrefabsEntry} value
   * @param {UndoablePropsData_PrefabsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsData_PrefabsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoablePrefabData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoablePrefabData.WithParent(UndoablePrefabData.default, this._parent.value) : UndoablePrefabData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoablePropsData_PrefabsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoablePropsData_PrefabsEntry_WithParent.default = new UndoablePropsData_PrefabsEntry_WithParent(UndoablePropsData_PrefabsEntry.default, null);
UndoablePropsData_PrefabsEntry.WithParent = UndoablePropsData_PrefabsEntry_WithParent;
class UndoablePropsData_PrefabsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoablePrefabData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoablePropsData_PrefabsEntry.descriptor = new UndoablePropsData_PrefabsEntry_Descriptor();
class UndoablePropsData_PropsEntry {
  get descriptor() {
    return UndoablePropsData_PropsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsData_PropsEntry) {
      return value;
    }
    return UndoablePropsData_PropsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsData_PropsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoablePropData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoablePropData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoablePropData}
   */
  get value() {
    return this._hasValue ? this._value : UndoablePropData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PropsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoablePropsData_PropsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PropsEntry(this);
              copy._hasValue = true;
              copy._value = UndoablePropData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoablePropsData_PropsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoablePropsData_PropsEntry(this);
            copy._hasValue = true;
            copy._value = UndoablePropData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoablePropsData_PropsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsData_PropsEntry} other
   * @returns {UndoablePropsData_PropsEntry}
   */
  merge(other) {
    const copy = new UndoablePropsData_PropsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoablePropsData_PropsEntry.default = new UndoablePropsData_PropsEntry();
class UndoablePropsData_PropsEntry_Builder {
  constructor(value) {
    this._value = new UndoablePropsData_PropsEntry(value);
  }
  build() {
    return new UndoablePropsData_PropsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoablePropsData_PropsEntry.Builder = UndoablePropsData_PropsEntry_Builder;
class UndoablePropsData_PropsEntry_WithParent {
  /**
   * @param {UndoablePropsData_PropsEntry} value
   * @param {UndoablePropsData_PropsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsData_PropsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoablePropData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoablePropData.WithParent(UndoablePropData.default, this._parent.value) : UndoablePropData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoablePropsData_PropsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoablePropsData_PropsEntry_WithParent.default = new UndoablePropsData_PropsEntry_WithParent(UndoablePropsData_PropsEntry.default, null);
UndoablePropsData_PropsEntry.WithParent = UndoablePropsData_PropsEntry_WithParent;
class UndoablePropsData_PropsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoablePropData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoablePropsData_PropsEntry.descriptor = new UndoablePropsData_PropsEntry_Descriptor();
class UndoablePropsData_PropLayersEntry {
  get descriptor() {
    return UndoablePropsData_PropLayersEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsData_PropLayersEntry) {
      return value;
    }
    return UndoablePropsData_PropLayersEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsData_PropLayersEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = PropLayerInfo.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = PropLayerInfo.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {PropLayerInfo}
   */
  get value() {
    return this._hasValue ? this._value : PropLayerInfo.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PropLayersEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoablePropsData_PropLayersEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData_PropLayersEntry(this);
              copy._hasValue = true;
              copy._value = PropLayerInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoablePropsData_PropLayersEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoablePropsData_PropLayersEntry(this);
            copy._hasValue = true;
            copy._value = PropLayerInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoablePropsData_PropLayersEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsData_PropLayersEntry} other
   * @returns {UndoablePropsData_PropLayersEntry}
   */
  merge(other) {
    const copy = new UndoablePropsData_PropLayersEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoablePropsData_PropLayersEntry.default = new UndoablePropsData_PropLayersEntry();
class UndoablePropsData_PropLayersEntry_Builder {
  constructor(value) {
    this._value = new UndoablePropsData_PropLayersEntry(value);
  }
  build() {
    return new UndoablePropsData_PropLayersEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoablePropsData_PropLayersEntry.Builder = UndoablePropsData_PropLayersEntry_Builder;
class UndoablePropsData_PropLayersEntry_WithParent {
  /**
   * @param {UndoablePropsData_PropLayersEntry} value
   * @param {UndoablePropsData_PropLayersEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsData_PropLayersEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new PropLayerInfo.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new PropLayerInfo.WithParent(PropLayerInfo.default, this._parent.value) : PropLayerInfo.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoablePropsData_PropLayersEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoablePropsData_PropLayersEntry_WithParent.default = new UndoablePropsData_PropLayersEntry_WithParent(UndoablePropsData_PropLayersEntry.default, null);
UndoablePropsData_PropLayersEntry.WithParent = UndoablePropsData_PropLayersEntry_WithParent;
class UndoablePropsData_PropLayersEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: PropLayerInfo,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoablePropsData_PropLayersEntry.descriptor = new UndoablePropsData_PropLayersEntry_Descriptor();
export class UndoablePropsData {
  get descriptor() {
    return UndoablePropsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._prefabs = {};
    this._props = {};
    this._propLayers = {};
    this._hasDisplayDefaultLayer = false;
    this._displayDefaultLayer = null;
  }
  isEmpty() {
    if (Object.keys(this._prefabs).length > 0) return false;
    if (Object.keys(this._props).length > 0) return false;
    if (Object.keys(this._propLayers).length > 0) return false;
    if (this._hasDisplayDefaultLayer) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsData) {
      return value;
    }
    return UndoablePropsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsData();
    result._prefabs = JsonToMap(json.prefabs, JsonToString, UndoablePrefabData);
    result._props = JsonToMap(json.props, JsonToString, UndoablePropData);
    result._propLayers = JsonToMap(json.propLayers, JsonToString, PropLayerInfo);
    if (json.displayDefaultLayer != null) {
      result._hasDisplayDefaultLayer = true;
      result._displayDefaultLayer = JsonToBoolean.fromJson(json.displayDefaultLayer);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._prefabs).length > 0) {
      result.prefabs = MapToJson(this._prefabs, JsonToString, UndoablePrefabData);
    }
    if (Object.keys(this._props).length > 0) {
      result.props = MapToJson(this._props, JsonToString, UndoablePropData);
    }
    if (Object.keys(this._propLayers).length > 0) {
      result.propLayers = MapToJson(this._propLayers, JsonToString, PropLayerInfo);
    }
    if (this._hasDisplayDefaultLayer) {
      result.displayDefaultLayer = JsonToBoolean.toJson(this._displayDefaultLayer);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoablePrefabData>}
   */
  get prefabs() {
    return this._prefabs;
  }
  setPrefabs(path, value) {
    return {type: 'SET', path: path.concat(['prefabs']), value: MapToJson(value, JsonToString, UndoablePrefabData)};
  }
  setPrefabsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['prefabs', key]), value: value.toJson()};
  }
  deletePrefabs(path) {
    return {type: 'DELETE', path: path.concat(['prefabs'])};
  }
  deletePrefabsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['prefabs', key])};
  }
  /**
   * @returns {Object<string, UndoablePropData>}
   */
  get props() {
    return this._props;
  }
  setProps(path, value) {
    return {type: 'SET', path: path.concat(['props']), value: MapToJson(value, JsonToString, UndoablePropData)};
  }
  setPropsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['props', key]), value: value.toJson()};
  }
  deleteProps(path) {
    return {type: 'DELETE', path: path.concat(['props'])};
  }
  deletePropsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['props', key])};
  }
  /**
   * @returns {Object<string, PropLayerInfo>}
   */
  get propLayers() {
    return this._propLayers;
  }
  setPropLayers(path, value) {
    return {type: 'SET', path: path.concat(['propLayers']), value: MapToJson(value, JsonToString, PropLayerInfo)};
  }
  setPropLayersByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['propLayers', key]), value: value.toJson()};
  }
  deletePropLayers(path) {
    return {type: 'DELETE', path: path.concat(['propLayers'])};
  }
  deletePropLayersByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['propLayers', key])};
  }
  /**
   * @returns {boolean}
   */
  get displayDefaultLayer() {
    return this._hasDisplayDefaultLayer ? this._displayDefaultLayer : JsonToBoolean.default;
  }
  get hasDisplayDefaultLayer() {
    return this._hasDisplayDefaultLayer;
  }
  setDisplayDefaultLayer(path, value) {
    return {type: 'SET', path: path.concat(['displayDefaultLayer']), value};
  }
  deleteDisplayDefaultLayer(path) {
    return {type: 'DELETE', path: path.concat(['displayDefaultLayer'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefabs": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._prefabs).length === 0) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._prefabs = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._prefabs = {};
              for (let key in value) {
                copy._prefabs[key] = UndoablePrefabData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._prefabs = {...copy._prefabs};
              copy._prefabs[path[1]] = UndoablePrefabData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._prefabs[path[1]]) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._prefabs = {...copy._prefabs};
              delete copy._prefabs[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._prefabs[key] === undefined) {
            const copy = new UndoablePropsData(this);
            copy._prefabs = {...copy._prefabs};
            copy._prefabs[key] = UndoablePrefabData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._prefabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoablePropsData(this);
          copy._prefabs = {...copy._prefabs};
          copy._prefabs[key] = newValue;
          return copy;
        }
      }
      case "props": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._props).length === 0) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._props = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._props = {};
              for (let key in value) {
                copy._props[key] = UndoablePropData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._props = {...copy._props};
              copy._props[path[1]] = UndoablePropData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._props[path[1]]) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._props = {...copy._props};
              delete copy._props[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._props[key] === undefined) {
            const copy = new UndoablePropsData(this);
            copy._props = {...copy._props};
            copy._props[key] = UndoablePropData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._props[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoablePropsData(this);
          copy._props = {...copy._props};
          copy._props[key] = newValue;
          return copy;
        }
      }
      case "propLayers": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._propLayers).length === 0) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._propLayers = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._propLayers = {};
              for (let key in value) {
                copy._propLayers[key] = PropLayerInfo.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._propLayers = {...copy._propLayers};
              copy._propLayers[path[1]] = PropLayerInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._propLayers[path[1]]) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._propLayers = {...copy._propLayers};
              delete copy._propLayers[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._propLayers[key] === undefined) {
            const copy = new UndoablePropsData(this);
            copy._propLayers = {...copy._propLayers};
            copy._propLayers[key] = PropLayerInfo.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._propLayers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoablePropsData(this);
          copy._propLayers = {...copy._propLayers};
          copy._propLayers[key] = newValue;
          return copy;
        }
      }
      case "displayDefaultLayer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsData(this);
              copy._hasDisplayDefaultLayer = true;
              copy._displayDefaultLayer = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayDefaultLayer) {
                return this;
              }
              const copy = new UndoablePropsData(this);
              copy._hasDisplayDefaultLayer = false;
              copy._displayDefaultLayer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsData} other
   * @returns {UndoablePropsData}
   */
  merge(other) {
    const copy = new UndoablePropsData(this);
    copy._prefabs = {...this._prefabs, ...other._prefabs};
    copy._props = {...this._props, ...other._props};
    copy._propLayers = {...this._propLayers, ...other._propLayers};
    if (other._hasDisplayDefaultLayer) {
      copy._hasDisplayDefaultLayer = true;
      copy._displayDefaultLayer = other._displayDefaultLayer;
    }
    return copy;
  }
}
UndoablePropsData.default = new UndoablePropsData();
UndoablePropsData.PrefabsEntry = UndoablePropsData_PrefabsEntry;
UndoablePropsData.PropsEntry = UndoablePropsData_PropsEntry;
UndoablePropsData.PropLayersEntry = UndoablePropsData_PropLayersEntry;
class UndoablePropsData_Builder {
  constructor(value) {
    this._value = new UndoablePropsData(value);
  }
  build() {
    return new UndoablePropsData(this._value);
  }
  setPrefabs(key, value) {
    this._value._prefabs = {...this._value._prefabs, [key]: value};
    return this;
  }
  addAllPrefabs(values) {
    this._value._prefabs = {...this._value._prefabs, ...values};
    return this;
  }
  deletePrefabs(key) {
    this._value._prefabs = {...this._value._prefabs};
    delete this._value._prefabs[key];
    return this;
  }
  clearPrefabs() {
    this._value._prefabs = {};
    return this;
  }
  setProps(key, value) {
    this._value._props = {...this._value._props, [key]: value};
    return this;
  }
  addAllProps(values) {
    this._value._props = {...this._value._props, ...values};
    return this;
  }
  deleteProps(key) {
    this._value._props = {...this._value._props};
    delete this._value._props[key];
    return this;
  }
  clearProps() {
    this._value._props = {};
    return this;
  }
  setPropLayers(key, value) {
    this._value._propLayers = {...this._value._propLayers, [key]: value};
    return this;
  }
  addAllPropLayers(values) {
    this._value._propLayers = {...this._value._propLayers, ...values};
    return this;
  }
  deletePropLayers(key) {
    this._value._propLayers = {...this._value._propLayers};
    delete this._value._propLayers[key];
    return this;
  }
  clearPropLayers() {
    this._value._propLayers = {};
    return this;
  }
  setDisplayDefaultLayer(value) {
    this._value._hasDisplayDefaultLayer = true;
    this._value._displayDefaultLayer = value;
    return this;
  }
  deleteDisplayDefaultLayer() {
    this._value._hasDisplayDefaultLayer = false;
    this._value._displayDefaultLayer = null;
    return this;
  }
}
UndoablePropsData.Builder = UndoablePropsData_Builder;
class UndoablePropsData_WithParent {
  /**
   * @param {UndoablePropsData} value
   * @param {UndoablePropsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPrefabs() {
    if (!this._selfPrefabs) {
      this._selfPrefabs = {};
      for (let i in this._value.prefabs) {
        this._selfPrefabs[i] = new UndoablePrefabData.WithParent(this._value.prefabs[i], null);
      }
    }
    return this._selfPrefabs;
  }
  get inherentPrefabs() {
    if (!this._inherentPrefabs) {
      this._inherentPrefabs = this._parent ? this._parent.prefabs : {};
    }
    return this._inherentPrefabs;
  }
  get prefabs() {
    if (!this._allPrefabs) {
      this._allPrefabs = this._parent ? {...this._parent.prefabs, ...this.selfPrefabs} : this.selfPrefabs;
    }
    return this._allPrefabs;
  }
  get selfProps() {
    if (!this._selfProps) {
      this._selfProps = {};
      for (let i in this._value.props) {
        this._selfProps[i] = new UndoablePropData.WithParent(this._value.props[i], null);
      }
    }
    return this._selfProps;
  }
  get inherentProps() {
    if (!this._inherentProps) {
      this._inherentProps = this._parent ? this._parent.props : {};
    }
    return this._inherentProps;
  }
  get props() {
    if (!this._allProps) {
      this._allProps = this._parent ? {...this._parent.props, ...this.selfProps} : this.selfProps;
    }
    return this._allProps;
  }
  get selfPropLayers() {
    if (!this._selfPropLayers) {
      this._selfPropLayers = {};
      for (let i in this._value.propLayers) {
        this._selfPropLayers[i] = new PropLayerInfo.WithParent(this._value.propLayers[i], null);
      }
    }
    return this._selfPropLayers;
  }
  get inherentPropLayers() {
    if (!this._inherentPropLayers) {
      this._inherentPropLayers = this._parent ? this._parent.propLayers : {};
    }
    return this._inherentPropLayers;
  }
  get propLayers() {
    if (!this._allPropLayers) {
      this._allPropLayers = this._parent ? {...this._parent.propLayers, ...this.selfPropLayers} : this.selfPropLayers;
    }
    return this._allPropLayers;
  }
  get hasDisplayDefaultLayer() {
    if (this._cachedHasDisplayDefaultLayer === undefined) {
      if (this._value.hasDisplayDefaultLayer) {
        this._cachedHasDisplayDefaultLayer = true;
      } else {
        this._cachedHasDisplayDefaultLayer = this._parent ? this._parent.hasDisplayDefaultLayer : false;
      }
    }
    return this._cachedHasDisplayDefaultLayer;
  }
  get displayDefaultLayer() {
    if (this._cachedDisplayDefaultLayer === undefined) {
      if (this._value.hasDisplayDefaultLayer) {
        this._cachedDisplayDefaultLayer = this._value.displayDefaultLayer;
      } else {
        this._cachedDisplayDefaultLayer = this._parent ? this._parent.displayDefaultLayer : this._value.displayDefaultLayer;
      }
    }
    return this._cachedDisplayDefaultLayer;
  }
  update(current, parent) {
    const result = new UndoablePropsData_WithParent(current, parent);
    if (this._selfPrefabs) {
      if (this._value.prefabs === current.prefabs) {
        result._selfPrefabs = this._selfPrefabs;
      } else {
        result._selfPrefabs = {};
        for (let i in current.prefabs) {
          const oldValue = this._value.prefabs[i];
          if (oldValue) {
            const oldCache = this._selfPrefabs[i];
            if (oldValue === current.prefabs[i]) {
              result._selfPrefabs[i] = oldCache;
            } else {
              result._selfPrefabs[i] = oldCache.update(current.prefabs[i], null);
            }
          } else {
            result._selfPrefabs[i] = new UndoablePrefabData.WithParent(current.prefabs[i], null);
          }
        }
      }
    }
    if (this._selfProps) {
      if (this._value.props === current.props) {
        result._selfProps = this._selfProps;
      } else {
        result._selfProps = {};
        for (let i in current.props) {
          const oldValue = this._value.props[i];
          if (oldValue) {
            const oldCache = this._selfProps[i];
            if (oldValue === current.props[i]) {
              result._selfProps[i] = oldCache;
            } else {
              result._selfProps[i] = oldCache.update(current.props[i], null);
            }
          } else {
            result._selfProps[i] = new UndoablePropData.WithParent(current.props[i], null);
          }
        }
      }
    }
    if (this._selfPropLayers) {
      if (this._value.propLayers === current.propLayers) {
        result._selfPropLayers = this._selfPropLayers;
      } else {
        result._selfPropLayers = {};
        for (let i in current.propLayers) {
          const oldValue = this._value.propLayers[i];
          if (oldValue) {
            const oldCache = this._selfPropLayers[i];
            if (oldValue === current.propLayers[i]) {
              result._selfPropLayers[i] = oldCache;
            } else {
              result._selfPropLayers[i] = oldCache.update(current.propLayers[i], null);
            }
          } else {
            result._selfPropLayers[i] = new PropLayerInfo.WithParent(current.propLayers[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoablePropsData_WithParent.default = new UndoablePropsData_WithParent(UndoablePropsData.default, null);
UndoablePropsData.WithParent = UndoablePropsData_WithParent;
class UndoablePropsData_Descriptor {
  get prefabs() {
    if (!this._prefabs) {
      this._prefabs = {
        name: "prefabs",
        Name: "Prefabs",
        number: 1,
        protoType: 11,
        protoName: "prefabs",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoablePrefabData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefabs;
  }
  get props() {
    if (!this._props) {
      this._props = {
        name: "props",
        Name: "Props",
        number: 2,
        protoType: 11,
        protoName: "props",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoablePropData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._props;
  }
  get propLayers() {
    if (!this._propLayers) {
      this._propLayers = {
        name: "propLayers",
        Name: "PropLayers",
        number: 4,
        protoType: 11,
        protoName: "prop_layers",
        isMap: true,
        keyType: JsonToString,
        valueType: PropLayerInfo,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
          comments: "UndoablePropsGroup prop_group = 3;",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propLayers;
  }
  get displayDefaultLayer() {
    if (!this._displayDefaultLayer) {
      this._displayDefaultLayer = {
        name: "displayDefaultLayer",
        Name: "DisplayDefaultLayer",
        number: 5,
        protoType: 8,
        protoName: "display_default_layer",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayDefaultLayer;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefabs,
        this.props,
        this.propLayers,
        this.displayDefaultLayer,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDisplayDefaultLayer",
        Name: "DummyOneofForDisplayDefaultLayer",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoablePropsData.descriptor = new UndoablePropsData_Descriptor();
class UndoablePropsGroup_ChildPropsEntry {
  get descriptor() {
    return UndoablePropsGroup_ChildPropsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsGroup_ChildPropsEntry) {
      return value;
    }
    return UndoablePropsGroup_ChildPropsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsGroup_ChildPropsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoablePropData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoablePropData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoablePropData}
   */
  get value() {
    return this._hasValue ? this._value : UndoablePropData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup_ChildPropsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoablePropsGroup_ChildPropsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup_ChildPropsEntry(this);
              copy._hasValue = true;
              copy._value = UndoablePropData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoablePropsGroup_ChildPropsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoablePropsGroup_ChildPropsEntry(this);
            copy._hasValue = true;
            copy._value = UndoablePropData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoablePropsGroup_ChildPropsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsGroup_ChildPropsEntry} other
   * @returns {UndoablePropsGroup_ChildPropsEntry}
   */
  merge(other) {
    const copy = new UndoablePropsGroup_ChildPropsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoablePropsGroup_ChildPropsEntry.default = new UndoablePropsGroup_ChildPropsEntry();
class UndoablePropsGroup_ChildPropsEntry_Builder {
  constructor(value) {
    this._value = new UndoablePropsGroup_ChildPropsEntry(value);
  }
  build() {
    return new UndoablePropsGroup_ChildPropsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoablePropsGroup_ChildPropsEntry.Builder = UndoablePropsGroup_ChildPropsEntry_Builder;
class UndoablePropsGroup_ChildPropsEntry_WithParent {
  /**
   * @param {UndoablePropsGroup_ChildPropsEntry} value
   * @param {UndoablePropsGroup_ChildPropsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsGroup_ChildPropsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoablePropData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoablePropData.WithParent(UndoablePropData.default, this._parent.value) : UndoablePropData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoablePropsGroup_ChildPropsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoablePropsGroup_ChildPropsEntry_WithParent.default = new UndoablePropsGroup_ChildPropsEntry_WithParent(UndoablePropsGroup_ChildPropsEntry.default, null);
UndoablePropsGroup_ChildPropsEntry.WithParent = UndoablePropsGroup_ChildPropsEntry_WithParent;
class UndoablePropsGroup_ChildPropsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoablePropData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoablePropsGroup_ChildPropsEntry.descriptor = new UndoablePropsGroup_ChildPropsEntry_Descriptor();
export class UndoablePropsGroup {
  get descriptor() {
    return UndoablePropsGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPropPosition = false;
    this._propPosition = null;
    this._hasPropRotation = false;
    this._propRotation = null;
    this._hasPropScale = false;
    this._propScale = null;
    this._childProps = {};
  }
  isEmpty() {
    if (this._hasPropPosition && !this._propPosition.isEmpty()) return false;
    if (this._hasPropRotation && !this._propRotation.isEmpty()) return false;
    if (this._hasPropScale && !this._propScale.isEmpty()) return false;
    if (Object.keys(this._childProps).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropsGroup) {
      return value;
    }
    return UndoablePropsGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropsGroup();
    if (json.propPosition != null) {
      result._hasPropPosition = true;
      result._propPosition = FVector3.fromJson(json.propPosition);
    }
    if (json.propRotation != null) {
      result._hasPropRotation = true;
      result._propRotation = FVector4.fromJson(json.propRotation);
    }
    if (json.propScale != null) {
      result._hasPropScale = true;
      result._propScale = FVector3.fromJson(json.propScale);
    }
    result._childProps = JsonToMap(json.childProps, JsonToString, UndoablePropData);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPropPosition && !this._propPosition.isEmpty()) {
      result.propPosition = FVector3.toJson(this._propPosition);
    }
    if (this._hasPropRotation && !this._propRotation.isEmpty()) {
      result.propRotation = FVector4.toJson(this._propRotation);
    }
    if (this._hasPropScale && !this._propScale.isEmpty()) {
      result.propScale = FVector3.toJson(this._propScale);
    }
    if (Object.keys(this._childProps).length > 0) {
      result.childProps = MapToJson(this._childProps, JsonToString, UndoablePropData);
    }
    return result;
  }
  /**
   * @returns {FVector3}
   */
  get propPosition() {
    return this._hasPropPosition ? this._propPosition : FVector3.default;
  }
  get hasPropPosition() {
    return this._hasPropPosition;
  }
  setPropPosition(path, value) {
    return {type: 'SET', path: path.concat(['propPosition']), value: value.toJson()};
  }
  deletePropPosition(path) {
    return {type: 'DELETE', path: path.concat(['propPosition'])};
  }
  /**
   * @returns {FVector4}
   */
  get propRotation() {
    return this._hasPropRotation ? this._propRotation : FVector4.default;
  }
  get hasPropRotation() {
    return this._hasPropRotation;
  }
  setPropRotation(path, value) {
    return {type: 'SET', path: path.concat(['propRotation']), value: value.toJson()};
  }
  deletePropRotation(path) {
    return {type: 'DELETE', path: path.concat(['propRotation'])};
  }
  /**
   * @returns {FVector3}
   */
  get propScale() {
    return this._hasPropScale ? this._propScale : FVector3.default;
  }
  get hasPropScale() {
    return this._hasPropScale;
  }
  setPropScale(path, value) {
    return {type: 'SET', path: path.concat(['propScale']), value: value.toJson()};
  }
  deletePropScale(path) {
    return {type: 'DELETE', path: path.concat(['propScale'])};
  }
  /**
   * @returns {Object<string, UndoablePropData>}
   */
  get childProps() {
    return this._childProps;
  }
  setChildProps(path, value) {
    return {type: 'SET', path: path.concat(['childProps']), value: MapToJson(value, JsonToString, UndoablePropData)};
  }
  setChildPropsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['childProps', key]), value: value.toJson()};
  }
  deleteChildProps(path) {
    return {type: 'DELETE', path: path.concat(['childProps'])};
  }
  deleteChildPropsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['childProps', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "propPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup(this);
              copy._hasPropPosition = true;
              copy._propPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropPosition) {
                return this;
              }
              const copy = new UndoablePropsGroup(this);
              copy._hasPropPosition = false;
              copy._propPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropPosition) {
            const copy = new UndoablePropsGroup(this);
            copy._hasPropPosition = true;
            copy._propPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propPosition.apply(type, path.slice(1), value);
          if (newValue === this._propPosition) {
            return this;
          }
          const copy = new UndoablePropsGroup(this);
          copy._propPosition = copy._propPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup(this);
              copy._hasPropRotation = true;
              copy._propRotation = FVector4.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropRotation) {
                return this;
              }
              const copy = new UndoablePropsGroup(this);
              copy._hasPropRotation = false;
              copy._propRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropRotation) {
            const copy = new UndoablePropsGroup(this);
            copy._hasPropRotation = true;
            copy._propRotation = FVector4.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propRotation.apply(type, path.slice(1), value);
          if (newValue === this._propRotation) {
            return this;
          }
          const copy = new UndoablePropsGroup(this);
          copy._propRotation = copy._propRotation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup(this);
              copy._hasPropScale = true;
              copy._propScale = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropScale) {
                return this;
              }
              const copy = new UndoablePropsGroup(this);
              copy._hasPropScale = false;
              copy._propScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropScale) {
            const copy = new UndoablePropsGroup(this);
            copy._hasPropScale = true;
            copy._propScale = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propScale.apply(type, path.slice(1), value);
          if (newValue === this._propScale) {
            return this;
          }
          const copy = new UndoablePropsGroup(this);
          copy._propScale = copy._propScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "childProps": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._childProps).length === 0) {
                return this;
              }
              const copy = new UndoablePropsGroup(this);
              copy._childProps = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoablePropsGroup(this);
              copy._childProps = {};
              for (let key in value) {
                copy._childProps[key] = UndoablePropData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropsGroup(this);
              copy._childProps = {...copy._childProps};
              copy._childProps[path[1]] = UndoablePropData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._childProps[path[1]]) {
                return this;
              }
              const copy = new UndoablePropsGroup(this);
              copy._childProps = {...copy._childProps};
              delete copy._childProps[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._childProps[key] === undefined) {
            const copy = new UndoablePropsGroup(this);
            copy._childProps = {...copy._childProps};
            copy._childProps[key] = UndoablePropData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._childProps[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoablePropsGroup(this);
          copy._childProps = {...copy._childProps};
          copy._childProps[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropsGroup} other
   * @returns {UndoablePropsGroup}
   */
  merge(other) {
    const copy = new UndoablePropsGroup(this);
    if (other._hasPropPosition) {
      if (copy._hasPropPosition) {
        copy._propPosition = copy.propPosition.merge(other.propPosition);
      } else {
        copy._propPosition = other._propPosition;
      }
      copy._hasPropPosition = true;
    }
    if (other._hasPropRotation) {
      if (copy._hasPropRotation) {
        copy._propRotation = copy.propRotation.merge(other.propRotation);
      } else {
        copy._propRotation = other._propRotation;
      }
      copy._hasPropRotation = true;
    }
    if (other._hasPropScale) {
      if (copy._hasPropScale) {
        copy._propScale = copy.propScale.merge(other.propScale);
      } else {
        copy._propScale = other._propScale;
      }
      copy._hasPropScale = true;
    }
    copy._childProps = {...this._childProps, ...other._childProps};
    return copy;
  }
}
UndoablePropsGroup.default = new UndoablePropsGroup();
UndoablePropsGroup.ChildPropsEntry = UndoablePropsGroup_ChildPropsEntry;
class UndoablePropsGroup_Builder {
  constructor(value) {
    this._value = new UndoablePropsGroup(value);
  }
  build() {
    return new UndoablePropsGroup(this._value);
  }
  setPropPosition(value) {
    this._value._hasPropPosition = true;
    this._value._propPosition = value;
    return this;
  }
  deletePropPosition() {
    this._value._hasPropPosition = false;
    this._value._propPosition = null;
    return this;
  }
  setPropRotation(value) {
    this._value._hasPropRotation = true;
    this._value._propRotation = value;
    return this;
  }
  deletePropRotation() {
    this._value._hasPropRotation = false;
    this._value._propRotation = null;
    return this;
  }
  setPropScale(value) {
    this._value._hasPropScale = true;
    this._value._propScale = value;
    return this;
  }
  deletePropScale() {
    this._value._hasPropScale = false;
    this._value._propScale = null;
    return this;
  }
  setChildProps(key, value) {
    this._value._childProps = {...this._value._childProps, [key]: value};
    return this;
  }
  addAllChildProps(values) {
    this._value._childProps = {...this._value._childProps, ...values};
    return this;
  }
  deleteChildProps(key) {
    this._value._childProps = {...this._value._childProps};
    delete this._value._childProps[key];
    return this;
  }
  clearChildProps() {
    this._value._childProps = {};
    return this;
  }
}
UndoablePropsGroup.Builder = UndoablePropsGroup_Builder;
class UndoablePropsGroup_WithParent {
  /**
   * @param {UndoablePropsGroup} value
   * @param {UndoablePropsGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropsGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPropPosition() {
    if (this._cachedHasPropPosition === undefined) {
      if (this._value.hasPropPosition) {
        this._cachedHasPropPosition = true;
      } else {
        this._cachedHasPropPosition = this._parent ? this._parent.hasPropPosition : false;
      }
    }
    return this._cachedHasPropPosition;
  }
  get propPosition() {
    if (!this._cachedPropPosition) {
      if (this._value.hasPropPosition) {
        this._cachedPropPosition = new FVector3.WithParent(this._value.propPosition, this._parent && this._parent.hasPropPosition ? this._parent.propPosition : null);
      } else {
        this._cachedPropPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.propPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedPropPosition;
  }
  get hasPropRotation() {
    if (this._cachedHasPropRotation === undefined) {
      if (this._value.hasPropRotation) {
        this._cachedHasPropRotation = true;
      } else {
        this._cachedHasPropRotation = this._parent ? this._parent.hasPropRotation : false;
      }
    }
    return this._cachedHasPropRotation;
  }
  get propRotation() {
    if (!this._cachedPropRotation) {
      if (this._value.hasPropRotation) {
        this._cachedPropRotation = new FVector4.WithParent(this._value.propRotation, this._parent && this._parent.hasPropRotation ? this._parent.propRotation : null);
      } else {
        this._cachedPropRotation = this._parent ? new FVector4.WithParent(FVector4.default, this._parent.propRotation) : FVector4.WithParent.default;
      }
    }
    return this._cachedPropRotation;
  }
  get hasPropScale() {
    if (this._cachedHasPropScale === undefined) {
      if (this._value.hasPropScale) {
        this._cachedHasPropScale = true;
      } else {
        this._cachedHasPropScale = this._parent ? this._parent.hasPropScale : false;
      }
    }
    return this._cachedHasPropScale;
  }
  get propScale() {
    if (!this._cachedPropScale) {
      if (this._value.hasPropScale) {
        this._cachedPropScale = new FVector3.WithParent(this._value.propScale, this._parent && this._parent.hasPropScale ? this._parent.propScale : null);
      } else {
        this._cachedPropScale = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.propScale) : FVector3.WithParent.default;
      }
    }
    return this._cachedPropScale;
  }
  get selfChildProps() {
    if (!this._selfChildProps) {
      this._selfChildProps = {};
      for (let i in this._value.childProps) {
        this._selfChildProps[i] = new UndoablePropData.WithParent(this._value.childProps[i], null);
      }
    }
    return this._selfChildProps;
  }
  get inherentChildProps() {
    if (!this._inherentChildProps) {
      this._inherentChildProps = this._parent ? this._parent.childProps : {};
    }
    return this._inherentChildProps;
  }
  get childProps() {
    if (!this._allChildProps) {
      this._allChildProps = this._parent ? {...this._parent.childProps, ...this.selfChildProps} : this.selfChildProps;
    }
    return this._allChildProps;
  }
  update(current, parent) {
    const result = new UndoablePropsGroup_WithParent(current, parent);
    if (this._cachedPropPosition && this._value.hasPropPosition && current.hasPropPosition) {
      if (this._value.propPosition === current.propPosition && this._parent === parent) {
        result._cachedPropPosition = this._cachedPropPosition;
      } else {
        result._cachedPropPosition = this._cachedPropPosition.update(current.propPosition, parent && parent.hasPropPosition ? parent.propPosition : null);
      }
    }
    if (this._cachedPropRotation && this._value.hasPropRotation && current.hasPropRotation) {
      if (this._value.propRotation === current.propRotation && this._parent === parent) {
        result._cachedPropRotation = this._cachedPropRotation;
      } else {
        result._cachedPropRotation = this._cachedPropRotation.update(current.propRotation, parent && parent.hasPropRotation ? parent.propRotation : null);
      }
    }
    if (this._cachedPropScale && this._value.hasPropScale && current.hasPropScale) {
      if (this._value.propScale === current.propScale && this._parent === parent) {
        result._cachedPropScale = this._cachedPropScale;
      } else {
        result._cachedPropScale = this._cachedPropScale.update(current.propScale, parent && parent.hasPropScale ? parent.propScale : null);
      }
    }
    if (this._selfChildProps) {
      if (this._value.childProps === current.childProps) {
        result._selfChildProps = this._selfChildProps;
      } else {
        result._selfChildProps = {};
        for (let i in current.childProps) {
          const oldValue = this._value.childProps[i];
          if (oldValue) {
            const oldCache = this._selfChildProps[i];
            if (oldValue === current.childProps[i]) {
              result._selfChildProps[i] = oldCache;
            } else {
              result._selfChildProps[i] = oldCache.update(current.childProps[i], null);
            }
          } else {
            result._selfChildProps[i] = new UndoablePropData.WithParent(current.childProps[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoablePropsGroup_WithParent.default = new UndoablePropsGroup_WithParent(UndoablePropsGroup.default, null);
UndoablePropsGroup.WithParent = UndoablePropsGroup_WithParent;
class UndoablePropsGroup_Descriptor {
  get propPosition() {
    if (!this._propPosition) {
      this._propPosition = {
        name: "propPosition",
        Name: "PropPosition",
        number: 1,
        protoType: 11,
        protoName: "prop_position",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propPosition;
  }
  get propRotation() {
    if (!this._propRotation) {
      this._propRotation = {
        name: "propRotation",
        Name: "PropRotation",
        number: 2,
        protoType: 11,
        protoName: "prop_rotation",
        type: FVector4,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propRotation;
  }
  get propScale() {
    if (!this._propScale) {
      this._propScale = {
        name: "propScale",
        Name: "PropScale",
        number: 3,
        protoType: 11,
        protoName: "prop_scale",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propScale;
  }
  get childProps() {
    if (!this._childProps) {
      this._childProps = {
        name: "childProps",
        Name: "ChildProps",
        number: 4,
        protoType: 11,
        protoName: "child_props",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoablePropData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._childProps;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.propPosition,
        this.propRotation,
        this.propScale,
        this.childProps,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPropPosition",
        Name: "DummyOneofForPropPosition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropRotation",
        Name: "DummyOneofForPropRotation",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropScale",
        Name: "DummyOneofForPropScale",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoablePropsGroup.descriptor = new UndoablePropsGroup_Descriptor();
export class UndoablePrefabData {
  get descriptor() {
    return UndoablePrefabData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPath = false;
    this._path = null;
  }
  isEmpty() {
    if (this._hasPath) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePrefabData) {
      return value;
    }
    return UndoablePrefabData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePrefabData();
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePrefabData(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new UndoablePrefabData(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePrefabData} other
   * @returns {UndoablePrefabData}
   */
  merge(other) {
    const copy = new UndoablePrefabData(this);
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    return copy;
  }
}
UndoablePrefabData.default = new UndoablePrefabData();
class UndoablePrefabData_Builder {
  constructor(value) {
    this._value = new UndoablePrefabData(value);
  }
  build() {
    return new UndoablePrefabData(this._value);
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
}
UndoablePrefabData.Builder = UndoablePrefabData_Builder;
class UndoablePrefabData_WithParent {
  /**
   * @param {UndoablePrefabData} value
   * @param {UndoablePrefabData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePrefabData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  update(current, parent) {
    const result = new UndoablePrefabData_WithParent(current, parent);
    return result;
  }
}
UndoablePrefabData_WithParent.default = new UndoablePrefabData_WithParent(UndoablePrefabData.default, null);
UndoablePrefabData.WithParent = UndoablePrefabData_WithParent;
class UndoablePrefabData_Descriptor {
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 1,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.path,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoablePrefabData.descriptor = new UndoablePrefabData_Descriptor();
export class UndoablePropData {
  get descriptor() {
    return UndoablePropData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefabName = false;
    this._prefabName = null;
    this._hasPropPosition = false;
    this._propPosition = null;
    this._hasPropRotation = false;
    this._propRotation = null;
    this._hasPropScale = false;
    this._propScale = null;
    this._hasColliderScale = false;
    this._colliderScale = null;
    this._hasNavmeshIgnore = false;
    this._navmeshIgnore = null;
    this._hasPropLayer = false;
    this._propLayer = null;
    this._hasPropTag = false;
    this._propTag = null;
  }
  isEmpty() {
    if (this._hasPrefabName) return false;
    if (this._hasPropPosition && !this._propPosition.isEmpty()) return false;
    if (this._hasPropRotation && !this._propRotation.isEmpty()) return false;
    if (this._hasPropScale && !this._propScale.isEmpty()) return false;
    if (this._hasColliderScale) return false;
    if (this._hasNavmeshIgnore) return false;
    if (this._hasPropLayer) return false;
    if (this._hasPropTag) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePropData) {
      return value;
    }
    return UndoablePropData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePropData();
    if (json.prefabName != null) {
      result._hasPrefabName = true;
      result._prefabName = JsonToString.fromJson(json.prefabName);
    }
    if (json.propPosition != null) {
      result._hasPropPosition = true;
      result._propPosition = FVector3.fromJson(json.propPosition);
    }
    if (json.propRotation != null) {
      result._hasPropRotation = true;
      result._propRotation = FVector4.fromJson(json.propRotation);
    }
    if (json.propScale != null) {
      result._hasPropScale = true;
      result._propScale = FVector3.fromJson(json.propScale);
    }
    if (json.colliderScale != null) {
      result._hasColliderScale = true;
      result._colliderScale = JsonToDouble.fromJson(json.colliderScale);
    }
    if (json.navmeshIgnore != null) {
      result._hasNavmeshIgnore = true;
      result._navmeshIgnore = JsonToBoolean.fromJson(json.navmeshIgnore);
    }
    if (json.propLayer != null) {
      result._hasPropLayer = true;
      result._propLayer = JsonToInt32.fromJson(json.propLayer);
    }
    if (json.propTag != null) {
      result._hasPropTag = true;
      result._propTag = JsonToString.fromJson(json.propTag);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefabName) {
      result.prefabName = JsonToString.toJson(this._prefabName);
    }
    if (this._hasPropPosition && !this._propPosition.isEmpty()) {
      result.propPosition = FVector3.toJson(this._propPosition);
    }
    if (this._hasPropRotation && !this._propRotation.isEmpty()) {
      result.propRotation = FVector4.toJson(this._propRotation);
    }
    if (this._hasPropScale && !this._propScale.isEmpty()) {
      result.propScale = FVector3.toJson(this._propScale);
    }
    if (this._hasColliderScale) {
      result.colliderScale = JsonToDouble.toJson(this._colliderScale);
    }
    if (this._hasNavmeshIgnore) {
      result.navmeshIgnore = JsonToBoolean.toJson(this._navmeshIgnore);
    }
    if (this._hasPropLayer) {
      result.propLayer = JsonToInt32.toJson(this._propLayer);
    }
    if (this._hasPropTag) {
      result.propTag = JsonToString.toJson(this._propTag);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefabName() {
    return this._hasPrefabName ? this._prefabName : JsonToString.default;
  }
  get hasPrefabName() {
    return this._hasPrefabName;
  }
  setPrefabName(path, value) {
    return {type: 'SET', path: path.concat(['prefabName']), value};
  }
  deletePrefabName(path) {
    return {type: 'DELETE', path: path.concat(['prefabName'])};
  }
  /**
   * @returns {FVector3}
   */
  get propPosition() {
    return this._hasPropPosition ? this._propPosition : FVector3.default;
  }
  get hasPropPosition() {
    return this._hasPropPosition;
  }
  setPropPosition(path, value) {
    return {type: 'SET', path: path.concat(['propPosition']), value: value.toJson()};
  }
  deletePropPosition(path) {
    return {type: 'DELETE', path: path.concat(['propPosition'])};
  }
  /**
   * @returns {FVector4}
   */
  get propRotation() {
    return this._hasPropRotation ? this._propRotation : FVector4.default;
  }
  get hasPropRotation() {
    return this._hasPropRotation;
  }
  setPropRotation(path, value) {
    return {type: 'SET', path: path.concat(['propRotation']), value: value.toJson()};
  }
  deletePropRotation(path) {
    return {type: 'DELETE', path: path.concat(['propRotation'])};
  }
  /**
   * @returns {FVector3}
   */
  get propScale() {
    return this._hasPropScale ? this._propScale : FVector3.default;
  }
  get hasPropScale() {
    return this._hasPropScale;
  }
  setPropScale(path, value) {
    return {type: 'SET', path: path.concat(['propScale']), value: value.toJson()};
  }
  deletePropScale(path) {
    return {type: 'DELETE', path: path.concat(['propScale'])};
  }
  /**
   * @returns {number}
   */
  get colliderScale() {
    return this._hasColliderScale ? this._colliderScale : JsonToDouble.default;
  }
  get hasColliderScale() {
    return this._hasColliderScale;
  }
  setColliderScale(path, value) {
    return {type: 'SET', path: path.concat(['colliderScale']), value};
  }
  deleteColliderScale(path) {
    return {type: 'DELETE', path: path.concat(['colliderScale'])};
  }
  /**
   * @returns {boolean}
   */
  get navmeshIgnore() {
    return this._hasNavmeshIgnore ? this._navmeshIgnore : JsonToBoolean.default;
  }
  get hasNavmeshIgnore() {
    return this._hasNavmeshIgnore;
  }
  setNavmeshIgnore(path, value) {
    return {type: 'SET', path: path.concat(['navmeshIgnore']), value};
  }
  deleteNavmeshIgnore(path) {
    return {type: 'DELETE', path: path.concat(['navmeshIgnore'])};
  }
  /**
   * @returns {number}
   */
  get propLayer() {
    return this._hasPropLayer ? this._propLayer : JsonToInt32.default;
  }
  get hasPropLayer() {
    return this._hasPropLayer;
  }
  setPropLayer(path, value) {
    return {type: 'SET', path: path.concat(['propLayer']), value};
  }
  deletePropLayer(path) {
    return {type: 'DELETE', path: path.concat(['propLayer'])};
  }
  /**
   * @returns {string}
   */
  get propTag() {
    return this._hasPropTag ? this._propTag : JsonToString.default;
  }
  get hasPropTag() {
    return this._hasPropTag;
  }
  setPropTag(path, value) {
    return {type: 'SET', path: path.concat(['propTag']), value};
  }
  deletePropTag(path) {
    return {type: 'DELETE', path: path.concat(['propTag'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefabName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPrefabName = true;
              copy._prefabName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefabName) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPrefabName = false;
              copy._prefabName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "propPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPropPosition = true;
              copy._propPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropPosition) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPropPosition = false;
              copy._propPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropPosition) {
            const copy = new UndoablePropData(this);
            copy._hasPropPosition = true;
            copy._propPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propPosition.apply(type, path.slice(1), value);
          if (newValue === this._propPosition) {
            return this;
          }
          const copy = new UndoablePropData(this);
          copy._propPosition = copy._propPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPropRotation = true;
              copy._propRotation = FVector4.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropRotation) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPropRotation = false;
              copy._propRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropRotation) {
            const copy = new UndoablePropData(this);
            copy._hasPropRotation = true;
            copy._propRotation = FVector4.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propRotation.apply(type, path.slice(1), value);
          if (newValue === this._propRotation) {
            return this;
          }
          const copy = new UndoablePropData(this);
          copy._propRotation = copy._propRotation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "propScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPropScale = true;
              copy._propScale = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropScale) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPropScale = false;
              copy._propScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPropScale) {
            const copy = new UndoablePropData(this);
            copy._hasPropScale = true;
            copy._propScale = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._propScale.apply(type, path.slice(1), value);
          if (newValue === this._propScale) {
            return this;
          }
          const copy = new UndoablePropData(this);
          copy._propScale = copy._propScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "colliderScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasColliderScale = true;
              copy._colliderScale = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasColliderScale) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasColliderScale = false;
              copy._colliderScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "navmeshIgnore": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasNavmeshIgnore = true;
              copy._navmeshIgnore = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavmeshIgnore) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasNavmeshIgnore = false;
              copy._navmeshIgnore = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "propLayer": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPropLayer = true;
              copy._propLayer = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropLayer) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPropLayer = false;
              copy._propLayer = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "propTag": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePropData(this);
              copy._hasPropTag = true;
              copy._propTag = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPropTag) {
                return this;
              }
              const copy = new UndoablePropData(this);
              copy._hasPropTag = false;
              copy._propTag = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePropData} other
   * @returns {UndoablePropData}
   */
  merge(other) {
    const copy = new UndoablePropData(this);
    if (other._hasPrefabName) {
      copy._hasPrefabName = true;
      copy._prefabName = other._prefabName;
    }
    if (other._hasPropPosition) {
      if (copy._hasPropPosition) {
        copy._propPosition = copy.propPosition.merge(other.propPosition);
      } else {
        copy._propPosition = other._propPosition;
      }
      copy._hasPropPosition = true;
    }
    if (other._hasPropRotation) {
      if (copy._hasPropRotation) {
        copy._propRotation = copy.propRotation.merge(other.propRotation);
      } else {
        copy._propRotation = other._propRotation;
      }
      copy._hasPropRotation = true;
    }
    if (other._hasPropScale) {
      if (copy._hasPropScale) {
        copy._propScale = copy.propScale.merge(other.propScale);
      } else {
        copy._propScale = other._propScale;
      }
      copy._hasPropScale = true;
    }
    if (other._hasColliderScale) {
      copy._hasColliderScale = true;
      copy._colliderScale = other._colliderScale;
    }
    if (other._hasNavmeshIgnore) {
      copy._hasNavmeshIgnore = true;
      copy._navmeshIgnore = other._navmeshIgnore;
    }
    if (other._hasPropLayer) {
      copy._hasPropLayer = true;
      copy._propLayer = other._propLayer;
    }
    if (other._hasPropTag) {
      copy._hasPropTag = true;
      copy._propTag = other._propTag;
    }
    return copy;
  }
}
UndoablePropData.default = new UndoablePropData();
class UndoablePropData_Builder {
  constructor(value) {
    this._value = new UndoablePropData(value);
  }
  build() {
    return new UndoablePropData(this._value);
  }
  setPrefabName(value) {
    this._value._hasPrefabName = true;
    this._value._prefabName = value;
    return this;
  }
  deletePrefabName() {
    this._value._hasPrefabName = false;
    this._value._prefabName = null;
    return this;
  }
  setPropPosition(value) {
    this._value._hasPropPosition = true;
    this._value._propPosition = value;
    return this;
  }
  deletePropPosition() {
    this._value._hasPropPosition = false;
    this._value._propPosition = null;
    return this;
  }
  setPropRotation(value) {
    this._value._hasPropRotation = true;
    this._value._propRotation = value;
    return this;
  }
  deletePropRotation() {
    this._value._hasPropRotation = false;
    this._value._propRotation = null;
    return this;
  }
  setPropScale(value) {
    this._value._hasPropScale = true;
    this._value._propScale = value;
    return this;
  }
  deletePropScale() {
    this._value._hasPropScale = false;
    this._value._propScale = null;
    return this;
  }
  setColliderScale(value) {
    this._value._hasColliderScale = true;
    this._value._colliderScale = value;
    return this;
  }
  deleteColliderScale() {
    this._value._hasColliderScale = false;
    this._value._colliderScale = null;
    return this;
  }
  setNavmeshIgnore(value) {
    this._value._hasNavmeshIgnore = true;
    this._value._navmeshIgnore = value;
    return this;
  }
  deleteNavmeshIgnore() {
    this._value._hasNavmeshIgnore = false;
    this._value._navmeshIgnore = null;
    return this;
  }
  setPropLayer(value) {
    this._value._hasPropLayer = true;
    this._value._propLayer = value;
    return this;
  }
  deletePropLayer() {
    this._value._hasPropLayer = false;
    this._value._propLayer = null;
    return this;
  }
  setPropTag(value) {
    this._value._hasPropTag = true;
    this._value._propTag = value;
    return this;
  }
  deletePropTag() {
    this._value._hasPropTag = false;
    this._value._propTag = null;
    return this;
  }
}
UndoablePropData.Builder = UndoablePropData_Builder;
class UndoablePropData_WithParent {
  /**
   * @param {UndoablePropData} value
   * @param {UndoablePropData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePropData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefabName() {
    if (this._cachedHasPrefabName === undefined) {
      if (this._value.hasPrefabName) {
        this._cachedHasPrefabName = true;
      } else {
        this._cachedHasPrefabName = this._parent ? this._parent.hasPrefabName : false;
      }
    }
    return this._cachedHasPrefabName;
  }
  get prefabName() {
    if (this._cachedPrefabName === undefined) {
      if (this._value.hasPrefabName) {
        this._cachedPrefabName = this._value.prefabName;
      } else {
        this._cachedPrefabName = this._parent ? this._parent.prefabName : this._value.prefabName;
      }
    }
    return this._cachedPrefabName;
  }
  get hasPropPosition() {
    if (this._cachedHasPropPosition === undefined) {
      if (this._value.hasPropPosition) {
        this._cachedHasPropPosition = true;
      } else {
        this._cachedHasPropPosition = this._parent ? this._parent.hasPropPosition : false;
      }
    }
    return this._cachedHasPropPosition;
  }
  get propPosition() {
    if (!this._cachedPropPosition) {
      if (this._value.hasPropPosition) {
        this._cachedPropPosition = new FVector3.WithParent(this._value.propPosition, this._parent && this._parent.hasPropPosition ? this._parent.propPosition : null);
      } else {
        this._cachedPropPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.propPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedPropPosition;
  }
  get hasPropRotation() {
    if (this._cachedHasPropRotation === undefined) {
      if (this._value.hasPropRotation) {
        this._cachedHasPropRotation = true;
      } else {
        this._cachedHasPropRotation = this._parent ? this._parent.hasPropRotation : false;
      }
    }
    return this._cachedHasPropRotation;
  }
  get propRotation() {
    if (!this._cachedPropRotation) {
      if (this._value.hasPropRotation) {
        this._cachedPropRotation = new FVector4.WithParent(this._value.propRotation, this._parent && this._parent.hasPropRotation ? this._parent.propRotation : null);
      } else {
        this._cachedPropRotation = this._parent ? new FVector4.WithParent(FVector4.default, this._parent.propRotation) : FVector4.WithParent.default;
      }
    }
    return this._cachedPropRotation;
  }
  get hasPropScale() {
    if (this._cachedHasPropScale === undefined) {
      if (this._value.hasPropScale) {
        this._cachedHasPropScale = true;
      } else {
        this._cachedHasPropScale = this._parent ? this._parent.hasPropScale : false;
      }
    }
    return this._cachedHasPropScale;
  }
  get propScale() {
    if (!this._cachedPropScale) {
      if (this._value.hasPropScale) {
        this._cachedPropScale = new FVector3.WithParent(this._value.propScale, this._parent && this._parent.hasPropScale ? this._parent.propScale : null);
      } else {
        this._cachedPropScale = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.propScale) : FVector3.WithParent.default;
      }
    }
    return this._cachedPropScale;
  }
  get hasColliderScale() {
    if (this._cachedHasColliderScale === undefined) {
      if (this._value.hasColliderScale) {
        this._cachedHasColliderScale = true;
      } else {
        this._cachedHasColliderScale = this._parent ? this._parent.hasColliderScale : false;
      }
    }
    return this._cachedHasColliderScale;
  }
  get colliderScale() {
    if (this._cachedColliderScale === undefined) {
      if (this._value.hasColliderScale) {
        this._cachedColliderScale = this._value.colliderScale;
      } else {
        this._cachedColliderScale = this._parent ? this._parent.colliderScale : this._value.colliderScale;
      }
    }
    return this._cachedColliderScale;
  }
  get hasNavmeshIgnore() {
    if (this._cachedHasNavmeshIgnore === undefined) {
      if (this._value.hasNavmeshIgnore) {
        this._cachedHasNavmeshIgnore = true;
      } else {
        this._cachedHasNavmeshIgnore = this._parent ? this._parent.hasNavmeshIgnore : false;
      }
    }
    return this._cachedHasNavmeshIgnore;
  }
  get navmeshIgnore() {
    if (this._cachedNavmeshIgnore === undefined) {
      if (this._value.hasNavmeshIgnore) {
        this._cachedNavmeshIgnore = this._value.navmeshIgnore;
      } else {
        this._cachedNavmeshIgnore = this._parent ? this._parent.navmeshIgnore : this._value.navmeshIgnore;
      }
    }
    return this._cachedNavmeshIgnore;
  }
  get hasPropLayer() {
    if (this._cachedHasPropLayer === undefined) {
      if (this._value.hasPropLayer) {
        this._cachedHasPropLayer = true;
      } else {
        this._cachedHasPropLayer = this._parent ? this._parent.hasPropLayer : false;
      }
    }
    return this._cachedHasPropLayer;
  }
  get propLayer() {
    if (this._cachedPropLayer === undefined) {
      if (this._value.hasPropLayer) {
        this._cachedPropLayer = this._value.propLayer;
      } else {
        this._cachedPropLayer = this._parent ? this._parent.propLayer : this._value.propLayer;
      }
    }
    return this._cachedPropLayer;
  }
  get hasPropTag() {
    if (this._cachedHasPropTag === undefined) {
      if (this._value.hasPropTag) {
        this._cachedHasPropTag = true;
      } else {
        this._cachedHasPropTag = this._parent ? this._parent.hasPropTag : false;
      }
    }
    return this._cachedHasPropTag;
  }
  get propTag() {
    if (this._cachedPropTag === undefined) {
      if (this._value.hasPropTag) {
        this._cachedPropTag = this._value.propTag;
      } else {
        this._cachedPropTag = this._parent ? this._parent.propTag : this._value.propTag;
      }
    }
    return this._cachedPropTag;
  }
  update(current, parent) {
    const result = new UndoablePropData_WithParent(current, parent);
    if (this._cachedPropPosition && this._value.hasPropPosition && current.hasPropPosition) {
      if (this._value.propPosition === current.propPosition && this._parent === parent) {
        result._cachedPropPosition = this._cachedPropPosition;
      } else {
        result._cachedPropPosition = this._cachedPropPosition.update(current.propPosition, parent && parent.hasPropPosition ? parent.propPosition : null);
      }
    }
    if (this._cachedPropRotation && this._value.hasPropRotation && current.hasPropRotation) {
      if (this._value.propRotation === current.propRotation && this._parent === parent) {
        result._cachedPropRotation = this._cachedPropRotation;
      } else {
        result._cachedPropRotation = this._cachedPropRotation.update(current.propRotation, parent && parent.hasPropRotation ? parent.propRotation : null);
      }
    }
    if (this._cachedPropScale && this._value.hasPropScale && current.hasPropScale) {
      if (this._value.propScale === current.propScale && this._parent === parent) {
        result._cachedPropScale = this._cachedPropScale;
      } else {
        result._cachedPropScale = this._cachedPropScale.update(current.propScale, parent && parent.hasPropScale ? parent.propScale : null);
      }
    }
    return result;
  }
}
UndoablePropData_WithParent.default = new UndoablePropData_WithParent(UndoablePropData.default, null);
UndoablePropData.WithParent = UndoablePropData_WithParent;
class UndoablePropData_Descriptor {
  get prefabName() {
    if (!this._prefabName) {
      this._prefabName = {
        name: "prefabName",
        Name: "PrefabName",
        number: 1,
        protoType: 9,
        protoName: "prefab_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefabName;
  }
  get propPosition() {
    if (!this._propPosition) {
      this._propPosition = {
        name: "propPosition",
        Name: "PropPosition",
        number: 2,
        protoType: 11,
        protoName: "prop_position",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propPosition;
  }
  get propRotation() {
    if (!this._propRotation) {
      this._propRotation = {
        name: "propRotation",
        Name: "PropRotation",
        number: 3,
        protoType: 11,
        protoName: "prop_rotation",
        type: FVector4,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propRotation;
  }
  get propScale() {
    if (!this._propScale) {
      this._propScale = {
        name: "propScale",
        Name: "PropScale",
        number: 4,
        protoType: 11,
        protoName: "prop_scale",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propScale;
  }
  get colliderScale() {
    if (!this._colliderScale) {
      this._colliderScale = {
        name: "colliderScale",
        Name: "ColliderScale",
        number: 5,
        protoType: 1,
        protoName: "collider_scale",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._colliderScale;
  }
  get navmeshIgnore() {
    if (!this._navmeshIgnore) {
      this._navmeshIgnore = {
        name: "navmeshIgnore",
        Name: "NavmeshIgnore",
        number: 6,
        protoType: 8,
        protoName: "navmesh_ignore",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navmeshIgnore;
  }
  get propLayer() {
    if (!this._propLayer) {
      this._propLayer = {
        name: "propLayer",
        Name: "PropLayer",
        number: 7,
        protoType: 5,
        protoName: "prop_layer",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propLayer;
  }
  get propTag() {
    if (!this._propTag) {
      this._propTag = {
        name: "propTag",
        Name: "PropTag",
        number: 10,
        protoType: 9,
        protoName: "prop_tag",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._propTag;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefabName,
        this.propPosition,
        this.propRotation,
        this.propScale,
        this.colliderScale,
        this.navmeshIgnore,
        this.propLayer,
        this.propTag,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefabName",
        Name: "DummyOneofForPrefabName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropPosition",
        Name: "DummyOneofForPropPosition",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropRotation",
        Name: "DummyOneofForPropRotation",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropScale",
        Name: "DummyOneofForPropScale",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForColliderScale",
        Name: "DummyOneofForColliderScale",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNavmeshIgnore",
        Name: "DummyOneofForNavmeshIgnore",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropLayer",
        Name: "DummyOneofForPropLayer",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPropTag",
        Name: "DummyOneofForPropTag",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoablePropData.descriptor = new UndoablePropData_Descriptor();
class UndoableWaterData_WaterRegionsEntry {
  get descriptor() {
    return UndoableWaterData_WaterRegionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaterData_WaterRegionsEntry) {
      return value;
    }
    return UndoableWaterData_WaterRegionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaterData_WaterRegionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableWaterRegion.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableWaterRegion.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableWaterRegion}
   */
  get value() {
    return this._hasValue ? this._value : UndoableWaterRegion.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaterData_WaterRegionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableWaterData_WaterRegionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaterData_WaterRegionsEntry(this);
              copy._hasValue = true;
              copy._value = UndoableWaterRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableWaterData_WaterRegionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableWaterData_WaterRegionsEntry(this);
            copy._hasValue = true;
            copy._value = UndoableWaterRegion.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableWaterData_WaterRegionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaterData_WaterRegionsEntry} other
   * @returns {UndoableWaterData_WaterRegionsEntry}
   */
  merge(other) {
    const copy = new UndoableWaterData_WaterRegionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableWaterData_WaterRegionsEntry.default = new UndoableWaterData_WaterRegionsEntry();
class UndoableWaterData_WaterRegionsEntry_Builder {
  constructor(value) {
    this._value = new UndoableWaterData_WaterRegionsEntry(value);
  }
  build() {
    return new UndoableWaterData_WaterRegionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableWaterData_WaterRegionsEntry.Builder = UndoableWaterData_WaterRegionsEntry_Builder;
class UndoableWaterData_WaterRegionsEntry_WithParent {
  /**
   * @param {UndoableWaterData_WaterRegionsEntry} value
   * @param {UndoableWaterData_WaterRegionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaterData_WaterRegionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableWaterRegion.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableWaterRegion.WithParent(UndoableWaterRegion.default, this._parent.value) : UndoableWaterRegion.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableWaterData_WaterRegionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableWaterData_WaterRegionsEntry_WithParent.default = new UndoableWaterData_WaterRegionsEntry_WithParent(UndoableWaterData_WaterRegionsEntry.default, null);
UndoableWaterData_WaterRegionsEntry.WithParent = UndoableWaterData_WaterRegionsEntry_WithParent;
class UndoableWaterData_WaterRegionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableWaterRegion,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableWaterData_WaterRegionsEntry.descriptor = new UndoableWaterData_WaterRegionsEntry_Descriptor();
export class UndoableWaterData {
  get descriptor() {
    return UndoableWaterData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._waterRegions = {};
  }
  isEmpty() {
    if (Object.keys(this._waterRegions).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaterData) {
      return value;
    }
    return UndoableWaterData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaterData();
    result._waterRegions = JsonToMap(json.waterRegions, JsonToString, UndoableWaterRegion);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._waterRegions).length > 0) {
      result.waterRegions = MapToJson(this._waterRegions, JsonToString, UndoableWaterRegion);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoableWaterRegion>}
   */
  get waterRegions() {
    return this._waterRegions;
  }
  setWaterRegions(path, value) {
    return {type: 'SET', path: path.concat(['waterRegions']), value: MapToJson(value, JsonToString, UndoableWaterRegion)};
  }
  setWaterRegionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['waterRegions', key]), value: value.toJson()};
  }
  deleteWaterRegions(path) {
    return {type: 'DELETE', path: path.concat(['waterRegions'])};
  }
  deleteWaterRegionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['waterRegions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "waterRegions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._waterRegions).length === 0) {
                return this;
              }
              const copy = new UndoableWaterData(this);
              copy._waterRegions = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableWaterData(this);
              copy._waterRegions = {};
              for (let key in value) {
                copy._waterRegions[key] = UndoableWaterRegion.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaterData(this);
              copy._waterRegions = {...copy._waterRegions};
              copy._waterRegions[path[1]] = UndoableWaterRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._waterRegions[path[1]]) {
                return this;
              }
              const copy = new UndoableWaterData(this);
              copy._waterRegions = {...copy._waterRegions};
              delete copy._waterRegions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._waterRegions[key] === undefined) {
            const copy = new UndoableWaterData(this);
            copy._waterRegions = {...copy._waterRegions};
            copy._waterRegions[key] = UndoableWaterRegion.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._waterRegions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableWaterData(this);
          copy._waterRegions = {...copy._waterRegions};
          copy._waterRegions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaterData} other
   * @returns {UndoableWaterData}
   */
  merge(other) {
    const copy = new UndoableWaterData(this);
    copy._waterRegions = {...this._waterRegions, ...other._waterRegions};
    return copy;
  }
}
UndoableWaterData.default = new UndoableWaterData();
UndoableWaterData.WaterRegionsEntry = UndoableWaterData_WaterRegionsEntry;
class UndoableWaterData_Builder {
  constructor(value) {
    this._value = new UndoableWaterData(value);
  }
  build() {
    return new UndoableWaterData(this._value);
  }
  setWaterRegions(key, value) {
    this._value._waterRegions = {...this._value._waterRegions, [key]: value};
    return this;
  }
  addAllWaterRegions(values) {
    this._value._waterRegions = {...this._value._waterRegions, ...values};
    return this;
  }
  deleteWaterRegions(key) {
    this._value._waterRegions = {...this._value._waterRegions};
    delete this._value._waterRegions[key];
    return this;
  }
  clearWaterRegions() {
    this._value._waterRegions = {};
    return this;
  }
}
UndoableWaterData.Builder = UndoableWaterData_Builder;
class UndoableWaterData_WithParent {
  /**
   * @param {UndoableWaterData} value
   * @param {UndoableWaterData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaterData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfWaterRegions() {
    if (!this._selfWaterRegions) {
      this._selfWaterRegions = {};
      for (let i in this._value.waterRegions) {
        this._selfWaterRegions[i] = new UndoableWaterRegion.WithParent(this._value.waterRegions[i], null);
      }
    }
    return this._selfWaterRegions;
  }
  get inherentWaterRegions() {
    if (!this._inherentWaterRegions) {
      this._inherentWaterRegions = this._parent ? this._parent.waterRegions : {};
    }
    return this._inherentWaterRegions;
  }
  get waterRegions() {
    if (!this._allWaterRegions) {
      this._allWaterRegions = this._parent ? {...this._parent.waterRegions, ...this.selfWaterRegions} : this.selfWaterRegions;
    }
    return this._allWaterRegions;
  }
  update(current, parent) {
    const result = new UndoableWaterData_WithParent(current, parent);
    if (this._selfWaterRegions) {
      if (this._value.waterRegions === current.waterRegions) {
        result._selfWaterRegions = this._selfWaterRegions;
      } else {
        result._selfWaterRegions = {};
        for (let i in current.waterRegions) {
          const oldValue = this._value.waterRegions[i];
          if (oldValue) {
            const oldCache = this._selfWaterRegions[i];
            if (oldValue === current.waterRegions[i]) {
              result._selfWaterRegions[i] = oldCache;
            } else {
              result._selfWaterRegions[i] = oldCache.update(current.waterRegions[i], null);
            }
          } else {
            result._selfWaterRegions[i] = new UndoableWaterRegion.WithParent(current.waterRegions[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableWaterData_WithParent.default = new UndoableWaterData_WithParent(UndoableWaterData.default, null);
UndoableWaterData.WithParent = UndoableWaterData_WithParent;
class UndoableWaterData_Descriptor {
  get waterRegions() {
    if (!this._waterRegions) {
      this._waterRegions = {
        name: "waterRegions",
        Name: "WaterRegions",
        number: 1,
        protoType: 11,
        protoName: "water_regions",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableWaterRegion,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waterRegions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.waterRegions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableWaterData.descriptor = new UndoableWaterData_Descriptor();
export class UndoableWaterRegion {
  get descriptor() {
    return UndoableWaterRegion.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDeepestTileId = false;
    this._deepestTileId = null;
    this._hasWaterLevel = false;
    this._waterLevel = null;
  }
  isEmpty() {
    if (this._hasDeepestTileId) return false;
    if (this._hasWaterLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaterRegion) {
      return value;
    }
    return UndoableWaterRegion.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaterRegion();
    if (json.deepestTileId != null) {
      result._hasDeepestTileId = true;
      result._deepestTileId = JsonToInt32.fromJson(json.deepestTileId);
    }
    if (json.waterLevel != null) {
      result._hasWaterLevel = true;
      result._waterLevel = JsonToDouble.fromJson(json.waterLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDeepestTileId) {
      result.deepestTileId = JsonToInt32.toJson(this._deepestTileId);
    }
    if (this._hasWaterLevel) {
      result.waterLevel = JsonToDouble.toJson(this._waterLevel);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get deepestTileId() {
    return this._hasDeepestTileId ? this._deepestTileId : JsonToInt32.default;
  }
  get hasDeepestTileId() {
    return this._hasDeepestTileId;
  }
  setDeepestTileId(path, value) {
    return {type: 'SET', path: path.concat(['deepestTileId']), value};
  }
  deleteDeepestTileId(path) {
    return {type: 'DELETE', path: path.concat(['deepestTileId'])};
  }
  /**
   * @returns {number}
   */
  get waterLevel() {
    return this._hasWaterLevel ? this._waterLevel : JsonToDouble.default;
  }
  get hasWaterLevel() {
    return this._hasWaterLevel;
  }
  setWaterLevel(path, value) {
    return {type: 'SET', path: path.concat(['waterLevel']), value};
  }
  deleteWaterLevel(path) {
    return {type: 'DELETE', path: path.concat(['waterLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "deepestTileId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaterRegion(this);
              copy._hasDeepestTileId = true;
              copy._deepestTileId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeepestTileId) {
                return this;
              }
              const copy = new UndoableWaterRegion(this);
              copy._hasDeepestTileId = false;
              copy._deepestTileId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "waterLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaterRegion(this);
              copy._hasWaterLevel = true;
              copy._waterLevel = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWaterLevel) {
                return this;
              }
              const copy = new UndoableWaterRegion(this);
              copy._hasWaterLevel = false;
              copy._waterLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaterRegion} other
   * @returns {UndoableWaterRegion}
   */
  merge(other) {
    const copy = new UndoableWaterRegion(this);
    if (other._hasDeepestTileId) {
      copy._hasDeepestTileId = true;
      copy._deepestTileId = other._deepestTileId;
    }
    if (other._hasWaterLevel) {
      copy._hasWaterLevel = true;
      copy._waterLevel = other._waterLevel;
    }
    return copy;
  }
}
UndoableWaterRegion.default = new UndoableWaterRegion();
class UndoableWaterRegion_Builder {
  constructor(value) {
    this._value = new UndoableWaterRegion(value);
  }
  build() {
    return new UndoableWaterRegion(this._value);
  }
  setDeepestTileId(value) {
    this._value._hasDeepestTileId = true;
    this._value._deepestTileId = value;
    return this;
  }
  deleteDeepestTileId() {
    this._value._hasDeepestTileId = false;
    this._value._deepestTileId = null;
    return this;
  }
  setWaterLevel(value) {
    this._value._hasWaterLevel = true;
    this._value._waterLevel = value;
    return this;
  }
  deleteWaterLevel() {
    this._value._hasWaterLevel = false;
    this._value._waterLevel = null;
    return this;
  }
}
UndoableWaterRegion.Builder = UndoableWaterRegion_Builder;
class UndoableWaterRegion_WithParent {
  /**
   * @param {UndoableWaterRegion} value
   * @param {UndoableWaterRegion_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaterRegion.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDeepestTileId() {
    if (this._cachedHasDeepestTileId === undefined) {
      if (this._value.hasDeepestTileId) {
        this._cachedHasDeepestTileId = true;
      } else {
        this._cachedHasDeepestTileId = this._parent ? this._parent.hasDeepestTileId : false;
      }
    }
    return this._cachedHasDeepestTileId;
  }
  get deepestTileId() {
    if (this._cachedDeepestTileId === undefined) {
      if (this._value.hasDeepestTileId) {
        this._cachedDeepestTileId = this._value.deepestTileId;
      } else {
        this._cachedDeepestTileId = this._parent ? this._parent.deepestTileId : this._value.deepestTileId;
      }
    }
    return this._cachedDeepestTileId;
  }
  get hasWaterLevel() {
    if (this._cachedHasWaterLevel === undefined) {
      if (this._value.hasWaterLevel) {
        this._cachedHasWaterLevel = true;
      } else {
        this._cachedHasWaterLevel = this._parent ? this._parent.hasWaterLevel : false;
      }
    }
    return this._cachedHasWaterLevel;
  }
  get waterLevel() {
    if (this._cachedWaterLevel === undefined) {
      if (this._value.hasWaterLevel) {
        this._cachedWaterLevel = this._value.waterLevel;
      } else {
        this._cachedWaterLevel = this._parent ? this._parent.waterLevel : this._value.waterLevel;
      }
    }
    return this._cachedWaterLevel;
  }
  update(current, parent) {
    const result = new UndoableWaterRegion_WithParent(current, parent);
    return result;
  }
}
UndoableWaterRegion_WithParent.default = new UndoableWaterRegion_WithParent(UndoableWaterRegion.default, null);
UndoableWaterRegion.WithParent = UndoableWaterRegion_WithParent;
class UndoableWaterRegion_Descriptor {
  get deepestTileId() {
    if (!this._deepestTileId) {
      this._deepestTileId = {
        name: "deepestTileId",
        Name: "DeepestTileId",
        number: 1,
        protoType: 5,
        protoName: "deepest_tile_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deepestTileId;
  }
  get waterLevel() {
    if (!this._waterLevel) {
      this._waterLevel = {
        name: "waterLevel",
        Name: "WaterLevel",
        number: 2,
        protoType: 1,
        protoName: "water_level",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waterLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.deepestTileId,
        this.waterLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDeepestTileId",
        Name: "DummyOneofForDeepestTileId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWaterLevel",
        Name: "DummyOneofForWaterLevel",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableWaterRegion.descriptor = new UndoableWaterRegion_Descriptor();
class UndoableUnitsData_UnitsEntry {
  get descriptor() {
    return UndoableUnitsData_UnitsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableUnitsData_UnitsEntry) {
      return value;
    }
    return UndoableUnitsData_UnitsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableUnitsData_UnitsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableUnit.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableUnit.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableUnit}
   */
  get value() {
    return this._hasValue ? this._value : UndoableUnit.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsData_UnitsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableUnitsData_UnitsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsData_UnitsEntry(this);
              copy._hasValue = true;
              copy._value = UndoableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableUnitsData_UnitsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableUnitsData_UnitsEntry(this);
            copy._hasValue = true;
            copy._value = UndoableUnit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableUnitsData_UnitsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableUnitsData_UnitsEntry} other
   * @returns {UndoableUnitsData_UnitsEntry}
   */
  merge(other) {
    const copy = new UndoableUnitsData_UnitsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableUnitsData_UnitsEntry.default = new UndoableUnitsData_UnitsEntry();
class UndoableUnitsData_UnitsEntry_Builder {
  constructor(value) {
    this._value = new UndoableUnitsData_UnitsEntry(value);
  }
  build() {
    return new UndoableUnitsData_UnitsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableUnitsData_UnitsEntry.Builder = UndoableUnitsData_UnitsEntry_Builder;
class UndoableUnitsData_UnitsEntry_WithParent {
  /**
   * @param {UndoableUnitsData_UnitsEntry} value
   * @param {UndoableUnitsData_UnitsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableUnitsData_UnitsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableUnit.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableUnit.WithParent(UndoableUnit.default, this._parent.value) : UndoableUnit.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableUnitsData_UnitsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableUnitsData_UnitsEntry_WithParent.default = new UndoableUnitsData_UnitsEntry_WithParent(UndoableUnitsData_UnitsEntry.default, null);
UndoableUnitsData_UnitsEntry.WithParent = UndoableUnitsData_UnitsEntry_WithParent;
class UndoableUnitsData_UnitsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableUnit,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableUnitsData_UnitsEntry.descriptor = new UndoableUnitsData_UnitsEntry_Descriptor();
export class UndoableUnitsData {
  get descriptor() {
    return UndoableUnitsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._units = {};
  }
  isEmpty() {
    if (Object.keys(this._units).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableUnitsData) {
      return value;
    }
    return UndoableUnitsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableUnitsData();
    result._units = JsonToMap(json.units, JsonToString, UndoableUnit);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._units).length > 0) {
      result.units = MapToJson(this._units, JsonToString, UndoableUnit);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoableUnit>}
   */
  get units() {
    return this._units;
  }
  setUnits(path, value) {
    return {type: 'SET', path: path.concat(['units']), value: MapToJson(value, JsonToString, UndoableUnit)};
  }
  setUnitsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['units', key]), value: value.toJson()};
  }
  deleteUnits(path) {
    return {type: 'DELETE', path: path.concat(['units'])};
  }
  deleteUnitsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['units', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "units": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._units).length === 0) {
                return this;
              }
              const copy = new UndoableUnitsData(this);
              copy._units = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableUnitsData(this);
              copy._units = {};
              for (let key in value) {
                copy._units[key] = UndoableUnit.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsData(this);
              copy._units = {...copy._units};
              copy._units[path[1]] = UndoableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._units[path[1]]) {
                return this;
              }
              const copy = new UndoableUnitsData(this);
              copy._units = {...copy._units};
              delete copy._units[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._units[key] === undefined) {
            const copy = new UndoableUnitsData(this);
            copy._units = {...copy._units};
            copy._units[key] = UndoableUnit.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._units[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableUnitsData(this);
          copy._units = {...copy._units};
          copy._units[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableUnitsData} other
   * @returns {UndoableUnitsData}
   */
  merge(other) {
    const copy = new UndoableUnitsData(this);
    copy._units = {...this._units, ...other._units};
    return copy;
  }
}
UndoableUnitsData.default = new UndoableUnitsData();
UndoableUnitsData.UnitsEntry = UndoableUnitsData_UnitsEntry;
class UndoableUnitsData_Builder {
  constructor(value) {
    this._value = new UndoableUnitsData(value);
  }
  build() {
    return new UndoableUnitsData(this._value);
  }
  setUnits(key, value) {
    this._value._units = {...this._value._units, [key]: value};
    return this;
  }
  addAllUnits(values) {
    this._value._units = {...this._value._units, ...values};
    return this;
  }
  deleteUnits(key) {
    this._value._units = {...this._value._units};
    delete this._value._units[key];
    return this;
  }
  clearUnits() {
    this._value._units = {};
    return this;
  }
}
UndoableUnitsData.Builder = UndoableUnitsData_Builder;
class UndoableUnitsData_WithParent {
  /**
   * @param {UndoableUnitsData} value
   * @param {UndoableUnitsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableUnitsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUnits() {
    if (!this._selfUnits) {
      this._selfUnits = {};
      for (let i in this._value.units) {
        this._selfUnits[i] = new UndoableUnit.WithParent(this._value.units[i], null);
      }
    }
    return this._selfUnits;
  }
  get inherentUnits() {
    if (!this._inherentUnits) {
      this._inherentUnits = this._parent ? this._parent.units : {};
    }
    return this._inherentUnits;
  }
  get units() {
    if (!this._allUnits) {
      this._allUnits = this._parent ? {...this._parent.units, ...this.selfUnits} : this.selfUnits;
    }
    return this._allUnits;
  }
  update(current, parent) {
    const result = new UndoableUnitsData_WithParent(current, parent);
    if (this._selfUnits) {
      if (this._value.units === current.units) {
        result._selfUnits = this._selfUnits;
      } else {
        result._selfUnits = {};
        for (let i in current.units) {
          const oldValue = this._value.units[i];
          if (oldValue) {
            const oldCache = this._selfUnits[i];
            if (oldValue === current.units[i]) {
              result._selfUnits[i] = oldCache;
            } else {
              result._selfUnits[i] = oldCache.update(current.units[i], null);
            }
          } else {
            result._selfUnits[i] = new UndoableUnit.WithParent(current.units[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableUnitsData_WithParent.default = new UndoableUnitsData_WithParent(UndoableUnitsData.default, null);
UndoableUnitsData.WithParent = UndoableUnitsData_WithParent;
class UndoableUnitsData_Descriptor {
  get units() {
    if (!this._units) {
      this._units = {
        name: "units",
        Name: "Units",
        number: 1,
        protoType: 11,
        protoName: "units",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableUnit,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._units;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.units,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableUnitsData.descriptor = new UndoableUnitsData_Descriptor();
class UndoableRegionsData_RegionsEntry {
  get descriptor() {
    return UndoableRegionsData_RegionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRegionsData_RegionsEntry) {
      return value;
    }
    return UndoableRegionsData_RegionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRegionsData_RegionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableRegion.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableRegion.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableRegion}
   */
  get value() {
    return this._hasValue ? this._value : UndoableRegion.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegionsData_RegionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableRegionsData_RegionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegionsData_RegionsEntry(this);
              copy._hasValue = true;
              copy._value = UndoableRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableRegionsData_RegionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableRegionsData_RegionsEntry(this);
            copy._hasValue = true;
            copy._value = UndoableRegion.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableRegionsData_RegionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRegionsData_RegionsEntry} other
   * @returns {UndoableRegionsData_RegionsEntry}
   */
  merge(other) {
    const copy = new UndoableRegionsData_RegionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableRegionsData_RegionsEntry.default = new UndoableRegionsData_RegionsEntry();
class UndoableRegionsData_RegionsEntry_Builder {
  constructor(value) {
    this._value = new UndoableRegionsData_RegionsEntry(value);
  }
  build() {
    return new UndoableRegionsData_RegionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableRegionsData_RegionsEntry.Builder = UndoableRegionsData_RegionsEntry_Builder;
class UndoableRegionsData_RegionsEntry_WithParent {
  /**
   * @param {UndoableRegionsData_RegionsEntry} value
   * @param {UndoableRegionsData_RegionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRegionsData_RegionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableRegion.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableRegion.WithParent(UndoableRegion.default, this._parent.value) : UndoableRegion.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableRegionsData_RegionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableRegionsData_RegionsEntry_WithParent.default = new UndoableRegionsData_RegionsEntry_WithParent(UndoableRegionsData_RegionsEntry.default, null);
UndoableRegionsData_RegionsEntry.WithParent = UndoableRegionsData_RegionsEntry_WithParent;
class UndoableRegionsData_RegionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableRegion,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableRegionsData_RegionsEntry.descriptor = new UndoableRegionsData_RegionsEntry_Descriptor();
export class UndoableRegionsData {
  get descriptor() {
    return UndoableRegionsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._regions = {};
  }
  isEmpty() {
    if (Object.keys(this._regions).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRegionsData) {
      return value;
    }
    return UndoableRegionsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRegionsData();
    result._regions = JsonToMap(json.regions, JsonToString, UndoableRegion);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._regions).length > 0) {
      result.regions = MapToJson(this._regions, JsonToString, UndoableRegion);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoableRegion>}
   */
  get regions() {
    return this._regions;
  }
  setRegions(path, value) {
    return {type: 'SET', path: path.concat(['regions']), value: MapToJson(value, JsonToString, UndoableRegion)};
  }
  setRegionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['regions', key]), value: value.toJson()};
  }
  deleteRegions(path) {
    return {type: 'DELETE', path: path.concat(['regions'])};
  }
  deleteRegionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['regions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "regions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._regions).length === 0) {
                return this;
              }
              const copy = new UndoableRegionsData(this);
              copy._regions = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableRegionsData(this);
              copy._regions = {};
              for (let key in value) {
                copy._regions[key] = UndoableRegion.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegionsData(this);
              copy._regions = {...copy._regions};
              copy._regions[path[1]] = UndoableRegion.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._regions[path[1]]) {
                return this;
              }
              const copy = new UndoableRegionsData(this);
              copy._regions = {...copy._regions};
              delete copy._regions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._regions[key] === undefined) {
            const copy = new UndoableRegionsData(this);
            copy._regions = {...copy._regions};
            copy._regions[key] = UndoableRegion.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._regions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableRegionsData(this);
          copy._regions = {...copy._regions};
          copy._regions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRegionsData} other
   * @returns {UndoableRegionsData}
   */
  merge(other) {
    const copy = new UndoableRegionsData(this);
    copy._regions = {...this._regions, ...other._regions};
    return copy;
  }
}
UndoableRegionsData.default = new UndoableRegionsData();
UndoableRegionsData.RegionsEntry = UndoableRegionsData_RegionsEntry;
class UndoableRegionsData_Builder {
  constructor(value) {
    this._value = new UndoableRegionsData(value);
  }
  build() {
    return new UndoableRegionsData(this._value);
  }
  setRegions(key, value) {
    this._value._regions = {...this._value._regions, [key]: value};
    return this;
  }
  addAllRegions(values) {
    this._value._regions = {...this._value._regions, ...values};
    return this;
  }
  deleteRegions(key) {
    this._value._regions = {...this._value._regions};
    delete this._value._regions[key];
    return this;
  }
  clearRegions() {
    this._value._regions = {};
    return this;
  }
}
UndoableRegionsData.Builder = UndoableRegionsData_Builder;
class UndoableRegionsData_WithParent {
  /**
   * @param {UndoableRegionsData} value
   * @param {UndoableRegionsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRegionsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRegions() {
    if (!this._selfRegions) {
      this._selfRegions = {};
      for (let i in this._value.regions) {
        this._selfRegions[i] = new UndoableRegion.WithParent(this._value.regions[i], null);
      }
    }
    return this._selfRegions;
  }
  get inherentRegions() {
    if (!this._inherentRegions) {
      this._inherentRegions = this._parent ? this._parent.regions : {};
    }
    return this._inherentRegions;
  }
  get regions() {
    if (!this._allRegions) {
      this._allRegions = this._parent ? {...this._parent.regions, ...this.selfRegions} : this.selfRegions;
    }
    return this._allRegions;
  }
  update(current, parent) {
    const result = new UndoableRegionsData_WithParent(current, parent);
    if (this._selfRegions) {
      if (this._value.regions === current.regions) {
        result._selfRegions = this._selfRegions;
      } else {
        result._selfRegions = {};
        for (let i in current.regions) {
          const oldValue = this._value.regions[i];
          if (oldValue) {
            const oldCache = this._selfRegions[i];
            if (oldValue === current.regions[i]) {
              result._selfRegions[i] = oldCache;
            } else {
              result._selfRegions[i] = oldCache.update(current.regions[i], null);
            }
          } else {
            result._selfRegions[i] = new UndoableRegion.WithParent(current.regions[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableRegionsData_WithParent.default = new UndoableRegionsData_WithParent(UndoableRegionsData.default, null);
UndoableRegionsData.WithParent = UndoableRegionsData_WithParent;
class UndoableRegionsData_Descriptor {
  get regions() {
    if (!this._regions) {
      this._regions = {
        name: "regions",
        Name: "Regions",
        number: 1,
        protoType: 11,
        protoName: "regions",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableRegion,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.regions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableRegionsData.descriptor = new UndoableRegionsData_Descriptor();
export class UndoableUnit {
  get descriptor() {
    return UndoableUnit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitName = false;
    this._unitName = null;
    this._hasUnitPosition = false;
    this._unitPosition = null;
    this._hasUnitRotation = false;
    this._unitRotation = null;
    this._hasTeam = false;
    this._team = null;
    this._hasPlayer = false;
    this._player = null;
  }
  isEmpty() {
    if (this._hasUnitName) return false;
    if (this._hasUnitPosition && !this._unitPosition.isEmpty()) return false;
    if (this._hasUnitRotation && !this._unitRotation.isEmpty()) return false;
    if (this._hasTeam) return false;
    if (this._hasPlayer) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableUnit) {
      return value;
    }
    return UndoableUnit.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableUnit();
    if (json.unitName != null) {
      result._hasUnitName = true;
      result._unitName = JsonToString.fromJson(json.unitName);
    }
    if (json.unitPosition != null) {
      result._hasUnitPosition = true;
      result._unitPosition = FVector3.fromJson(json.unitPosition);
    }
    if (json.unitRotation != null) {
      result._hasUnitRotation = true;
      result._unitRotation = FVector4.fromJson(json.unitRotation);
    }
    if (json.team != null) {
      result._hasTeam = true;
      result._team = Team.fromJson(json.team);
    }
    if (json.player != null) {
      result._hasPlayer = true;
      result._player = JsonToInt32.fromJson(json.player);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitName) {
      result.unitName = JsonToString.toJson(this._unitName);
    }
    if (this._hasUnitPosition && !this._unitPosition.isEmpty()) {
      result.unitPosition = FVector3.toJson(this._unitPosition);
    }
    if (this._hasUnitRotation && !this._unitRotation.isEmpty()) {
      result.unitRotation = FVector4.toJson(this._unitRotation);
    }
    if (this._hasTeam) {
      result.team = Team.toJson(this._team);
    }
    if (this._hasPlayer) {
      result.player = JsonToInt32.toJson(this._player);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unitName() {
    return this._hasUnitName ? this._unitName : JsonToString.default;
  }
  get hasUnitName() {
    return this._hasUnitName;
  }
  setUnitName(path, value) {
    return {type: 'SET', path: path.concat(['unitName']), value};
  }
  deleteUnitName(path) {
    return {type: 'DELETE', path: path.concat(['unitName'])};
  }
  /**
   * @returns {FVector3}
   */
  get unitPosition() {
    return this._hasUnitPosition ? this._unitPosition : FVector3.default;
  }
  get hasUnitPosition() {
    return this._hasUnitPosition;
  }
  setUnitPosition(path, value) {
    return {type: 'SET', path: path.concat(['unitPosition']), value: value.toJson()};
  }
  deleteUnitPosition(path) {
    return {type: 'DELETE', path: path.concat(['unitPosition'])};
  }
  /**
   * @returns {FVector4}
   */
  get unitRotation() {
    return this._hasUnitRotation ? this._unitRotation : FVector4.default;
  }
  get hasUnitRotation() {
    return this._hasUnitRotation;
  }
  setUnitRotation(path, value) {
    return {type: 'SET', path: path.concat(['unitRotation']), value: value.toJson()};
  }
  deleteUnitRotation(path) {
    return {type: 'DELETE', path: path.concat(['unitRotation'])};
  }
  /**
   * @returns {number}
   */
  get team() {
    return this._hasTeam ? this._team : Team.default;
  }
  get hasTeam() {
    return this._hasTeam;
  }
  setTeam(path, value) {
    return {type: 'SET', path: path.concat(['team']), value};
  }
  deleteTeam(path) {
    return {type: 'DELETE', path: path.concat(['team'])};
  }
  /**
   * @returns {number}
   */
  get player() {
    return this._hasPlayer ? this._player : JsonToInt32.default;
  }
  get hasPlayer() {
    return this._hasPlayer;
  }
  setPlayer(path, value) {
    return {type: 'SET', path: path.concat(['player']), value};
  }
  deletePlayer(path) {
    return {type: 'DELETE', path: path.concat(['player'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnit(this);
              copy._hasUnitName = true;
              copy._unitName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitName) {
                return this;
              }
              const copy = new UndoableUnit(this);
              copy._hasUnitName = false;
              copy._unitName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unitPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnit(this);
              copy._hasUnitPosition = true;
              copy._unitPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitPosition) {
                return this;
              }
              const copy = new UndoableUnit(this);
              copy._hasUnitPosition = false;
              copy._unitPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitPosition) {
            const copy = new UndoableUnit(this);
            copy._hasUnitPosition = true;
            copy._unitPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitPosition.apply(type, path.slice(1), value);
          if (newValue === this._unitPosition) {
            return this;
          }
          const copy = new UndoableUnit(this);
          copy._unitPosition = copy._unitPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnit(this);
              copy._hasUnitRotation = true;
              copy._unitRotation = FVector4.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitRotation) {
                return this;
              }
              const copy = new UndoableUnit(this);
              copy._hasUnitRotation = false;
              copy._unitRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitRotation) {
            const copy = new UndoableUnit(this);
            copy._hasUnitRotation = true;
            copy._unitRotation = FVector4.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitRotation.apply(type, path.slice(1), value);
          if (newValue === this._unitRotation) {
            return this;
          }
          const copy = new UndoableUnit(this);
          copy._unitRotation = copy._unitRotation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "team": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnit(this);
              copy._hasTeam = true;
              copy._team = Team.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTeam) {
                return this;
              }
              const copy = new UndoableUnit(this);
              copy._hasTeam = false;
              copy._team = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "player": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnit(this);
              copy._hasPlayer = true;
              copy._player = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayer) {
                return this;
              }
              const copy = new UndoableUnit(this);
              copy._hasPlayer = false;
              copy._player = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableUnit} other
   * @returns {UndoableUnit}
   */
  merge(other) {
    const copy = new UndoableUnit(this);
    if (other._hasUnitName) {
      copy._hasUnitName = true;
      copy._unitName = other._unitName;
    }
    if (other._hasUnitPosition) {
      if (copy._hasUnitPosition) {
        copy._unitPosition = copy.unitPosition.merge(other.unitPosition);
      } else {
        copy._unitPosition = other._unitPosition;
      }
      copy._hasUnitPosition = true;
    }
    if (other._hasUnitRotation) {
      if (copy._hasUnitRotation) {
        copy._unitRotation = copy.unitRotation.merge(other.unitRotation);
      } else {
        copy._unitRotation = other._unitRotation;
      }
      copy._hasUnitRotation = true;
    }
    if (other._hasTeam) {
      copy._hasTeam = true;
      copy._team = other._team;
    }
    if (other._hasPlayer) {
      copy._hasPlayer = true;
      copy._player = other._player;
    }
    return copy;
  }
}
UndoableUnit.default = new UndoableUnit();
class UndoableUnit_Builder {
  constructor(value) {
    this._value = new UndoableUnit(value);
  }
  build() {
    return new UndoableUnit(this._value);
  }
  setUnitName(value) {
    this._value._hasUnitName = true;
    this._value._unitName = value;
    return this;
  }
  deleteUnitName() {
    this._value._hasUnitName = false;
    this._value._unitName = null;
    return this;
  }
  setUnitPosition(value) {
    this._value._hasUnitPosition = true;
    this._value._unitPosition = value;
    return this;
  }
  deleteUnitPosition() {
    this._value._hasUnitPosition = false;
    this._value._unitPosition = null;
    return this;
  }
  setUnitRotation(value) {
    this._value._hasUnitRotation = true;
    this._value._unitRotation = value;
    return this;
  }
  deleteUnitRotation() {
    this._value._hasUnitRotation = false;
    this._value._unitRotation = null;
    return this;
  }
  setTeam(value) {
    this._value._hasTeam = true;
    this._value._team = value;
    return this;
  }
  deleteTeam() {
    this._value._hasTeam = false;
    this._value._team = null;
    return this;
  }
  setPlayer(value) {
    this._value._hasPlayer = true;
    this._value._player = value;
    return this;
  }
  deletePlayer() {
    this._value._hasPlayer = false;
    this._value._player = null;
    return this;
  }
}
UndoableUnit.Builder = UndoableUnit_Builder;
class UndoableUnit_WithParent {
  /**
   * @param {UndoableUnit} value
   * @param {UndoableUnit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableUnit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitName() {
    if (this._cachedHasUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedHasUnitName = true;
      } else {
        this._cachedHasUnitName = this._parent ? this._parent.hasUnitName : false;
      }
    }
    return this._cachedHasUnitName;
  }
  get unitName() {
    if (this._cachedUnitName === undefined) {
      if (this._value.hasUnitName) {
        this._cachedUnitName = this._value.unitName;
      } else {
        this._cachedUnitName = this._parent ? this._parent.unitName : this._value.unitName;
      }
    }
    return this._cachedUnitName;
  }
  get hasUnitPosition() {
    if (this._cachedHasUnitPosition === undefined) {
      if (this._value.hasUnitPosition) {
        this._cachedHasUnitPosition = true;
      } else {
        this._cachedHasUnitPosition = this._parent ? this._parent.hasUnitPosition : false;
      }
    }
    return this._cachedHasUnitPosition;
  }
  get unitPosition() {
    if (!this._cachedUnitPosition) {
      if (this._value.hasUnitPosition) {
        this._cachedUnitPosition = new FVector3.WithParent(this._value.unitPosition, this._parent && this._parent.hasUnitPosition ? this._parent.unitPosition : null);
      } else {
        this._cachedUnitPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.unitPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedUnitPosition;
  }
  get hasUnitRotation() {
    if (this._cachedHasUnitRotation === undefined) {
      if (this._value.hasUnitRotation) {
        this._cachedHasUnitRotation = true;
      } else {
        this._cachedHasUnitRotation = this._parent ? this._parent.hasUnitRotation : false;
      }
    }
    return this._cachedHasUnitRotation;
  }
  get unitRotation() {
    if (!this._cachedUnitRotation) {
      if (this._value.hasUnitRotation) {
        this._cachedUnitRotation = new FVector4.WithParent(this._value.unitRotation, this._parent && this._parent.hasUnitRotation ? this._parent.unitRotation : null);
      } else {
        this._cachedUnitRotation = this._parent ? new FVector4.WithParent(FVector4.default, this._parent.unitRotation) : FVector4.WithParent.default;
      }
    }
    return this._cachedUnitRotation;
  }
  get hasTeam() {
    if (this._cachedHasTeam === undefined) {
      if (this._value.hasTeam) {
        this._cachedHasTeam = true;
      } else {
        this._cachedHasTeam = this._parent ? this._parent.hasTeam : false;
      }
    }
    return this._cachedHasTeam;
  }
  get team() {
    if (this._cachedTeam === undefined) {
      if (this._value.hasTeam) {
        this._cachedTeam = this._value.team;
      } else {
        this._cachedTeam = this._parent ? this._parent.team : this._value.team;
      }
    }
    return this._cachedTeam;
  }
  get hasPlayer() {
    if (this._cachedHasPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedHasPlayer = true;
      } else {
        this._cachedHasPlayer = this._parent ? this._parent.hasPlayer : false;
      }
    }
    return this._cachedHasPlayer;
  }
  get player() {
    if (this._cachedPlayer === undefined) {
      if (this._value.hasPlayer) {
        this._cachedPlayer = this._value.player;
      } else {
        this._cachedPlayer = this._parent ? this._parent.player : this._value.player;
      }
    }
    return this._cachedPlayer;
  }
  update(current, parent) {
    const result = new UndoableUnit_WithParent(current, parent);
    if (this._cachedUnitPosition && this._value.hasUnitPosition && current.hasUnitPosition) {
      if (this._value.unitPosition === current.unitPosition && this._parent === parent) {
        result._cachedUnitPosition = this._cachedUnitPosition;
      } else {
        result._cachedUnitPosition = this._cachedUnitPosition.update(current.unitPosition, parent && parent.hasUnitPosition ? parent.unitPosition : null);
      }
    }
    if (this._cachedUnitRotation && this._value.hasUnitRotation && current.hasUnitRotation) {
      if (this._value.unitRotation === current.unitRotation && this._parent === parent) {
        result._cachedUnitRotation = this._cachedUnitRotation;
      } else {
        result._cachedUnitRotation = this._cachedUnitRotation.update(current.unitRotation, parent && parent.hasUnitRotation ? parent.unitRotation : null);
      }
    }
    return result;
  }
}
UndoableUnit_WithParent.default = new UndoableUnit_WithParent(UndoableUnit.default, null);
UndoableUnit.WithParent = UndoableUnit_WithParent;
class UndoableUnit_Descriptor {
  get unitName() {
    if (!this._unitName) {
      this._unitName = {
        name: "unitName",
        Name: "UnitName",
        number: 1,
        protoType: 9,
        protoName: "unit_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitName;
  }
  get unitPosition() {
    if (!this._unitPosition) {
      this._unitPosition = {
        name: "unitPosition",
        Name: "UnitPosition",
        number: 2,
        protoType: 11,
        protoName: "unit_position",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitPosition;
  }
  get unitRotation() {
    if (!this._unitRotation) {
      this._unitRotation = {
        name: "unitRotation",
        Name: "UnitRotation",
        number: 3,
        protoType: 11,
        protoName: "unit_rotation",
        type: FVector4,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitRotation;
  }
  get team() {
    if (!this._team) {
      this._team = {
        name: "team",
        Name: "Team",
        number: 4,
        protoType: 14,
        protoName: "team",
        type: Team,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._team;
  }
  get player() {
    if (!this._player) {
      this._player = {
        name: "player",
        Name: "Player",
        number: 5,
        protoType: 5,
        protoName: "player",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._player;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitName,
        this.unitPosition,
        this.unitRotation,
        this.team,
        this.player,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitName",
        Name: "DummyOneofForUnitName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitPosition",
        Name: "DummyOneofForUnitPosition",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitRotation",
        Name: "DummyOneofForUnitRotation",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTeam",
        Name: "DummyOneofForTeam",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayer",
        Name: "DummyOneofForPlayer",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableUnit.descriptor = new UndoableUnit_Descriptor();
class UndoableUnitsGroup_ChildUnitsEntry {
  get descriptor() {
    return UndoableUnitsGroup_ChildUnitsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableUnitsGroup_ChildUnitsEntry) {
      return value;
    }
    return UndoableUnitsGroup_ChildUnitsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableUnitsGroup_ChildUnitsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableUnit.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableUnit.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableUnit}
   */
  get value() {
    return this._hasValue ? this._value : UndoableUnit.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
              copy._hasValue = true;
              copy._value = UndoableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
            copy._hasValue = true;
            copy._value = UndoableUnit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableUnitsGroup_ChildUnitsEntry} other
   * @returns {UndoableUnitsGroup_ChildUnitsEntry}
   */
  merge(other) {
    const copy = new UndoableUnitsGroup_ChildUnitsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableUnitsGroup_ChildUnitsEntry.default = new UndoableUnitsGroup_ChildUnitsEntry();
class UndoableUnitsGroup_ChildUnitsEntry_Builder {
  constructor(value) {
    this._value = new UndoableUnitsGroup_ChildUnitsEntry(value);
  }
  build() {
    return new UndoableUnitsGroup_ChildUnitsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableUnitsGroup_ChildUnitsEntry.Builder = UndoableUnitsGroup_ChildUnitsEntry_Builder;
class UndoableUnitsGroup_ChildUnitsEntry_WithParent {
  /**
   * @param {UndoableUnitsGroup_ChildUnitsEntry} value
   * @param {UndoableUnitsGroup_ChildUnitsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableUnitsGroup_ChildUnitsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableUnit.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableUnit.WithParent(UndoableUnit.default, this._parent.value) : UndoableUnit.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableUnitsGroup_ChildUnitsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableUnitsGroup_ChildUnitsEntry_WithParent.default = new UndoableUnitsGroup_ChildUnitsEntry_WithParent(UndoableUnitsGroup_ChildUnitsEntry.default, null);
UndoableUnitsGroup_ChildUnitsEntry.WithParent = UndoableUnitsGroup_ChildUnitsEntry_WithParent;
class UndoableUnitsGroup_ChildUnitsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableUnit,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableUnitsGroup_ChildUnitsEntry.descriptor = new UndoableUnitsGroup_ChildUnitsEntry_Descriptor();
export class UndoableUnitsGroup {
  get descriptor() {
    return UndoableUnitsGroup.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitPosition = false;
    this._unitPosition = null;
    this._hasUnitRotation = false;
    this._unitRotation = null;
    this._hasUnitScale = false;
    this._unitScale = null;
    this._childUnits = {};
  }
  isEmpty() {
    if (this._hasUnitPosition && !this._unitPosition.isEmpty()) return false;
    if (this._hasUnitRotation && !this._unitRotation.isEmpty()) return false;
    if (this._hasUnitScale && !this._unitScale.isEmpty()) return false;
    if (Object.keys(this._childUnits).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableUnitsGroup) {
      return value;
    }
    return UndoableUnitsGroup.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableUnitsGroup();
    if (json.unitPosition != null) {
      result._hasUnitPosition = true;
      result._unitPosition = FVector3.fromJson(json.unitPosition);
    }
    if (json.unitRotation != null) {
      result._hasUnitRotation = true;
      result._unitRotation = FVector4.fromJson(json.unitRotation);
    }
    if (json.unitScale != null) {
      result._hasUnitScale = true;
      result._unitScale = FVector3.fromJson(json.unitScale);
    }
    result._childUnits = JsonToMap(json.childUnits, JsonToString, UndoableUnit);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitPosition && !this._unitPosition.isEmpty()) {
      result.unitPosition = FVector3.toJson(this._unitPosition);
    }
    if (this._hasUnitRotation && !this._unitRotation.isEmpty()) {
      result.unitRotation = FVector4.toJson(this._unitRotation);
    }
    if (this._hasUnitScale && !this._unitScale.isEmpty()) {
      result.unitScale = FVector3.toJson(this._unitScale);
    }
    if (Object.keys(this._childUnits).length > 0) {
      result.childUnits = MapToJson(this._childUnits, JsonToString, UndoableUnit);
    }
    return result;
  }
  /**
   * @returns {FVector3}
   */
  get unitPosition() {
    return this._hasUnitPosition ? this._unitPosition : FVector3.default;
  }
  get hasUnitPosition() {
    return this._hasUnitPosition;
  }
  setUnitPosition(path, value) {
    return {type: 'SET', path: path.concat(['unitPosition']), value: value.toJson()};
  }
  deleteUnitPosition(path) {
    return {type: 'DELETE', path: path.concat(['unitPosition'])};
  }
  /**
   * @returns {FVector4}
   */
  get unitRotation() {
    return this._hasUnitRotation ? this._unitRotation : FVector4.default;
  }
  get hasUnitRotation() {
    return this._hasUnitRotation;
  }
  setUnitRotation(path, value) {
    return {type: 'SET', path: path.concat(['unitRotation']), value: value.toJson()};
  }
  deleteUnitRotation(path) {
    return {type: 'DELETE', path: path.concat(['unitRotation'])};
  }
  /**
   * @returns {FVector3}
   */
  get unitScale() {
    return this._hasUnitScale ? this._unitScale : FVector3.default;
  }
  get hasUnitScale() {
    return this._hasUnitScale;
  }
  setUnitScale(path, value) {
    return {type: 'SET', path: path.concat(['unitScale']), value: value.toJson()};
  }
  deleteUnitScale(path) {
    return {type: 'DELETE', path: path.concat(['unitScale'])};
  }
  /**
   * @returns {Object<string, UndoableUnit>}
   */
  get childUnits() {
    return this._childUnits;
  }
  setChildUnits(path, value) {
    return {type: 'SET', path: path.concat(['childUnits']), value: MapToJson(value, JsonToString, UndoableUnit)};
  }
  setChildUnitsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['childUnits', key]), value: value.toJson()};
  }
  deleteChildUnits(path) {
    return {type: 'DELETE', path: path.concat(['childUnits'])};
  }
  deleteChildUnitsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['childUnits', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitPosition = true;
              copy._unitPosition = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitPosition) {
                return this;
              }
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitPosition = false;
              copy._unitPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitPosition) {
            const copy = new UndoableUnitsGroup(this);
            copy._hasUnitPosition = true;
            copy._unitPosition = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitPosition.apply(type, path.slice(1), value);
          if (newValue === this._unitPosition) {
            return this;
          }
          const copy = new UndoableUnitsGroup(this);
          copy._unitPosition = copy._unitPosition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitRotation = true;
              copy._unitRotation = FVector4.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitRotation) {
                return this;
              }
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitRotation = false;
              copy._unitRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitRotation) {
            const copy = new UndoableUnitsGroup(this);
            copy._hasUnitRotation = true;
            copy._unitRotation = FVector4.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitRotation.apply(type, path.slice(1), value);
          if (newValue === this._unitRotation) {
            return this;
          }
          const copy = new UndoableUnitsGroup(this);
          copy._unitRotation = copy._unitRotation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "unitScale": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitScale = true;
              copy._unitScale = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitScale) {
                return this;
              }
              const copy = new UndoableUnitsGroup(this);
              copy._hasUnitScale = false;
              copy._unitScale = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasUnitScale) {
            const copy = new UndoableUnitsGroup(this);
            copy._hasUnitScale = true;
            copy._unitScale = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._unitScale.apply(type, path.slice(1), value);
          if (newValue === this._unitScale) {
            return this;
          }
          const copy = new UndoableUnitsGroup(this);
          copy._unitScale = copy._unitScale.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "childUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._childUnits).length === 0) {
                return this;
              }
              const copy = new UndoableUnitsGroup(this);
              copy._childUnits = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableUnitsGroup(this);
              copy._childUnits = {};
              for (let key in value) {
                copy._childUnits[key] = UndoableUnit.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableUnitsGroup(this);
              copy._childUnits = {...copy._childUnits};
              copy._childUnits[path[1]] = UndoableUnit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._childUnits[path[1]]) {
                return this;
              }
              const copy = new UndoableUnitsGroup(this);
              copy._childUnits = {...copy._childUnits};
              delete copy._childUnits[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._childUnits[key] === undefined) {
            const copy = new UndoableUnitsGroup(this);
            copy._childUnits = {...copy._childUnits};
            copy._childUnits[key] = UndoableUnit.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._childUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableUnitsGroup(this);
          copy._childUnits = {...copy._childUnits};
          copy._childUnits[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableUnitsGroup} other
   * @returns {UndoableUnitsGroup}
   */
  merge(other) {
    const copy = new UndoableUnitsGroup(this);
    if (other._hasUnitPosition) {
      if (copy._hasUnitPosition) {
        copy._unitPosition = copy.unitPosition.merge(other.unitPosition);
      } else {
        copy._unitPosition = other._unitPosition;
      }
      copy._hasUnitPosition = true;
    }
    if (other._hasUnitRotation) {
      if (copy._hasUnitRotation) {
        copy._unitRotation = copy.unitRotation.merge(other.unitRotation);
      } else {
        copy._unitRotation = other._unitRotation;
      }
      copy._hasUnitRotation = true;
    }
    if (other._hasUnitScale) {
      if (copy._hasUnitScale) {
        copy._unitScale = copy.unitScale.merge(other.unitScale);
      } else {
        copy._unitScale = other._unitScale;
      }
      copy._hasUnitScale = true;
    }
    copy._childUnits = {...this._childUnits, ...other._childUnits};
    return copy;
  }
}
UndoableUnitsGroup.default = new UndoableUnitsGroup();
UndoableUnitsGroup.ChildUnitsEntry = UndoableUnitsGroup_ChildUnitsEntry;
class UndoableUnitsGroup_Builder {
  constructor(value) {
    this._value = new UndoableUnitsGroup(value);
  }
  build() {
    return new UndoableUnitsGroup(this._value);
  }
  setUnitPosition(value) {
    this._value._hasUnitPosition = true;
    this._value._unitPosition = value;
    return this;
  }
  deleteUnitPosition() {
    this._value._hasUnitPosition = false;
    this._value._unitPosition = null;
    return this;
  }
  setUnitRotation(value) {
    this._value._hasUnitRotation = true;
    this._value._unitRotation = value;
    return this;
  }
  deleteUnitRotation() {
    this._value._hasUnitRotation = false;
    this._value._unitRotation = null;
    return this;
  }
  setUnitScale(value) {
    this._value._hasUnitScale = true;
    this._value._unitScale = value;
    return this;
  }
  deleteUnitScale() {
    this._value._hasUnitScale = false;
    this._value._unitScale = null;
    return this;
  }
  setChildUnits(key, value) {
    this._value._childUnits = {...this._value._childUnits, [key]: value};
    return this;
  }
  addAllChildUnits(values) {
    this._value._childUnits = {...this._value._childUnits, ...values};
    return this;
  }
  deleteChildUnits(key) {
    this._value._childUnits = {...this._value._childUnits};
    delete this._value._childUnits[key];
    return this;
  }
  clearChildUnits() {
    this._value._childUnits = {};
    return this;
  }
}
UndoableUnitsGroup.Builder = UndoableUnitsGroup_Builder;
class UndoableUnitsGroup_WithParent {
  /**
   * @param {UndoableUnitsGroup} value
   * @param {UndoableUnitsGroup_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableUnitsGroup.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitPosition() {
    if (this._cachedHasUnitPosition === undefined) {
      if (this._value.hasUnitPosition) {
        this._cachedHasUnitPosition = true;
      } else {
        this._cachedHasUnitPosition = this._parent ? this._parent.hasUnitPosition : false;
      }
    }
    return this._cachedHasUnitPosition;
  }
  get unitPosition() {
    if (!this._cachedUnitPosition) {
      if (this._value.hasUnitPosition) {
        this._cachedUnitPosition = new FVector3.WithParent(this._value.unitPosition, this._parent && this._parent.hasUnitPosition ? this._parent.unitPosition : null);
      } else {
        this._cachedUnitPosition = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.unitPosition) : FVector3.WithParent.default;
      }
    }
    return this._cachedUnitPosition;
  }
  get hasUnitRotation() {
    if (this._cachedHasUnitRotation === undefined) {
      if (this._value.hasUnitRotation) {
        this._cachedHasUnitRotation = true;
      } else {
        this._cachedHasUnitRotation = this._parent ? this._parent.hasUnitRotation : false;
      }
    }
    return this._cachedHasUnitRotation;
  }
  get unitRotation() {
    if (!this._cachedUnitRotation) {
      if (this._value.hasUnitRotation) {
        this._cachedUnitRotation = new FVector4.WithParent(this._value.unitRotation, this._parent && this._parent.hasUnitRotation ? this._parent.unitRotation : null);
      } else {
        this._cachedUnitRotation = this._parent ? new FVector4.WithParent(FVector4.default, this._parent.unitRotation) : FVector4.WithParent.default;
      }
    }
    return this._cachedUnitRotation;
  }
  get hasUnitScale() {
    if (this._cachedHasUnitScale === undefined) {
      if (this._value.hasUnitScale) {
        this._cachedHasUnitScale = true;
      } else {
        this._cachedHasUnitScale = this._parent ? this._parent.hasUnitScale : false;
      }
    }
    return this._cachedHasUnitScale;
  }
  get unitScale() {
    if (!this._cachedUnitScale) {
      if (this._value.hasUnitScale) {
        this._cachedUnitScale = new FVector3.WithParent(this._value.unitScale, this._parent && this._parent.hasUnitScale ? this._parent.unitScale : null);
      } else {
        this._cachedUnitScale = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.unitScale) : FVector3.WithParent.default;
      }
    }
    return this._cachedUnitScale;
  }
  get selfChildUnits() {
    if (!this._selfChildUnits) {
      this._selfChildUnits = {};
      for (let i in this._value.childUnits) {
        this._selfChildUnits[i] = new UndoableUnit.WithParent(this._value.childUnits[i], null);
      }
    }
    return this._selfChildUnits;
  }
  get inherentChildUnits() {
    if (!this._inherentChildUnits) {
      this._inherentChildUnits = this._parent ? this._parent.childUnits : {};
    }
    return this._inherentChildUnits;
  }
  get childUnits() {
    if (!this._allChildUnits) {
      this._allChildUnits = this._parent ? {...this._parent.childUnits, ...this.selfChildUnits} : this.selfChildUnits;
    }
    return this._allChildUnits;
  }
  update(current, parent) {
    const result = new UndoableUnitsGroup_WithParent(current, parent);
    if (this._cachedUnitPosition && this._value.hasUnitPosition && current.hasUnitPosition) {
      if (this._value.unitPosition === current.unitPosition && this._parent === parent) {
        result._cachedUnitPosition = this._cachedUnitPosition;
      } else {
        result._cachedUnitPosition = this._cachedUnitPosition.update(current.unitPosition, parent && parent.hasUnitPosition ? parent.unitPosition : null);
      }
    }
    if (this._cachedUnitRotation && this._value.hasUnitRotation && current.hasUnitRotation) {
      if (this._value.unitRotation === current.unitRotation && this._parent === parent) {
        result._cachedUnitRotation = this._cachedUnitRotation;
      } else {
        result._cachedUnitRotation = this._cachedUnitRotation.update(current.unitRotation, parent && parent.hasUnitRotation ? parent.unitRotation : null);
      }
    }
    if (this._cachedUnitScale && this._value.hasUnitScale && current.hasUnitScale) {
      if (this._value.unitScale === current.unitScale && this._parent === parent) {
        result._cachedUnitScale = this._cachedUnitScale;
      } else {
        result._cachedUnitScale = this._cachedUnitScale.update(current.unitScale, parent && parent.hasUnitScale ? parent.unitScale : null);
      }
    }
    if (this._selfChildUnits) {
      if (this._value.childUnits === current.childUnits) {
        result._selfChildUnits = this._selfChildUnits;
      } else {
        result._selfChildUnits = {};
        for (let i in current.childUnits) {
          const oldValue = this._value.childUnits[i];
          if (oldValue) {
            const oldCache = this._selfChildUnits[i];
            if (oldValue === current.childUnits[i]) {
              result._selfChildUnits[i] = oldCache;
            } else {
              result._selfChildUnits[i] = oldCache.update(current.childUnits[i], null);
            }
          } else {
            result._selfChildUnits[i] = new UndoableUnit.WithParent(current.childUnits[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableUnitsGroup_WithParent.default = new UndoableUnitsGroup_WithParent(UndoableUnitsGroup.default, null);
UndoableUnitsGroup.WithParent = UndoableUnitsGroup_WithParent;
class UndoableUnitsGroup_Descriptor {
  get unitPosition() {
    if (!this._unitPosition) {
      this._unitPosition = {
        name: "unitPosition",
        Name: "UnitPosition",
        number: 1,
        protoType: 11,
        protoName: "unit_position",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitPosition;
  }
  get unitRotation() {
    if (!this._unitRotation) {
      this._unitRotation = {
        name: "unitRotation",
        Name: "UnitRotation",
        number: 2,
        protoType: 11,
        protoName: "unit_rotation",
        type: FVector4,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitRotation;
  }
  get unitScale() {
    if (!this._unitScale) {
      this._unitScale = {
        name: "unitScale",
        Name: "UnitScale",
        number: 3,
        protoType: 11,
        protoName: "unit_scale",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitScale;
  }
  get childUnits() {
    if (!this._childUnits) {
      this._childUnits = {
        name: "childUnits",
        Name: "ChildUnits",
        number: 4,
        protoType: 11,
        protoName: "child_units",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableUnit,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._childUnits;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitPosition,
        this.unitRotation,
        this.unitScale,
        this.childUnits,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitPosition",
        Name: "DummyOneofForUnitPosition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitRotation",
        Name: "DummyOneofForUnitRotation",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnitScale",
        Name: "DummyOneofForUnitScale",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableUnitsGroup.descriptor = new UndoableUnitsGroup_Descriptor();
export class ColorSetting {
  get descriptor() {
    return ColorSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasR = false;
    this._r = null;
    this._hasG = false;
    this._g = null;
    this._hasB = false;
    this._b = null;
    this._hasA = false;
    this._a = null;
  }
  isEmpty() {
    if (this._hasR) return false;
    if (this._hasG) return false;
    if (this._hasB) return false;
    if (this._hasA) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ColorSetting) {
      return value;
    }
    return ColorSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new ColorSetting();
    if (json.r != null) {
      result._hasR = true;
      result._r = JsonToInt32.fromJson(json.r);
    }
    if (json.g != null) {
      result._hasG = true;
      result._g = JsonToInt32.fromJson(json.g);
    }
    if (json.b != null) {
      result._hasB = true;
      result._b = JsonToInt32.fromJson(json.b);
    }
    if (json.a != null) {
      result._hasA = true;
      result._a = JsonToInt32.fromJson(json.a);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasR) {
      result.r = JsonToInt32.toJson(this._r);
    }
    if (this._hasG) {
      result.g = JsonToInt32.toJson(this._g);
    }
    if (this._hasB) {
      result.b = JsonToInt32.toJson(this._b);
    }
    if (this._hasA) {
      result.a = JsonToInt32.toJson(this._a);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get r() {
    return this._hasR ? this._r : JsonToInt32.default;
  }
  get hasR() {
    return this._hasR;
  }
  setR(path, value) {
    return {type: 'SET', path: path.concat(['r']), value};
  }
  deleteR(path) {
    return {type: 'DELETE', path: path.concat(['r'])};
  }
  /**
   * @returns {number}
   */
  get g() {
    return this._hasG ? this._g : JsonToInt32.default;
  }
  get hasG() {
    return this._hasG;
  }
  setG(path, value) {
    return {type: 'SET', path: path.concat(['g']), value};
  }
  deleteG(path) {
    return {type: 'DELETE', path: path.concat(['g'])};
  }
  /**
   * @returns {number}
   */
  get b() {
    return this._hasB ? this._b : JsonToInt32.default;
  }
  get hasB() {
    return this._hasB;
  }
  setB(path, value) {
    return {type: 'SET', path: path.concat(['b']), value};
  }
  deleteB(path) {
    return {type: 'DELETE', path: path.concat(['b'])};
  }
  /**
   * @returns {number}
   */
  get a() {
    return this._hasA ? this._a : JsonToInt32.default;
  }
  get hasA() {
    return this._hasA;
  }
  setA(path, value) {
    return {type: 'SET', path: path.concat(['a']), value};
  }
  deleteA(path) {
    return {type: 'DELETE', path: path.concat(['a'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "r": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ColorSetting(this);
              copy._hasR = true;
              copy._r = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasR) {
                return this;
              }
              const copy = new ColorSetting(this);
              copy._hasR = false;
              copy._r = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "g": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ColorSetting(this);
              copy._hasG = true;
              copy._g = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasG) {
                return this;
              }
              const copy = new ColorSetting(this);
              copy._hasG = false;
              copy._g = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "b": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ColorSetting(this);
              copy._hasB = true;
              copy._b = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasB) {
                return this;
              }
              const copy = new ColorSetting(this);
              copy._hasB = false;
              copy._b = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "a": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ColorSetting(this);
              copy._hasA = true;
              copy._a = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasA) {
                return this;
              }
              const copy = new ColorSetting(this);
              copy._hasA = false;
              copy._a = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ColorSetting} other
   * @returns {ColorSetting}
   */
  merge(other) {
    const copy = new ColorSetting(this);
    if (other._hasR) {
      copy._hasR = true;
      copy._r = other._r;
    }
    if (other._hasG) {
      copy._hasG = true;
      copy._g = other._g;
    }
    if (other._hasB) {
      copy._hasB = true;
      copy._b = other._b;
    }
    if (other._hasA) {
      copy._hasA = true;
      copy._a = other._a;
    }
    return copy;
  }
}
ColorSetting.default = new ColorSetting();
class ColorSetting_Builder {
  constructor(value) {
    this._value = new ColorSetting(value);
  }
  build() {
    return new ColorSetting(this._value);
  }
  setR(value) {
    this._value._hasR = true;
    this._value._r = value;
    return this;
  }
  deleteR() {
    this._value._hasR = false;
    this._value._r = null;
    return this;
  }
  setG(value) {
    this._value._hasG = true;
    this._value._g = value;
    return this;
  }
  deleteG() {
    this._value._hasG = false;
    this._value._g = null;
    return this;
  }
  setB(value) {
    this._value._hasB = true;
    this._value._b = value;
    return this;
  }
  deleteB() {
    this._value._hasB = false;
    this._value._b = null;
    return this;
  }
  setA(value) {
    this._value._hasA = true;
    this._value._a = value;
    return this;
  }
  deleteA() {
    this._value._hasA = false;
    this._value._a = null;
    return this;
  }
}
ColorSetting.Builder = ColorSetting_Builder;
class ColorSetting_WithParent {
  /**
   * @param {ColorSetting} value
   * @param {ColorSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ColorSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasR() {
    if (this._cachedHasR === undefined) {
      if (this._value.hasR) {
        this._cachedHasR = true;
      } else {
        this._cachedHasR = this._parent ? this._parent.hasR : false;
      }
    }
    return this._cachedHasR;
  }
  get r() {
    if (this._cachedR === undefined) {
      if (this._value.hasR) {
        this._cachedR = this._value.r;
      } else {
        this._cachedR = this._parent ? this._parent.r : this._value.r;
      }
    }
    return this._cachedR;
  }
  get hasG() {
    if (this._cachedHasG === undefined) {
      if (this._value.hasG) {
        this._cachedHasG = true;
      } else {
        this._cachedHasG = this._parent ? this._parent.hasG : false;
      }
    }
    return this._cachedHasG;
  }
  get g() {
    if (this._cachedG === undefined) {
      if (this._value.hasG) {
        this._cachedG = this._value.g;
      } else {
        this._cachedG = this._parent ? this._parent.g : this._value.g;
      }
    }
    return this._cachedG;
  }
  get hasB() {
    if (this._cachedHasB === undefined) {
      if (this._value.hasB) {
        this._cachedHasB = true;
      } else {
        this._cachedHasB = this._parent ? this._parent.hasB : false;
      }
    }
    return this._cachedHasB;
  }
  get b() {
    if (this._cachedB === undefined) {
      if (this._value.hasB) {
        this._cachedB = this._value.b;
      } else {
        this._cachedB = this._parent ? this._parent.b : this._value.b;
      }
    }
    return this._cachedB;
  }
  get hasA() {
    if (this._cachedHasA === undefined) {
      if (this._value.hasA) {
        this._cachedHasA = true;
      } else {
        this._cachedHasA = this._parent ? this._parent.hasA : false;
      }
    }
    return this._cachedHasA;
  }
  get a() {
    if (this._cachedA === undefined) {
      if (this._value.hasA) {
        this._cachedA = this._value.a;
      } else {
        this._cachedA = this._parent ? this._parent.a : this._value.a;
      }
    }
    return this._cachedA;
  }
  update(current, parent) {
    const result = new ColorSetting_WithParent(current, parent);
    return result;
  }
}
ColorSetting_WithParent.default = new ColorSetting_WithParent(ColorSetting.default, null);
ColorSetting.WithParent = ColorSetting_WithParent;
class ColorSetting_Descriptor {
  get r() {
    if (!this._r) {
      this._r = {
        name: "r",
        Name: "R",
        number: 1,
        protoType: 5,
        protoName: "r",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._r;
  }
  get g() {
    if (!this._g) {
      this._g = {
        name: "g",
        Name: "G",
        number: 2,
        protoType: 5,
        protoName: "g",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._g;
  }
  get b() {
    if (!this._b) {
      this._b = {
        name: "b",
        Name: "B",
        number: 3,
        protoType: 5,
        protoName: "b",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._b;
  }
  get a() {
    if (!this._a) {
      this._a = {
        name: "a",
        Name: "A",
        number: 4,
        protoType: 5,
        protoName: "a",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._a;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.r,
        this.g,
        this.b,
        this.a,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForR",
        Name: "DummyOneofForR",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForG",
        Name: "DummyOneofForG",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForB",
        Name: "DummyOneofForB",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForA",
        Name: "DummyOneofForA",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ColorSetting.descriptor = new ColorSetting_Descriptor();
export class UndoableRegion {
  get descriptor() {
    return UndoableRegion.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRegionName = false;
    this._regionName = null;
    this._hasCenter = false;
    this._center = null;
    this._hasSizeX = false;
    this._sizeX = null;
    this._hasSizeY = false;
    this._sizeY = null;
    this._hasRegionColorIndex = false;
    this._regionColorIndex = null;
    this._hasRegionColor = false;
    this._regionColor = null;
  }
  isEmpty() {
    if (this._hasRegionName) return false;
    if (this._hasCenter && !this._center.isEmpty()) return false;
    if (this._hasSizeX) return false;
    if (this._hasSizeY) return false;
    if (this._hasRegionColorIndex) return false;
    if (this._hasRegionColor && !this._regionColor.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableRegion) {
      return value;
    }
    return UndoableRegion.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableRegion();
    if (json.regionName != null) {
      result._hasRegionName = true;
      result._regionName = JsonToString.fromJson(json.regionName);
    }
    if (json.center != null) {
      result._hasCenter = true;
      result._center = FVector3.fromJson(json.center);
    }
    if (json.sizeX != null) {
      result._hasSizeX = true;
      result._sizeX = JsonToDouble.fromJson(json.sizeX);
    }
    if (json.sizeY != null) {
      result._hasSizeY = true;
      result._sizeY = JsonToDouble.fromJson(json.sizeY);
    }
    if (json.regionColorIndex != null) {
      result._hasRegionColorIndex = true;
      result._regionColorIndex = JsonToInt32.fromJson(json.regionColorIndex);
    }
    if (json.regionColor != null) {
      result._hasRegionColor = true;
      result._regionColor = ColorSetting.fromJson(json.regionColor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRegionName) {
      result.regionName = JsonToString.toJson(this._regionName);
    }
    if (this._hasCenter && !this._center.isEmpty()) {
      result.center = FVector3.toJson(this._center);
    }
    if (this._hasSizeX) {
      result.sizeX = JsonToDouble.toJson(this._sizeX);
    }
    if (this._hasSizeY) {
      result.sizeY = JsonToDouble.toJson(this._sizeY);
    }
    if (this._hasRegionColorIndex) {
      result.regionColorIndex = JsonToInt32.toJson(this._regionColorIndex);
    }
    if (this._hasRegionColor && !this._regionColor.isEmpty()) {
      result.regionColor = ColorSetting.toJson(this._regionColor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get regionName() {
    return this._hasRegionName ? this._regionName : JsonToString.default;
  }
  get hasRegionName() {
    return this._hasRegionName;
  }
  setRegionName(path, value) {
    return {type: 'SET', path: path.concat(['regionName']), value};
  }
  deleteRegionName(path) {
    return {type: 'DELETE', path: path.concat(['regionName'])};
  }
  /**
   * @returns {FVector3}
   */
  get center() {
    return this._hasCenter ? this._center : FVector3.default;
  }
  get hasCenter() {
    return this._hasCenter;
  }
  setCenter(path, value) {
    return {type: 'SET', path: path.concat(['center']), value: value.toJson()};
  }
  deleteCenter(path) {
    return {type: 'DELETE', path: path.concat(['center'])};
  }
  /**
   * @returns {number}
   */
  get sizeX() {
    return this._hasSizeX ? this._sizeX : JsonToDouble.default;
  }
  get hasSizeX() {
    return this._hasSizeX;
  }
  setSizeX(path, value) {
    return {type: 'SET', path: path.concat(['sizeX']), value};
  }
  deleteSizeX(path) {
    return {type: 'DELETE', path: path.concat(['sizeX'])};
  }
  /**
   * @returns {number}
   */
  get sizeY() {
    return this._hasSizeY ? this._sizeY : JsonToDouble.default;
  }
  get hasSizeY() {
    return this._hasSizeY;
  }
  setSizeY(path, value) {
    return {type: 'SET', path: path.concat(['sizeY']), value};
  }
  deleteSizeY(path) {
    return {type: 'DELETE', path: path.concat(['sizeY'])};
  }
  /**
   * @returns {number}
   */
  get regionColorIndex() {
    return this._hasRegionColorIndex ? this._regionColorIndex : JsonToInt32.default;
  }
  get hasRegionColorIndex() {
    return this._hasRegionColorIndex;
  }
  setRegionColorIndex(path, value) {
    return {type: 'SET', path: path.concat(['regionColorIndex']), value};
  }
  deleteRegionColorIndex(path) {
    return {type: 'DELETE', path: path.concat(['regionColorIndex'])};
  }
  /**
   * @returns {ColorSetting}
   */
  get regionColor() {
    return this._hasRegionColor ? this._regionColor : ColorSetting.default;
  }
  get hasRegionColor() {
    return this._hasRegionColor;
  }
  setRegionColor(path, value) {
    return {type: 'SET', path: path.concat(['regionColor']), value: value.toJson()};
  }
  deleteRegionColor(path) {
    return {type: 'DELETE', path: path.concat(['regionColor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "regionName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasRegionName = true;
              copy._regionName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionName) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasRegionName = false;
              copy._regionName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "center": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasCenter = true;
              copy._center = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCenter) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasCenter = false;
              copy._center = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCenter) {
            const copy = new UndoableRegion(this);
            copy._hasCenter = true;
            copy._center = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._center.apply(type, path.slice(1), value);
          if (newValue === this._center) {
            return this;
          }
          const copy = new UndoableRegion(this);
          copy._center = copy._center.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "sizeX": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasSizeX = true;
              copy._sizeX = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSizeX) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasSizeX = false;
              copy._sizeX = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "sizeY": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasSizeY = true;
              copy._sizeY = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSizeY) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasSizeY = false;
              copy._sizeY = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regionColorIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasRegionColorIndex = true;
              copy._regionColorIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionColorIndex) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasRegionColorIndex = false;
              copy._regionColorIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regionColor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableRegion(this);
              copy._hasRegionColor = true;
              copy._regionColor = ColorSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegionColor) {
                return this;
              }
              const copy = new UndoableRegion(this);
              copy._hasRegionColor = false;
              copy._regionColor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRegionColor) {
            const copy = new UndoableRegion(this);
            copy._hasRegionColor = true;
            copy._regionColor = ColorSetting.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._regionColor.apply(type, path.slice(1), value);
          if (newValue === this._regionColor) {
            return this;
          }
          const copy = new UndoableRegion(this);
          copy._regionColor = copy._regionColor.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableRegion} other
   * @returns {UndoableRegion}
   */
  merge(other) {
    const copy = new UndoableRegion(this);
    if (other._hasRegionName) {
      copy._hasRegionName = true;
      copy._regionName = other._regionName;
    }
    if (other._hasCenter) {
      if (copy._hasCenter) {
        copy._center = copy.center.merge(other.center);
      } else {
        copy._center = other._center;
      }
      copy._hasCenter = true;
    }
    if (other._hasSizeX) {
      copy._hasSizeX = true;
      copy._sizeX = other._sizeX;
    }
    if (other._hasSizeY) {
      copy._hasSizeY = true;
      copy._sizeY = other._sizeY;
    }
    if (other._hasRegionColorIndex) {
      copy._hasRegionColorIndex = true;
      copy._regionColorIndex = other._regionColorIndex;
    }
    if (other._hasRegionColor) {
      if (copy._hasRegionColor) {
        copy._regionColor = copy.regionColor.merge(other.regionColor);
      } else {
        copy._regionColor = other._regionColor;
      }
      copy._hasRegionColor = true;
    }
    return copy;
  }
}
UndoableRegion.default = new UndoableRegion();
class UndoableRegion_Builder {
  constructor(value) {
    this._value = new UndoableRegion(value);
  }
  build() {
    return new UndoableRegion(this._value);
  }
  setRegionName(value) {
    this._value._hasRegionName = true;
    this._value._regionName = value;
    return this;
  }
  deleteRegionName() {
    this._value._hasRegionName = false;
    this._value._regionName = null;
    return this;
  }
  setCenter(value) {
    this._value._hasCenter = true;
    this._value._center = value;
    return this;
  }
  deleteCenter() {
    this._value._hasCenter = false;
    this._value._center = null;
    return this;
  }
  setSizeX(value) {
    this._value._hasSizeX = true;
    this._value._sizeX = value;
    return this;
  }
  deleteSizeX() {
    this._value._hasSizeX = false;
    this._value._sizeX = null;
    return this;
  }
  setSizeY(value) {
    this._value._hasSizeY = true;
    this._value._sizeY = value;
    return this;
  }
  deleteSizeY() {
    this._value._hasSizeY = false;
    this._value._sizeY = null;
    return this;
  }
  setRegionColorIndex(value) {
    this._value._hasRegionColorIndex = true;
    this._value._regionColorIndex = value;
    return this;
  }
  deleteRegionColorIndex() {
    this._value._hasRegionColorIndex = false;
    this._value._regionColorIndex = null;
    return this;
  }
  setRegionColor(value) {
    this._value._hasRegionColor = true;
    this._value._regionColor = value;
    return this;
  }
  deleteRegionColor() {
    this._value._hasRegionColor = false;
    this._value._regionColor = null;
    return this;
  }
}
UndoableRegion.Builder = UndoableRegion_Builder;
class UndoableRegion_WithParent {
  /**
   * @param {UndoableRegion} value
   * @param {UndoableRegion_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableRegion.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRegionName() {
    if (this._cachedHasRegionName === undefined) {
      if (this._value.hasRegionName) {
        this._cachedHasRegionName = true;
      } else {
        this._cachedHasRegionName = this._parent ? this._parent.hasRegionName : false;
      }
    }
    return this._cachedHasRegionName;
  }
  get regionName() {
    if (this._cachedRegionName === undefined) {
      if (this._value.hasRegionName) {
        this._cachedRegionName = this._value.regionName;
      } else {
        this._cachedRegionName = this._parent ? this._parent.regionName : this._value.regionName;
      }
    }
    return this._cachedRegionName;
  }
  get hasCenter() {
    if (this._cachedHasCenter === undefined) {
      if (this._value.hasCenter) {
        this._cachedHasCenter = true;
      } else {
        this._cachedHasCenter = this._parent ? this._parent.hasCenter : false;
      }
    }
    return this._cachedHasCenter;
  }
  get center() {
    if (!this._cachedCenter) {
      if (this._value.hasCenter) {
        this._cachedCenter = new FVector3.WithParent(this._value.center, this._parent && this._parent.hasCenter ? this._parent.center : null);
      } else {
        this._cachedCenter = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.center) : FVector3.WithParent.default;
      }
    }
    return this._cachedCenter;
  }
  get hasSizeX() {
    if (this._cachedHasSizeX === undefined) {
      if (this._value.hasSizeX) {
        this._cachedHasSizeX = true;
      } else {
        this._cachedHasSizeX = this._parent ? this._parent.hasSizeX : false;
      }
    }
    return this._cachedHasSizeX;
  }
  get sizeX() {
    if (this._cachedSizeX === undefined) {
      if (this._value.hasSizeX) {
        this._cachedSizeX = this._value.sizeX;
      } else {
        this._cachedSizeX = this._parent ? this._parent.sizeX : this._value.sizeX;
      }
    }
    return this._cachedSizeX;
  }
  get hasSizeY() {
    if (this._cachedHasSizeY === undefined) {
      if (this._value.hasSizeY) {
        this._cachedHasSizeY = true;
      } else {
        this._cachedHasSizeY = this._parent ? this._parent.hasSizeY : false;
      }
    }
    return this._cachedHasSizeY;
  }
  get sizeY() {
    if (this._cachedSizeY === undefined) {
      if (this._value.hasSizeY) {
        this._cachedSizeY = this._value.sizeY;
      } else {
        this._cachedSizeY = this._parent ? this._parent.sizeY : this._value.sizeY;
      }
    }
    return this._cachedSizeY;
  }
  get hasRegionColorIndex() {
    if (this._cachedHasRegionColorIndex === undefined) {
      if (this._value.hasRegionColorIndex) {
        this._cachedHasRegionColorIndex = true;
      } else {
        this._cachedHasRegionColorIndex = this._parent ? this._parent.hasRegionColorIndex : false;
      }
    }
    return this._cachedHasRegionColorIndex;
  }
  get regionColorIndex() {
    if (this._cachedRegionColorIndex === undefined) {
      if (this._value.hasRegionColorIndex) {
        this._cachedRegionColorIndex = this._value.regionColorIndex;
      } else {
        this._cachedRegionColorIndex = this._parent ? this._parent.regionColorIndex : this._value.regionColorIndex;
      }
    }
    return this._cachedRegionColorIndex;
  }
  get hasRegionColor() {
    if (this._cachedHasRegionColor === undefined) {
      if (this._value.hasRegionColor) {
        this._cachedHasRegionColor = true;
      } else {
        this._cachedHasRegionColor = this._parent ? this._parent.hasRegionColor : false;
      }
    }
    return this._cachedHasRegionColor;
  }
  get regionColor() {
    if (!this._cachedRegionColor) {
      if (this._value.hasRegionColor) {
        this._cachedRegionColor = new ColorSetting.WithParent(this._value.regionColor, this._parent && this._parent.hasRegionColor ? this._parent.regionColor : null);
      } else {
        this._cachedRegionColor = this._parent ? new ColorSetting.WithParent(ColorSetting.default, this._parent.regionColor) : ColorSetting.WithParent.default;
      }
    }
    return this._cachedRegionColor;
  }
  update(current, parent) {
    const result = new UndoableRegion_WithParent(current, parent);
    if (this._cachedCenter && this._value.hasCenter && current.hasCenter) {
      if (this._value.center === current.center && this._parent === parent) {
        result._cachedCenter = this._cachedCenter;
      } else {
        result._cachedCenter = this._cachedCenter.update(current.center, parent && parent.hasCenter ? parent.center : null);
      }
    }
    if (this._cachedRegionColor && this._value.hasRegionColor && current.hasRegionColor) {
      if (this._value.regionColor === current.regionColor && this._parent === parent) {
        result._cachedRegionColor = this._cachedRegionColor;
      } else {
        result._cachedRegionColor = this._cachedRegionColor.update(current.regionColor, parent && parent.hasRegionColor ? parent.regionColor : null);
      }
    }
    return result;
  }
}
UndoableRegion_WithParent.default = new UndoableRegion_WithParent(UndoableRegion.default, null);
UndoableRegion.WithParent = UndoableRegion_WithParent;
class UndoableRegion_Descriptor {
  get regionName() {
    if (!this._regionName) {
      this._regionName = {
        name: "regionName",
        Name: "RegionName",
        number: 1,
        protoType: 9,
        protoName: "region_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionName;
  }
  get center() {
    if (!this._center) {
      this._center = {
        name: "center",
        Name: "Center",
        number: 2,
        protoType: 11,
        protoName: "center",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._center;
  }
  get sizeX() {
    if (!this._sizeX) {
      this._sizeX = {
        name: "sizeX",
        Name: "SizeX",
        number: 3,
        protoType: 1,
        protoName: "size_x",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sizeX;
  }
  get sizeY() {
    if (!this._sizeY) {
      this._sizeY = {
        name: "sizeY",
        Name: "SizeY",
        number: 4,
        protoType: 1,
        protoName: "size_y",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sizeY;
  }
  get regionColorIndex() {
    if (!this._regionColorIndex) {
      this._regionColorIndex = {
        name: "regionColorIndex",
        Name: "RegionColorIndex",
        number: 5,
        protoType: 5,
        protoName: "region_color_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionColorIndex;
  }
  get regionColor() {
    if (!this._regionColor) {
      this._regionColor = {
        name: "regionColor",
        Name: "RegionColor",
        number: 6,
        protoType: 11,
        protoName: "region_color",
        type: ColorSetting,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regionColor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.regionName,
        this.center,
        this.sizeX,
        this.sizeY,
        this.regionColorIndex,
        this.regionColor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRegionName",
        Name: "DummyOneofForRegionName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCenter",
        Name: "DummyOneofForCenter",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSizeX",
        Name: "DummyOneofForSizeX",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSizeY",
        Name: "DummyOneofForSizeY",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionColorIndex",
        Name: "DummyOneofForRegionColorIndex",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegionColor",
        Name: "DummyOneofForRegionColor",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableRegion.descriptor = new UndoableRegion_Descriptor();
export class UndoablePath {
  get descriptor() {
    return UndoablePath.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPathName = false;
    this._pathName = null;
    this._hasDisableRally = false;
    this._disableRally = null;
    this._nodeIds = [];
  }
  isEmpty() {
    if (this._hasPathName) return false;
    if (this._hasDisableRally) return false;
    if (this._nodeIds.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoablePath) {
      return value;
    }
    return UndoablePath.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoablePath();
    if (json.pathName != null) {
      result._hasPathName = true;
      result._pathName = JsonToString.fromJson(json.pathName);
    }
    if (json.disableRally != null) {
      result._hasDisableRally = true;
      result._disableRally = JsonToBoolean.fromJson(json.disableRally);
    }
    result._nodeIds = JsonToList(json.nodeIds, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPathName) {
      result.pathName = JsonToString.toJson(this._pathName);
    }
    if (this._hasDisableRally) {
      result.disableRally = JsonToBoolean.toJson(this._disableRally);
    }
    if (this._nodeIds.length > 0) {
      result.nodeIds = ArrayToJson(this._nodeIds, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get pathName() {
    return this._hasPathName ? this._pathName : JsonToString.default;
  }
  get hasPathName() {
    return this._hasPathName;
  }
  setPathName(path, value) {
    return {type: 'SET', path: path.concat(['pathName']), value};
  }
  deletePathName(path) {
    return {type: 'DELETE', path: path.concat(['pathName'])};
  }
  /**
   * @returns {boolean}
   */
  get disableRally() {
    return this._hasDisableRally ? this._disableRally : JsonToBoolean.default;
  }
  get hasDisableRally() {
    return this._hasDisableRally;
  }
  setDisableRally(path, value) {
    return {type: 'SET', path: path.concat(['disableRally']), value};
  }
  deleteDisableRally(path) {
    return {type: 'DELETE', path: path.concat(['disableRally'])};
  }
  /**
   * @returns {string[]}
   */
  get nodeIds() {
    return this._nodeIds;
  }
  addNodeIds(path, value) {
    return {type: 'ADD', path: path.concat(['nodeIds']), value};
  }
  setNodeIds(path, value) {
    return {type: 'SET', path: path.concat(['nodeIds']), value: ArrayToJson(value, JsonToString)};
  }
  setNodeIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['nodeIds', key]), value};
  }
  deleteNodeIds(path) {
    return {type: 'DELETE', path: path.concat(['nodeIds'])};
  }
  deleteNodeIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['nodeIds', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "pathName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePath(this);
              copy._hasPathName = true;
              copy._pathName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPathName) {
                return this;
              }
              const copy = new UndoablePath(this);
              copy._hasPathName = false;
              copy._pathName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableRally": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePath(this);
              copy._hasDisableRally = true;
              copy._disableRally = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableRally) {
                return this;
              }
              const copy = new UndoablePath(this);
              copy._hasDisableRally = false;
              copy._disableRally = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nodeIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoablePath(this);
              copy._nodeIds = [];        for (let i of value) {
                copy._nodeIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UndoablePath(this);
              copy._nodeIds = copy._nodeIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._nodeIds.length === 0) {
                return this;
              }
              const copy = new UndoablePath(this);
              copy._nodeIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._nodeIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UndoablePath(this);
              copy._nodeIds = copy._nodeIds.slice();
              copy._nodeIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UndoablePath(this);
              copy._nodeIds = copy._nodeIds.slice(0, path[1]).concat(copy._nodeIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._nodeIds.length) {
            return this;
          }
          const oldValue = this._nodeIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoablePath(this);
          copy._nodeIds = copy._nodeIds.slice();
          copy._nodeIds[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoablePath} other
   * @returns {UndoablePath}
   */
  merge(other) {
    const copy = new UndoablePath(this);
    if (other._hasPathName) {
      copy._hasPathName = true;
      copy._pathName = other._pathName;
    }
    if (other._hasDisableRally) {
      copy._hasDisableRally = true;
      copy._disableRally = other._disableRally;
    }
    copy._nodeIds = this._nodeIds.concat(other._nodeIds);
    return copy;
  }
}
UndoablePath.default = new UndoablePath();
class UndoablePath_Builder {
  constructor(value) {
    this._value = new UndoablePath(value);
  }
  build() {
    return new UndoablePath(this._value);
  }
  setPathName(value) {
    this._value._hasPathName = true;
    this._value._pathName = value;
    return this;
  }
  deletePathName() {
    this._value._hasPathName = false;
    this._value._pathName = null;
    return this;
  }
  setDisableRally(value) {
    this._value._hasDisableRally = true;
    this._value._disableRally = value;
    return this;
  }
  deleteDisableRally() {
    this._value._hasDisableRally = false;
    this._value._disableRally = null;
    return this;
  }
  addAllNodeIds(values) {
    this._value._nodeIds = this._value._nodeIds.concat(values);
    return this;
  }
  addNodeIds(value) {
    this._value._nodeIds = this._value._nodeIds.concat([value]);
    return this;
  }
  setNodeIds(index, value) {
    this._value._nodeIds = this._value._nodeIds.concat();
    this._value._nodeIds[index] = value;
    return this;
  }
  clearNodeIds() {
    this._value._nodeIds = [];
    return this;
  }
}
UndoablePath.Builder = UndoablePath_Builder;
class UndoablePath_WithParent {
  /**
   * @param {UndoablePath} value
   * @param {UndoablePath_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoablePath.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPathName() {
    if (this._cachedHasPathName === undefined) {
      if (this._value.hasPathName) {
        this._cachedHasPathName = true;
      } else {
        this._cachedHasPathName = this._parent ? this._parent.hasPathName : false;
      }
    }
    return this._cachedHasPathName;
  }
  get pathName() {
    if (this._cachedPathName === undefined) {
      if (this._value.hasPathName) {
        this._cachedPathName = this._value.pathName;
      } else {
        this._cachedPathName = this._parent ? this._parent.pathName : this._value.pathName;
      }
    }
    return this._cachedPathName;
  }
  get hasDisableRally() {
    if (this._cachedHasDisableRally === undefined) {
      if (this._value.hasDisableRally) {
        this._cachedHasDisableRally = true;
      } else {
        this._cachedHasDisableRally = this._parent ? this._parent.hasDisableRally : false;
      }
    }
    return this._cachedHasDisableRally;
  }
  get disableRally() {
    if (this._cachedDisableRally === undefined) {
      if (this._value.hasDisableRally) {
        this._cachedDisableRally = this._value.disableRally;
      } else {
        this._cachedDisableRally = this._parent ? this._parent.disableRally : this._value.disableRally;
      }
    }
    return this._cachedDisableRally;
  }
  get selfNodeIds() {
    return this._value.nodeIds;
  }
  get inherentNodeIds() {
    if (!this._inherentNodeIds) {
      this._inherentNodeIds = this._parent ? this._parent.nodeIds : [];
    }
    return this._inherentNodeIds;
  }
  get nodeIds() {
    if (!this._allNodeIds) {
      this._allNodeIds = this._parent ? this._parent.nodeIds.concat(this.selfNodeIds) : this.selfNodeIds;
    }
    return this._allNodeIds;
  }
  update(current, parent) {
    const result = new UndoablePath_WithParent(current, parent);
    return result;
  }
}
UndoablePath_WithParent.default = new UndoablePath_WithParent(UndoablePath.default, null);
UndoablePath.WithParent = UndoablePath_WithParent;
class UndoablePath_Descriptor {
  get pathName() {
    if (!this._pathName) {
      this._pathName = {
        name: "pathName",
        Name: "PathName",
        number: 1,
        protoType: 9,
        protoName: "path_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._pathName;
  }
  get disableRally() {
    if (!this._disableRally) {
      this._disableRally = {
        name: "disableRally",
        Name: "DisableRally",
        number: 2,
        protoType: 8,
        protoName: "disable_rally",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableRally;
  }
  get nodeIds() {
    if (!this._nodeIds) {
      this._nodeIds = {
        name: "nodeIds",
        Name: "NodeIds",
        number: 3,
        protoType: 9,
        protoName: "node_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nodeIds;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.pathName,
        this.disableRally,
        this.nodeIds,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPathName",
        Name: "DummyOneofForPathName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableRally",
        Name: "DummyOneofForDisableRally",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoablePath.descriptor = new UndoablePath_Descriptor();
class UndoableWaypointsData_AdditionalRoadNodesEntry {
  get descriptor() {
    return UndoableWaypointsData_AdditionalRoadNodesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaypointsData_AdditionalRoadNodesEntry) {
      return value;
    }
    return UndoableWaypointsData_AdditionalRoadNodesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaypointsData_AdditionalRoadNodesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableNodeData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableNodeData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableNodeData}
   */
  get value() {
    return this._hasValue ? this._value : UndoableNodeData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
              copy._hasValue = true;
              copy._value = UndoableNodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
            copy._hasValue = true;
            copy._value = UndoableNodeData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaypointsData_AdditionalRoadNodesEntry} other
   * @returns {UndoableWaypointsData_AdditionalRoadNodesEntry}
   */
  merge(other) {
    const copy = new UndoableWaypointsData_AdditionalRoadNodesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableWaypointsData_AdditionalRoadNodesEntry.default = new UndoableWaypointsData_AdditionalRoadNodesEntry();
class UndoableWaypointsData_AdditionalRoadNodesEntry_Builder {
  constructor(value) {
    this._value = new UndoableWaypointsData_AdditionalRoadNodesEntry(value);
  }
  build() {
    return new UndoableWaypointsData_AdditionalRoadNodesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableWaypointsData_AdditionalRoadNodesEntry.Builder = UndoableWaypointsData_AdditionalRoadNodesEntry_Builder;
class UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent {
  /**
   * @param {UndoableWaypointsData_AdditionalRoadNodesEntry} value
   * @param {UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaypointsData_AdditionalRoadNodesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableNodeData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableNodeData.WithParent(UndoableNodeData.default, this._parent.value) : UndoableNodeData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent.default = new UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent(UndoableWaypointsData_AdditionalRoadNodesEntry.default, null);
UndoableWaypointsData_AdditionalRoadNodesEntry.WithParent = UndoableWaypointsData_AdditionalRoadNodesEntry_WithParent;
class UndoableWaypointsData_AdditionalRoadNodesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableNodeData,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableWaypointsData_AdditionalRoadNodesEntry.descriptor = new UndoableWaypointsData_AdditionalRoadNodesEntry_Descriptor();
class UndoableWaypointsData_WaypointPathsEntry {
  get descriptor() {
    return UndoableWaypointsData_WaypointPathsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaypointsData_WaypointPathsEntry) {
      return value;
    }
    return UndoableWaypointsData_WaypointPathsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaypointsData_WaypointPathsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoablePath.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoablePath.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoablePath}
   */
  get value() {
    return this._hasValue ? this._value : UndoablePath.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
              copy._hasValue = true;
              copy._value = UndoablePath.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
            copy._hasValue = true;
            copy._value = UndoablePath.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaypointsData_WaypointPathsEntry} other
   * @returns {UndoableWaypointsData_WaypointPathsEntry}
   */
  merge(other) {
    const copy = new UndoableWaypointsData_WaypointPathsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableWaypointsData_WaypointPathsEntry.default = new UndoableWaypointsData_WaypointPathsEntry();
class UndoableWaypointsData_WaypointPathsEntry_Builder {
  constructor(value) {
    this._value = new UndoableWaypointsData_WaypointPathsEntry(value);
  }
  build() {
    return new UndoableWaypointsData_WaypointPathsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableWaypointsData_WaypointPathsEntry.Builder = UndoableWaypointsData_WaypointPathsEntry_Builder;
class UndoableWaypointsData_WaypointPathsEntry_WithParent {
  /**
   * @param {UndoableWaypointsData_WaypointPathsEntry} value
   * @param {UndoableWaypointsData_WaypointPathsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaypointsData_WaypointPathsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoablePath.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoablePath.WithParent(UndoablePath.default, this._parent.value) : UndoablePath.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableWaypointsData_WaypointPathsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableWaypointsData_WaypointPathsEntry_WithParent.default = new UndoableWaypointsData_WaypointPathsEntry_WithParent(UndoableWaypointsData_WaypointPathsEntry.default, null);
UndoableWaypointsData_WaypointPathsEntry.WithParent = UndoableWaypointsData_WaypointPathsEntry_WithParent;
class UndoableWaypointsData_WaypointPathsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoablePath,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableWaypointsData_WaypointPathsEntry.descriptor = new UndoableWaypointsData_WaypointPathsEntry_Descriptor();
export class UndoableWaypointsData {
  get descriptor() {
    return UndoableWaypointsData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._additionalRoadNodes = {};
    this._waypointPaths = {};
  }
  isEmpty() {
    if (Object.keys(this._additionalRoadNodes).length > 0) return false;
    if (Object.keys(this._waypointPaths).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableWaypointsData) {
      return value;
    }
    return UndoableWaypointsData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableWaypointsData();
    result._additionalRoadNodes = JsonToMap(json.additionalRoadNodes, JsonToString, UndoableNodeData);
    result._waypointPaths = JsonToMap(json.waypointPaths, JsonToString, UndoablePath);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._additionalRoadNodes).length > 0) {
      result.additionalRoadNodes = MapToJson(this._additionalRoadNodes, JsonToString, UndoableNodeData);
    }
    if (Object.keys(this._waypointPaths).length > 0) {
      result.waypointPaths = MapToJson(this._waypointPaths, JsonToString, UndoablePath);
    }
    return result;
  }
  /**
   * @returns {Object<string, UndoableNodeData>}
   */
  get additionalRoadNodes() {
    return this._additionalRoadNodes;
  }
  setAdditionalRoadNodes(path, value) {
    return {type: 'SET', path: path.concat(['additionalRoadNodes']), value: MapToJson(value, JsonToString, UndoableNodeData)};
  }
  setAdditionalRoadNodesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['additionalRoadNodes', key]), value: value.toJson()};
  }
  deleteAdditionalRoadNodes(path) {
    return {type: 'DELETE', path: path.concat(['additionalRoadNodes'])};
  }
  deleteAdditionalRoadNodesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['additionalRoadNodes', key])};
  }
  /**
   * @returns {Object<string, UndoablePath>}
   */
  get waypointPaths() {
    return this._waypointPaths;
  }
  setWaypointPaths(path, value) {
    return {type: 'SET', path: path.concat(['waypointPaths']), value: MapToJson(value, JsonToString, UndoablePath)};
  }
  setWaypointPathsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['waypointPaths', key]), value: value.toJson()};
  }
  deleteWaypointPaths(path) {
    return {type: 'DELETE', path: path.concat(['waypointPaths'])};
  }
  deleteWaypointPathsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['waypointPaths', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "additionalRoadNodes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._additionalRoadNodes).length === 0) {
                return this;
              }
              const copy = new UndoableWaypointsData(this);
              copy._additionalRoadNodes = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableWaypointsData(this);
              copy._additionalRoadNodes = {};
              for (let key in value) {
                copy._additionalRoadNodes[key] = UndoableNodeData.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData(this);
              copy._additionalRoadNodes = {...copy._additionalRoadNodes};
              copy._additionalRoadNodes[path[1]] = UndoableNodeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._additionalRoadNodes[path[1]]) {
                return this;
              }
              const copy = new UndoableWaypointsData(this);
              copy._additionalRoadNodes = {...copy._additionalRoadNodes};
              delete copy._additionalRoadNodes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._additionalRoadNodes[key] === undefined) {
            const copy = new UndoableWaypointsData(this);
            copy._additionalRoadNodes = {...copy._additionalRoadNodes};
            copy._additionalRoadNodes[key] = UndoableNodeData.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._additionalRoadNodes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableWaypointsData(this);
          copy._additionalRoadNodes = {...copy._additionalRoadNodes};
          copy._additionalRoadNodes[key] = newValue;
          return copy;
        }
      }
      case "waypointPaths": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._waypointPaths).length === 0) {
                return this;
              }
              const copy = new UndoableWaypointsData(this);
              copy._waypointPaths = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableWaypointsData(this);
              copy._waypointPaths = {};
              for (let key in value) {
                copy._waypointPaths[key] = UndoablePath.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableWaypointsData(this);
              copy._waypointPaths = {...copy._waypointPaths};
              copy._waypointPaths[path[1]] = UndoablePath.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._waypointPaths[path[1]]) {
                return this;
              }
              const copy = new UndoableWaypointsData(this);
              copy._waypointPaths = {...copy._waypointPaths};
              delete copy._waypointPaths[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._waypointPaths[key] === undefined) {
            const copy = new UndoableWaypointsData(this);
            copy._waypointPaths = {...copy._waypointPaths};
            copy._waypointPaths[key] = UndoablePath.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._waypointPaths[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableWaypointsData(this);
          copy._waypointPaths = {...copy._waypointPaths};
          copy._waypointPaths[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableWaypointsData} other
   * @returns {UndoableWaypointsData}
   */
  merge(other) {
    const copy = new UndoableWaypointsData(this);
    copy._additionalRoadNodes = {...this._additionalRoadNodes, ...other._additionalRoadNodes};
    copy._waypointPaths = {...this._waypointPaths, ...other._waypointPaths};
    return copy;
  }
}
UndoableWaypointsData.default = new UndoableWaypointsData();
UndoableWaypointsData.AdditionalRoadNodesEntry = UndoableWaypointsData_AdditionalRoadNodesEntry;
UndoableWaypointsData.WaypointPathsEntry = UndoableWaypointsData_WaypointPathsEntry;
class UndoableWaypointsData_Builder {
  constructor(value) {
    this._value = new UndoableWaypointsData(value);
  }
  build() {
    return new UndoableWaypointsData(this._value);
  }
  setAdditionalRoadNodes(key, value) {
    this._value._additionalRoadNodes = {...this._value._additionalRoadNodes, [key]: value};
    return this;
  }
  addAllAdditionalRoadNodes(values) {
    this._value._additionalRoadNodes = {...this._value._additionalRoadNodes, ...values};
    return this;
  }
  deleteAdditionalRoadNodes(key) {
    this._value._additionalRoadNodes = {...this._value._additionalRoadNodes};
    delete this._value._additionalRoadNodes[key];
    return this;
  }
  clearAdditionalRoadNodes() {
    this._value._additionalRoadNodes = {};
    return this;
  }
  setWaypointPaths(key, value) {
    this._value._waypointPaths = {...this._value._waypointPaths, [key]: value};
    return this;
  }
  addAllWaypointPaths(values) {
    this._value._waypointPaths = {...this._value._waypointPaths, ...values};
    return this;
  }
  deleteWaypointPaths(key) {
    this._value._waypointPaths = {...this._value._waypointPaths};
    delete this._value._waypointPaths[key];
    return this;
  }
  clearWaypointPaths() {
    this._value._waypointPaths = {};
    return this;
  }
}
UndoableWaypointsData.Builder = UndoableWaypointsData_Builder;
class UndoableWaypointsData_WithParent {
  /**
   * @param {UndoableWaypointsData} value
   * @param {UndoableWaypointsData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableWaypointsData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfAdditionalRoadNodes() {
    if (!this._selfAdditionalRoadNodes) {
      this._selfAdditionalRoadNodes = {};
      for (let i in this._value.additionalRoadNodes) {
        this._selfAdditionalRoadNodes[i] = new UndoableNodeData.WithParent(this._value.additionalRoadNodes[i], null);
      }
    }
    return this._selfAdditionalRoadNodes;
  }
  get inherentAdditionalRoadNodes() {
    if (!this._inherentAdditionalRoadNodes) {
      this._inherentAdditionalRoadNodes = this._parent ? this._parent.additionalRoadNodes : {};
    }
    return this._inherentAdditionalRoadNodes;
  }
  get additionalRoadNodes() {
    if (!this._allAdditionalRoadNodes) {
      this._allAdditionalRoadNodes = this._parent ? {...this._parent.additionalRoadNodes, ...this.selfAdditionalRoadNodes} : this.selfAdditionalRoadNodes;
    }
    return this._allAdditionalRoadNodes;
  }
  get selfWaypointPaths() {
    if (!this._selfWaypointPaths) {
      this._selfWaypointPaths = {};
      for (let i in this._value.waypointPaths) {
        this._selfWaypointPaths[i] = new UndoablePath.WithParent(this._value.waypointPaths[i], null);
      }
    }
    return this._selfWaypointPaths;
  }
  get inherentWaypointPaths() {
    if (!this._inherentWaypointPaths) {
      this._inherentWaypointPaths = this._parent ? this._parent.waypointPaths : {};
    }
    return this._inherentWaypointPaths;
  }
  get waypointPaths() {
    if (!this._allWaypointPaths) {
      this._allWaypointPaths = this._parent ? {...this._parent.waypointPaths, ...this.selfWaypointPaths} : this.selfWaypointPaths;
    }
    return this._allWaypointPaths;
  }
  update(current, parent) {
    const result = new UndoableWaypointsData_WithParent(current, parent);
    if (this._selfAdditionalRoadNodes) {
      if (this._value.additionalRoadNodes === current.additionalRoadNodes) {
        result._selfAdditionalRoadNodes = this._selfAdditionalRoadNodes;
      } else {
        result._selfAdditionalRoadNodes = {};
        for (let i in current.additionalRoadNodes) {
          const oldValue = this._value.additionalRoadNodes[i];
          if (oldValue) {
            const oldCache = this._selfAdditionalRoadNodes[i];
            if (oldValue === current.additionalRoadNodes[i]) {
              result._selfAdditionalRoadNodes[i] = oldCache;
            } else {
              result._selfAdditionalRoadNodes[i] = oldCache.update(current.additionalRoadNodes[i], null);
            }
          } else {
            result._selfAdditionalRoadNodes[i] = new UndoableNodeData.WithParent(current.additionalRoadNodes[i], null);
          }
        }
      }
    }
    if (this._selfWaypointPaths) {
      if (this._value.waypointPaths === current.waypointPaths) {
        result._selfWaypointPaths = this._selfWaypointPaths;
      } else {
        result._selfWaypointPaths = {};
        for (let i in current.waypointPaths) {
          const oldValue = this._value.waypointPaths[i];
          if (oldValue) {
            const oldCache = this._selfWaypointPaths[i];
            if (oldValue === current.waypointPaths[i]) {
              result._selfWaypointPaths[i] = oldCache;
            } else {
              result._selfWaypointPaths[i] = oldCache.update(current.waypointPaths[i], null);
            }
          } else {
            result._selfWaypointPaths[i] = new UndoablePath.WithParent(current.waypointPaths[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableWaypointsData_WithParent.default = new UndoableWaypointsData_WithParent(UndoableWaypointsData.default, null);
UndoableWaypointsData.WithParent = UndoableWaypointsData_WithParent;
class UndoableWaypointsData_Descriptor {
  get additionalRoadNodes() {
    if (!this._additionalRoadNodes) {
      this._additionalRoadNodes = {
        name: "additionalRoadNodes",
        Name: "AdditionalRoadNodes",
        number: 1,
        protoType: 11,
        protoName: "additional_road_nodes",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableNodeData,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._additionalRoadNodes;
  }
  get waypointPaths() {
    if (!this._waypointPaths) {
      this._waypointPaths = {
        name: "waypointPaths",
        Name: "WaypointPaths",
        number: 2,
        protoType: 11,
        protoName: "waypoint_paths",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoablePath,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._waypointPaths;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.additionalRoadNodes,
        this.waypointPaths,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableWaypointsData.descriptor = new UndoableWaypointsData_Descriptor();
export class UndoableChunkDefinition {
  get descriptor() {
    return UndoableChunkDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasId = false;
    this._id = null;
    this._hasCenter = false;
    this._center = null;
    this._hasSize = false;
    this._size = null;
    this._hasStartPoint = false;
    this._startPoint = null;
  }
  isEmpty() {
    if (this._hasId) return false;
    if (this._hasCenter && !this._center.isEmpty()) return false;
    if (this._hasSize && !this._size.isEmpty()) return false;
    if (this._hasStartPoint && !this._startPoint.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableChunkDefinition) {
      return value;
    }
    return UndoableChunkDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableChunkDefinition();
    if (json.id != null) {
      result._hasId = true;
      result._id = JsonToString.fromJson(json.id);
    }
    if (json.center != null) {
      result._hasCenter = true;
      result._center = FVector3.fromJson(json.center);
    }
    if (json.size != null) {
      result._hasSize = true;
      result._size = FVector2.fromJson(json.size);
    }
    if (json.startPoint != null) {
      result._hasStartPoint = true;
      result._startPoint = FVector2.fromJson(json.startPoint);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasId) {
      result.id = JsonToString.toJson(this._id);
    }
    if (this._hasCenter && !this._center.isEmpty()) {
      result.center = FVector3.toJson(this._center);
    }
    if (this._hasSize && !this._size.isEmpty()) {
      result.size = FVector2.toJson(this._size);
    }
    if (this._hasStartPoint && !this._startPoint.isEmpty()) {
      result.startPoint = FVector2.toJson(this._startPoint);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get id() {
    return this._hasId ? this._id : JsonToString.default;
  }
  get hasId() {
    return this._hasId;
  }
  setId(path, value) {
    return {type: 'SET', path: path.concat(['id']), value};
  }
  deleteId(path) {
    return {type: 'DELETE', path: path.concat(['id'])};
  }
  /**
   * @returns {FVector3}
   */
  get center() {
    return this._hasCenter ? this._center : FVector3.default;
  }
  get hasCenter() {
    return this._hasCenter;
  }
  setCenter(path, value) {
    return {type: 'SET', path: path.concat(['center']), value: value.toJson()};
  }
  deleteCenter(path) {
    return {type: 'DELETE', path: path.concat(['center'])};
  }
  /**
   * @returns {FVector2}
   */
  get size() {
    return this._hasSize ? this._size : FVector2.default;
  }
  get hasSize() {
    return this._hasSize;
  }
  setSize(path, value) {
    return {type: 'SET', path: path.concat(['size']), value: value.toJson()};
  }
  deleteSize(path) {
    return {type: 'DELETE', path: path.concat(['size'])};
  }
  /**
   * @returns {FVector2}
   */
  get startPoint() {
    return this._hasStartPoint ? this._startPoint : FVector2.default;
  }
  get hasStartPoint() {
    return this._hasStartPoint;
  }
  setStartPoint(path, value) {
    return {type: 'SET', path: path.concat(['startPoint']), value: value.toJson()};
  }
  deleteStartPoint(path) {
    return {type: 'DELETE', path: path.concat(['startPoint'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "id": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableChunkDefinition(this);
              copy._hasId = true;
              copy._id = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasId) {
                return this;
              }
              const copy = new UndoableChunkDefinition(this);
              copy._hasId = false;
              copy._id = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "center": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableChunkDefinition(this);
              copy._hasCenter = true;
              copy._center = FVector3.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCenter) {
                return this;
              }
              const copy = new UndoableChunkDefinition(this);
              copy._hasCenter = false;
              copy._center = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCenter) {
            const copy = new UndoableChunkDefinition(this);
            copy._hasCenter = true;
            copy._center = FVector3.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._center.apply(type, path.slice(1), value);
          if (newValue === this._center) {
            return this;
          }
          const copy = new UndoableChunkDefinition(this);
          copy._center = copy._center.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "size": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableChunkDefinition(this);
              copy._hasSize = true;
              copy._size = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSize) {
                return this;
              }
              const copy = new UndoableChunkDefinition(this);
              copy._hasSize = false;
              copy._size = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSize) {
            const copy = new UndoableChunkDefinition(this);
            copy._hasSize = true;
            copy._size = FVector2.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._size.apply(type, path.slice(1), value);
          if (newValue === this._size) {
            return this;
          }
          const copy = new UndoableChunkDefinition(this);
          copy._size = copy._size.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "startPoint": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableChunkDefinition(this);
              copy._hasStartPoint = true;
              copy._startPoint = FVector2.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartPoint) {
                return this;
              }
              const copy = new UndoableChunkDefinition(this);
              copy._hasStartPoint = false;
              copy._startPoint = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStartPoint) {
            const copy = new UndoableChunkDefinition(this);
            copy._hasStartPoint = true;
            copy._startPoint = FVector2.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._startPoint.apply(type, path.slice(1), value);
          if (newValue === this._startPoint) {
            return this;
          }
          const copy = new UndoableChunkDefinition(this);
          copy._startPoint = copy._startPoint.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableChunkDefinition} other
   * @returns {UndoableChunkDefinition}
   */
  merge(other) {
    const copy = new UndoableChunkDefinition(this);
    if (other._hasId) {
      copy._hasId = true;
      copy._id = other._id;
    }
    if (other._hasCenter) {
      if (copy._hasCenter) {
        copy._center = copy.center.merge(other.center);
      } else {
        copy._center = other._center;
      }
      copy._hasCenter = true;
    }
    if (other._hasSize) {
      if (copy._hasSize) {
        copy._size = copy.size.merge(other.size);
      } else {
        copy._size = other._size;
      }
      copy._hasSize = true;
    }
    if (other._hasStartPoint) {
      if (copy._hasStartPoint) {
        copy._startPoint = copy.startPoint.merge(other.startPoint);
      } else {
        copy._startPoint = other._startPoint;
      }
      copy._hasStartPoint = true;
    }
    return copy;
  }
}
UndoableChunkDefinition.default = new UndoableChunkDefinition();
class UndoableChunkDefinition_Builder {
  constructor(value) {
    this._value = new UndoableChunkDefinition(value);
  }
  build() {
    return new UndoableChunkDefinition(this._value);
  }
  setId(value) {
    this._value._hasId = true;
    this._value._id = value;
    return this;
  }
  deleteId() {
    this._value._hasId = false;
    this._value._id = null;
    return this;
  }
  setCenter(value) {
    this._value._hasCenter = true;
    this._value._center = value;
    return this;
  }
  deleteCenter() {
    this._value._hasCenter = false;
    this._value._center = null;
    return this;
  }
  setSize(value) {
    this._value._hasSize = true;
    this._value._size = value;
    return this;
  }
  deleteSize() {
    this._value._hasSize = false;
    this._value._size = null;
    return this;
  }
  setStartPoint(value) {
    this._value._hasStartPoint = true;
    this._value._startPoint = value;
    return this;
  }
  deleteStartPoint() {
    this._value._hasStartPoint = false;
    this._value._startPoint = null;
    return this;
  }
}
UndoableChunkDefinition.Builder = UndoableChunkDefinition_Builder;
class UndoableChunkDefinition_WithParent {
  /**
   * @param {UndoableChunkDefinition} value
   * @param {UndoableChunkDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableChunkDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasId() {
    if (this._cachedHasId === undefined) {
      if (this._value.hasId) {
        this._cachedHasId = true;
      } else {
        this._cachedHasId = this._parent ? this._parent.hasId : false;
      }
    }
    return this._cachedHasId;
  }
  get id() {
    if (this._cachedId === undefined) {
      if (this._value.hasId) {
        this._cachedId = this._value.id;
      } else {
        this._cachedId = this._parent ? this._parent.id : this._value.id;
      }
    }
    return this._cachedId;
  }
  get hasCenter() {
    if (this._cachedHasCenter === undefined) {
      if (this._value.hasCenter) {
        this._cachedHasCenter = true;
      } else {
        this._cachedHasCenter = this._parent ? this._parent.hasCenter : false;
      }
    }
    return this._cachedHasCenter;
  }
  get center() {
    if (!this._cachedCenter) {
      if (this._value.hasCenter) {
        this._cachedCenter = new FVector3.WithParent(this._value.center, this._parent && this._parent.hasCenter ? this._parent.center : null);
      } else {
        this._cachedCenter = this._parent ? new FVector3.WithParent(FVector3.default, this._parent.center) : FVector3.WithParent.default;
      }
    }
    return this._cachedCenter;
  }
  get hasSize() {
    if (this._cachedHasSize === undefined) {
      if (this._value.hasSize) {
        this._cachedHasSize = true;
      } else {
        this._cachedHasSize = this._parent ? this._parent.hasSize : false;
      }
    }
    return this._cachedHasSize;
  }
  get size() {
    if (!this._cachedSize) {
      if (this._value.hasSize) {
        this._cachedSize = new FVector2.WithParent(this._value.size, this._parent && this._parent.hasSize ? this._parent.size : null);
      } else {
        this._cachedSize = this._parent ? new FVector2.WithParent(FVector2.default, this._parent.size) : FVector2.WithParent.default;
      }
    }
    return this._cachedSize;
  }
  get hasStartPoint() {
    if (this._cachedHasStartPoint === undefined) {
      if (this._value.hasStartPoint) {
        this._cachedHasStartPoint = true;
      } else {
        this._cachedHasStartPoint = this._parent ? this._parent.hasStartPoint : false;
      }
    }
    return this._cachedHasStartPoint;
  }
  get startPoint() {
    if (!this._cachedStartPoint) {
      if (this._value.hasStartPoint) {
        this._cachedStartPoint = new FVector2.WithParent(this._value.startPoint, this._parent && this._parent.hasStartPoint ? this._parent.startPoint : null);
      } else {
        this._cachedStartPoint = this._parent ? new FVector2.WithParent(FVector2.default, this._parent.startPoint) : FVector2.WithParent.default;
      }
    }
    return this._cachedStartPoint;
  }
  update(current, parent) {
    const result = new UndoableChunkDefinition_WithParent(current, parent);
    if (this._cachedCenter && this._value.hasCenter && current.hasCenter) {
      if (this._value.center === current.center && this._parent === parent) {
        result._cachedCenter = this._cachedCenter;
      } else {
        result._cachedCenter = this._cachedCenter.update(current.center, parent && parent.hasCenter ? parent.center : null);
      }
    }
    if (this._cachedSize && this._value.hasSize && current.hasSize) {
      if (this._value.size === current.size && this._parent === parent) {
        result._cachedSize = this._cachedSize;
      } else {
        result._cachedSize = this._cachedSize.update(current.size, parent && parent.hasSize ? parent.size : null);
      }
    }
    if (this._cachedStartPoint && this._value.hasStartPoint && current.hasStartPoint) {
      if (this._value.startPoint === current.startPoint && this._parent === parent) {
        result._cachedStartPoint = this._cachedStartPoint;
      } else {
        result._cachedStartPoint = this._cachedStartPoint.update(current.startPoint, parent && parent.hasStartPoint ? parent.startPoint : null);
      }
    }
    return result;
  }
}
UndoableChunkDefinition_WithParent.default = new UndoableChunkDefinition_WithParent(UndoableChunkDefinition.default, null);
UndoableChunkDefinition.WithParent = UndoableChunkDefinition_WithParent;
class UndoableChunkDefinition_Descriptor {
  get id() {
    if (!this._id) {
      this._id = {
        name: "id",
        Name: "Id",
        number: 1,
        protoType: 9,
        protoName: "id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._id;
  }
  get center() {
    if (!this._center) {
      this._center = {
        name: "center",
        Name: "Center",
        number: 2,
        protoType: 11,
        protoName: "center",
        type: FVector3,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._center;
  }
  get size() {
    if (!this._size) {
      this._size = {
        name: "size",
        Name: "Size",
        number: 3,
        protoType: 11,
        protoName: "size",
        type: FVector2,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._size;
  }
  get startPoint() {
    if (!this._startPoint) {
      this._startPoint = {
        name: "startPoint",
        Name: "StartPoint",
        number: 4,
        protoType: 11,
        protoName: "start_point",
        type: FVector2,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startPoint;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.id,
        this.center,
        this.size,
        this.startPoint,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForId",
        Name: "DummyOneofForId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCenter",
        Name: "DummyOneofForCenter",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSize",
        Name: "DummyOneofForSize",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartPoint",
        Name: "DummyOneofForStartPoint",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableChunkDefinition.descriptor = new UndoableChunkDefinition_Descriptor();
class UndoableTerrainChunkData_ChunckDefinitionsEntry {
  get descriptor() {
    return UndoableTerrainChunkData_ChunckDefinitionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableTerrainChunkData_ChunckDefinitionsEntry) {
      return value;
    }
    return UndoableTerrainChunkData_ChunckDefinitionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableTerrainChunkData_ChunckDefinitionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UndoableChunkDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UndoableChunkDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UndoableChunkDefinition}
   */
  get value() {
    return this._hasValue ? this._value : UndoableChunkDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
              copy._hasValue = true;
              copy._value = UndoableChunkDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
            copy._hasValue = true;
            copy._value = UndoableChunkDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableTerrainChunkData_ChunckDefinitionsEntry} other
   * @returns {UndoableTerrainChunkData_ChunckDefinitionsEntry}
   */
  merge(other) {
    const copy = new UndoableTerrainChunkData_ChunckDefinitionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UndoableTerrainChunkData_ChunckDefinitionsEntry.default = new UndoableTerrainChunkData_ChunckDefinitionsEntry();
class UndoableTerrainChunkData_ChunckDefinitionsEntry_Builder {
  constructor(value) {
    this._value = new UndoableTerrainChunkData_ChunckDefinitionsEntry(value);
  }
  build() {
    return new UndoableTerrainChunkData_ChunckDefinitionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UndoableTerrainChunkData_ChunckDefinitionsEntry.Builder = UndoableTerrainChunkData_ChunckDefinitionsEntry_Builder;
class UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent {
  /**
   * @param {UndoableTerrainChunkData_ChunckDefinitionsEntry} value
   * @param {UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableTerrainChunkData_ChunckDefinitionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UndoableChunkDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UndoableChunkDefinition.WithParent(UndoableChunkDefinition.default, this._parent.value) : UndoableChunkDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent.default = new UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent(UndoableTerrainChunkData_ChunckDefinitionsEntry.default, null);
UndoableTerrainChunkData_ChunckDefinitionsEntry.WithParent = UndoableTerrainChunkData_ChunckDefinitionsEntry_WithParent;
class UndoableTerrainChunkData_ChunckDefinitionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UndoableChunkDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UndoableTerrainChunkData_ChunckDefinitionsEntry.descriptor = new UndoableTerrainChunkData_ChunckDefinitionsEntry_Descriptor();
export class UndoableTerrainChunkData {
  get descriptor() {
    return UndoableTerrainChunkData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUseTerrainChunk = false;
    this._useTerrainChunk = null;
    this._chunckDefinitions = {};
  }
  isEmpty() {
    if (this._hasUseTerrainChunk) return false;
    if (Object.keys(this._chunckDefinitions).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UndoableTerrainChunkData) {
      return value;
    }
    return UndoableTerrainChunkData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UndoableTerrainChunkData();
    if (json.useTerrainChunk != null) {
      result._hasUseTerrainChunk = true;
      result._useTerrainChunk = JsonToBoolean.fromJson(json.useTerrainChunk);
    }
    result._chunckDefinitions = JsonToMap(json.chunckDefinitions, JsonToString, UndoableChunkDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUseTerrainChunk) {
      result.useTerrainChunk = JsonToBoolean.toJson(this._useTerrainChunk);
    }
    if (Object.keys(this._chunckDefinitions).length > 0) {
      result.chunckDefinitions = MapToJson(this._chunckDefinitions, JsonToString, UndoableChunkDefinition);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get useTerrainChunk() {
    return this._hasUseTerrainChunk ? this._useTerrainChunk : JsonToBoolean.default;
  }
  get hasUseTerrainChunk() {
    return this._hasUseTerrainChunk;
  }
  setUseTerrainChunk(path, value) {
    return {type: 'SET', path: path.concat(['useTerrainChunk']), value};
  }
  deleteUseTerrainChunk(path) {
    return {type: 'DELETE', path: path.concat(['useTerrainChunk'])};
  }
  /**
   * @returns {Object<string, UndoableChunkDefinition>}
   */
  get chunckDefinitions() {
    return this._chunckDefinitions;
  }
  setChunckDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['chunckDefinitions']), value: MapToJson(value, JsonToString, UndoableChunkDefinition)};
  }
  setChunckDefinitionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['chunckDefinitions', key]), value: value.toJson()};
  }
  deleteChunckDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['chunckDefinitions'])};
  }
  deleteChunckDefinitionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['chunckDefinitions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "useTerrainChunk": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainChunkData(this);
              copy._hasUseTerrainChunk = true;
              copy._useTerrainChunk = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseTerrainChunk) {
                return this;
              }
              const copy = new UndoableTerrainChunkData(this);
              copy._hasUseTerrainChunk = false;
              copy._useTerrainChunk = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chunckDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._chunckDefinitions).length === 0) {
                return this;
              }
              const copy = new UndoableTerrainChunkData(this);
              copy._chunckDefinitions = {};
              return copy;
            }
            case 'SET': {
              const copy = new UndoableTerrainChunkData(this);
              copy._chunckDefinitions = {};
              for (let key in value) {
                copy._chunckDefinitions[key] = UndoableChunkDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UndoableTerrainChunkData(this);
              copy._chunckDefinitions = {...copy._chunckDefinitions};
              copy._chunckDefinitions[path[1]] = UndoableChunkDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._chunckDefinitions[path[1]]) {
                return this;
              }
              const copy = new UndoableTerrainChunkData(this);
              copy._chunckDefinitions = {...copy._chunckDefinitions};
              delete copy._chunckDefinitions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._chunckDefinitions[key] === undefined) {
            const copy = new UndoableTerrainChunkData(this);
            copy._chunckDefinitions = {...copy._chunckDefinitions};
            copy._chunckDefinitions[key] = UndoableChunkDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._chunckDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UndoableTerrainChunkData(this);
          copy._chunckDefinitions = {...copy._chunckDefinitions};
          copy._chunckDefinitions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UndoableTerrainChunkData} other
   * @returns {UndoableTerrainChunkData}
   */
  merge(other) {
    const copy = new UndoableTerrainChunkData(this);
    if (other._hasUseTerrainChunk) {
      copy._hasUseTerrainChunk = true;
      copy._useTerrainChunk = other._useTerrainChunk;
    }
    copy._chunckDefinitions = {...this._chunckDefinitions, ...other._chunckDefinitions};
    return copy;
  }
}
UndoableTerrainChunkData.default = new UndoableTerrainChunkData();
UndoableTerrainChunkData.ChunckDefinitionsEntry = UndoableTerrainChunkData_ChunckDefinitionsEntry;
class UndoableTerrainChunkData_Builder {
  constructor(value) {
    this._value = new UndoableTerrainChunkData(value);
  }
  build() {
    return new UndoableTerrainChunkData(this._value);
  }
  setUseTerrainChunk(value) {
    this._value._hasUseTerrainChunk = true;
    this._value._useTerrainChunk = value;
    return this;
  }
  deleteUseTerrainChunk() {
    this._value._hasUseTerrainChunk = false;
    this._value._useTerrainChunk = null;
    return this;
  }
  setChunckDefinitions(key, value) {
    this._value._chunckDefinitions = {...this._value._chunckDefinitions, [key]: value};
    return this;
  }
  addAllChunckDefinitions(values) {
    this._value._chunckDefinitions = {...this._value._chunckDefinitions, ...values};
    return this;
  }
  deleteChunckDefinitions(key) {
    this._value._chunckDefinitions = {...this._value._chunckDefinitions};
    delete this._value._chunckDefinitions[key];
    return this;
  }
  clearChunckDefinitions() {
    this._value._chunckDefinitions = {};
    return this;
  }
}
UndoableTerrainChunkData.Builder = UndoableTerrainChunkData_Builder;
class UndoableTerrainChunkData_WithParent {
  /**
   * @param {UndoableTerrainChunkData} value
   * @param {UndoableTerrainChunkData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UndoableTerrainChunkData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUseTerrainChunk() {
    if (this._cachedHasUseTerrainChunk === undefined) {
      if (this._value.hasUseTerrainChunk) {
        this._cachedHasUseTerrainChunk = true;
      } else {
        this._cachedHasUseTerrainChunk = this._parent ? this._parent.hasUseTerrainChunk : false;
      }
    }
    return this._cachedHasUseTerrainChunk;
  }
  get useTerrainChunk() {
    if (this._cachedUseTerrainChunk === undefined) {
      if (this._value.hasUseTerrainChunk) {
        this._cachedUseTerrainChunk = this._value.useTerrainChunk;
      } else {
        this._cachedUseTerrainChunk = this._parent ? this._parent.useTerrainChunk : this._value.useTerrainChunk;
      }
    }
    return this._cachedUseTerrainChunk;
  }
  get selfChunckDefinitions() {
    if (!this._selfChunckDefinitions) {
      this._selfChunckDefinitions = {};
      for (let i in this._value.chunckDefinitions) {
        this._selfChunckDefinitions[i] = new UndoableChunkDefinition.WithParent(this._value.chunckDefinitions[i], null);
      }
    }
    return this._selfChunckDefinitions;
  }
  get inherentChunckDefinitions() {
    if (!this._inherentChunckDefinitions) {
      this._inherentChunckDefinitions = this._parent ? this._parent.chunckDefinitions : {};
    }
    return this._inherentChunckDefinitions;
  }
  get chunckDefinitions() {
    if (!this._allChunckDefinitions) {
      this._allChunckDefinitions = this._parent ? {...this._parent.chunckDefinitions, ...this.selfChunckDefinitions} : this.selfChunckDefinitions;
    }
    return this._allChunckDefinitions;
  }
  update(current, parent) {
    const result = new UndoableTerrainChunkData_WithParent(current, parent);
    if (this._selfChunckDefinitions) {
      if (this._value.chunckDefinitions === current.chunckDefinitions) {
        result._selfChunckDefinitions = this._selfChunckDefinitions;
      } else {
        result._selfChunckDefinitions = {};
        for (let i in current.chunckDefinitions) {
          const oldValue = this._value.chunckDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfChunckDefinitions[i];
            if (oldValue === current.chunckDefinitions[i]) {
              result._selfChunckDefinitions[i] = oldCache;
            } else {
              result._selfChunckDefinitions[i] = oldCache.update(current.chunckDefinitions[i], null);
            }
          } else {
            result._selfChunckDefinitions[i] = new UndoableChunkDefinition.WithParent(current.chunckDefinitions[i], null);
          }
        }
      }
    }
    return result;
  }
}
UndoableTerrainChunkData_WithParent.default = new UndoableTerrainChunkData_WithParent(UndoableTerrainChunkData.default, null);
UndoableTerrainChunkData.WithParent = UndoableTerrainChunkData_WithParent;
class UndoableTerrainChunkData_Descriptor {
  get useTerrainChunk() {
    if (!this._useTerrainChunk) {
      this._useTerrainChunk = {
        name: "useTerrainChunk",
        Name: "UseTerrainChunk",
        number: 1,
        protoType: 8,
        protoName: "use_terrain_chunk",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useTerrainChunk;
  }
  get chunckDefinitions() {
    if (!this._chunckDefinitions) {
      this._chunckDefinitions = {
        name: "chunckDefinitions",
        Name: "ChunckDefinitions",
        number: 2,
        protoType: 11,
        protoName: "chunck_definitions",
        isMap: true,
        keyType: JsonToString,
        valueType: UndoableChunkDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chunckDefinitions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.useTerrainChunk,
        this.chunckDefinitions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUseTerrainChunk",
        Name: "DummyOneofForUseTerrainChunk",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UndoableTerrainChunkData.descriptor = new UndoableTerrainChunkData_Descriptor();
export class Team {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PLAYER": return 0;
        case "ENEMY": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Team.fromJson(value);
  }
  static fromReact(e) {
    return Team.fromJson(e);
  }
}
Team.PLAYER = 0;
Team.ENEMY = 1;
Team.default = 0;
Team.values = {
  PLAYER: 0,
  ENEMY: 1,
};
Team.names = {
  0: "PLAYER",
  1: "ENEMY",
};
